function getCompareItems() {
    try {
      return JSON.parse(localStorage.getItem('product_compare_items_v2')) || [];
    } catch (e) {
      return [];
    }
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function normalizeCompareTooltipKey(value) {
    return String(value || '')
      .normalize('NFC')
      .trim()
      .toLowerCase()
      .replace(/[–—]/g, '-')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ');
  }

  window.compareTooltips = (window.compareTooltipsRaw || []).reduce(function(acc, item) {
    const groupKey = normalizeCompareTooltipKey(item.group);
    const valueKey = normalizeCompareTooltipKey(item.value);
    const codeKey = normalizeCompareTooltipKey(item.code);
    const tooltipText = String(item.tooltip || '').trim();

    if (!tooltipText) return acc;

    if (groupKey && valueKey) {
      acc['group_value::' + groupKey + '::' + valueKey] = tooltipText;
    }

    if (groupKey && codeKey) {
      acc['group_code::' + groupKey + '::' + codeKey] = tooltipText;
    }

    if (valueKey) {
      acc['value::' + valueKey] = tooltipText;
    }

    if (codeKey) {
      acc['code::' + codeKey] = tooltipText;
    }

    return acc;
  }, {});

  function renderCompareLabel(label, group, code) {
    const normalizedLabel = normalizeCompareTooltipKey(label);
    const normalizedGroup = normalizeCompareTooltipKey(group);
    const normalizedCode = normalizeCompareTooltipKey(code);
    const safeLabel = escapeHtml(label);

    let tooltip = '';

    if (window.compareTooltips) {
      if (normalizedGroup && normalizedCode) {
        tooltip = window.compareTooltips['group_code::' + normalizedGroup + '::' + normalizedCode] || '';
      }

      if (!tooltip && normalizedGroup && normalizedLabel) {
        tooltip = window.compareTooltips['group_value::' + normalizedGroup + '::' + normalizedLabel] || '';
      }

      if (!tooltip && normalizedCode) {
        tooltip = window.compareTooltips['code::' + normalizedCode] || '';
      }

      if (!tooltip && normalizedLabel) {
        tooltip = window.compareTooltips['value::' + normalizedLabel] || '';
      }
    }

    if (!tooltip) {
      return `<span class="compare-page__label-text">${safeLabel}</span>`;
    }

    return `
      <span class="compare-page__label-text">${safeLabel}</span>
      <span class="compare-tooltip">
        <button
          type="button"
          class="compare-tooltip-trigger"
          aria-label="Více informací: ${safeLabel}"
        >
          i
        </button>
        <span class="compare-tooltip-content" role="tooltip">
          ${escapeHtml(tooltip)}
        </span>
      </span>
    `;
  }

  function renderCompareValue(value, options) {
  const settings = options || {};
  const booleanFilled = settings.booleanFilled === true;

  const raw = String(value ?? '').trim();
  const normalized = raw.toLowerCase();
  const tooltipKey = normalizeCompareTooltipKey(raw);
  const tooltip =
    (window.compareTooltips && window.compareTooltips['value::' + tooltipKey]) ||
    (window.compareTooltips && window.compareTooltips['code::' + tooltipKey]) ||
    '';

  if (booleanFilled) {
    if (
      raw !== '' &&
      normalized !== '—' &&
      normalized !== '-' &&
      normalized !== 'neuvedeno' &&
      normalized !== 'null' &&
      normalized !== 'undefined' &&
      normalized !== 'ne' &&
      normalized !== 'no' &&
      normalized !== 'false'
    ) {
      return `
        <span class="compare-page__value-badge compare-page__value-badge--yes">
          <span class="compare-page__value-icon" aria-hidden="true">✓</span>
        </span>
      `;
    }

    return `
      <span class="compare-page__value-badge compare-page__value-badge--no">
        <span class="compare-page__value-icon" aria-hidden="true">✕</span>
      </span>
    `;
  }

  if (
    normalized === 'ano' ||
    normalized === 'yes' ||
    normalized === 'true'
  ) {
    return `
      <span class="compare-page__value-badge compare-page__value-badge--yes">
        <span class="compare-page__value-icon" aria-hidden="true">✓</span>
      </span>
    `;
  }

  if (
    normalized === 'ne' ||
    normalized === 'no' ||
    normalized === 'false'
  ) {
    return `
      <span class="compare-page__value-badge compare-page__value-badge--no">
        <span class="compare-page__value-icon" aria-hidden="true">✕</span>
      </span>
    `;
  }

  if (
    raw === '' ||
    normalized === '—' ||
    normalized === '-' ||
    normalized === 'neuvedeno' ||
    normalized === 'null' ||
    normalized === 'undefined'
  ) {
    return `
      <span class="compare-page__value-badge compare-page__value-badge--empty">
        Údaj neuveden
      </span>
    `;
  }

  if (tooltip && String(tooltip).trim() !== '') {
    return `
      <span class="compare-page__value-badge">
        <span>${escapeHtml(raw)}</span>
        <span class="compare-tooltip">
          <button
            type="button"
            class="compare-tooltip-trigger"
            aria-label="Více informací: ${escapeHtml(raw)}"
          >
            i
          </button>
          <span class="compare-tooltip-content" role="tooltip">
            ${escapeHtml(tooltip)}
          </span>
        </span>
      </span>
    `;
  }

  return `
    <span class="compare-page__value-badge">
      ${escapeHtml(raw)}
    </span>
  `;
}

  function normalizeCompareRawValue(value) {
    const raw = String(value ?? '').trim().toLowerCase();

    if (
      raw === '' ||
      raw === '—' ||
      raw === '-' ||
      raw === 'neuvedeno' ||
      raw === 'null' ||
      raw === 'undefined'
    ) {
      return '__EMPTY__';
    }

    if (raw === 'ano' || raw === 'yes' || raw === 'true') {
      return 'ano';
    }

    if (raw === 'ne' || raw === 'no' || raw === 'false') {
      return 'ne';
    }

    return raw;
  }

  function isFilledCompareValue(value) {
    const raw = String(value ?? '').trim().toLowerCase();

    return !(
      raw === '' ||
      raw === '—' ||
      raw === '-' ||
      raw === 'neuvedeno' ||
      raw === 'null' ||
      raw === 'undefined'
    );
  }
function getCompareJsonValue(item, fieldKey, code) {
  let raw = getCompareItemValue(item, fieldKey);

  if (!isFilledCompareValue(raw) && fieldKey === 'technicke_udaje_hodnota') {
    raw = getCompareItemValue(item, 'technicke_udaje_hodnoty');
  }

  if (!isFilledCompareValue(raw) && fieldKey === 'technicke_udaje_hodnoty') {
    raw = getCompareItemValue(item, 'technicke_udaje_hodnota');
  }

  if (!isFilledCompareValue(raw)) {
    if (
      fieldKey === 'provedeni_hodnota' &&
      normalizeCompareCode(code) === 'typ_pristroje'
    ) {
      const directTypPristroje = getCompareItemValue(item, 'typ_pristroje');

      if (isFilledCompareValue(directTypPristroje)) {
        return directTypPristroje;
      }
    }

    return '—';
  }

  let data = raw;

  if (typeof data === 'string') {
    data = data
      .replace(/&quot;/g, '"')
      .replace(/&#34;/g, '"')
      .replace(/&amp;quot;/g, '"')
      .replace(/&apos;/g, "'")
      .replace(/&#39;/g, "'")
      .trim();

    for (let i = 0; i < 3; i++) {
      if (typeof data !== 'string') break;

      try {
        data = JSON.parse(data);
      } catch (e) {
        break;
      }
    }
  }

  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch (e) {
      return '—';
    }
  }

  if (!data || typeof data !== 'object' || Array.isArray(data)) {
    return '—';
  }

  const compareValueCodeAliases = {
    trida_energeticke_ucinnosti_a_g: [
      'trida_energeticke_ucinnosti',
      'energeticka_trida',
      'trida_energeticke_ucinnosti_a_d',
      'trida_energeticke_ucinnosti_a_g_',
      'trida_energeticke_ucinnosti_a__g',
      'trida_energeticke_ucinnosti_ag',
      'trida_energeticke_ucinnosti_a_g_hodnota',
      'energeticka_ucinnost',
      'energy_efficiency_class'
    ],
    trida_urovne_emisi_hluku_a_d: [
      'trida_urovne_emisi_hluku',
      'trida_emisi_hluku_prenaseneho_vzduchem_a_d',
      'trida_akustickych_emisi',
      'trida_urovne_emisi_hluku_a__d',
      'trida_urovne_emisi_hluku_ad',
      'noise_emission_class'
    ],
   rozmery_v_x_s_x_h_v_mm: [
      'rozmery_s_x_v_x_h_v_mm',
      'rozmery_pristroje_s_x_v_x_h_v_mm',
      'rozmery_pristroje_v_x_s_x_h_v_mm'
    ],
    rozmery_pristroje_s_x_v_x_h_v_mm: [
      'rozmery_v_x_s_x_h_v_mm',
      'rozmery_s_x_v_x_h_v_mm',
      'rozmery_pristroje_v_x_s_x_h_v_mm'
    ],
    vazena_spotreba_el_energie_na_100_mycich_sarzi_v_programu_eco_no: [
      'vazena_spotreba_el_energie_na_100_cyklu',
      'vazena_spotreba_el_energie_na_100_cyklu_programu_eco_normal_v_kwh',
      'vazena_spotreba_elektricke_energie_na_100_cyklu_programu_eco_normal_v_kwh'
    ],
    emise_hluku_prenaseneho_vzduchem_ve_standardnim_programu_eco_nor: [
      'emise_hluku_prenaseneho_vzduchem',
      'emise_hluku_prenaseneho_vzduchem_v_db_a',
      'akusticke_emise_v_db_a'
    ],
    potencial_globalniho_oteplovani_chladiva_v_co_e: [
      'potencial_globalniho_oteplovani_chladiva_v_co2e'
    ],
    potencial_globalniho_oteplovani_pristroje_v_co_e: [
      'potencial_globalniho_oteplovani_pristroje_v_co2e'
    ],
    rocni_spotreba_energie_v_kwh_rok: [
      'rocni_spotreba_elektricke_energie_v_kwh_rok'
    ],
    cirkulace_nevedena_plug_and_play_instalace: [
      'cirkulace_nevedena_plug_and_play',
      'cirkulace_nevedena_plug_play_instalace',
      'cirkulace_nevedena_plug_play'
    ],
        sirka_zehliciho_valce_v_mm2: [
      'sirka_zehliciho_valce_v_mm'
    ],
    objem_zasobniku_na_vodu_v_l2: [
      'objem_zasobniku_na_vodu_v_l'
    ],
    icemaker_s_pripojenim_na_cerstvou_vodu: [
      'vyrobnik_ledu_s_pripojenim_na_cerstvou_vodu_icemaker',
      'icemaker_vyrobnik_ledu_s_pripojenim_na_cerstvou_vodu'
    ],
    elektronicka_regulace_vykonu: [
      'naslapna_tlacitka_plus_minus',
      '4stupnovy_otocny_volic',
      'bezdratove_ovladani_na_rukojeti',
      'tlacitko_mode'
    ],
    saci_trubice: [
      'saci_trubice_x_hes',
      'teleskopicka_trubice_easyslide',
      'teleskopicka_trubice_stredni_hes',
      'trubice_easylock'
    ],
    parkovaci_system_pro_uskladneni: [
      'z_obou_stran'
    ]
  };

  const targetCode = normalizeCompareCode(code);
  const candidateCodes = [targetCode].concat(compareValueCodeAliases[targetCode] || []);

  const foundKey = Object.keys(data).find(function(key) {
    const normalizedKey = normalizeCompareCode(key);

    return candidateCodes.some(function(candidateCode) {
      return normalizedKey === normalizeCompareCode(candidateCode);
    });
  });

  if (
    !foundKey ||
    data[foundKey] === undefined ||
    data[foundKey] === null ||
    String(data[foundKey]).trim() === ''
  ) {
    if (
      fieldKey === 'provedeni_hodnota' &&
      normalizeCompareCode(code) === 'typ_pristroje'
    ) {
      const directTypPristroje = getCompareItemValue(item, 'typ_pristroje');

      if (isFilledCompareValue(directTypPristroje)) {
        return directTypPristroje;
      }
    }

    return '—';
  }

  const foundKeyCode = normalizeCompareCode(foundKey);
  const compareValueLabels = {
    naslapna_tlacitka_plus_minus: 'Nášlapná tlačítka +/-',
    '4stupnovy_otocny_volic': '4stupňový otočný volič',
    bezdratove_ovladani_na_rukojeti: 'Bezdrátové ovládání na rukojeti',
    tlacitko_mode: 'Tlačítko MODE',
    saci_trubice_x_hes: 'Sací trubice X(HES)',
    teleskopicka_trubice_easyslide: 'Teleskopická trubice EasySlide',
    teleskopicka_trubice_stredni_hes: 'Teleskopická trubice střední, HES',
    trubice_easylock: 'Trubice EasyLock',
    z_obou_stran: 'Z obou stran'
  };

  if (
    normalizeCompareRawValue(data[foundKey]) === 'ano' &&
    compareValueLabels[foundKeyCode]
  ) {
    return compareValueLabels[foundKeyCode];
  }

  return data[foundKey];
}
function normalizeCompareCode(value) {
    return String(value ?? '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[–—]/g, '-')
      .replace(/&/g, ' and ')
      .replace(/\+/g, ' plus ')
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/ultra_phase/g, 'ultraphase')
      .replace(/perfect_clean/g, 'perfectclean')
      .replace(/brilliant_light/g, 'brilliantlight')
      .replace(/silence_drum/g, 'silencedrum')
      .replace(/flexi_clip/g, 'flexiclip')
      .replace(/s_povrchovou_upravou_/g, '')
      .replace(/s_upravou_/g, '')
      .replace(/dgg_ano00_40/g, 'dgg_100_40')
      .replace(/hfc_7ano/g, 'hfc_71')
      .replace(/sportovni_prado/g, 'sportovni_pradlo')
      .replace(/spojovaci_pojistka_pro_podlahovou_hubici_a_rukojeti/g, 'spojovaci_pojistka_pro_podlahovou_hubici_a_rukojet')
      .replace(/^([0-9]+)x_/g, '$1_x_')
      .replace(/vysuvne_pojezdy_flexiclip_perfectclean_hfc_71_par/g, 'vysuvne_pojezdy_flexiclip_perfectclean_hfc_71_par')
      .replace(/^_+|_+$/g, '');
  }
  function normalizeCompareAccessoryLabel(value) {
    return String(value ?? '')
      .replace(/DGG\s+ano00\s+40/gi, 'DGG 100 40')
      .replace(/HFC\s+7ano/gi, 'HFC 71');
  }

  function getCompareCodeList(value) {
    const raw = String(value ?? '').trim();

    if (!raw) return [];

    return raw
      .split(/[|,;\n]+/)
      .map(normalizeCompareCode)
      .filter(Boolean);
  }

function compareCodeListIncludes(value, code) {
    const targetCode = normalizeCompareCode(code);

    if (!targetCode) return false;

 return getCompareCodeList(value).some(function(itemCode) {
  return itemCode === targetCode || (targetCode.includes('_') && itemCode.endsWith('_' + targetCode));
});
  }
  function getCompareRawCodeList(value) {
  const raw = String(value ?? '').trim();

  if (!raw) return [];

  return raw
    .split(/[|,;\n]+/)
    .map(function(item) {
      return String(item || '').trim();
    })
    .filter(Boolean);
}

function getCompareLabelForCode(code, group) {
  const targetCode = normalizeCompareCode(code);
  const targetGroup = normalizeCompareCode(group);

  const match = (window.compareTooltipsRaw || []).find(function(item) {
    return (
      normalizeCompareCode(item.group) === targetGroup &&
      (
        normalizeCompareCode(item.code) === targetCode ||
        normalizeCompareCode(item.value) === targetCode
      )
    );
  });

  if (match) {
    return normalizeCompareAccessoryLabel(match.value || match.code || code);
  }

  return normalizeCompareAccessoryLabel(code)
    .replace(/_/g, ' ')
    .replace(/-/g, ' ');
}

function formatCompareCodeListLabels(value, group) {
  const items = getCompareRawCodeList(value);

  if (!items.length) return '—';

  return items
    .map(function(item) {
      return getCompareLabelForCode(item, group);
    })
    .filter(Boolean)
    .join(', ');
}
    function getCompareDynamicRows(group) {
    const targetGroup = normalizeCompareCode(group);
    const seen = {};

    return (window.compareTooltipsRaw || [])
      .filter(function(item) {
        return normalizeCompareCode(item.group) === targetGroup;
      })
      .map(function(item) {
 const label = normalizeCompareAccessoryLabel(item.value || item.code || '');
        const code = normalizeCompareCode(item.code || item.value);
        const order = Number(item.order);

      return {
  label: label,
  key: targetGroup,
  code: code,
  tooltipGroup: targetGroup,
  alwaysShow: targetGroup === 'dodavane_prislusenstvi',
  _order: isFinite(order) ? order : 9999
};
      })
      .filter(function(row) {
        const uniqueKey = normalizeCompareCode(row.code || row.key || row.label);

        if (!row.label || !uniqueKey || seen[uniqueKey]) return false;

        seen[uniqueKey] = true;
        return true;
      })
      .sort(function(a, b) {
        if (a._order !== b._order) return a._order - b._order;

        return String(a.label || '').localeCompare(String(b.label || ''), 'cs');
      });
  }
function getCompareDynamicRowsWithValue(group, valueKey) {
  return getCompareDynamicRows(group).map(function(row) {
    return {
      label: row.label,
      key: row.key,
      code: row.code,
      valueKey: valueKey,
      valueCode: row.code,
      tooltipGroup: row.tooltipGroup,
      alwaysShow: row.alwaysShow,
      _order: row._order
    };
  });
}
 function getCompareSchemaWithDynamicAccessoryRows(schema, compareCategory) {
    if (compareCategory === 'profesionalni_mycky') {
      return schema.filter(function(section) {
        return section.title !== 'DODÁVANÉ PŘÍSLUŠENSTVÍ';
      });
    }

 if (
  compareCategory === 'mycky' ||
  compareCategory === 'kavovary' ||
  compareCategory === 'vinoteky' ||
  compareCategory === 'chladnicky' ||
  compareCategory === 'mraznicky' ||
  compareCategory === 'varne_desky' ||
  compareCategory === 'odsavace' ||
  compareCategory === 'konvektomaty' ||
  compareCategory === 'pecici_trouby' ||
compareCategory === 'pracky' ||
compareCategory === 'pracky_se_susickou' ||
compareCategory === 'tycove_akumulatorove_vysavace' ||
compareCategory === 'sackove_vysavace' ||
compareCategory === 'bezsackove_vysavace' ||
compareCategory === 'zehlici_pristroje'
) {
  return schema;
}
    const dynamicAccessoryRows = getCompareDynamicRows('dodavane_prislusenstvi');

    if (!dynamicAccessoryRows.length) return schema;

    let hasAccessorySection = false;

    const mergedSchema = schema.map(function(section) {
      if (section.title !== 'DODÁVANÉ PŘÍSLUŠENSTVÍ') return section;

      hasAccessorySection = true;

      const seen = {};
      const rows = [];

      (section.rows || []).concat(dynamicAccessoryRows).forEach(function(row) {
        const uniqueKey = normalizeCompareCode(row.code || row.key || row.label);

        if (!uniqueKey || seen[uniqueKey]) return;

        seen[uniqueKey] = true;
        rows.push(row);
      });

      return {
        title: section.title,
        rows: rows
      };
    });

    if (hasAccessorySection) return mergedSchema;

    const accessorySection = {
      title: 'DODÁVANÉ PŘÍSLUŠENSTVÍ',
      rows: dynamicAccessoryRows
    };

    const languageSectionIndex = mergedSchema.findIndex(function(section) {
      return section.title === 'DOSTUPNÉ JAZYKY DISPLEJE';
    });

    if (languageSectionIndex === -1) {
      return mergedSchema.concat([accessorySection]);
    }

    return mergedSchema
      .slice(0, languageSectionIndex)
      .concat([accessorySection], mergedSchema.slice(languageSectionIndex));
  }

  function rowHasDifferences(values) {
    const normalizedValues = values.map(normalizeCompareRawValue);
    const firstValue = normalizedValues[0];

    return normalizedValues.some(function(value) {
      return value !== firstValue;
    });
  }
function getShowDifferencesOnly() {
  const count = getCompareItems().length;
  const previousCount = window.compareLastItemsCount;

  if (count <= 1) {
    window.compareShowDifferencesOnly = false;
  } else if (!previousCount || previousCount <= 1) {
    window.compareShowDifferencesOnly = true;
  } else if (typeof window.compareShowDifferencesOnly !== 'boolean') {
    window.compareShowDifferencesOnly = true;
  }

  window.compareLastItemsCount = count;
  return window.compareShowDifferencesOnly;
}

function setShowDifferencesOnly(value) {
  window.compareShowDifferencesOnly = !!value;
}

  async function fetchProductData(handle) {
    const response = await fetch('/products/' + handle + '.js');
    if (!response.ok) throw new Error('Nepodařilo se načíst produkt: ' + handle);
    return response.json();
  }

  function updateCompareCount() {
    const compareItems = getCompareItems();
    const count = compareItems.length;

    document.querySelectorAll('[data-compare-count]').forEach(function(el) {
      if (count > 0) {
        el.textContent = count > 99 ? '99+' : String(count);
        el.hidden = false;
        el.classList.remove('is-hidden');
      } else {
        el.textContent = '';
        el.hidden = true;
        el.classList.add('is-hidden');
      }
    });
  }

  function updateCompareButtons() {
    const compareItems = getCompareItems();

    document.querySelectorAll('[data-compare-product]').forEach(function(button) {
      const productId = String(button.dataset.productId);

      const exists = compareItems.some(function(item) {
        return String(item.id) === productId;
      });

      if (exists) {
        button.classList.add('is-added');
      } else {
        button.classList.remove('is-added');
      }
    });
  }

function buildCompareTop(products, items) {
    const compareTypeLabels = products.map(function(product, index) {
      const item = items[index] || {};

      let type = getCompareItemValue(item, 'typ_pristroje');

      if (!isFilledCompareValue(type)) {
        type =
          item.product_type ||
          item.type ||
          product.product_type ||
          product.type ||
          '';
      }

      const source = normalizeCompareCode(
        [
          item.title,
          item.handle,
          product.title,
          product.handle
        ].filter(Boolean).join(' ')
      );

      // VARNÉ DESKY – rozlišení výrazně odlišných typů
      if (source.includes('plynova_varna_deska')) {
        return 'Plynová varná deska';
      }

      if (
        source.includes('indukcni_varna_deska') &&
        (
          source.includes('odsavacem') ||
          source.includes('odsavac')
        )
      ) {
        return 'Indukční varná deska s odsavačem';
      }

      if (source.includes('indukcni_varna_deska')) {
        return 'Indukční varná deska';
      }

      if (source.includes('elektricka_varna_deska')) {
        return 'Elektrická varná deska';
      }

      return isFilledCompareValue(type) ? String(type).trim() : '';
    });

    const uniqueCompareTypes = compareTypeLabels
      .filter(Boolean)
      .filter(function(type, index, array) {
        return array.findIndex(function(otherType) {
          return normalizeCompareCode(otherType) === normalizeCompareCode(type);
        }) === index;
      });

    const compareTypeWarning =
      uniqueCompareTypes.length > 1
        ? `
          <p style="
            margin: 10px 0 0;
            max-width: 330px;
            font-size: 12px;
            line-height: 1.4;
            color: #8C0014;
          ">
            Upozornění: porovnáváte rozdílné typy nebo provedení produktů.
            Některé parametry proto nemusí být přímo srovnatelné.
          </p>
        `
        : '';

    const intro = `
      <div class="compare-page__intro">
        <button type="button" class="compare-page__clear-all" data-compare-clear>
          <span class="compare-page__clear-all-icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16 16" fill="none">
              <path d="M2.5 4H13.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
              <path d="M6 2.5H10" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
              <path d="M5 5.5V11.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
              <path d="M8 5.5V11.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
              <path d="M11 5.5V11.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
              <path d="M3.5 4L4 12.5C4.05 13.3 4.7 13.9 5.5 13.9H10.5C11.3 13.9 11.95 13.3 12 12.5L12.5 4" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
            </svg>
          </span>
          <span>Odstranit vše</span>
        </button>

        <h2 class="compare-page__intro-title">Porovnání modelů</h2>
        <p class="compare-page__intro-text">Můžete porovnat až 3 produkty</p>
${compareTypeWarning}
      </div>
    `;

const itemsHtml = products.map(function(product, index) {
  const compareItem = items[index] || {};
  const productUrl = compareItem.url || ('/products/' + product.handle);

  return `
    <article class="compare-page__product">
      <button
        type="button"
        class="compare-page__remove-top"
        data-compare-remove
        data-product-id="${escapeHtml(product.id)}"
        aria-label="Odebrat ${escapeHtml(product.title)}"
      >
        ×
      </button>

      <a
        href="${escapeHtml(productUrl)}"
        class="compare-page__product-link"
        aria-label="Přejít na detail produktu ${escapeHtml(product.title)}"
      >
        <div class="compare-page__image-wrap">
          ${product.featured_image ? `<img class="compare-page__image" src="${escapeHtml(product.featured_image)}" alt="${escapeHtml(product.title)}">` : ''}
        </div>

        <h3 class="compare-page__name">${escapeHtml(product.title)}</h3>
      </a>
    </article>
  `;
}).join('');

return intro + itemsHtml;
  }

  function buildCompareControls() {
    const showDifferencesOnly = getShowDifferencesOnly();

    return `
      <div class="compare-page__top-toggle">
        <label class="compare-page__switch">
          <span class="compare-page__switch-label">Zobrazit jen rozdíly</span>
          <input type="checkbox" data-compare-differences-toggle ${showDifferencesOnly ? 'checked' : ''}>
          <span class="compare-page__switch-slider"></span>
        </label>
      </div>
    `;
  }
    function getCompareCategory(items, products) {
  if (!items || !items.length) return 'pracky';

  const firstItem = items[0] || {};
  const firstProduct = products && products[0] ? products[0] : {};

 const categorySource = [
    firstItem.compare_category,
    firstItem.category,
    firstItem.product_type,
    firstItem.type,
    firstItem.kategorie_pristroju,
    firstItem.custom_kategorie_pristroju,
    firstItem['custom.kategorie_pristroju'],
    firstItem.provedeni,
    firstItem.provedeni_a_design,
    firstItem.design,
    firstItem.design_hodnoty,
    firstItem.custom_design_hodnoty,
    firstItem['custom.design_hodnoty'],
    firstItem.url,
    firstItem.handle,
    firstItem.title,
    firstProduct.product_type,
    firstProduct.type,
    firstProduct.handle,
    firstProduct.title,
    Array.isArray(firstProduct.tags) ? firstProduct.tags.join(' ') : firstProduct.tags
  ].filter(Boolean).join(' ');

  const rawCategory = String(categorySource || '').trim().toLowerCase();
  const normalizedCategory = normalizeCompareCode(rawCategory);

  function categoryMatches() {
    return Array.prototype.slice.call(arguments).some(function(term) {
      const normalizedTerm = normalizeCompareCode(term);
      return normalizedCategory === normalizedTerm || normalizedCategory.includes(normalizedTerm);
    });
  }
  if (
    categoryMatches(
      'zehlici_pristroje',
      'zehlici_pristroj',
      'zehlici_systemy',
      'zehlici_system',
      'zehlici_lisy',
      'zehlici_lis',
      'mandly',
      'mandl',
      'mandl_zehlici',
      'fashionmaster',
      'zehleni'
    ) ||
    /(^|_)b_?(990|995|3312|4312|4826|4847)(_|$)/.test(normalizedCategory) ||
    normalizedCategory.includes('barva_zehlicky') ||
    normalizedCategory.includes('barva_zehliciho_potahu')
  ) {
    return 'zehlici_pristroje';
  }
  if (categoryMatches('bezsackove_vysavace', 'bezsackovy_vysavac', 'bezsackovy_podlahovy_vysavac')) {
    return 'bezsackove_vysavace';
  }

  if (
    categoryMatches('sackove_vysavace', 'sackovy_vysavac', 'sackovy_podlahovy_vysavac') &&
    !categoryMatches('bezsackove_vysavace', 'bezsackovy_vysavac', 'bezsackovy_podlahovy_vysavac')
  ) {
    return 'sackove_vysavace';
  }
  if (categoryMatches('tycove_akumulatorove_vysavace', 'tycovy_akumulatorovy_vysavac', 'akumulatorovy_vysavac')) {
    return 'tycove_akumulatorove_vysavace';
  }

if (categoryMatches('pracky_se_susickou', 'pracka_se_susickou')) {
  return 'pracky_se_susickou';
}

if (
  categoryMatches(
    'pracky',
    'pracka',
    'pracky_pradla',
    'pracka_pradla',
    'automaticke_pracky',
    'automaticka_pracka',
    'pracka_s_prednim_plnenim',
    'pracka_s_hornim_plnenim'
  )
) {
  return 'pracky';
}

if (categoryMatches('susicky', 'susicka', 'susicky_pradla')) {
  return 'susicky';
}
if (
  categoryMatches(
    'zehlici_pristroje',
    'zehlici_pristroj',
    'zehlici_systemy',
    'zehlici_system',
    'zehlici_lisy',
    'zehlici_lis',
    'mandly',
    'mandl',
    'fashionmaster'
  )
) {
  return 'zehlici_pristroje';
}
  if (categoryMatches('konvektomaty', 'konvektomat', 'parni_trouby', 'parni_trouba', 'parni_trouby_a_konvektomaty')) {
    return 'konvektomaty';
  }

  if (categoryMatches('pecici_trouby', 'pecici_trouba')) {
    return 'pecici_trouby';
  }

  if (categoryMatches('mikrovlnne_trouby', 'mikrovlnna_trouba')) {
    return 'mikrovlnne_trouby';
  }
if (
  categoryMatches(
    'varne_desky',
    'varna_deska',
    'varne_desky_a_smartline',
    'indukcni_varna_deska',
    'indukcni_varne_desky',
    'plynova_varna_deska',
    'plynove_varne_desky'
  ) ||
  normalizedCategory.includes('kmda') ||
  /(^|_)km_[0-9]/.test(normalizedCategory)
) {
  return 'varne_desky';
}
  if (categoryMatches('odsavace', 'odsavac', 'odsavace_par', 'odsavac_par', 'digestore', 'digestor')) {
    return 'odsavace';
  }
  if (
    categoryMatches(
      'vinoteky',
      'vinoteka',
      'vinoteky',
      'temperujici_vinoteka',
      'temperujici_vinoteky',
      'chladnicky_na_vino',
      'chladnicka_na_vino',
      'wine_cooler',
      'wine_coolers'
    ) ||
    normalizedCategory.includes('kwt')
  ) {
    return 'vinoteky';
  }

  if (
    categoryMatches(
      'chladnicky',
      'chladnicka',
      'kombinace_chladnicky_s_mraznickou',
      'kombinovana_chladnicka',
      'kombinovana_chladnicka_s_mraznickou',
      'kombinace_chladnicky_s_mrazakem',
      'chladici_skrin',
      'chladici_skrine',
      'refrigerator',
      'refrigerators'
    ) ||
    normalizedCategory.includes('ks_') ||
    normalizedCategory.includes('kfn_') ||
    normalizedCategory.includes('kdn_') ||
    /(^|_)k_[0-9]/.test(normalizedCategory)
  ) {
    return 'chladnicky';
  }

  if (
    categoryMatches(
      'mraznicky',
      'mraznicka',
      'mrazici_skrin',
      'mrazici_skrine',
      'freezer',
      'freezers'
    ) ||
    (
      !normalizedCategory.includes('kfn_') &&
      !normalizedCategory.includes('kdn_') &&
      (
        normalizedCategory.includes('fn_') ||
        normalizedCategory.includes('fns_')
      )
    )
  ) {
    return 'mraznicky';
  }
  if (categoryMatches('profesionalni_mycky', 'profesionalni_mycka', 'profi_mycky', 'profi_mycka', 'profesionalni')) {
    return 'profesionalni_mycky';
  }

  if (categoryMatches('mycky', 'mycka', 'mycky_nadobi', 'mycka_nadobi', 'mycky_na_nadobi', 'mycka_na_nadobi')) {
    return 'mycky';
  }

  if (
    categoryMatches('kavovary', 'kavovar', 'volne_stojici_kavovary', 'volne_stojici_kavovar', 'automaticke_kavovary', 'automaticky_kavovar', 'coffee', 'cva') ||
    /(^|_)cm_[0-9]/.test(normalizedCategory)
  ) {
    return 'kavovary';
  }

  return 'pracky';
}

  const PARNI_TECHNOLOGIE_PRIVOD_VODY_SECTION = {
    title: 'PARNÍ TECHNOLOGIE A PŘÍVOD VODY',
    rows: [
      { label: 'Nasávací trubička k jímání vody', key: 'parni_technologie_privod_vody', code: 'nasavaci_trubicka_k_jimani_vody', tooltipGroup: 'parni_technologie_privod_vody', alwaysShow: true },
      { label: 'DualSteam', key: 'parni_technologie_privod_vody', code: 'dualsteam', tooltipGroup: 'parni_technologie_privod_vody', alwaysShow: true },
      { label: 'Vyjmutí zásobníku na čerstvou vodu', key: 'parni_technologie_privod_vody', code: 'vyjmuti_zasobniku_na_cerstvou_vodu', tooltipGroup: 'parni_technologie_privod_vody', alwaysShow: true },
      { label: 'DirectWater', key: 'parni_technologie_privod_vody', code: 'directwater', tooltipGroup: 'parni_technologie_privod_vody', alwaysShow: true },
      { label: 'MonoSteam', key: 'parni_technologie_privod_vody', code: 'monosteam', tooltipGroup: 'parni_technologie_privod_vody', alwaysShow: true },
      { label: 'Zásobník na čerstvou vodu za výsuvným panelem', key: 'parni_technologie_privod_vody', code: 'zasobnik_na_cerstvou_vodu_za_vysuvnym_panelem', tooltipGroup: 'parni_technologie_privod_vody', alwaysShow: true },
      { label: 'Nádoba na kondenzát za výsuvným panelem', key: 'parni_technologie_privod_vody', code: 'nadoba_na_kondenzat_za_vysuvnym_panelem', tooltipGroup: 'parni_technologie_privod_vody', alwaysShow: true },
      { label: 'Odpadní sítko', key: 'parni_technologie_privod_vody', code: 'odpadni_sitko', tooltipGroup: 'parni_technologie_privod_vody', alwaysShow: true },
      { label: 'DirectWater plus', key: 'parni_technologie_privod_vody', code: 'directwater_plus', tooltipGroup: 'parni_technologie_privod_vody', alwaysShow: true },
      { label: 'Vyjmutí zásobníku na čerstvou vodu pomocí mechanismu Push2Release', key: 'parni_technologie_privod_vody', code: 'vyjmuti_zasobniku_na_cerstvou_vodu_pomoci_mechanismu_push2release', tooltipGroup: 'parni_technologie_privod_vody', alwaysShow: true },
      { label: 'Objem zásobníku na čerstvou vodu v l', key: 'parni_technologie_privod_vody', code: 'objem_zasobniku_na_cerstvou_vodu_v_l', valueKey: 'parni_technologie_privod_vody_hodnoty', valueCode: 'objem_zasobniku_na_cerstvou_vodu_v_l', valueOnly: true, tooltipGroup: 'parni_technologie_privod_vody', alwaysShow: true },
      { label: 'Výkon vyvíječe páry v kW', key: 'parni_technologie_privod_vody', code: 'vykon_vyvijece_pary_v_kw', valueKey: 'parni_technologie_privod_vody_hodnoty', valueCode: 'vykon_vyvijece_pary_v_kw', valueOnly: true, tooltipGroup: 'parni_technologie_privod_vody', alwaysShow: true }
    ]
  };
  const COMPARE_SCHEMAS = {
    vinoteky: [
  {
    title: "VŠEOBECNÉ ÚDAJE",
    rows: [
      { label: "Číslo EAN", key: "cislo_ean", alwaysShow: true },
      { label: "Marketingová třída", key: "marketingova_trida", alwaysShow: true },
      { label: "Typ přístroje", key: "typ_pristroje", alwaysShow: true }
    ]
  },
  {
    title: "PROVEDENÍ",
    rows: [
      { label: "Volně stojící přístroj", key: "provedeni", code: "volne_stojici_pristroj", valueKey: "provedeni_hodnota", valueCode: "volne_stojici_pristroj", tooltipGroup: "provedeni", alwaysShow: true },
      { label: "Vestavný přístroj", key: "provedeni", code: "vestavny_pristroj", valueKey: "provedeni_hodnota", valueCode: "vestavny_pristroj", tooltipGroup: "provedeni", alwaysShow: true },
      { label: "Integrovaný vestavný přístroj", key: "provedeni", code: "integrovany_vestavny_pristroj", valueKey: "provedeni_hodnota", valueCode: "integrovany_vestavny_pristroj", tooltipGroup: "provedeni", alwaysShow: true },
      { label: "Podstavný přístroj", key: "provedeni", code: "podstavny_pristroj", valueKey: "provedeni_hodnota", valueCode: "podstavny_pristroj", tooltipGroup: "provedeni", alwaysShow: true },
      { label: "Závěs dvířek", key: "provedeni", code: "zaves_dvirek", valueKey: "provedeni_hodnota", valueCode: "zaves_dvirek", tooltipGroup: "provedeni", alwaysShow: true },
      { label: "Závěs dvířek měnitelný", key: "provedeni", code: "zaves_dvirek_menitelny", valueKey: "provedeni_hodnota", valueCode: "zaves_dvirek_menitelny", tooltipGroup: "provedeni", alwaysShow: true },
      { label: "Možnost kombinace Side-by-Side", key: "provedeni", code: "moznost_kombinace_side_by_side", valueKey: "provedeni_hodnota", valueCode: "moznost_kombinace_side_by_side", tooltipGroup: "provedeni", alwaysShow: true }
    ]
  },
  {
    title: "DESIGN",
    rows: [
      { label: "Barva opláštění", key: "design", code: "barva_oplasteni", valueKey: "design_hodnoty", valueCode: "barva_oplasteni", tooltipGroup: "design", alwaysShow: true },
      { label: "Barva čelní stěny", key: "design", code: "barva_celni_steny", valueKey: "design_hodnoty", valueCode: "barva_celni_steny", tooltipGroup: "design", alwaysShow: true },
      { label: "Osvětlení zóny pro víno", key: "design", code: "osvetleni_zony_pro_vino", valueKey: "design_hodnoty", valueCode: "osvetleni_zony_pro_vino", tooltipGroup: "design", alwaysShow: true },
      { label: "UV ochrana vína", key: "design", code: "uv_ochrana_vina", valueKey: "design_hodnoty", valueCode: "uv_ochrana_vina", tooltipGroup: "design", alwaysShow: true },
      { label: "Osvětlení mrazicí zóny", key: "design", code: "osvetleni_mrazici_zony", valueKey: "design_hodnoty", valueCode: "osvetleni_mrazici_zony", tooltipGroup: "design", alwaysShow: true },
      { label: "Osvětlení IceMakeru", key: "design", code: "osvetleni_icemakeru", valueKey: "design_hodnoty", valueCode: "osvetleni_icemakeru", tooltipGroup: "design", alwaysShow: true }
    ]
  },
  {
    title: "ŘÍDICÍ JEDNOTKA",
    rows: [
      { label: "Koncepce ovládání", key: "ridici_jednotka", code: "koncepce_ovladani", valueKey: "ridici_jednotka_hodnoty", valueCode: "koncepce_ovladani", tooltipGroup: "ridici_jednotka", alwaysShow: true },
      { label: "Počet teplotních zón celkem", key: "ridici_jednotka", code: "pocet_teplotnich_zon_celkem", valueKey: "ridici_jednotka_hodnoty", valueCode: "pocet_teplotnich_zon_celkem", tooltipGroup: "ridici_jednotka", alwaysShow: true },
      { label: "Počet teplotních zón pro víno", key: "ridici_jednotka", code: "pocet_teplotnich_zon_pro_vino", valueKey: "ridici_jednotka_hodnoty", valueCode: "pocet_teplotnich_zon_pro_vino", tooltipGroup: "ridici_jednotka", alwaysShow: true },
      { label: "Minimálně nastavitelný rozsah teplot ve °C", key: "ridici_jednotka", code: "minimalne_nastavitelny_rozsah_teplot_ve_c", valueKey: "ridici_jednotka_hodnoty", valueCode: "minimalne_nastavitelny_rozsah_teplot_ve_c", tooltipGroup: "ridici_jednotka", alwaysShow: true },
      { label: "Maximálně nastavitelný rozsah teplot ve °C", key: "ridici_jednotka", code: "maximalne_nastavitelny_rozsah_teplot_ve_c", valueKey: "ridici_jednotka_hodnoty", valueCode: "maximalne_nastavitelny_rozsah_teplot_ve_c", tooltipGroup: "ridici_jednotka", alwaysShow: true },
      { label: "Režim sabat", key: "ridici_jednotka", code: "rezim_sabat", valueKey: "ridici_jednotka_hodnoty", valueCode: "rezim_sabat", emptyAsNo: true, tooltipGroup: "ridici_jednotka", alwaysShow: true },
      { label: "Možnost vypnout chladicí část", key: "ridici_jednotka", code: "moznost_vypnout_chladici_cast", valueKey: "ridici_jednotka_hodnoty", valueCode: "moznost_vypnout_chladici_cast", emptyAsNo: true, tooltipGroup: "ridici_jednotka", alwaysShow: true },
      { label: "Nezávislá regulace teploty chladicí a mrazicí zóny", key: "ridici_jednotka", code: "nezavisla_regulace_teploty_chladici_a_mrazici_zony", valueKey: "ridici_jednotka_hodnoty", valueCode: "nezavisla_regulace_teploty_chladici_a_mrazici_zony", emptyAsNo: true, tooltipGroup: "ridici_jednotka", alwaysShow: true },
      { label: "Supermražení", key: "ridici_jednotka", code: "supermrazeni", valueKey: "ridici_jednotka_hodnoty", valueCode: "supermrazeni", emptyAsNo: true, tooltipGroup: "ridici_jednotka", alwaysShow: true }
    ]
  },
  {
    title: "KOMFORT PŘI OBSLUZE",
    rows: [
      { label: "Propojení s Miele@home", key: "komfort_pri_obsluze", code: "propojeni_s_miele_home", valueKey: "komfort_pri_obsluze_hodnoty", valueCode: "propojeni_s_miele_home", emptyAsNo: true, tooltipGroup: "komfort_pri_obsluze", alwaysShow: true },
      { label: "Snadné otvírání dvířek", key: "komfort_pri_obsluze", code: "snadne_otvirani_dvirek", valueKey: "komfort_pri_obsluze_hodnoty", valueCode: "snadne_otvirani_dvirek", tooltipGroup: "komfort_pri_obsluze", alwaysShow: true },
      { label: "ActiveHumidity", key: "komfort_pri_obsluze", code: "activehumidity", valueKey: "komfort_pri_obsluze_hodnoty", valueCode: "activehumidity", emptyAsNo: true, tooltipGroup: "komfort_pri_obsluze", alwaysShow: true },
      { label: "DynaCool", key: "komfort_pri_obsluze", code: "dynacool", valueKey: "komfort_pri_obsluze_hodnoty", valueCode: "dynacool", emptyAsNo: true, tooltipGroup: "komfort_pri_obsluze", alwaysShow: true },
      { label: "Filtr Active AirClean", key: "komfort_pri_obsluze", code: "filtr_active_airclean", valueKey: "komfort_pri_obsluze_hodnoty", valueCode: "filtr_active_airclean", emptyAsNo: true, tooltipGroup: "komfort_pri_obsluze", alwaysShow: true },
      { label: "SoftClose", key: "komfort_pri_obsluze", code: "softclose", valueKey: "komfort_pri_obsluze_hodnoty", valueCode: "softclose", emptyAsNo: true, tooltipGroup: "komfort_pri_obsluze", alwaysShow: true },
      { label: "Systém Silence", key: "komfort_pri_obsluze", code: "system_silence", valueKey: "komfort_pri_obsluze_hodnoty", valueCode: "system_silence", emptyAsNo: true, tooltipGroup: "komfort_pri_obsluze", alwaysShow: true },
      { label: "NoFrost", key: "komfort_pri_obsluze", code: "nofrost", valueKey: "komfort_pri_obsluze_hodnoty", valueCode: "nofrost", emptyAsNo: true, tooltipGroup: "komfort_pri_obsluze", alwaysShow: true },
      { label: "VarioRoom", key: "komfort_pri_obsluze", code: "varioroom", valueKey: "komfort_pri_obsluze_hodnoty", valueCode: "varioroom", emptyAsNo: true, tooltipGroup: "komfort_pri_obsluze", alwaysShow: true },
      { label: "Výrobník ledu s připojením na čerstvou vodu (IceMaker)", key: "komfort_pri_obsluze", code: "vyrobnik_ledu_s_pripojenim_na_cerstvou_vodu_icemaker", valueKey: "komfort_pri_obsluze_hodnoty", valueCode: "vyrobnik_ledu_s_pripojenim_na_cerstvou_vodu_icemaker", emptyAsNo: true, tooltipGroup: "komfort_pri_obsluze", alwaysShow: true },
      { label: "Celkový počet roštů", key: "komfort_pri_obsluze", code: "celkovy_pocet_rostu", valueKey: "komfort_pri_obsluze_hodnoty", valueCode: "celkovy_pocet_rostu", tooltipGroup: "komfort_pri_obsluze", alwaysShow: true },
      { label: "Počet roštů", key: "komfort_pri_obsluze", code: "pocet_rostu", valueKey: "komfort_pri_obsluze_hodnoty", valueCode: "pocet_rostu", tooltipGroup: "komfort_pri_obsluze", alwaysShow: true },
      { label: "Materiál roštů", key: "komfort_pri_obsluze", code: "material_rostu", valueKey: "komfort_pri_obsluze_hodnoty", valueCode: "material_rostu", tooltipGroup: "komfort_pri_obsluze", alwaysShow: true },
      { label: "Počet roštů FlexiFrame", key: "komfort_pri_obsluze", code: "pocet_rostu_flexiframe", valueKey: "komfort_pri_obsluze_hodnoty", valueCode: "pocet_rostu_flexiframe", tooltipGroup: "komfort_pri_obsluze", alwaysShow: true },
      { label: "Počet roštů FlexiFrame Plus", key: "komfort_pri_obsluze", code: "pocet_rostu_flexiframe_plus", valueKey: "komfort_pri_obsluze_hodnoty", valueCode: "pocet_rostu_flexiframe_plus", tooltipGroup: "komfort_pri_obsluze", alwaysShow: true },
      { label: "Počet roštů pro ukládání napříč", key: "komfort_pri_obsluze", code: "pocet_rostu_pro_ukladani_napric", valueKey: "komfort_pri_obsluze_hodnoty", valueCode: "pocet_rostu_pro_ukladani_napric", tooltipGroup: "komfort_pri_obsluze", alwaysShow: true },
      { label: "SelfClose FlexiFrame", key: "komfort_pri_obsluze", code: "selfclose_flexiframe", valueKey: "komfort_pri_obsluze_hodnoty", valueCode: "selfclose_flexiframe", emptyAsNo: true, tooltipGroup: "komfort_pri_obsluze", alwaysShow: true },
      { label: "SommelierSet", key: "komfort_pri_obsluze", code: "sommelierset", valueKey: "komfort_pri_obsluze_hodnoty", valueCode: "sommelierset", emptyAsNo: true, tooltipGroup: "komfort_pri_obsluze", alwaysShow: true },
      { label: "NoteBoard", key: "komfort_pri_obsluze", code: "noteboard", valueKey: "komfort_pri_obsluze_hodnoty", valueCode: "noteboard", emptyAsNo: true, tooltipGroup: "komfort_pri_obsluze", alwaysShow: true },
      { label: "Prezentér lahví", key: "komfort_pri_obsluze", code: "prezenter_lahvi", valueKey: "komfort_pri_obsluze_hodnoty", valueCode: "prezenter_lahvi", emptyAsNo: true, tooltipGroup: "komfort_pri_obsluze", alwaysShow: true },
      { label: "PresenterFrame", key: "komfort_pri_obsluze", code: "presenterframe", valueKey: "komfort_pri_obsluze_hodnoty", valueCode: "presenterframe", emptyAsNo: true, tooltipGroup: "komfort_pri_obsluze", alwaysShow: true },
      { label: "3D prezentační rošt", key: "komfort_pri_obsluze", code: "3d_prezentacni_rost", valueKey: "komfort_pri_obsluze_hodnoty", valueCode: "3d_prezentacni_rost", emptyAsNo: true, tooltipGroup: "komfort_pri_obsluze", alwaysShow: true },
      { label: "Uložení s minimálními vibracemi", key: "komfort_pri_obsluze", code: "ulozeni_s_minimalnimi_vibracemi", valueKey: "komfort_pri_obsluze_hodnoty", valueCode: "ulozeni_s_minimalnimi_vibracemi", emptyAsNo: true, tooltipGroup: "komfort_pri_obsluze", alwaysShow: true },
      { label: "Závěsy MaxLoad", key: "komfort_pri_obsluze", code: "zavesy_maxload", valueKey: "komfort_pri_obsluze_hodnoty", valueCode: "zavesy_maxload", emptyAsNo: true, tooltipGroup: "komfort_pri_obsluze", alwaysShow: true },
      { label: "Potřebné příslušenství k dokoupení", key: "komfort_pri_obsluze", code: "potrebne_prislusenstvi_k_dokoupeni", valueKey: "komfort_pri_obsluze_hodnoty", valueCode: "potrebne_prislusenstvi_k_dokoupeni", valueOnly: true, tooltipGroup: "komfort_pri_obsluze", alwaysShow: true }
    ]
  },
  {
    title: "HOSPODÁRNOST A UDRŽITELNOST",
    rows: [
      { label: "Třída energetické účinnosti (A–G)", key: "hospodarnost_a_udrzitelnost", code: "trida_energeticke_ucinnosti_a_g", valueKey: "hospodarnost_a_udrzitelnost_hodnoty", valueCode: "trida_energeticke_ucinnosti_a_g", tooltipGroup: "hospodarnost_a_udrzitelnost", alwaysShow: true },
      { label: "Roční spotřeba energie v kWh", key: "hospodarnost_a_udrzitelnost", code: "rocni_spotreba_energie_v_kwh", valueKey: "hospodarnost_a_udrzitelnost_hodnoty", valueCode: "rocni_spotreba_energie_v_kwh", tooltipGroup: "hospodarnost_a_udrzitelnost", alwaysShow: true },
      { label: "Spotřeba energie za 24 h v kWh", key: "hospodarnost_a_udrzitelnost", code: "spotreba_energie_za_24_h_v_kwh", valueKey: "hospodarnost_a_udrzitelnost_hodnoty", valueCode: "spotreba_energie_za_24_h_v_kwh", tooltipGroup: "hospodarnost_a_udrzitelnost", alwaysShow: true }
    ]
  },
  {
    title: "CHLADICÍ ZÓNA",
    rows: [
      { label: "Suchá zadní stěna", key: "chladici_zona", code: "sucha_zadni_stena", valueKey: "chladici_zona_hodnoty", valueCode: "sucha_zadni_stena", tooltipGroup: "chladici_zona", alwaysShow: true }
    ]
  },
  {
    title: "MRAZICÍ ZÓNA",
    rows: [
      { label: "Počet mrazicích zásuvek", key: "mrazici_zona", code: "pocet_mrazicich_zasuvek", valueKey: "mrazici_zona_hodnoty", valueCode: "pocet_mrazicich_zasuvek", tooltipGroup: "mrazici_zona", alwaysShow: true }
    ]
  },
  {
    title: "BEZPEČNOST",
    rows: [
      { label: "Blokovací funkce", key: "bezpecnost", code: "blokovaci_funkce", tooltipGroup: "bezpecnost", alwaysShow: true },
      { label: "Zámek dvířek", key: "bezpecnost", code: "zamek_dvirek", tooltipGroup: "bezpecnost", alwaysShow: true },
      { label: "Akustický alarm při otevřených dvířkách", key: "bezpecnost", code: "akusticky_alarm_pri_otevrenych_dvirkach", tooltipGroup: "bezpecnost", alwaysShow: true },
      { label: "Akustický alarm při změně teploty", key: "bezpecnost", code: "akusticky_alarm_pri_zmene_teploty", tooltipGroup: "bezpecnost", alwaysShow: true },
      { label: "Akustický alarm při změně teploty v mrazicí části", key: "bezpecnost", code: "akusticky_alarm_pri_zmene_teploty_v_mrazici_casti", tooltipGroup: "bezpecnost", alwaysShow: true },
      { label: "Optický alarm při otevřených dvířkách", key: "bezpecnost", code: "opticky_alarm_pri_otevrenych_dvirkach", tooltipGroup: "bezpecnost", alwaysShow: true },
      { label: "Optický alarm při změně teploty", key: "bezpecnost", code: "opticky_alarm_pri_zmene_teploty", tooltipGroup: "bezpecnost", alwaysShow: true },
      { label: "Indikace výpadku proudu v zóně pro víno", key: "bezpecnost", code: "indikace_vypadku_proudu_v_zone_pro_vino", tooltipGroup: "bezpecnost", alwaysShow: true }
    ]
  },
  {
    title: "TECHNICKÉ ÚDAJE",
    rows: [
      { label: "Minimální šířka výklenku v mm", key: "technicke_udaje", code: "minimalni_sirka_vyklenku_v_mm", valueKey: "technicke_udaje_hodnota", valueCode: "minimalni_sirka_vyklenku_v_mm", tooltipGroup: "technicke_udaje", alwaysShow: true },
      { label: "Maximální šířka výklenku v mm", key: "technicke_udaje", code: "maximalni_sirka_vyklenku_v_mm", valueKey: "technicke_udaje_hodnota", valueCode: "maximalni_sirka_vyklenku_v_mm", tooltipGroup: "technicke_udaje", alwaysShow: true },
      { label: "Minimální výška výklenku v mm", key: "technicke_udaje", code: "minimalni_vyska_vyklenku_v_mm", valueKey: "technicke_udaje_hodnota", valueCode: "minimalni_vyska_vyklenku_v_mm", tooltipGroup: "technicke_udaje", alwaysShow: true },
      { label: "Maximální výška výklenku v mm", key: "technicke_udaje", code: "maximalni_vyska_vyklenku_v_mm", valueKey: "technicke_udaje_hodnota", valueCode: "maximalni_vyska_vyklenku_v_mm", tooltipGroup: "technicke_udaje", alwaysShow: true },
      { label: "Hloubka výklenku v mm", key: "technicke_udaje", code: "hloubka_vyklenku_v_mm", valueKey: "technicke_udaje_hodnota", valueCode: "hloubka_vyklenku_v_mm", tooltipGroup: "technicke_udaje", alwaysShow: true },
      { label: "Šířka přístroje v mm", key: "technicke_udaje", code: "sirka_pristroje_v_mm", valueKey: "technicke_udaje_hodnota", valueCode: "sirka_pristroje_v_mm", valueOnly: true, tooltipGroup: "technicke_udaje", alwaysShow: true },
      { label: "Výška přístroje v mm", key: "technicke_udaje", code: "vyska_pristroje_v_mm", valueKey: "technicke_udaje_hodnota", valueCode: "vyska_pristroje_v_mm", tooltipGroup: "technicke_udaje", alwaysShow: true },
      { label: "Hloubka přístroje v mm", key: "technicke_udaje", code: "hloubka_pristroje_v_mm", valueKey: "technicke_udaje_hodnota", valueCode: "hloubka_pristroje_v_mm", tooltipGroup: "technicke_udaje", alwaysShow: true },
      { label: "Hmotnost v kg", key: "technicke_udaje", code: "hmotnost_v_kg", valueKey: "technicke_udaje_hodnota", valueCode: "hmotnost_v_kg", tooltipGroup: "technicke_udaje", alwaysShow: true },
      { label: "Upevňovací technika", key: "technicke_udaje", code: "upevnovaci_technika", valueKey: "technicke_udaje_hodnota", valueCode: "upevnovaci_technika", tooltipGroup: "technicke_udaje", alwaysShow: true },
      { label: "Maximální zatížení čelní strany dvířek chladicí části v kg", key: "technicke_udaje", code: "maximalni_zatizeni_celni_strany_dvirek_chladici_casti_v_kg", valueKey: "technicke_udaje_hodnota", valueCode: "maximalni_zatizeni_celni_strany_dvirek_chladici_casti_v_kg", tooltipGroup: "technicke_udaje", alwaysShow: true },
      { label: "Klimatická třída", key: "technicke_udaje", code: "klimaticka_trida", valueKey: "technicke_udaje_hodnota", valueCode: "klimaticka_trida", tooltipGroup: "technicke_udaje", alwaysShow: true },
      { label: "4hvězdičková mrazicí zóna v l", key: "technicke_udaje", code: "4hvezdickova_mrazici_zona_v_l", valueKey: "technicke_udaje_hodnota", valueCode: "4hvezdickova_mrazici_zona_v_l", tooltipGroup: "technicke_udaje", alwaysShow: true },
      { label: "Chladicí zóna v l", key: "technicke_udaje", code: "chladici_zona_v_l", valueKey: "technicke_udaje_hodnota", valueCode: "chladici_zona_v_l", tooltipGroup: "technicke_udaje", alwaysShow: true },
      { label: "Zóna pro víno v litrech", key: "technicke_udaje", code: "zona_pro_vino_v_litrech", valueKey: "technicke_udaje_hodnota", valueCode: "zona_pro_vino_v_litrech", tooltipGroup: "technicke_udaje", alwaysShow: true },
      { label: "Celkový užitný objem v l", key: "technicke_udaje", code: "celkovy_uzitny_objem_v_l", valueKey: "technicke_udaje_hodnota", valueCode: "celkovy_uzitny_objem_v_l", tooltipGroup: "technicke_udaje", alwaysShow: true },
      { label: "Počet lahví na víno o objemu 0,75 l", key: "technicke_udaje", code: "pocet_lahvi_na_vino_o_objemu_0_75_l", valueKey: "technicke_udaje_hodnota", valueCode: "pocet_lahvi_na_vino_o_objemu_0_75_l", tooltipGroup: "technicke_udaje", alwaysShow: true },
      { label: "Doba skladování při poruše v h", key: "technicke_udaje", code: "doba_skladovani_pri_poruse_v_h", valueKey: "technicke_udaje_hodnota", valueCode: "doba_skladovani_pri_poruse_v_h", tooltipGroup: "technicke_udaje", alwaysShow: true },
      { label: "Kapacita mražení v kg/24 h", key: "technicke_udaje", code: "kapacita_mrazeni_v_kg_24_h", valueKey: "technicke_udaje_hodnota", valueCode: "kapacita_mrazeni_v_kg_24_h", tooltipGroup: "technicke_udaje", alwaysShow: true },
      { label: "Třída úrovně emisí hluku (A–D)", key: "hospodarnost_a_udrzitelnost", code: "trida_urovne_emisi_hluku_a_d", valueKey: "hospodarnost_a_udrzitelnost_hodnoty", valueCode: "trida_urovne_emisi_hluku_a_d", tooltipGroup: "hospodarnost_a_udrzitelnost", alwaysShow: true },
      { label: "Úroveň emisí hluku v dB(A) re 1 pW", key: "technicke_udaje", code: "uroven_emisi_hluku_v_db_a_re_1_pw", valueKey: "technicke_udaje_hodnota", valueCode: "uroven_emisi_hluku_v_db_a_re_1_pw", tooltipGroup: "technicke_udaje", alwaysShow: true },
      { label: "Spotřeba energie v miliampérech (mA)", key: "technicke_udaje", code: "spotreba_energie_v_miliamperech_ma", valueKey: "technicke_udaje_hodnota", valueCode: "spotreba_energie_v_miliamperech_ma", tooltipGroup: "technicke_udaje", alwaysShow: true },
      { label: "Napětí ve V", key: "technicke_udaje", code: "napeti_ve_v", valueKey: "technicke_udaje_hodnota", valueCode: "napeti_ve_v", tooltipGroup: "technicke_udaje", alwaysShow: true },
      { label: "Jištění v A", key: "technicke_udaje", code: "jisteni_v_a", valueKey: "technicke_udaje_hodnota", valueCode: "jisteni_v_a", tooltipGroup: "technicke_udaje", alwaysShow: true },
      { label: "Počet fází", key: "technicke_udaje", code: "pocet_fazi", valueKey: "technicke_udaje_hodnota", valueCode: "pocet_fazi", tooltipGroup: "technicke_udaje", alwaysShow: true },
      { label: "Frekvence v Hz", key: "technicke_udaje", code: "frekvence_v_hz", valueKey: "technicke_udaje_hodnota", valueCode: "frekvence_v_hz", tooltipGroup: "technicke_udaje", alwaysShow: true },
      { label: "Délka elektrického přívodního kabelu v m", key: "technicke_udaje", code: "delka_elektrickeho_privodniho_kabelu_v_m", valueKey: "technicke_udaje_hodnota", valueCode: "delka_elektrickeho_privodniho_kabelu_v_m", tooltipGroup: "technicke_udaje", alwaysShow: true }
    ]
  },
  {
    title: "DODÁVANÉ PŘÍSLUŠENSTVÍ",
    rows: [
      { label: "Bílá křídová tužka", key: "dodavane_prislusenstvi", code: "bila_kridova_tuzka", tooltipGroup: "dodavane_prislusenstvi", alwaysShow: true },
      { label: "Vodní filtr", key: "dodavane_prislusenstvi", code: "vodni_filtr", tooltipGroup: "dodavane_prislusenstvi", alwaysShow: true }
    ]
  },
  {
    title: "DOSTUPNÉ JAZYKY DISPLEJE",
    rows: [
      { label: "Dostupné jazyky displeje díky MultiLingua", key: "dostupne_jazyky_displeje_diky_multilingua", alwaysShow: true }
    ]
  }
],
    pecici_trouby: [
      {
        title: 'VŠEOBECNÉ ÚDAJE',
        rows: [
          { label: 'Marketingová třída', key: 'vseobecne_udaje', code: 'marketingova_trida', valueKey: 'vseobecne_udaje_hodnoty', valueCode: 'marketingova_trida', valueOnly: true, tooltipGroup: 'vseobecne_udaje', alwaysShow: true }
        ]
      },
      {
        title: 'PROVEDENÍ A DESIGN',
        rows: [
          { label: 'Vestavná pečicí trouba', key: 'provedeni', code: 'vestavna_pecici_trouba', tooltipGroup: 'provedeni', alwaysShow: true },
          { label: 'Barva přístroje', key: 'provedeni', code: 'barva_pristroje', valueKey: 'provedeni_hodnota', valueCode: 'barva_pristroje', valueOnly: true, tooltipGroup: 'provedeni', alwaysShow: true },
          { label: 'BlackLine', key: 'provedeni', code: 'blackline', tooltipGroup: 'provedeni', alwaysShow: true },
          { label: 'PureLine', key: 'provedeni', code: 'pureline', tooltipGroup: 'provedeni', alwaysShow: true },
          { label: 'VitroLine', key: 'provedeni', code: 'vitroline', tooltipGroup: 'provedeni', alwaysShow: true },
          { label: 'Zápustné otočné voliče', key: 'provedeni', code: 'zapustne_otocne_volice', tooltipGroup: 'provedeni', alwaysShow: true },
          { label: 'Vestavná pečicí trouba s mikrovlnou', key: 'provedeni', code: 'vestavna_pecici_trouba_s_mikrovlnou', tooltipGroup: 'provedeni', alwaysShow: true },
          { label: 'ContourLine', key: 'provedeni', code: 'contourline', tooltipGroup: 'provedeni', alwaysShow: true },
          { label: 'ArtLine', key: 'provedeni', code: 'artline', tooltipGroup: 'provedeni', alwaysShow: true },
          { label: 'Bez rukojeti', key: 'provedeni', code: 'bez_rukojeti', tooltipGroup: 'provedeni', alwaysShow: true }
        ]
      },
      {
        title: 'UŽIVATELSKÉ VÝHODY',
        rows: [
          { label: 'Rychloohřev', key: 'uzivatelske_vyhody', code: 'rychloohrev', tooltipGroup: 'uzivatelske_vyhody' },
          { label: 'Quick & Gentle', key: 'uzivatelske_vyhody', code: 'quick_gentle', tooltipGroup: 'uzivatelske_vyhody' },
          { label: 'Udržování teploty', key: 'uzivatelske_vyhody', code: 'udrzovani_teploty', tooltipGroup: 'uzivatelske_vyhody' },
          { label: 'Pokrmový teploměr', key: 'uzivatelske_vyhody', code: 'pokrmovy_teplomer', tooltipGroup: 'uzivatelske_vyhody' },
          { label: 'TasteControl', key: 'uzivatelske_vyhody', code: 'taste_control', tooltipGroup: 'uzivatelske_vyhody' },
          { label: 'Předehřátí', key: 'uzivatelske_vyhody', code: 'predehrati', tooltipGroup: 'uzivatelske_vyhody' },
          { label: 'Funkce Crisp', key: 'uzivatelske_vyhody', code: 'funkce_crisp', tooltipGroup: 'uzivatelske_vyhody' },
          { label: 'Motoricky otočný grilovací špíz', key: 'uzivatelske_vyhody', code: 'motoricky_otocny_grilovaci_spiz', tooltipGroup: 'uzivatelske_vyhody' }
        ]
      },
{
  title: 'PARNÍ TECHNOLOGIE A PŘÍVOD VODY',
  rows: [
    { label: 'Výkon vyvíječe páry v kW', key: 'parni_technologie_privod_vody', code: 'vykon_vyvijece_pary_v_kw', valueKey: 'parni_technologie_privod_vody_hodnoty', valueCode: 'vykon_vyvijece_pary_v_kw', valueOnly: true, tooltipGroup: 'parni_technologie_privod_vody', alwaysShow: true },
    { label: 'Objem zásobníku na čerstvou vodu v l', key: 'parni_technologie_privod_vody', code: 'objem_zasobniku_na_cerstvou_vodu_v_l', valueKey: 'parni_technologie_privod_vody_hodnoty', valueCode: 'objem_zasobniku_na_cerstvou_vodu_v_l', valueOnly: true, tooltipGroup: 'parni_technologie_privod_vody', alwaysShow: true },
    { label: 'Nasávací trubička k jímání vody', key: 'parni_technologie_privod_vody', code: 'nasavaci_trubicka_k_jimani_vody', tooltipGroup: 'parni_technologie_privod_vody', alwaysShow: true }
  ]
},
            {
        title: 'PROVOZNÍ ZPŮSOBY',
        rows: [
          { label: 'Horký vzduch plus', key: 'provozni_zpusoby', code: 'horky_vzduch_plus', tooltipGroup: 'provozni_zpusoby' },
          { label: 'Intenzivní pečení', key: 'provozni_zpusoby', code: 'intenzivni_peceni', tooltipGroup: 'provozni_zpusoby' },
          { label: 'Horní/spodní pečení', key: 'provozni_zpusoby', code: 'horni_spodni_peceni', tooltipGroup: 'provozni_zpusoby' },
          { label: 'Spodní pečení', key: 'provozni_zpusoby', code: 'spodni_peceni', tooltipGroup: 'provozni_zpusoby' },
          { label: 'Grilování s cirkulací', key: 'provozni_zpusoby', code: 'grilovani_s_cirkulaci', tooltipGroup: 'provozni_zpusoby' },
          { label: 'AirFry', key: 'provozni_zpusoby', code: 'airfry', tooltipGroup: 'provozni_zpusoby' },
          { label: 'Gril', key: 'provozni_zpusoby', code: 'gril', tooltipGroup: 'provozni_zpusoby' },
          { label: 'Horký vzduch Eco', key: 'provozni_zpusoby', code: 'horky_vzduch_eco', tooltipGroup: 'provozni_zpusoby' },
          { label: 'Automatické programy', key: 'provozni_zpusoby', code: 'automaticke_programy', tooltipGroup: 'provozni_zpusoby' },
          { label: 'Rozmrazování', key: 'provozni_zpusoby', code: 'rozmrazovani', tooltipGroup: 'provozni_zpusoby' },
          { label: 'Pečicí automatika', key: 'provozni_zpusoby', code: 'pecici_automatika', tooltipGroup: 'provozni_zpusoby' },
          { label: 'Mikrovlna', key: 'provozni_zpusoby', code: 'mikrovlna', tooltipGroup: 'provozni_zpusoby' },
          { label: 'Mikrovlna s grilem', key: 'provozni_zpusoby', code: 'mikrovlna_s_grilem', tooltipGroup: 'provozni_zpusoby' },
          { label: 'Mikrovlna s horkým vzduchem plus', key: 'provozni_zpusoby', code: 'mikrovlna_s_horkym_vzduchem_plus', tooltipGroup: 'provozni_zpusoby' },
          { label: 'Mikrovlna s grilováním s cirkulací', key: 'provozni_zpusoby', code: 'mikrovlna_s_grilovanim_s_cirkulaci', tooltipGroup: 'provozni_zpusoby' },
          { label: 'Mikrovlna s pečicí automatikou', key: 'provozni_zpusoby', code: 'mikrovlna_s_pecici_automatikou', tooltipGroup: 'provozni_zpusoby' },
          { label: 'Klimatické pečení s horkým vzduchem plus', key: 'provozni_zpusoby', code: 'klimaticke_peceni_s_horkym_vzduchem_plus', tooltipGroup: 'provozni_zpusoby' },
          { label: 'Klimatické pečení', key: 'provozni_zpusoby', code: 'klimaticke_peceni', tooltipGroup: 'provozni_zpusoby' },
          { label: 'Klimatické pečení s pečicí automatikou', key: 'provozni_zpusoby', code: 'klimaticke_peceni_s_pecici_automatikou', tooltipGroup: 'provozni_zpusoby' },
          { label: 'Klimatické pečení s intenzivním pečením', key: 'provozni_zpusoby', code: 'klimaticke_peceni_s_intenzivnim_pecenim', tooltipGroup: 'provozni_zpusoby' },
          { label: 'Klimatické pečení s horním/spodním pečením', key: 'provozni_zpusoby', code: 'klimaticke_peceni_s_hornim_spodnim_pecenim', tooltipGroup: 'provozni_zpusoby' },
          { label: 'Specifické národní automatické programy', key: 'provozni_zpusoby', code: 'specificke_narodni_automaticke_programy', tooltipGroup: 'provozni_zpusoby' },
          { label: 'Speciální použití', key: 'provozni_zpusoby', code: 'specialni_pouziti', tooltipGroup: 'provozni_zpusoby' },
          { label: 'Malý gril', key: 'provozni_zpusoby', code: 'maly_gril', tooltipGroup: 'provozni_zpusoby' },
          { label: 'Příprava při nízké teplotě', key: 'provozni_zpusoby', code: 'priprava_pri_nizke_teplote', tooltipGroup: 'provozni_zpusoby' },
          { label: 'Horní pečení', key: 'provozni_zpusoby', code: 'horni_peceni', tooltipGroup: 'provozni_zpusoby' }
        ]
      },
{
  title: 'KOMFORT PŘI OBSLUZE',
  rows: [
    { label: 'Propojení s Miele@home', key: 'komfort_pri_obsluze', code: 'propojeni_s_miele_home', tooltipGroup: 'komfort_pri_obsluze' },
    { label: 'Displej', key: 'komfort_pri_obsluze', code: 'displej', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'displej', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
    { label: 'MultiLingua', key: 'komfort_pri_obsluze', code: 'multilingua', tooltipGroup: 'komfort_pri_obsluze' },
    { label: 'Zobrazení denního času', key: 'komfort_pri_obsluze', code: 'zobrazeni_denniho_casu', tooltipGroup: 'komfort_pri_obsluze' },
    { label: 'Kuchyňský budík', key: 'komfort_pri_obsluze', code: 'kuchynsky_budik', tooltipGroup: 'komfort_pri_obsluze' },
    { label: 'Programování začátku přípravy', key: 'komfort_pri_obsluze', code: 'programovani_zacatku_pripravy', tooltipGroup: 'komfort_pri_obsluze' },
    { label: 'Programování konce přípravy', key: 'komfort_pri_obsluze', code: 'programovani_konce_pripravy', tooltipGroup: 'komfort_pri_obsluze' },
    { label: 'Nastavení délky přípravy', key: 'komfort_pri_obsluze', code: 'nastaveni_delky_pripravy', tooltipGroup: 'komfort_pri_obsluze' },
    { label: 'Ukazatel aktuální teploty', key: 'komfort_pri_obsluze', code: 'ukazatel_aktualni_teploty', tooltipGroup: 'komfort_pri_obsluze' },
    { label: 'Ukazatel požadované teploty', key: 'komfort_pri_obsluze', code: 'ukazatel_pozadovane_teploty', tooltipGroup: 'komfort_pri_obsluze' },
    { label: 'Signální tón při dosažení požadované teploty', key: 'komfort_pri_obsluze', code: 'signalni_ton_pri_dosazeni_pozadovane_teploty', tooltipGroup: 'komfort_pri_obsluze' },
    { label: 'Navrhovaná teplota', key: 'komfort_pri_obsluze', code: 'navrhovana_teplota', tooltipGroup: 'komfort_pri_obsluze' },
    { label: 'Individuální nastavení', key: 'komfort_pri_obsluze', code: 'individualni_nastaveni', tooltipGroup: 'komfort_pri_obsluze' },
    { label: 'SoftOpen', key: 'komfort_pri_obsluze', code: 'softopen', tooltipGroup: 'komfort_pri_obsluze' },
    { label: 'SoftClose', key: 'komfort_pri_obsluze', code: 'softclose', tooltipGroup: 'komfort_pri_obsluze' },
    { label: 'Funkce 3 v 1', key: 'komfort_pri_obsluze', code: 'funkce_3_v_1', tooltipGroup: 'komfort_pri_obsluze' },
    { label: 'Funkce Popcorn', key: 'komfort_pri_obsluze', code: 'funkce_popcorn', tooltipGroup: 'komfort_pri_obsluze' },
    { label: 'Synchronizace času', key: 'komfort_pri_obsluze', code: 'synchronizace_casu', tooltipGroup: 'komfort_pri_obsluze' },
    { label: 'Návrh výkonu mikrovlny', key: 'komfort_pri_obsluze', code: 'navrh_vykonu_mikrovlny', tooltipGroup: 'komfort_pri_obsluze' },
    { label: 'Quick mikrovlna', key: 'komfort_pri_obsluze', code: 'quick_mikrovlna', tooltipGroup: 'komfort_pri_obsluze' },
    { label: 'Časově programovatelné dávky páry', key: 'komfort_pri_obsluze', code: 'casove_programovatelne_davky_pary', tooltipGroup: 'komfort_pri_obsluze' },
    { label: 'Zobrazení data', key: 'komfort_pri_obsluze', code: 'zobrazeni_data', tooltipGroup: 'komfort_pri_obsluze' },
    { label: 'Vlastní programy', key: 'komfort_pri_obsluze', code: 'vlastni_programy', tooltipGroup: 'komfort_pri_obsluze' },
    { label: 'Touch2Open', key: 'komfort_pri_obsluze', code: 'touch2open', tooltipGroup: 'komfort_pri_obsluze' },
    { label: 'MyMiele', key: 'komfort_pri_obsluze', code: 'mymiele', tooltipGroup: 'komfort_pri_obsluze' },
    { label: 'Funkce nápovědy', key: 'komfort_pri_obsluze', code: 'funkce_napovedy', tooltipGroup: 'komfort_pri_obsluze' },
    { label: 'Program Sabat', key: 'komfort_pri_obsluze', code: 'program_sabat', tooltipGroup: 'komfort_pri_obsluze' },
    { label: 'Snímač pohybu MotionReact', key: 'komfort_pri_obsluze', code: 'snimac_pohybu_motionreact', tooltipGroup: 'komfort_pri_obsluze' },
    { label: 'Polyfonní signální tóny', key: 'komfort_pri_obsluze', code: 'polyfonni_signalni_tony', tooltipGroup: 'komfort_pri_obsluze' },
    { label: 'Kamera v ohřevném prostoru', key: 'komfort_pri_obsluze', code: 'kamera_v_ohrevnem_prostoru', tooltipGroup: 'komfort_pri_obsluze' },
    { label: '3D ovládací panel', key: 'komfort_pri_obsluze', code: '3d_ovladaci_panel', tooltipGroup: 'komfort_pri_obsluze' }
  ]
},
{
  title: 'KOMFORT PŘI ÚDRŽBĚ',
  rows: [
    { label: 'Emailovaný ohřevný prostor s úpravou PerfectClean a katalytickou zadní stěnou', key: 'komfort_pri_udrzbe', code: 'emailovany_ohrevny_prostor_perfectclean_katalyticka_zadni_stena', tooltipGroup: 'komfort_pri_udrzbe' },
    { label: 'Dvířka CleanGlass', key: 'komfort_pri_udrzbe', code: 'dvirka_cleanglass', tooltipGroup: 'komfort_pri_udrzbe' },
    { label: 'Pyrolytické samočištění', key: 'komfort_pri_udrzbe', code: 'pyrolyticke_samocisteni', tooltipGroup: 'komfort_pri_udrzbe' },
    { label: 'Nerezový povrch/CleanSteel', key: 'komfort_pri_udrzbe', code: 'nerezovy_povrch_cleansteel', tooltipGroup: 'komfort_pri_udrzbe' },
    { label: 'Sklopné grilovací těleso', key: 'komfort_pri_udrzbe', code: 'sklopne_grilovaci_teleso', tooltipGroup: 'komfort_pri_udrzbe' },
    { label: 'Nerezový ohřevný prostor se lněnou strukturou a úpravou PerfectClean', key: 'komfort_pri_udrzbe', code: 'nerezovy_ohrevny_prostor_se_lnenou_strukturou_a_upravou_perfectclean', tooltipGroup: 'komfort_pri_udrzbe' },
    { label: 'Katalyzátor', key: 'komfort_pri_udrzbe', code: 'katalyzator', tooltipGroup: 'komfort_pri_udrzbe' }
  ]
},
{
  title: 'BEZPEČNOST',
  rows: [
    { label: 'Systém chlazení přístroje s vlažnou čelní stěnou', key: 'bezpecnost', code: 'system_chlazeni_pristroje_s_vlaznou_celni_stenou', tooltipGroup: 'bezpecnost' },
    { label: 'Bezpečnostní vypínání', key: 'bezpecnost', code: 'bezpecnostni_vypinani', tooltipGroup: 'bezpecnost' },
    { label: 'Zablokování zprovoznění', key: 'bezpecnost', code: 'zablokovani_zprovozneni', tooltipGroup: 'bezpecnost' },
    { label: 'Zablokování dvířek během pyrolýzy', key: 'bezpecnost', code: 'zablokovani_dvirek_behem_pyrolyzy', tooltipGroup: 'bezpecnost' },
    { label: 'Zablokování tlačítek', key: 'bezpecnost', code: 'zablokovani_tlacitek', tooltipGroup: 'bezpecnost' }
  ]
},

{
    title: 'HOSPODÁRNOST A UDRŽITELNOST',
    rows: [
      { label: 'Třída energetické účinnosti (A+++ – D)', key: 'hospodarnost_a_udrzitelnost', code: 'trida_energeticke_ucinnosti_a_d', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'trida_energeticke_ucinnosti_a_d', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Příkon ve vypnutém stavu ve W', key: 'hospodarnost_a_udrzitelnost', code: 'prikon_ve_vypnutem_stavu_ve_w', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'prikon_ve_vypnutem_stavu_ve_w', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Příkon v pohotovostním režimu ve W', key: 'hospodarnost_a_udrzitelnost', code: 'prikon_v_pohotovostnim_rezimu_ve_w', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'prikon_v_pohotovostnim_rezimu_ve_w', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Příkon v síťovém pohotovostním režimu ve W', key: 'hospodarnost_a_udrzitelnost', code: 'prikon_v_sitovem_pohotovostnim_rezimu_ve_w', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'prikon_v_sitovem_pohotovostnim_rezimu_ve_w', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Čas do automatického zapnutí z pohotovostního režimu v min', key: 'hospodarnost_a_udrzitelnost', code: 'cas_do_automatickeho_zapnuti_z_pohotovostniho_rezimu_v_min', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'cas_do_automatickeho_zapnuti_z_pohotovostniho_rezimu_v_min', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Čas do automatického zapnutí ze síťového pohotovostního režimu v min', key: 'hospodarnost_a_udrzitelnost', code: 'cas_do_automatickeho_zapnuti_ze_sitoveho_pohotovostniho_rezimu_v_min', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'cas_do_automatickeho_zapnuti_ze_sitoveho_pohotovostniho_rezimu_v_min', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Čas do automatického zapnutí z vypnutého stavu v min', key: 'hospodarnost_a_udrzitelnost', code: 'cas_do_automatickeho_zapnuti_z_vypnuteho_stavu_v_min', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'cas_do_automatickeho_zapnuti_z_vypnuteho_stavu_v_min', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Využití zbytkového tepla', key: 'hospodarnost_a_udrzitelnost', code: 'vyuziti_zbytkoveho_tepla', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'vyuziti_zbytkoveho_tepla', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Automatické využití zbytkového tepla', key: 'hospodarnost_a_udrzitelnost', code: 'automaticke_vyuziti_zbytkoveho_tepla', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'automaticke_vyuziti_zbytkoveho_tepla', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true }
    ]
  },
{
  title: 'TECHNICKÉ ÚDAJE',
  rows: [
    { label: 'Objem ohřevného prostoru v l', key: 'technicke_udaje', code: 'objem_ohrevneho_prostoru_v_l', valueKey: 'technicke_udaje_hodnota', valueCode: 'objem_ohrevneho_prostoru_v_l', tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Závěs dvířek', key: 'technicke_udaje', code: 'zaves_dvirek', valueKey: 'technicke_udaje_hodnota', valueCode: 'zaves_dvirek', tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Počet úrovní zasunutí', key: 'technicke_udaje', code: 'pocet_urovni_zasunuti', valueKey: 'technicke_udaje_hodnota', valueCode: 'pocet_urovni_zasunuti', tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Označení úrovní zasunutí', key: 'technicke_udaje', code: 'oznaceni_urovni_zasunuti', valueKey: 'technicke_udaje_hodnota', valueCode: 'oznaceni_urovni_zasunuti', tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Osvětlení ohřevného prostoru', key: 'technicke_udaje', code: 'osvetleni_ohrevneho_prostoru', valueKey: 'technicke_udaje_hodnota', valueCode: 'osvetleni_ohrevneho_prostoru', tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Typ zásuvky', key: 'technicke_udaje', code: 'typ_zasuvky', valueKey: 'technicke_udaje_hodnota', valueCode: 'typ_zasuvky', tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Minimální šířka výklenku v mm', key: 'technicke_udaje', code: 'minimalni_sirka_vyklenku_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'minimalni_sirka_vyklenku_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Maximální šířka výklenku v mm', key: 'technicke_udaje', code: 'maximalni_sirka_vyklenku_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'maximalni_sirka_vyklenku_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Minimální výška výklenku v mm', key: 'technicke_udaje', code: 'minimalni_vyska_vyklenku_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'minimalni_vyska_vyklenku_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Maximální výška výklenku v mm', key: 'technicke_udaje', code: 'maximalni_vyska_vyklenku_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'maximalni_vyska_vyklenku_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Hloubka výklenku v mm', key: 'technicke_udaje', code: 'hloubka_vyklenku_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'hloubka_vyklenku_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Hmotnost v kg', key: 'technicke_udaje', code: 'hmotnost_v_kg', valueKey: 'technicke_udaje_hodnota', valueCode: 'hmotnost_v_kg', tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Celkový příkon v kW', key: 'technicke_udaje', code: 'celkovy_prikon_v_kw', valueKey: 'technicke_udaje_hodnota', valueCode: 'celkovy_prikon_v_kw', tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Délka elektrického přívodního kabelu v m', key: 'technicke_udaje', code: 'delka_elektrickeho_privodniho_kabelu_v_m', valueKey: 'technicke_udaje_hodnota', valueCode: 'delka_elektrickeho_privodniho_kabelu_v_m', tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Napětí ve V', key: 'technicke_udaje', code: 'napeti_ve_v', valueKey: 'technicke_udaje_hodnota', valueCode: 'napeti_ve_v', tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Frekvence v Hz', key: 'technicke_udaje', code: 'frekvence_v_hz', valueKey: 'technicke_udaje_hodnota', valueCode: 'frekvence_v_hz', tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Jištění v A', key: 'technicke_udaje', code: 'jisteni_v_a', valueKey: 'technicke_udaje_hodnota', valueCode: 'jisteni_v_a', tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Počet fází', key: 'technicke_udaje', code: 'pocet_fazi', valueKey: 'technicke_udaje_hodnota', valueCode: 'pocet_fazi', tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Připojovací kabel se zástrčkou', key: 'technicke_udaje', code: 'pripojovaci_kabel_se_zastrckou', valueKey: 'technicke_udaje_hodnota', valueCode: 'pripojovaci_kabel_se_zastrckou', tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Výměna svítidel', key: 'technicke_udaje', code: 'vymena_svitidel', valueKey: 'technicke_udaje_hodnota', valueCode: 'vymena_svitidel', tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Počet úrovní zasunutí, ohřevný prostor 1', key: 'technicke_udaje', code: 'pocet_urovni_zasunuti_ohrevny_prostor_1', valueKey: 'technicke_udaje_hodnota', valueCode: 'pocet_urovni_zasunuti_ohrevny_prostor_1', tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Počet úrovní zasunutí, ohřevný prostor 2', key: 'technicke_udaje', code: 'pocet_urovni_zasunuti_ohrevny_prostor_2', valueKey: 'technicke_udaje_hodnota', valueCode: 'pocet_urovni_zasunuti_ohrevny_prostor_2', tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Teploty ve °C', key: 'technicke_udaje', code: 'teploty_ve_c', valueKey: 'technicke_udaje_hodnota', valueCode: 'teploty_ve_c', tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Minimální teploty ve °C', key: 'technicke_udaje', code: 'minimalni_teploty_ve_c', valueKey: 'technicke_udaje_hodnota', valueCode: 'minimalni_teploty_ve_c', tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Maximální teploty ve °C', key: 'technicke_udaje', code: 'maximalni_teploty_ve_c', valueKey: 'technicke_udaje_hodnota', valueCode: 'maximalni_teploty_ve_c', tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Šířka přístroje v mm', key: 'technicke_udaje', code: 'sirka_pristroje_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'sirka_pristroje_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Výška přístroje v mm', key: 'technicke_udaje', code: 'vyska_pristroje_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'vyska_pristroje_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Hloubka přístroje v mm', key: 'technicke_udaje', code: 'hloubka_pristroje_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'hloubka_pristroje_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Elektronicky řízený výkon mikrovlny', key: 'technicke_udaje', code: 'elektronicky_rizeny_vykon_mikrovlny', valueKey: 'technicke_udaje_hodnota', valueCode: 'elektronicky_rizeny_vykon_mikrovlny', tooltipGroup: 'technicke_udaje', alwaysShow: true }
  ]
},
{
  title: 'DODÁVANÉ PŘÍSLUŠENSTVÍ',
  rows: [
    { label: 'Pečicí rošt', key: 'dodavane_prislusenstvi', code: 'pecici_rost', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
    { label: 'Vyjímatelné postranní mřížky (pár)', key: 'dodavane_prislusenstvi', code: 'vyjimatelne_postranni_mrizky_par', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
    { label: 'Pečicí plech s úpravou PerfectClean HBB 71', key: 'dodavane_prislusenstvi', code: 'pecici_plech_s_upravou_perfectclean_hbb_71', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
    { label: 'Výsuvné pojezdy FlexiClip HFC 70-C (pár)', key: 'dodavane_prislusenstvi', code: 'vysuvne_pojezdy_flexiclip_hfc_70_c_par', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
    { label: 'Děrovaný pečicí plech AirFry Gourmet s úpravou PerfectClean HBBL 71', key: 'dodavane_prislusenstvi', code: 'derovany_pecici_plech_airfry_gourmet_s_upravou_perfectclean_hbbl_71', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
    { label: 'Voucher na grilovací a pečicí plech s úpravou PerfectClean HGBB71', key: 'dodavane_prislusenstvi', code: 'voucher_na_grilovaci_a_pecici_plech_s_upravou_perfectclean_hgbb71', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
    { label: 'Voucher na kámen na pečení a pizzu Gourmet HBS 70', key: 'dodavane_prislusenstvi', code: 'voucher_na_kamen_na_peceni_a_pizzu_gourmet_hbs_70', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
    { label: 'Pečicí rošt s úpravou PerfectClean', key: 'dodavane_prislusenstvi', code: 'pecici_rost_s_upravou_perfectclean', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
    { label: 'Skleněná miska', key: 'dodavane_prislusenstvi', code: 'sklenena_miska', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
    { label: 'Výsuvné pojezdy FlexiClip s PerfectClean HFC 71', key: 'dodavane_prislusenstvi', code: 'vysuvne_pojezdy_flexiclip_s_perfectclean_hfc_71', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
    { label: 'Vyjímatelné postranní mřížky s úpravou PerfectClean (pár)', key: 'dodavane_prislusenstvi', code: 'vyjimatelne_postranni_mrizky_s_upravou_perfectclean_par', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
    { label: 'Odvápňovací tablety', key: 'dodavane_prislusenstvi', code: 'odvapnovaci_tablety', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
    { label: 'Pečicí rošt s úpravou PyroFit', key: 'dodavane_prislusenstvi', code: 'pecici_rost_s_upravou_pyrofit', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
    { label: 'Výsuvné pojezdy FlexiClip s úpravou PyroFit (pár)', key: 'dodavane_prislusenstvi', code: 'vysuvne_pojezdy_flexiclip_s_upravou_pyrofit_par', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
    { label: 'Vyjímatelné postranní mřížky s úpravou PyroFit (pár)', key: 'dodavane_prislusenstvi', code: 'vyjimatelne_postranni_mrizky_s_upravou_pyrofit_par', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
    { label: 'Poukaz na pekáč Gourmet vhodný na indukci HUB 5001-M', key: 'dodavane_prislusenstvi', code: 'poukaz_na_pekac_gourmet_vhodny_na_indukci_hub_5001_m', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
    { label: 'Kabelový pokrmový teploměr', key: 'dodavane_prislusenstvi', code: 'kabelovy_pokrmovy_teplomer', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
    { label: 'Bezdrátový pokrmový teploměr', key: 'dodavane_prislusenstvi', code: 'bezdratovy_pokrmovy_teplomer', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
    { label: 'Univerzální plech s úpravou PerfectClean', key: 'dodavane_prislusenstvi', code: 'univerzalni_plech_s_upravou_perfectclean', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
    { label: 'Grilovací a pečicí plech s úpravou PerfectClean', key: 'dodavane_prislusenstvi', code: 'grilovaci_a_pecici_plech_s_upravou_perfectclean', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true }
  ]
},
{
  title: 'DOSTUPNÉ JAZYKY DISPLEJE',
  rows: [
    { label: 'Dostupné jazyky displeje díky MultiLingua', key: 'dostupne_jazyky_displeje_diky_multilingua' }
  ]
}
    ],
    pracky: [
      {
        title: 'PROVEDENÍ',
        rows: [
          { label: 'Možnost věžového uspořádání', key: 'provedeni', code: 'moznost_vezoveho_usporadani' },
          { label: 'Závěs dvířek vpravo', key: 'provedeni', code: 'zaves_dvirek_vpravo' },
          { label: 'Side-by-side', key: 'provedeni', code: 'side_by_side' },
          { label: 'Podsuvné provedení', key: 'provedeni', code: 'podsuvna' },
          { label: 'Možnost podstavby', key: 'provedeni', code: 'podstavna' }
        ]
      },
    {
  title: 'KONSTRUKCE',
  rows: [
    { label: 'Označení přístroje', key: 'oznaceni_pristroje' },
    { label: 'Pračka s předním plněním', key: 'konstrukce', code: 'pracka_s_prednim_plnenim' }
  ]
},
      {
        title: 'ODSTŘEĎOVÁNÍ',
        rows: [
          { label: 'Maximální počet otáček', key: 'maximalni_pocet_otacek' },
          { label: 'Konec máchání', key: 'odstredovani', code: 'konec_machani' },
          { label: 'Funkce bez odstřeďování', key: 'odstredovani', code: 'funkce_bez_odstredovani' }
        ]
      },
      {
        title: 'DESIGN',
        rows: [
          { label: 'Barva přístroje', key: 'design', code: 'barva_pristroje', valueKey: 'design_hodnoty', valueCode: 'barva_pristroje', valueOnly: true, tooltipGroup: 'design', alwaysShow: true },
          { label: 'Barva ovládacího panelu', key: 'design', code: 'barva_ovladaciho_panelu', valueKey: 'design_hodnoty', valueCode: 'barva_ovladaciho_panelu', valueOnly: true, tooltipGroup: 'design', alwaysShow: true },
          { label: 'Design dvířek', key: 'design', code: 'design_dvirek', valueKey: 'design_hodnoty', valueCode: 'design_dvirek', valueOnly: true, tooltipGroup: 'design', alwaysShow: true },
          { label: 'Barva otočného voliče', key: 'design', code: 'barva_otocneho_volice', valueKey: 'design_hodnoty', valueCode: 'barva_otocneho_volice', valueOnly: true, tooltipGroup: 'design', alwaysShow: true },
          { label: 'Design dvířek a ovládacích panelů', key: 'design', code: 'design_dvirek_a_ovladacich_panelu', valueKey: 'design_hodnoty', valueCode: 'design_dvirek_a_ovladacich_panelu', valueOnly: true, tooltipGroup: 'design', alwaysShow: true },
          { label: 'Provedení ovládacího panelu', key: 'design', code: 'provedeni_ovladaciho_panelu', valueKey: 'design_hodnoty', valueCode: 'provedeni_ovladaciho_panelu', valueOnly: true, tooltipGroup: 'design', alwaysShow: true },
          { label: 'Způsob ovládání', key: 'design', code: 'zpusob_ovladani', valueKey: 'design_hodnoty', valueCode: 'zpusob_ovladani', valueOnly: true, tooltipGroup: 'design', alwaysShow: true },
          { label: 'Displej', key: 'design', code: 'displej', valueKey: 'design_hodnoty', valueCode: 'displej', valueOnly: true, tooltipGroup: 'design', alwaysShow: true },
          { label: 'AmbientLight', key: 'design', code: 'ambientlight', valueKey: 'design_hodnoty', valueCode: 'ambientlight', emptyAsNo: true, tooltipGroup: 'design', alwaysShow: true },
          { label: 'MotionReact', key: 'design', code: 'motionreact', valueKey: 'design_hodnoty', valueCode: 'motionreact', emptyAsNo: true, tooltipGroup: 'design', alwaysShow: true }
        ]
      },
      {
        title: 'ČISTICÍ VÝKON',
        rows: [
          { label: 'PowerWash', key: 'cistici_vykon', code: 'powerwash' },
          { label: 'TwinDos', key: 'cistici_vykon', code: 'twindos' },
          { label: 'Automatické rozpoznání kartuše TwinDos', key: 'cistici_vykon', code: 'automaticke_rozpoznani_kartuse_twindos' },
          { label: 'CapDosing', key: 'cistici_vykon', code: 'capdosing' },
          { label: 'Funkce Skvrny', key: 'cistici_vykon', code: 'funkce_skvrny' },
          { label: 'Programy AddLoad', key: 'cistici_vykon', code: 'programy_addload' },
          { label: 'Testovaná protivirová hygiena', key: 'cistici_vykon', code: 'testovana_protivirova_hygiena' },
          { label: 'Excelentní hygiena', key: 'cistici_vykon', code: 'excelentni_hygiena' }
        ]
      },
      {
        title: 'ŠETRNÁ PÉČE O PRÁDLO',
        rows: [
          { label: 'Voštinový buben', key: 'setrna_pece_o_pradlo', code: 'vostinovy_buben' },
          { label: 'Voštinový buben InfinityCare', key: 'setrna_pece_o_pradlo', code: 'vostinovy_buben_infinitycare' },
          { label: 'Hmotnost náplně v kg', key: 'setrna_pece_o_pradlo', code: 'hmotnost_naplne_v_kg', valueKey: 'setrna_pece_o_pradlo_hodnota', valueCode: 'hmotnost_naplne_v_kg', valueOnly: true, tooltipGroup: 'setrna_pece_o_pradlo', alwaysShow: true }
        ]
      },    
           {
        title: 'KOMFORT PŘI OBSLUZE',
        rows: [
          { label: 'Propojení s Miele@home', key: 'komfort_pri_obsluze', code: 'propojeni_s_miele_home', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'propojeni_s_miele_home', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
          { label: 'Parní systém SteamCare', key: 'komfort_pri_obsluze', code: 'steamcare', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
          { label: 'Předvolba startu až 24 hodin', key: 'komfort_pri_obsluze', code: 'predvolba_startu_az_24_hodin', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'predvolba_startu_az_24_hodin', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
          { label: 'Indikace zbývajícího času', key: 'komfort_pri_obsluze', code: 'indikace_zbyvajiciho_casu', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'indikace_zbyvajiciho_casu', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
          { label: 'Indikace průběhu programu', key: 'komfort_pri_obsluze', code: 'indikace_prubehu_programu', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'indikace_prubehu_programu', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
          { label: 'Zobrazení denního času', key: 'komfort_pri_obsluze', code: 'zobrazeni_denniho_casu', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'zobrazeni_denniho_casu', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
          { label: 'Informační texty', key: 'komfort_pri_obsluze', code: 'informacni_texty', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'informacni_texty', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
          { label: 'Oblíbené programy', key: 'komfort_pri_obsluze', code: 'oblibene_programy', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'oblibene_programy', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
          { label: 'MultiLingua', key: 'komfort_pri_obsluze', code: 'multilingua', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'multilingua', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
          { label: 'Zásobník na prací prostředky AutoClean', key: 'komfort_pri_obsluze', code: 'zasobnik_na_praci_prostredky_autoclean', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'zasobnik_na_praci_prostredky_autoclean', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
          { label: 'AddLoad', key: 'komfort_pri_obsluze', code: 'addload', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'addload', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
          { label: 'ComfortOpen', key: 'komfort_pri_obsluze', code: 'comfortopen', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'comfortopen', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
          { label: 'Osvětlení bubnu LED', key: 'komfort_pri_obsluze', code: 'osvetleni_bubnu_led', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'osvetleni_bubnu_led', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true }
        ]
      },
      {
        title: 'PROGRAMY PRANÍ',
        rows: [
          { label: 'QuickPowerWash', key: 'programy_prani', code: 'quickpowerwash' },
          { label: 'Automatika plus', key: 'programy_prani', code: 'automatika_plus' },
          { label: 'Bavlna', key: 'programy_prani', code: 'bavlna' },
          { label: 'Bavlna s předepráním', key: 'programy_prani', code: 'bavlna_s_predepranim' },
          { label: 'Snadno ošetřovatelné', key: 'programy_prani', code: 'snadno_osetrovatelne' },
          { label: 'Jemné prádlo', key: 'programy_prani', code: 'jemne_pradlo' },
          { label: 'Košile', key: 'programy_prani', code: 'kosile' },
          { label: 'Košile/halenky', key: 'programy_prani', code: 'kosile_halenky' },
          { label: 'Hedvábí (ruční praní)', key: 'programy_prani', code: 'hedvabi_rucni_prani' },
          { label: 'Vlna (ruční praní)', key: 'programy_prani', code: 'vlna_rucni_prani' },
          { label: 'Expres 20', key: 'programy_prani', code: 'expres_20' },
          { label: 'Tmavé/jeans', key: 'programy_prani', code: 'tmave_jeans' },
          { label: 'Outdoor', key: 'programy_prani', code: 'outdoor' },
          { label: 'Impregnace', key: 'programy_prani', code: 'impregnace' },
          { label: 'Sportovní prádlo', key: 'programy_prani', code: 'sportovni_pradlo' },
          { label: 'Sportovní obuv', key: 'programy_prani', code: 'sportovni_obuv' },
          { label: 'Polštáře', key: 'programy_prani', code: 'polstare' },
          { label: 'Peří', key: 'programy_prani', code: 'peri' },
          { label: 'Peří/přikrývky', key: 'programy_prani', code: 'peri_prikryvky' },
          { label: 'Péřové přikrývky', key: 'programy_prani', code: 'perove_prikryvky' },
          { label: 'Záclony', key: 'programy_prani', code: 'zaclony' },
          { label: 'Záclony/závěsy', key: 'programy_prani', code: 'zaclony_zavesy' },
          { label: 'Bavlna hygiena', key: 'programy_prani', code: 'bavlna_hygiena' },
          { label: 'Konečná úprava párou', key: 'programy_prani', code: 'konecna_uprava_parou' },
          { label: 'Čištění přístroje', key: 'programy_prani', code: 'cisteni_pristroje' },
          { label: 'Bavlna se šipkou', key: 'programy_prani', code: 'bavlna_se_sipkou' },
          { label: 'Čištění bubnu', key: 'programy_prani', code: 'cisteni_bubnu' },
          { label: 'Nové textilie', key: 'programy_prani', code: 'nove_textilie' },
          { label: 'Nové oblečení', key: 'programy_prani', code: 'nove_obleceni' },
          { label: 'Pouze máchání/škrobení', key: 'programy_prani', code: 'pouze_machani_skrobeni' },
          { label: 'Pouze máchání', key: 'programy_prani', code: 'pouze_machani' },
          { label: 'Odčerpávání/odstřeďování', key: 'programy_prani', code: 'odcerpavani_odstredovani' },
          { label: 'ECO 40–60', key: 'programy_prani', code: 'eco_40_60' },
          { label: 'SmartMatic', key: 'programy_prani', code: 'smartmatic' },
          { label: 'Jen předžehlení', key: 'programy_prani', code: 'jen_predzehleni' },
          { label: 'Ložní prádlo', key: 'programy_prani', code: 'lozni_pradlo' }
        ]
      },
      {
        title: 'EXTRA FUNKCE PRANÍ',
        rows: [
          { label: 'SingleWash', key: 'extra_funkce', code: 'singlewash' },
          { label: 'Krátký', key: 'extra_funkce', code: 'kratky' },
          { label: 'Odmočení', key: 'extra_funkce', code: 'odmoceni' },
          { label: 'Předeprání', key: 'extra_funkce', code: 'predeprani' },
          { label: 'Více vody', key: 'extra_funkce', code: 'vice_vody' },
          { label: 'Extra máchání', key: 'extra_funkce', code: 'extra_machani' },
          { label: 'Předžehlení párou', key: 'extra_funkce', code: 'predzehleni_parou' },
          { label: 'Bzučák', key: 'extra_funkce', code: 'bzucak' },
          { label: 'Extra tichý', key: 'extra_funkce', code: 'extra_tichy' },
          { label: 'Hygiena plus', key: 'extra_funkce', code: 'hygiena_plus' },
          { label: 'Úspora energie', key: 'extra_funkce', code: 'uspora_energie' },
          { label: 'AllergoWash', key: 'extra_funkce', code: 'allergowash' }
        ]
      },
              {
        title: 'HOSPODÁRNOST A UDRŽITELNOST',
        rows: [
          { label: 'Třída energetické účinnosti (A–G)', key: 'hospodarnost_a_udrzitelnost', code: 'trida_energeticke_ucinnosti_a_g', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'trida_energeticke_ucinnosti_a_g', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
          { label: 'Úspornější než mezní hodnota třídy A', key: 'hospodarnost_a_udrzitelnost', code: 'uspornejsi_nez_mezni_hodnota_tridy_a', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'uspornejsi_nez_mezni_hodnota_tridy_a', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
          { label: 'Vážená spotřeba elektrické energie na 100 cyklů v kWh', key: 'hospodarnost_a_udrzitelnost', code: 'vazena_spotreba_elektricke_energie_na_100_cyklu_kwh', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'vazena_spotreba_elektricke_energie_na_100_cyklu_kwh', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
          { label: 'Vážená spotřeba vody na cyklus v l', key: 'hospodarnost_a_udrzitelnost', code: 'vazena_spotreba_vody_na_cyklus_l', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'vazena_spotreba_vody_na_cyklus_l', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
          { label: 'Třída účinnosti odstřeďování (A–G)', key: 'hospodarnost_a_udrzitelnost', code: 'trida_energeticke_ucinnosti_odstredovani_a_g', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'trida_energeticke_ucinnosti_odstredovani_a_g', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
          { label: 'Třída úrovně emisí hluku při odstřeďování (A–D)', key: 'hospodarnost_a_udrzitelnost', code: 'trida_urovne_emisi_hluku_pri_odstredovani_a_d', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'trida_urovne_emisi_hluku_pri_odstredovani_a_d', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
          { label: 'Úroveň emisí hluku při odstřeďování dB(A)', key: 'hospodarnost_a_udrzitelnost', code: 'uroven_emisi_hluku_pri_odstredovani_db_a', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'uroven_emisi_hluku_pri_odstredovani_db_a', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
          { label: 'Délka programu ECO 40–60 při jmenovité kapacitě', key: 'hospodarnost_a_udrzitelnost', code: 'delka_programu_eco_40_60_pri_jmenovite_kapacite', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'delka_programu_eco_40_60_pri_jmenovite_kapacite', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
          { label: 'Příkon ve vypnutém stavu ve W', key: 'hospodarnost_a_udrzitelnost', code: 'prikon_ve_vypnutem_stavu_ve_w', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'prikon_ve_vypnutem_stavu_ve_w', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
          { label: 'Příkon v pohotovostním režimu ve W', key: 'hospodarnost_a_udrzitelnost', code: 'prikon_v_pohotovostnim_rezimu_ve_w', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'prikon_v_pohotovostnim_rezimu_ve_w', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
          { label: 'Příkon v síťovém pohotovostním režimu ve W', key: 'hospodarnost_a_udrzitelnost', code: 'prikon_v_sitovem_pohotovostnim_rezimu_ve_w', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'prikon_v_sitovem_pohotovostnim_rezimu_ve_w', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
          { label: 'Čas do automatického zapnutí z vypnutého stavu v min', key: 'hospodarnost_a_udrzitelnost', code: 'cas_do_automatickeho_zapnuti_z_vypnuteho_stavu_v_min', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'cas_do_automatickeho_zapnuti_z_vypnuteho_stavu_v_min', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
          { label: 'Čas do automatického zapnutí z pohotovostního režimu v min', key: 'hospodarnost_a_udrzitelnost', code: 'cas_do_automatickeho_zapnuti_z_pohotovostniho_rezimu_v_min', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'cas_do_automatickeho_zapnuti_z_pohotovostniho_rezimu_v_min', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
          { label: 'Čas do automatického zapnutí ze síťového pohotovostního režimu v min', key: 'hospodarnost_a_udrzitelnost', code: 'cas_do_automatickeho_zapnuti_ze_sitoveho_pohotovostniho_rezimu_v_min', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'cas_do_automatickeho_zapnuti_ze_sitoveho_pohotovostniho_rezimu_v_min', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
          { label: 'Automatické rozpoznání naplnění FlexLoad', key: 'hospodarnost_a_udrzitelnost', code: 'automaticke_rozpoznani_naplneni_flexload', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'automaticke_rozpoznani_naplneni_flexload', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
          { label: 'Připojení na teplou vodu', key: 'hospodarnost_a_udrzitelnost', code: 'pripojeni_na_teplou_vodu', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'pripojeni_na_teplou_vodu', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
          { label: 'EcoFeedback', key: 'hospodarnost_a_udrzitelnost', code: 'ecofeedback', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'ecofeedback', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
          { label: 'Praní při nízkých teplotách studená / 20 °C', key: 'hospodarnost_a_udrzitelnost', code: 'prani_pri_nizkych_teplotach_studena_20_c', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'prani_pri_nizkych_teplotach_studena_20_c', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
          { label: 'Množstevní automatika', key: 'hospodarnost_a_udrzitelnost', code: 'mnozstevni_automatika', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'mnozstevni_automatika', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
          { label: 'Průtokový měřič', key: 'hospodarnost_a_udrzitelnost', code: 'prutokovy_meric', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'prutokovy_meric', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
          { label: 'Regulace pěnivosti', key: 'hospodarnost_a_udrzitelnost', code: 'regulace_penivosti', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'regulace_penivosti', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
          { label: 'Motor ProfiEco', key: 'hospodarnost_a_udrzitelnost', code: 'motor_profieco', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'motor_profieco', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true }
        ]
      },
      {
        title: 'BEZPEČNOST',
        rows: [
          { label: 'Systém ochrany proti poškození vodou', key: 'bezpecnost', code: 'system_ochrany_proti_poskozeni_vodou', valueKey: 'bezpecnost_hodnota', valueCode: 'system_ochrany_proti_poskozeni_vodou', tooltipGroup: 'bezpecnost', alwaysShow: true, valueOnly: true },
          { label: 'Dětská pojistka', key: 'bezpecnost', code: 'detska_pojistka', valueKey: 'bezpecnost_hodnota', valueCode: 'detska_pojistka', tooltipGroup: 'bezpecnost', alwaysShow: true },
          { label: 'PIN kód', key: 'bezpecnost', code: 'pin_kod', valueKey: 'bezpecnost_hodnota', valueCode: 'pin_kod', tooltipGroup: 'bezpecnost', alwaysShow: true },
          { label: 'Optické rozhraní', key: 'bezpecnost', code: 'opticke_rozhrani', valueKey: 'bezpecnost_hodnota', valueCode: 'opticke_rozhrani', tooltipGroup: 'bezpecnost', alwaysShow: true }
        ]
      },
      {
        title: 'TECHNICKÉ ÚDAJE',
        rows: [
          { label: 'Rozměry (v x š x h) v mm', key: 'technicke_udaje', code: 'rozmery_v_x_s_x_h_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'rozmery_v_x_s_x_h_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
          { label: 'Rozměry v mm (šířka)', key: 'technicke_udaje', code: 'rozmery_v_mm_sirka', valueKey: 'technicke_udaje_hodnota', valueCode: 'rozmery_v_mm_sirka', tooltipGroup: 'technicke_udaje', alwaysShow: true },
          { label: 'Rozměry v mm (výška)', key: 'technicke_udaje', code: 'rozmery_v_mm_vyska', valueKey: 'technicke_udaje_hodnota', valueCode: 'rozmery_v_mm_vyska', tooltipGroup: 'technicke_udaje', alwaysShow: true },
          { label: 'Rozměry v mm (hloubka)', key: 'technicke_udaje', code: 'rozmery_v_mm_hloubka', valueKey: 'technicke_udaje_hodnota', valueCode: 'rozmery_v_mm_hloubka', tooltipGroup: 'technicke_udaje', alwaysShow: true },
          { label: 'Hloubka přístroje s otevřenými dvířky v mm', key: 'technicke_udaje', code: 'hloubka_pristroje_s_otevrenymi_dvirky_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'hloubka_pristroje_s_otevrenymi_dvirky_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
          { label: 'Hloubka přístroje bez dvířek v mm', key: 'technicke_udaje', code: 'hloubka_pristroje_bez_dvirek_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'hloubka_pristroje_bez_dvirek_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
          { label: 'Hmotnost v kg', key: 'technicke_udaje', code: 'hmotnost_v_kg', valueKey: 'technicke_udaje_hodnota', valueCode: 'hmotnost_v_kg', tooltipGroup: 'technicke_udaje', alwaysShow: true },
          { label: 'Napětí ve V', key: 'technicke_udaje', code: 'napeti_ve_v', valueKey: 'technicke_udaje_hodnota', valueCode: 'napeti_ve_v', tooltipGroup: 'technicke_udaje', alwaysShow: true },
          { label: 'Jištění v A', key: 'technicke_udaje', code: 'jisteni_v_a', valueKey: 'technicke_udaje_hodnota', valueCode: 'jisteni_v_a', tooltipGroup: 'technicke_udaje', alwaysShow: true },
          { label: 'Frekvence v Hz', key: 'technicke_udaje', code: 'frekvence_v_hz', valueKey: 'technicke_udaje_hodnota', valueCode: 'frekvence_v_hz', tooltipGroup: 'technicke_udaje', alwaysShow: true },
          { label: 'Celkový příkon v kW', key: 'technicke_udaje', code: 'celkovy_prikon_v_kw', valueKey: 'technicke_udaje_hodnota', valueCode: 'celkovy_prikon_v_kw', tooltipGroup: 'technicke_udaje', alwaysShow: true },
          { label: 'Délka přívodní hadice v m', key: 'technicke_udaje', code: 'delka_privodni_hadice_v_m', valueKey: 'technicke_udaje_hodnota', valueCode: 'delka_privodni_hadice_v_m', tooltipGroup: 'technicke_udaje', alwaysShow: true },
          { label: 'Délka vypouštěcí hadice v m', key: 'technicke_udaje', code: 'delka_vypousteci_hadice_v_m', valueKey: 'technicke_udaje_hodnota', valueCode: 'delka_vypousteci_hadice_v_m', tooltipGroup: 'technicke_udaje', alwaysShow: true },
          { label: 'Délka elektrického přívodního kabelu v m', key: 'technicke_udaje', code: 'delka_elektrickeho_privodniho_kabelu_v_m', valueKey: 'technicke_udaje_hodnota', valueCode: 'delka_elektrickeho_privodniho_kabelu_v_m', tooltipGroup: 'technicke_udaje', alwaysShow: true }
        ]
      },
      {
        title: 'DODÁVANÉ PŘÍSLUŠENSTVÍ',
        rows: [
          { label: '3 kapsle', key: 'dodavane_prislusenstvi', code: 'tri_kapsle', tooltipGroup: 'dodavane_prislusenstvi' },
          { label: 'UltraPhase 1 + 2', key: 'dodavane_prislusenstvi', code: 'ultraphase_1_2', tooltipGroup: 'dodavane_prislusenstvi' },
          { label: 'Voucher na 5 kartuší pracího prostředku UltraPhase od Miele', key: 'dodavane_prislusenstvi', code: 'voucher_na_5_kartusi_praciho_prostredku_ultraphase_od_miele', tooltipGroup: 'dodavane_prislusenstvi' },
          { label: 'Voucher na prací prostředky Miele', key: 'dodavane_prislusenstvi', code: 'voucher_na_praci_prostredky_miele', tooltipGroup: 'dodavane_prislusenstvi' }
        ]
      },
      {
        title: 'DOSTUPNÉ JAZYKY DISPLEJE',
        rows: [
          { label: 'Dostupné jazyky displeje díky funkci MultiLingua', key: 'dostupne_jazyky_displeje_diky_multilingua', alwaysShow: true }
        ]
      }
    ]
  };
COMPARE_SCHEMAS.chladnicky = [
  {
    title: 'VŠEOBECNÉ ÚDAJE',
    rows: [
      { label: 'Číslo EAN', key: 'cislo_ean', alwaysShow: true },
      { label: 'Marketingová třída', key: 'marketingova_trida', alwaysShow: true }
    ]
  },
  {
    title: 'KATEGORIE PŘÍSTROJŮ',
    rows: [
      { label: 'Kombinace chladničky s mrazničkou', key: 'kategorie_pristroju', code: 'kombinace_chladnicky_s_mraznickou', emptyAsNo: true, tooltipGroup: 'kategorie_pristroju', alwaysShow: true },
      { label: 'Chladnička', key: 'kategorie_pristroju', code: 'chladnicka', emptyAsNo: true, tooltipGroup: 'kategorie_pristroju', alwaysShow: true }
    ]
  },
  {
    title: 'PROVEDENÍ',
    rows: [
      { label: 'Vestavný přístroj', key: 'provedeni', code: 'vestavny_pristroj', valueKey: 'provedeni_hodnota', valueCode: 'vestavny_pristroj', emptyAsNo: true, tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'Integrovaný vestavný přístroj', key: 'provedeni', code: 'integrovany_vestavny_pristroj', valueKey: 'provedeni_hodnota', valueCode: 'integrovany_vestavny_pristroj', emptyAsNo: true, tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'Závěs dvířek', key: 'provedeni', code: 'zaves_dvirek', valueKey: 'provedeni_hodnota', valueCode: 'zaves_dvirek', valueOnly: true, tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'Závěs dvířek měnitelný', key: 'provedeni', code: 'zaves_dvirek_menitelny', valueKey: 'provedeni_hodnota', valueCode: 'zaves_dvirek_menitelny', emptyAsNo: true, tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'Možnost kombinace Side-by-Side', key: 'provedeni', code: 'moznost_kombinace_side_by_side', valueKey: 'provedeni_hodnota', valueCode: 'moznost_kombinace_side_by_side', emptyAsNo: true, tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'Volně stojící přístroj', key: 'provedeni', code: 'volne_stojici_pristroj', valueKey: 'provedeni_hodnota', valueCode: 'volne_stojici_pristroj', emptyAsNo: true, tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'Podstavný přístroj', key: 'provedeni', code: 'podstavny_pristroj', valueKey: 'provedeni_hodnota', valueCode: 'podstavny_pristroj', emptyAsNo: true, tooltipGroup: 'provedeni', alwaysShow: true }
    ]
  },
  {
    title: 'DESIGN',
    rows: [
      { label: 'Osvětlení', key: 'design', code: 'osvetleni', valueKey: 'design_hodnoty', valueCode: 'osvetleni', valueOnly: true, tooltipGroup: 'design', alwaysShow: true },
      { label: 'Barva opláštění', key: 'design', code: 'barva_oplasteni', valueKey: 'design_hodnoty', valueCode: 'barva_oplasteni', valueOnly: true, tooltipGroup: 'design', alwaysShow: true },
      { label: 'Barva čelní stěny', key: 'design', code: 'barva_celni_steny', valueKey: 'design_hodnoty', valueCode: 'barva_celni_steny', valueOnly: true, tooltipGroup: 'design', alwaysShow: true },
      { label: 'Osvětlení chladicí zóny', key: 'design', code: 'osvetleni_chladici_zony', valueKey: 'design_hodnoty', valueCode: 'osvetleni_chladici_zony', valueOnly: true, tooltipGroup: 'design', alwaysShow: true },
      { label: 'Osvětlení mrazicí zóny', key: 'design', code: 'osvetleni_mrazici_zony', valueKey: 'design_hodnoty', valueCode: 'osvetleni_mrazici_zony', valueOnly: true, tooltipGroup: 'design', alwaysShow: true },
      { label: 'Osvětlení IceMakeru', key: 'design', code: 'osvetleni_icemakeru', valueKey: 'design_hodnoty', valueCode: 'osvetleni_icemakeru', emptyAsNo: true, tooltipGroup: 'design', alwaysShow: true },
      { label: 'Osvětlení ventilátoru', key: 'design', code: 'osvetleni_ventilatoru', valueKey: 'design_hodnoty', valueCode: 'osvetleni_ventilatoru', emptyAsNo: true, tooltipGroup: 'design', alwaysShow: true },
      { label: 'Osvětlení systému uchování čerstvosti', key: 'design', code: 'osvetleni_systemu_uchovani_cerstvosti', valueKey: 'design_hodnoty', valueCode: 'osvetleni_systemu_uchovani_cerstvosti', emptyAsNo: true, tooltipGroup: 'design', alwaysShow: true },
      { label: 'SmartLight', key: 'design', code: 'smartlight', valueKey: 'design_hodnoty', valueCode: 'smartlight', emptyAsNo: true, tooltipGroup: 'design', alwaysShow: true }
    ]
  },
  {
    title: 'KOMFORT PŘI OBSLUZE',
    rows: [
      { label: 'Propojení s Miele@home', key: 'komfort_pri_obsluze', code: 'propojeni_s_miele_home', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'propojeni_s_miele_home', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'NoFrost', key: 'komfort_pri_obsluze', code: 'nofrost', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'nofrost', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'SoftClose', key: 'komfort_pri_obsluze', code: 'softclose', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'softclose', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'IceMaker / výrobník ledu s připojením na čerstvou vodu', key: 'komfort_pri_obsluze', code: 'icemaker_vyrobnik_ledu_s_pripojenim_na_cerstvou_vodu', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'icemaker_vyrobnik_ledu_s_pripojenim_na_cerstvou_vodu', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Push2open', key: 'komfort_pri_obsluze', code: 'push2open', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'push2open', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'FullAccess', key: 'komfort_pri_obsluze', code: 'fullaccess', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'fullaccess', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'EasyClean', key: 'komfort_pri_obsluze', code: 'easyclean', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'easyclean', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Závěsy MaxLoad', key: 'komfort_pri_obsluze', code: 'zavesy_maxload', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'zavesy_maxload', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Systém uchování čerstvosti', key: 'komfort_pri_obsluze', code: 'system_uchovani_cerstvosti', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'system_uchovani_cerstvosti', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Snadné otvírání dvířek', key: 'komfort_pri_obsluze', code: 'snadne_otvirani_dvirek', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'snadne_otvirani_dvirek', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'ComfortClean', key: 'komfort_pri_obsluze', code: 'comfortclean', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'comfortclean', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'ComfortSize', key: 'komfort_pri_obsluze', code: 'comfortsize', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'comfortsize', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'DynaCool', key: 'komfort_pri_obsluze', code: 'dynacool', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'dynacool', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Režim párty', key: 'komfort_pri_obsluze', code: 'rezim_party', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'rezim_party', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Režim dovolená', key: 'komfort_pri_obsluze', code: 'rezim_dovolena', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'rezim_dovolena', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'DuplexCool', key: 'komfort_pri_obsluze', code: 'duplexcool', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'duplexcool', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'VarioRoom', key: 'komfort_pri_obsluze', code: 'varioroom', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'varioroom', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'SelfClose', key: 'komfort_pri_obsluze', code: 'selfclose', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'selfclose', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'ComfortFrost', key: 'komfort_pri_obsluze', code: 'comfortfrost', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'comfortfrost', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Jemné seřízení vnitřních dvířek', key: 'komfort_pri_obsluze', code: 'jemne_serizeni_vnitrnich_dvirek', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'jemne_serizeni_vnitrnich_dvirek', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Systém Longlife AirClean', key: 'komfort_pri_obsluze', code: 'system_longlife_airclean', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'system_longlife_airclean', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'DuplexCool Pro', key: 'komfort_pri_obsluze', code: 'duplexcool_pro', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'duplexcool_pro', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Počet IceMakerů s připojením na vodu', key: 'komfort_pri_obsluze', code: 'pocet_icemakeru_s_pripojenim_na_vodu', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'pocet_icemakeru_s_pripojenim_na_vodu', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'MyIce - výrobník kostek ledu se zásobníkem na vodu', key: 'komfort_pri_obsluze', code: 'myice_vyrobnik_kostek_ledu_se_zasobnikem_na_vodu', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'myice_vyrobnik_kostek_ledu_se_zasobnikem_na_vodu', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Freeze&Cool', key: 'komfort_pri_obsluze', code: 'freeze_cool', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'freeze_cool', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true }
    ]
  },
  {
    title: 'ŘÍDICÍ JEDNOTKA',
    rows: [
      { label: 'Koncepce ovládání', key: 'ridici_jednotka', code: 'koncepce_ovladani', valueKey: 'ridici_jednotka_hodnoty', valueCode: 'koncepce_ovladani', valueOnly: true, tooltipGroup: 'ridici_jednotka', alwaysShow: true },
      { label: 'Režim sabat', key: 'ridici_jednotka', code: 'rezim_sabat', valueKey: 'ridici_jednotka_hodnoty', valueCode: 'rezim_sabat', emptyAsNo: true, tooltipGroup: 'ridici_jednotka', alwaysShow: true },
      { label: 'Supermražení', key: 'ridici_jednotka', code: 'supermrazeni', valueKey: 'ridici_jednotka_hodnoty', valueCode: 'supermrazeni', emptyAsNo: true, tooltipGroup: 'ridici_jednotka', alwaysShow: true },
      { label: 'Počet teplotních zón celkem', key: 'ridici_jednotka', code: 'pocet_teplotnich_zon_celkem', valueKey: 'ridici_jednotka_hodnoty', valueCode: 'pocet_teplotnich_zon_celkem', valueOnly: true, tooltipGroup: 'ridici_jednotka', alwaysShow: true },
      { label: 'Režim Eco', key: 'ridici_jednotka', code: 'rezim_eco', valueKey: 'ridici_jednotka_hodnoty', valueCode: 'rezim_eco', emptyAsNo: true, tooltipGroup: 'ridici_jednotka', alwaysShow: true },
      { label: 'Nastavení s přesností na stupeň', key: 'ridici_jednotka', code: 'nastaveni_s_presnosti_na_stupen', valueKey: 'ridici_jednotka_hodnoty', valueCode: 'nastaveni_s_presnosti_na_stupen', valueOnly: true, tooltipGroup: 'ridici_jednotka', alwaysShow: true },
      { label: 'Možnost vypnout chladicí část', key: 'ridici_jednotka', code: 'moznost_vypnout_chladici_cast', valueKey: 'ridici_jednotka_hodnoty', valueCode: 'moznost_vypnout_chladici_cast', emptyAsNo: true, tooltipGroup: 'ridici_jednotka', alwaysShow: true },
      { label: 'Nezávislá regulace teploty chladicí a mrazicí zóny', key: 'ridici_jednotka', code: 'nezavisla_regulace_teploty_chladici_a_mrazici_zony', valueKey: 'ridici_jednotka_hodnoty', valueCode: 'nezavisla_regulace_teploty_chladici_a_mrazici_zony', emptyAsNo: true, tooltipGroup: 'ridici_jednotka', alwaysShow: true },
      { label: 'SuperCool', key: 'ridici_jednotka', code: 'supercool', valueKey: 'ridici_jednotka_hodnoty', valueCode: 'supercool', emptyAsNo: true, tooltipGroup: 'ridici_jednotka', alwaysShow: true },
      { label: 'SuperCool a AirClean', key: 'ridici_jednotka', code: 'supercool_a_airclean', valueKey: 'ridici_jednotka_hodnoty', valueCode: 'supercool_a_airclean', emptyAsNo: true, tooltipGroup: 'ridici_jednotka', alwaysShow: true },
      { label: 'QuickIce', key: 'ridici_jednotka', code: 'quickice', valueKey: 'ridici_jednotka_hodnoty', valueCode: 'quickice', emptyAsNo: true, tooltipGroup: 'ridici_jednotka', alwaysShow: true },
      { label: 'Možnost vypnout mrazicí část', key: 'ridici_jednotka', code: 'moznost_vypnout_mrazici_cast', valueKey: 'ridici_jednotka_hodnoty', valueCode: 'moznost_vypnout_mrazici_cast', emptyAsNo: true, tooltipGroup: 'ridici_jednotka', alwaysShow: true },
    ]
  },
  {
    title: 'HOSPODÁRNOST A UDRŽITELNOST',
    rows: [
      { label: 'Třída energetické účinnosti (A–G)', key: 'hospodarnost_a_udrzitelnost', code: 'trida_energeticke_ucinnosti_a_g', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'trida_energeticke_ucinnosti_a_g', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Roční spotřeba energie v kWh', key: 'hospodarnost_a_udrzitelnost', code: 'rocni_spotreba_energie_v_kwh', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'rocni_spotreba_energie_v_kwh', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Spotřeba energie za 24 h v kWh', key: 'hospodarnost_a_udrzitelnost', code: 'spotreba_energie_za_24_h_v_kwh', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'spotreba_energie_za_24_h_v_kwh', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true }
    ]
  },
  {
    title: 'CHLADICÍ ZÓNA',
    rows: [
      { label: 'Počet odkládacích ploch', key: 'chladici_zona', code: 'pocet_odkladacich_ploch', valueKey: 'chladici_zona_hodnoty', valueCode: 'pocet_odkladacich_ploch', valueOnly: true, tooltipGroup: 'chladici_zona', alwaysShow: true },
      { label: 'Počet přihrádek na čerstvé potraviny', key: 'chladici_zona', code: 'pocet_prihradek_na_cerstve_potraviny', valueKey: 'chladici_zona_hodnoty', valueCode: 'pocet_prihradek_na_cerstve_potraviny', valueOnly: true, tooltipGroup: 'chladici_zona', alwaysShow: true },
      { label: 'Suchá zadní stěna', key: 'chladici_zona', code: 'sucha_zadni_stena', valueKey: 'chladici_zona_hodnoty', valueCode: 'sucha_zadni_stena', valueOnly: true, tooltipGroup: 'chladici_zona', alwaysShow: true },
      { label: 'Počet polic na konzervy ve dvířkách', key: 'chladici_zona', code: 'pocet_polic_na_konzervy_ve_dvirkach', valueKey: 'chladici_zona_hodnoty', valueCode: 'pocet_polic_na_konzervy_ve_dvirkach', valueOnly: true, tooltipGroup: 'chladici_zona', alwaysShow: true },
      { label: 'Police na lahve ve dvířkách', key: 'chladici_zona', code: 'police_na_lahve_ve_dvirkach', valueKey: 'chladici_zona_hodnoty', valueCode: 'police_na_lahve_ve_dvirkach', valueOnly: true, tooltipGroup: 'chladici_zona', alwaysShow: true },
      { label: 'Police ve dvířkách', key: 'chladici_zona', code: 'police_ve_dvirkach', valueKey: 'chladici_zona_hodnoty', valueCode: 'police_ve_dvirkach', valueOnly: true, tooltipGroup: 'chladici_zona', alwaysShow: true },
      { label: 'Výškově nastavitelné odkládací plochy z bezpečnostního skla, celá šířka', key: 'chladici_zona', code: 'vyskove_nastavitelne_odkladaci_plochy_z_bezpecnostniho_skla_cela_sirka', valueKey: 'chladici_zona_hodnoty', valueCode: 'vyskove_nastavitelne_odkladaci_plochy_z_bezpecnostniho_skla_cela_sirka', valueOnly: true, tooltipGroup: 'chladici_zona', alwaysShow: true },
      { label: 'Počet VeggieBoxů', key: 'chladici_zona', code: 'pocet_veggieboxu', valueKey: 'chladici_zona_hodnoty', valueCode: 'pocet_veggieboxu', valueOnly: true, tooltipGroup: 'chladici_zona', alwaysShow: true },
      { label: 'SlidingShelf', key: 'chladici_zona', code: 'slidingshelf', valueKey: 'chladici_zona_hodnoty', valueCode: 'slidingshelf', emptyAsNo: true, tooltipGroup: 'chladici_zona', alwaysShow: true },
      { label: 'Mrazicí přihrádka 4*', key: 'chladici_zona', code: 'mrazici_prihradka_4', valueKey: 'chladici_zona_hodnoty', valueCode: 'mrazici_prihradka_4', emptyAsNo: true, tooltipGroup: 'chladici_zona', alwaysShow: true },
      { label: 'Držák na lahve z pochromovaného kovu', key: 'chladici_zona', code: 'drzak_na_lahve_z_pochromovaneho_kovu', valueKey: 'chladici_zona_hodnoty', valueCode: 'drzak_na_lahve_z_pochromovaneho_kovu', emptyAsNo: true, tooltipGroup: 'chladici_zona', alwaysShow: true },
      { label: 'z toho osvětlené', key: 'chladici_zona', code: 'z_toho_osvetlene', valueKey: 'chladici_zona_hodnoty', valueCode: 'z_toho_osvetlene', valueOnly: true, tooltipGroup: 'chladici_zona', alwaysShow: true },
      { label: 'z toho dělitelné (FlexiBoard)', key: 'chladici_zona', code: 'z_toho_delitelne_flexiboard', valueKey: 'chladici_zona_hodnoty', valueCode: 'z_toho_delitelne_flexiboard', valueOnly: true, tooltipGroup: 'chladici_zona', alwaysShow: true },
      { label: 'CompactCase', key: 'chladici_zona', code: 'compactcase', valueKey: 'chladici_zona_hodnoty', valueCode: 'compactcase', emptyAsNo: true, tooltipGroup: 'chladici_zona', alwaysShow: true },
      { label: 'Otočná police FlexiTray', key: 'chladici_zona', code: 'otocna_police_flexitray', valueKey: 'chladici_zona_hodnoty', valueCode: 'otocna_police_flexitray', emptyAsNo: true, tooltipGroup: 'chladici_zona', alwaysShow: true }
    ]
  },
  {
    title: 'MRAZICÍ ZÓNA',
    rows: [
      { label: 'Počet mrazicích košů', key: 'mrazici_zona', code: 'pocet_mrazicich_kosu', valueKey: 'mrazici_zona_hodnoty', valueCode: 'pocet_mrazicich_kosu', valueOnly: true, tooltipGroup: 'mrazici_zona', alwaysShow: true },
      { label: 'Počet mrazicích zásuvek', key: 'mrazici_zona', code: 'pocet_mrazicich_zasuvek', valueKey: 'mrazici_zona_hodnoty', valueCode: 'pocet_mrazicich_zasuvek', valueOnly: true, tooltipGroup: 'mrazici_zona', alwaysShow: true },
      { label: 'z toho na výsuvech', key: 'mrazici_zona', code: 'z_toho_na_vysuvech', valueKey: 'mrazici_zona_hodnoty', valueCode: 'z_toho_na_vysuvech', valueOnly: true, tooltipGroup: 'mrazici_zona', alwaysShow: true },
      { label: 'z toho na teleskopických výsuvech', key: 'mrazici_zona', code: 'z_toho_na_teleskopickych_vysuvech', valueKey: 'mrazici_zona_hodnoty', valueCode: 'z_toho_na_teleskopickych_vysuvech', valueOnly: true, tooltipGroup: 'mrazici_zona', alwaysShow: true }
    ]
  },
  {
    title: 'BEZPEČNOST',
    rows: [
      { label: 'Blokovací funkce', key: 'bezpecnost', code: 'blokovaci_funkce', emptyAsNo: true, tooltipGroup: 'bezpecnost', alwaysShow: true },
      { label: 'Akustický alarm při otevřených dvířkách', key: 'bezpecnost', code: 'akusticky_alarm_pri_otevrenych_dvirkach', emptyAsNo: true, tooltipGroup: 'bezpecnost', alwaysShow: true },
      { label: 'Akustický alarm při změně teploty v mrazicí části', key: 'bezpecnost', code: 'akusticky_alarm_pri_zmene_teploty_v_mrazici_casti', emptyAsNo: true, tooltipGroup: 'bezpecnost', alwaysShow: true },
      { label: 'Optický alarm při otevřených dvířkách', key: 'bezpecnost', code: 'opticky_alarm_pri_otevrenych_dvirkach', emptyAsNo: true, tooltipGroup: 'bezpecnost', alwaysShow: true },
      { label: 'Optický alarm při změně teploty', key: 'bezpecnost', code: 'opticky_alarm_pri_zmene_teploty', emptyAsNo: true, tooltipGroup: 'bezpecnost', alwaysShow: true },
      { label: 'Indikace výpadku proudu v mrazicí části', key: 'bezpecnost', code: 'indikace_vypadku_proudu_v_mrazici_casti', emptyAsNo: true, tooltipGroup: 'bezpecnost', alwaysShow: true },
      { label: 'Skleněné police s ochranou proti přetečení', key: 'bezpecnost', code: 'sklenene_police_s_ochranou_proti_preteceni', emptyAsNo: true, tooltipGroup: 'bezpecnost', alwaysShow: true }
    ]
  },
  {
    title: 'TECHNICKÉ ÚDAJE',
    rows: [
      { label: 'Minimální šířka výklenku v mm', key: 'technicke_udaje', code: 'minimalni_sirka_vyklenku_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'minimalni_sirka_vyklenku_v_mm', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Maximální šířka výklenku v mm', key: 'technicke_udaje', code: 'maximalni_sirka_vyklenku_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'maximalni_sirka_vyklenku_v_mm', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Minimální výška výklenku v mm', key: 'technicke_udaje', code: 'minimalni_vyska_vyklenku_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'minimalni_vyska_vyklenku_v_mm', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Maximální výška výklenku v mm', key: 'technicke_udaje', code: 'maximalni_vyska_vyklenku_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'maximalni_vyska_vyklenku_v_mm', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Hloubka výklenku v mm', key: 'technicke_udaje', code: 'hloubka_vyklenku_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'hloubka_vyklenku_v_mm', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Šířka přístroje v mm', key: 'technicke_udaje', code: 'sirka_pristroje_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'sirka_pristroje_v_mm', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Výška přístroje v mm', key: 'technicke_udaje', code: 'vyska_pristroje_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'vyska_pristroje_v_mm', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Hloubka přístroje v mm', key: 'technicke_udaje', code: 'hloubka_pristroje_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'hloubka_pristroje_v_mm', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Hmotnost v kg', key: 'technicke_udaje', code: 'hmotnost_v_kg', valueKey: 'technicke_udaje_hodnota', valueCode: 'hmotnost_v_kg', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Upevňovací technika', key: 'technicke_udaje', code: 'upevnovaci_technika', valueKey: 'technicke_udaje_hodnota', valueCode: 'upevnovaci_technika', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Maximální zatížení čelní strany dvířek chladicí části v kg', key: 'technicke_udaje', code: 'maximalni_zatizeni_celni_strany_dvirek_chladici_casti_v_kg', valueKey: 'technicke_udaje_hodnota', valueCode: 'maximalni_zatizeni_celni_strany_dvirek_chladici_casti_v_kg', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Maximální zatížení čelní strany dvířek mrazicí části v kg', key: 'technicke_udaje', code: 'maximalni_zatizeni_celni_strany_dvirek_mrazici_casti_v_kg', valueKey: 'technicke_udaje_hodnota', valueCode: 'maximalni_zatizeni_celni_strany_dvirek_mrazici_casti_v_kg', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Klimatická třída', key: 'technicke_udaje', code: 'klimaticka_trida', valueKey: 'technicke_udaje_hodnota', valueCode: 'klimaticka_trida', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: '4hvězdičková mrazicí zóna v l', key: 'technicke_udaje', code: '4hvezdickova_mrazici_zona_v_l', valueKey: 'technicke_udaje_hodnota', valueCode: '4hvezdickova_mrazici_zona_v_l', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Chladicí zóna v l', key: 'technicke_udaje', code: 'chladici_zona_v_l', valueKey: 'technicke_udaje_hodnota', valueCode: 'chladici_zona_v_l', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'z toho zóna PerfectFresh v l', key: 'technicke_udaje', code: 'z_toho_zona_perfectfresh_v_l', valueKey: 'technicke_udaje_hodnota', valueCode: 'z_toho_zona_perfectfresh_v_l', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Celkový užitný objem v l', key: 'technicke_udaje', code: 'celkovy_uzitny_objem_v_l', valueKey: 'technicke_udaje_hodnota', valueCode: 'celkovy_uzitny_objem_v_l', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Doba skladování při poruše v h', key: 'technicke_udaje', code: 'doba_skladovani_pri_poruse_v_h', valueKey: 'technicke_udaje_hodnota', valueCode: 'doba_skladovani_pri_poruse_v_h', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Kapacita mražení v kg/24 h', key: 'technicke_udaje', code: 'kapacita_mrazeni_v_kg_24_h', valueKey: 'technicke_udaje_hodnota', valueCode: 'kapacita_mrazeni_v_kg_24_h', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Třída úrovně emisí hluku (A–D)', key: 'hospodarnost_a_udrzitelnost', code: 'trida_urovne_emisi_hluku_a_d', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'trida_urovne_emisi_hluku_a_d', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Úroveň emisí hluku v dB(A) re 1 pW', key: 'technicke_udaje', code: 'uroven_emisi_hluku_v_db_a_re_1_pw', valueKey: 'technicke_udaje_hodnota', valueCode: 'uroven_emisi_hluku_v_db_a_re_1_pw', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Spotřeba energie v miliampérech (mA)', key: 'technicke_udaje', code: 'spotreba_energie_v_miliamperech_ma', valueKey: 'technicke_udaje_hodnota', valueCode: 'spotreba_energie_v_miliamperech_ma', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Napětí ve V', key: 'technicke_udaje', code: 'napeti_ve_v', valueKey: 'technicke_udaje_hodnota', valueCode: 'napeti_ve_v', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Jištění v A', key: 'technicke_udaje', code: 'jisteni_v_a', valueKey: 'technicke_udaje_hodnota', valueCode: 'jisteni_v_a', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Počet fází', key: 'technicke_udaje', code: 'pocet_fazi', valueKey: 'technicke_udaje_hodnota', valueCode: 'pocet_fazi', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Frekvence v Hz', key: 'technicke_udaje', code: 'frekvence_v_hz', valueKey: 'technicke_udaje_hodnota', valueCode: 'frekvence_v_hz', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Délka elektrického přívodního kabelu v m', key: 'technicke_udaje', code: 'delka_elektrickeho_privodniho_kabelu_v_m', valueKey: 'technicke_udaje_hodnota', valueCode: 'delka_elektrickeho_privodniho_kabelu_v_m', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Výměna svítidel', key: 'technicke_udaje', code: 'vymena_svitidel', valueKey: 'technicke_udaje_hodnota', valueCode: 'vymena_svitidel', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Rozměry přístroje (š x v x h) v mm', key: 'technicke_udaje', code: 'rozmery_v_x_s_x_h_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'rozmery_v_x_s_x_h_v_mm', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true }
    ]
  },
  {
    title: 'DODÁVANÉ PŘÍSLUŠENSTVÍ',
    rows: [
      { label: 'Vodní filtr', key: 'dodavane_prislusenstvi', code: 'vodni_filtr', emptyAsNo: true, tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Přihrádka na vejce', key: 'dodavane_prislusenstvi', code: 'prihradka_na_vejce', emptyAsNo: true, tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Miska na led', key: 'dodavane_prislusenstvi', code: 'miska_na_led', emptyAsNo: true, tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Lopatka na led', key: 'dodavane_prislusenstvi', code: 'lopatka_na_led', emptyAsNo: true, tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Filtr Active AirClean', key: 'dodavane_prislusenstvi', code: 'filtr_active_airclean', emptyAsNo: true, tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Organizační box PerfectFresh', key: 'dodavane_prislusenstvi', code: 'organizacni_box_perfectfresh', emptyAsNo: true, tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Akumulátory chladu', key: 'dodavane_prislusenstvi', code: 'akumulatory_chladu', emptyAsNo: true, tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Filtr Longlife AirClean', key: 'dodavane_prislusenstvi', code: 'filtr_longlife_airclean', emptyAsNo: true, tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true }
    ]
  }
];
  COMPARE_SCHEMAS.mraznicky = [
  {
    title: 'VŠEOBECNÉ ÚDAJE',
    rows: [
      { label: 'Číslo EAN', key: 'cislo_ean', alwaysShow: true },
      { label: 'Marketingová třída', key: 'marketingova_trida', alwaysShow: true }
    ]
  },
  {
    title: 'PROVEDENÍ',
    rows: [
      { label: 'Mraznička', key: 'provedeni', code: 'mraznicka', tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'Vestavný přístroj', key: 'provedeni', code: 'vestavny_pristroj', tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'Integrovaný vestavný přístroj', key: 'provedeni', code: 'integrovany_vestavny_pristroj', tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'Podstavný přístroj', key: 'provedeni', code: 'podstavny_pristroj', tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'Závěs dvířek', key: 'provedeni', code: 'zaves_dvirek', valueKey: 'provedeni_hodnota', valueCode: 'zaves_dvirek', valueOnly: true, tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'Závěs dvířek měnitelný', key: 'provedeni', code: 'zaves_dvirek_menitelny', valueKey: 'provedeni_hodnota', valueCode: 'zaves_dvirek_menitelny', tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'Možnost kombinace Side-by-Side', key: 'provedeni', code: 'moznost_kombinace_side_by_side', valueKey: 'provedeni_hodnota', valueCode: 'moznost_kombinace_side_by_side', tooltipGroup: 'provedeni', alwaysShow: true }
    ]
  },
  {
    title: 'DESIGN',
    rows: [
      { label: 'Osvětlení', key: 'design', code: 'osvetleni', valueKey: 'design_hodnoty', valueCode: 'osvetleni', valueOnly: true, tooltipGroup: 'design', alwaysShow: true },
      { label: 'Osvětlení mrazicí zóny', key: 'design', code: 'osvetleni_mrazici_zony', valueKey: 'design_hodnoty', valueCode: 'osvetleni_mrazici_zony', tooltipGroup: 'design', alwaysShow: true },
      { label: 'Osvětlení IceMakeru', key: 'design', code: 'osvetleni_icemakeru', valueKey: 'design_hodnoty', valueCode: 'osvetleni_icemakeru', tooltipGroup: 'design', alwaysShow: true }
    ]
  },
  {
    title: 'ŘÍDICÍ JEDNOTKA',
    rows: [
      { label: 'Koncepce ovládání', key: 'ridici_jednotka', code: 'koncepce_ovladani', valueKey: 'ridici_jednotka_hodnoty', valueCode: 'koncepce_ovladani', valueOnly: true, tooltipGroup: 'ridici_jednotka', alwaysShow: true },
      { label: 'Supermražení', key: 'ridici_jednotka', code: 'supermrazeni', valueKey: 'ridici_jednotka_hodnoty', valueCode: 'supermrazeni', emptyAsNo: true, tooltipGroup: 'ridici_jednotka', alwaysShow: true },
      { label: 'Počet teplotních zón celkem', key: 'ridici_jednotka', code: 'pocet_teplotnich_zon_celkem', valueKey: 'ridici_jednotka_hodnoty', valueCode: 'pocet_teplotnich_zon_celkem', valueOnly: true, tooltipGroup: 'ridici_jednotka', alwaysShow: true },
      { label: 'Režim sabat', key: 'ridici_jednotka', code: 'rezim_sabat', valueKey: 'ridici_jednotka_hodnoty', valueCode: 'rezim_sabat', emptyAsNo: true, tooltipGroup: 'ridici_jednotka', alwaysShow: true },
      { label: 'Režim Eco', key: 'ridici_jednotka', code: 'rezim_eco', valueKey: 'ridici_jednotka_hodnoty', valueCode: 'rezim_eco', emptyAsNo: true, tooltipGroup: 'ridici_jednotka', alwaysShow: true }
    ]
  },
  {
    title: 'KOMFORT PŘI OBSLUZE',
    rows: [
      { label: 'Propojení s Miele@home', key: 'komfort_pri_obsluze', code: 'propojeni_s_miele_home', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'propojeni_s_miele_home', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Snadné otvírání dvířek', key: 'komfort_pri_obsluze', code: 'snadne_otvirani_dvirek', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'snadne_otvirani_dvirek', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Režim párty', key: 'komfort_pri_obsluze', code: 'rezim_party', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'rezim_party', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Režim dovolená', key: 'komfort_pri_obsluze', code: 'rezim_dovolena', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'rezim_dovolena', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'NoFrost', key: 'komfort_pri_obsluze', code: 'nofrost', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'nofrost', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'VarioRoom', key: 'komfort_pri_obsluze', code: 'varioroom', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'varioroom', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'SoftClose', key: 'komfort_pri_obsluze', code: 'softclose', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'softclose', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'IceMaker s připojením na čerstvou vodu', key: 'komfort_pri_obsluze', code: 'icemaker_s_pripojenim_na_cerstvou_vodu', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'icemaker_s_pripojenim_na_cerstvou_vodu', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Push2open', key: 'komfort_pri_obsluze', code: 'push2open', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'push2open', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'ActiveDoor', key: 'komfort_pri_obsluze', code: 'activedoor', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'activedoor', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'FullAccess', key: 'komfort_pri_obsluze', code: 'fullaccess', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'fullaccess', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'EasyClean', key: 'komfort_pri_obsluze', code: 'easyclean', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'easyclean', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Závěsy MaxLoad', key: 'komfort_pri_obsluze', code: 'zavesy_maxload', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'zavesy_maxload', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'MultiLingua', key: 'komfort_pri_obsluze', code: 'multilingua', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'multilingua', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true }
    ]
  },
  {
    title: 'MRAZNIČKA/MRAZICÍ ZÓNA',
    rows: [
      { label: 'Počet mrazicích zásuvek', key: 'mrazici_zona', code: 'pocet_mrazicich_zasuvek', valueKey: 'mrazici_zona_hodnoty', valueCode: 'pocet_mrazicich_zasuvek', valueOnly: true, tooltipGroup: 'mrazici_zona', alwaysShow: true },
      { label: 'z toho na výsuvech', key: 'mrazici_zona', code: 'z_toho_na_vysuvech', valueKey: 'mrazici_zona_hodnoty', valueCode: 'z_toho_na_vysuvech', valueOnly: true, tooltipGroup: 'mrazici_zona', alwaysShow: true },
      { label: 'z toho Ice&PizzaBox', key: 'mrazici_zona', code: 'z_toho_ice_pizzabox', valueKey: 'mrazici_zona_hodnoty', valueCode: 'z_toho_ice_pizzabox', valueOnly: true, tooltipGroup: 'mrazici_zona', alwaysShow: true },
      { label: 'Počet odkládacích ploch', key: 'mrazici_zona', code: 'pocet_odkladacich_ploch', valueKey: 'mrazici_zona_hodnoty', valueCode: 'pocet_odkladacich_ploch', valueOnly: true, tooltipGroup: 'mrazici_zona', alwaysShow: true },
      { label: 'Počet mrazicích košů', key: 'mrazici_zona', code: 'pocet_mrazicich_kosu', valueKey: 'mrazici_zona_hodnoty', valueCode: 'pocet_mrazicich_kosu', valueOnly: true, tooltipGroup: 'mrazici_zona', alwaysShow: true },
      { label: 'Koše vnitřních dvířek, malé', key: 'mrazici_zona', code: 'kose_vnitrnich_dvirek_male', valueKey: 'mrazici_zona_hodnoty', valueCode: 'kose_vnitrnich_dvirek_male', valueOnly: true, tooltipGroup: 'mrazici_zona', alwaysShow: true },
      { label: 'Koše vnitřních dvířek, velké', key: 'mrazici_zona', code: 'kose_vnitrnich_dvirek_velke', valueKey: 'mrazici_zona_hodnoty', valueCode: 'kose_vnitrnich_dvirek_velke', valueOnly: true, tooltipGroup: 'mrazici_zona', alwaysShow: true }
    ]
  },
  {
    title: 'HOSPODÁRNOST A UDRŽITELNOST',
    rows: [
      { label: 'Třída energetické účinnosti (A–G)', key: 'hospodarnost_a_udrzitelnost', code: 'trida_energeticke_ucinnosti_a_g', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'trida_energeticke_ucinnosti_a_g', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Roční spotřeba energie v kWh', key: 'hospodarnost_a_udrzitelnost', code: 'rocni_spotreba_energie_v_kwh', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'rocni_spotreba_energie_v_kwh', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Spotřeba energie za 24 h v kWh', key: 'hospodarnost_a_udrzitelnost', code: 'spotreba_energie_za_24_h_v_kwh', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'spotreba_energie_za_24_h_v_kwh', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true }
    ]
  },
  {
    title: 'BEZPEČNOST',
    rows: [
      { label: 'Blokovací funkce', key: 'bezpecnost', code: 'blokovaci_funkce', emptyAsNo: true, tooltipGroup: 'bezpecnost', alwaysShow: true },
      { label: 'Akustický alarm při otevřených dvířkách', key: 'bezpecnost', code: 'akusticky_alarm_pri_otevrenych_dvirkach', emptyAsNo: true, tooltipGroup: 'bezpecnost', alwaysShow: true },
      { label: 'Akustický alarm při změně teploty v mrazicí části', key: 'bezpecnost', code: 'akusticky_alarm_pri_zmene_teploty_v_mrazici_casti', emptyAsNo: true, tooltipGroup: 'bezpecnost', alwaysShow: true },
      { label: 'Optický alarm při otevřených dvířkách', key: 'bezpecnost', code: 'opticky_alarm_pri_otevrenych_dvirkach', emptyAsNo: true, tooltipGroup: 'bezpecnost', alwaysShow: true },
      { label: 'Optický alarm při změně teploty', key: 'bezpecnost', code: 'opticky_alarm_pri_zmene_teploty', emptyAsNo: true, tooltipGroup: 'bezpecnost', alwaysShow: true },
      { label: 'Indikace výpadku proudu v mrazicí části', key: 'bezpecnost', code: 'indikace_vypadku_proudu_v_mrazici_casti', emptyAsNo: true, tooltipGroup: 'bezpecnost', alwaysShow: true }
    ]
  },
  {
    title: 'TECHNICKÉ ÚDAJE',
    rows: [
      { label: 'Minimální šířka výklenku v mm', key: 'technicke_udaje', code: 'minimalni_sirka_vyklenku_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'minimalni_sirka_vyklenku_v_mm', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Maximální šířka výklenku v mm', key: 'technicke_udaje', code: 'maximalni_sirka_vyklenku_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'maximalni_sirka_vyklenku_v_mm', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Minimální výška výklenku v mm', key: 'technicke_udaje', code: 'minimalni_vyska_vyklenku_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'minimalni_vyska_vyklenku_v_mm', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Maximální výška výklenku v mm', key: 'technicke_udaje', code: 'maximalni_vyska_vyklenku_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'maximalni_vyska_vyklenku_v_mm', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Hloubka výklenku v mm', key: 'technicke_udaje', code: 'hloubka_vyklenku_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'hloubka_vyklenku_v_mm', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Šířka přístroje v mm', key: 'technicke_udaje', code: 'sirka_pristroje_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'sirka_pristroje_v_mm', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Výška přístroje v mm', key: 'technicke_udaje', code: 'vyska_pristroje_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'vyska_pristroje_v_mm', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Hloubka přístroje v mm', key: 'technicke_udaje', code: 'hloubka_pristroje_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'hloubka_pristroje_v_mm', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Hmotnost v kg', key: 'technicke_udaje', code: 'hmotnost_v_kg', valueKey: 'technicke_udaje_hodnota', valueCode: 'hmotnost_v_kg', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Upevňovací technika', key: 'technicke_udaje', code: 'upevnovaci_technika', valueKey: 'technicke_udaje_hodnota', valueCode: 'upevnovaci_technika', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Maximální zatížení čelní strany dvířek chladicí části v kg', key: 'technicke_udaje', code: 'maximalni_zatizeni_celni_strany_dvirek_chladici_casti_v_kg', valueKey: 'technicke_udaje_hodnota', valueCode: 'maximalni_zatizeni_celni_strany_dvirek_chladici_casti_v_kg', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Klimatická třída', key: 'technicke_udaje', code: 'klimaticka_trida', valueKey: 'technicke_udaje_hodnota', valueCode: 'klimaticka_trida', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: '4hvězdičková mrazicí zóna v l', key: 'technicke_udaje', code: '4hvezdickova_mrazici_zona_v_l', valueKey: 'technicke_udaje_hodnota', valueCode: '4hvezdickova_mrazici_zona_v_l', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Celkový užitný objem v l', key: 'technicke_udaje', code: 'celkovy_uzitny_objem_v_l', valueKey: 'technicke_udaje_hodnota', valueCode: 'celkovy_uzitny_objem_v_l', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Doba skladování při poruše v h', key: 'technicke_udaje', code: 'doba_skladovani_pri_poruse_v_h', valueKey: 'technicke_udaje_hodnota', valueCode: 'doba_skladovani_pri_poruse_v_h', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Kapacita mražení v kg/24 h', key: 'technicke_udaje', code: 'kapacita_mrazeni_v_kg_24_h', valueKey: 'technicke_udaje_hodnota', valueCode: 'kapacita_mrazeni_v_kg_24_h', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Třída úrovně emisí hluku (A–D)', key: 'technicke_udaje', code: 'trida_urovne_emisi_hluku_a_d', valueKey: 'technicke_udaje_hodnota', valueCode: 'trida_urovne_emisi_hluku_a_d', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Úroveň emisí hluku v dB(A) re 1 pW', key: 'technicke_udaje', code: 'uroven_emisi_hluku_v_db_a_re_1_pw', valueKey: 'technicke_udaje_hodnota', valueCode: 'uroven_emisi_hluku_v_db_a_re_1_pw', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Spotřeba energie v miliampérech (mA)', key: 'technicke_udaje', code: 'spotreba_energie_v_miliamperech_ma', valueKey: 'technicke_udaje_hodnota', valueCode: 'spotreba_energie_v_miliamperech_ma', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Napětí ve V', key: 'technicke_udaje', code: 'napeti_ve_v', valueKey: 'technicke_udaje_hodnota', valueCode: 'napeti_ve_v', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Jištění v A', key: 'technicke_udaje', code: 'jisteni_v_a', valueKey: 'technicke_udaje_hodnota', valueCode: 'jisteni_v_a', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Počet fází', key: 'technicke_udaje', code: 'pocet_fazi', valueKey: 'technicke_udaje_hodnota', valueCode: 'pocet_fazi', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Frekvence v Hz', key: 'technicke_udaje', code: 'frekvence_v_hz', valueKey: 'technicke_udaje_hodnota', valueCode: 'frekvence_v_hz', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Délka elektrického přívodního kabelu v m', key: 'technicke_udaje', code: 'delka_elektrickeho_privodniho_kabelu_v_m', valueKey: 'technicke_udaje_hodnota', valueCode: 'delka_elektrickeho_privodniho_kabelu_v_m', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Výměna svítidel', key: 'technicke_udaje', code: 'vymena_svitidel', valueKey: 'technicke_udaje_hodnota', valueCode: 'vymena_svitidel', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true }
    ]
  },
  {
    title: 'DODÁVANÉ PŘÍSLUŠENSTVÍ',
    rows: [
      { label: 'Vodní filtr', key: 'dodavane_prislusenstvi', code: 'vodni_filtr', valueKey: 'dodavane_prislusenstvi_hodnota', valueCode: 'vodni_filtr', emptyAsNo: true, tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Miska na led', key: 'dodavane_prislusenstvi', code: 'miska_na_led', valueKey: 'dodavane_prislusenstvi_hodnota', valueCode: 'miska_na_led', emptyAsNo: true, tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Lopatka na led', key: 'dodavane_prislusenstvi', code: 'lopatka_na_led', valueKey: 'dodavane_prislusenstvi_hodnota', valueCode: 'lopatka_na_led', emptyAsNo: true, tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true }
    ]
  }
];

COMPARE_SCHEMAS.mycky = [
  {
    title: 'VŠEOBECNÉ ÚDAJE',
    rows: [
      { label: 'Číslo EAN', key: 'cislo_ean' },
      { label: 'Typ přístroje', key: 'typ_pristroje', alwaysShow: true },
      { label: 'Marketingová třída', key: 'marketingova_trida' }
    ]
  },
  {
    title: 'PROVEDENÍ',
    rows: [
      { label: 'Plně vestavné myčky nádobí', key: 'provedeni', code: 'plne_vestavne_mycky_nadobi', tooltipGroup: 'provedeni' },
      { label: 'Myčky nádobí o šířce 60 cm', key: 'provedeni', code: 'mycky_nadobi_o_sirce_60_cm', tooltipGroup: 'provedeni' },
      { label: 'Myčky nádobí XXL', key: 'provedeni', code: 'mycky_nadobi_xxl', tooltipGroup: 'provedeni' },
      { label: 'Volně stojící myčky nádobí', key: 'provedeni', code: 'volne_stojici_mycky_nadobi', tooltipGroup: 'provedeni' },
      { label: 'Myčky nádobí o šířce 45 cm', key: 'provedeni', code: 'mycky_nadobi_o_sirce_45_cm', tooltipGroup: 'provedeni' },
      { label: 'Vestavné myčky nádobí', key: 'provedeni', code: 'vestavne_mycky_nadobi', tooltipGroup: 'provedeni' }
    ]
  },
  {
    title: 'DESIGN',
    rows: [
      { label: 'Barva ovládacího panelu', key: 'design', code: 'barva_ovladaciho_panelu', valueKey: 'design_hodnoty', valueCode: 'barva_ovladaciho_panelu', valueOnly: true, tooltipGroup: 'design', alwaysShow: true },
      { label: 'Provedení ovládacího panelu', key: 'design', code: 'provedeni_ovladaciho_panelu', valueKey: 'design_hodnoty', valueCode: 'provedeni_ovladaciho_panelu', valueOnly: true, tooltipGroup: 'design', alwaysShow: true },
      { label: 'Způsob ovládání', key: 'design', code: 'zpusob_ovladani', valueKey: 'design_hodnoty', valueCode: 'zpusob_ovladani', valueOnly: true, tooltipGroup: 'design', alwaysShow: true },
      { label: 'Displej', key: 'design', code: 'displej', valueKey: 'design_hodnoty', valueCode: 'displej', valueOnly: true, tooltipGroup: 'design', alwaysShow: true },
      { label: 'Barva displeje', key: 'design', code: 'barva_displeje', valueKey: 'design_hodnoty', valueCode: 'barva_displeje', valueOnly: true, tooltipGroup: 'design', alwaysShow: true }
    ]
  },
  {
    title: 'KOMFORT',
    rows: [
      { label: 'MultiLingua', key: 'komfort_pri_obsluze', code: 'multilingua', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Snadné zavírání dvířek', key: 'komfort_pri_obsluze_hodnoty', code: 'snadne_zavirani_dvirek', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Indikace zbývajícího času', key: 'komfort_pri_obsluze', code: 'indikace_zbyvajiciho_casu', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Předvolba startu až 24 hodin', key: 'komfort_pri_obsluze', code: 'predvolba_startu_az_24_hodin', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Indikátor provozu / kontrolní funkce', key: 'komfort_pri_obsluze_hodnoty', code: 'indikator_provozu_kontrolni_funkce', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Propojení s Miele@home', key: 'komfort_pri_obsluze', code: 'propojeni_s_miele_home', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Automatické dávkování s PowerDiskem', key: 'komfort_pri_obsluze', code: 'automaticke_davkovani_s_powerdiskem', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Výběr jazyka displeje', key: 'komfort_pri_obsluze', code: 'vyber_jazyka_displeje', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'BrilliantLight', key: 'komfort_pri_obsluze', code: 'brilliantlight', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Knock2open', key: 'komfort_pri_obsluze', code: 'knock2open', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'FrontFit', key: 'komfort_pri_obsluze', code: 'frontfit', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Možnost doplnit nádobí', key: 'komfort_pri_obsluze', code: 'moznost_doplnit_nadobi', tooltipGroup: 'komfort_pri_obsluze' }
    ]
  },
  {
    title: 'KVALITA VÝSLEDKŮ',
    rows: [
      { label: 'Oplachování čerstvou vodou', key: 'kvalita_vysledku', code: 'oplachovani_cerstvou_vodou', tooltipGroup: 'kvalita_vysledku' },
      { label: 'Sušení AutoOpen', key: 'kvalita_vysledku', code: 'suseni_autoopen', tooltipGroup: 'kvalita_vysledku' },
      { label: 'SensorDry', key: 'kvalita_vysledku', code: 'sensordry', tooltipGroup: 'kvalita_vysledku' },
      { label: 'Aktivní kondenzační sušení', key: 'kvalita_vysledku', code: 'aktivni_kondenzacni_suseni', tooltipGroup: 'kvalita_vysledku' },
      { label: 'BrilliantGlassCare', key: 'kvalita_vysledku', code: 'brilliantglasscare', tooltipGroup: 'kvalita_vysledku' }
    ]
  },
  {
    title: 'PROGRAMY MYTÍ',
    rows: [
      { label: 'QuickPowerWash', key: 'programy_myti', code: 'quickpowerwash', tooltipGroup: 'programy_myti' },
      { label: 'ECO', key: 'programy_myti', code: 'eco', tooltipGroup: 'programy_myti' },
      { label: 'Automatika', key: 'programy_myti', code: 'automatika', tooltipGroup: 'programy_myti' },
      { label: 'Intenzivní 75 °C', key: 'programy_myti', code: 'intenzivni_75_c', tooltipGroup: 'programy_myti' },
      { label: 'Jemný', key: 'programy_myti', code: 'jemny', tooltipGroup: 'programy_myti' },
      { label: 'Extra tichý', key: 'programy_myti', code: 'extra_tichy', valueKey: 'programy_myti_hodnoty', valueCode: 'extra_tichy', emptyAsNo: true, tooltipGroup: 'programy_myti', alwaysShow: true },
      { label: 'Péče o přístroj', key: 'programy_myti', code: 'pece_o_pristroje', tooltipGroup: 'programy_myti' },
      { label: 'ComfortWash 45 °C', key: 'programy_myti', code: 'comfortwash_45_c', tooltipGroup: 'programy_myti' },
      { label: 'PowerWash', key: 'programy_myti', code: 'powerwash', tooltipGroup: 'programy_myti' },
      { label: 'ComfortWash+ 55 °C', key: 'programy_myti', code: 'comfortwash_55_c', tooltipGroup: 'programy_myti' },
      { label: 'Vypláchnutí soli', key: 'programy_myti', code: 'vyplachnuti_soli', tooltipGroup: 'programy_myti' },
      { label: 'Hygiena', key: 'programy_myti', code: 'hygiena', tooltipGroup: 'programy_myti' },
      { label: 'Solární úsporný', key: 'programy_myti', code: 'solarni_usporny', tooltipGroup: 'programy_myti' },
      { label: 'Pasta/Paella', key: 'programy_myti', code: 'pasta_paella', tooltipGroup: 'programy_myti' },
      { label: 'Bez horního koše 65 °C', key: 'programy_myti', code: 'bez_horniho_kose_65_c', tooltipGroup: 'programy_myti' }
    ]
  },
    {
    title: 'MOŽNOSTI MYTÍ',
    rows: [
      { label: 'Expres', key: 'moznosti_myti', code: 'expres', tooltipGroup: 'moznosti_myti' },
      { label: 'Extra čisté', key: 'moznosti_myti', code: 'extra_ciste', tooltipGroup: 'moznosti_myti' },
      { label: 'Extra suché', key: 'moznosti_myti', code: 'extra_suche', tooltipGroup: 'moznosti_myti' },
      { label: 'Quick / Krátký', key: 'moznosti_myti', code: 'quick_kratky', tooltipGroup: 'moznosti_myti' },
      { label: 'IntenseZone', key: 'moznosti_myti', code: 'intensezone', tooltipGroup: 'moznosti_myti' },
      { label: 'AutoDos', key: 'moznosti_myti', code: 'autodos', tooltipGroup: 'moznosti_myti' },
      { label: 'BottleClean', key: 'moznosti_myti', code: 'bottleclean', tooltipGroup: 'moznosti_myti' }
    ]
  },
  {
    title: 'KOŠOVÉ USPOŘÁDÁNÍ',
    rows: [
      { label: 'Umístění příborů', key: 'kosove_usporadani', code: 'umisteni_priboru', valueKey: 'kosove_usporadani_hodnota', valueCode: 'umisteni_priboru', tooltipGroup: 'kosove_usporadani', alwaysShow: true },
      { label: 'Odkládací plocha na šálky FlexCare', key: 'kosove_usporadani', code: 'odkladaci_plocha_na_salky_flexcare', valueKey: 'kosove_usporadani_hodnota', valueCode: 'odkladaci_plocha_na_salky_flexcare', tooltipGroup: 'kosove_usporadani', alwaysShow: true },
      { label: 'Košové uspořádání', key: 'kosove_usporadani', code: 'kosove_usporadani', valueKey: 'kosove_usporadani_hodnota', valueCode: 'kosove_usporadani', tooltipGroup: 'kosove_usporadani', alwaysShow: true },
      { label: 'Držák na sklenice FlexCare', key: 'kosove_usporadani', code: 'drzak_na_sklenice_flexcare', valueKey: 'kosove_usporadani_hodnota', valueCode: 'drzak_na_sklenice_flexcare', emptyAsNo: true, tooltipGroup: 'kosove_usporadani', alwaysShow: true },
      { label: 'MultiClip', key: 'kosove_usporadani', code: 'multiclip', tooltipGroup: 'kosove_usporadani' },
      { label: 'FlexCare Glass & Bottle', key: 'kosove_usporadani', code: 'flexcare_glass_bottle', tooltipGroup: 'kosove_usporadani' },
      { label: 'XL Assist', key: 'kosove_usporadani', code: 'xl_assist', tooltipGroup: 'kosove_usporadani' },
      { label: 'StrawClean', key: 'kosove_usporadani', code: 'strawclean', tooltipGroup: 'kosove_usporadani' }
    ]
  },
  {
    title: 'BEZPEČNOST',
    rows: [
      { label: 'Systém Waterproof', key: 'bezpecnost', code: 'system_waterproof', tooltipGroup: 'bezpecnost' },
      { label: 'Dětská pojistka', key: 'bezpecnost', code: 'detska_pojistka', tooltipGroup: 'bezpecnost' },
      { label: 'Kontrola sít', key: 'bezpecnost', code: 'kontrola_sit', tooltipGroup: 'bezpecnost' }
    ]
  },
{
  title: 'HOSPODÁRNOST A UDRŽITELNOST',
  rows: [
    { label: 'Třída energetické účinnosti (A–G)', key: 'hospodarnost_a_udrzitelnost', code: 'trida_energeticke_ucinnosti_a_g', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'trida_energeticke_ucinnosti_a_g', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
    { label: 'Spotřeba vody v programu „Automatika“ v litrech od', key: 'hospodarnost_a_udrzitelnost', code: 'spotreba_vody_v_programu_automatika_v_litrech_od', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'spotreba_vody_v_programu_automatika_v_litrech_od', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
    { label: 'Spotřeba vody v programu ECO na jeden programový cyklus v l', key: 'hospodarnost_a_udrzitelnost', code: 'spotreba_vody_v_programu_eco_na_jeden_programovy_cyklus_v_l', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'spotreba_vody_v_programu_eco_na_jeden_programovy_cyklus_v_l', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
    { label: 'Spotřeba elektrické energie v programu ECO (kWh)', key: 'hospodarnost_a_udrzitelnost', code: 'spotreba_elektricke_energie_v_programu_eco_kwh', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'spotreba_elektricke_energie_v_programu_eco_kwh', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
    { label: 'Spotřeba elektrické energie v programu ECO na 100 programových cyklů kWh', key: 'hospodarnost_a_udrzitelnost', code: 'spotreba_elektricke_energie_v_programu_eco_na_100_programovych_cyklu_kwh', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'spotreba_elektricke_energie_v_programu_eco_na_100_programovych_cyklu_kwh', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
    { label: 'Hodnota spotřeby s připojením na teplou vodu v programu ECO v (kWh)', key: 'hospodarnost_a_udrzitelnost', code: 'hodnota_spotreby_s_pripojenim_na_teplou_vodu_v_programu_eco_v_kwh', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'hodnota_spotreby_s_pripojenim_na_teplou_vodu_v_programu_eco_v_kwh', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
    { label: 'Délka programu ECO v minutách', key: 'hospodarnost_a_udrzitelnost', code: 'delka_programu_eco_v_minutach', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'delka_programu_eco_v_minutach', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
    { label: 'Příkon ve vypnutém stavu (W)', key: 'hospodarnost_a_udrzitelnost', code: 'prikon_ve_vypnutem_stavu_ve_w', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'prikon_ve_vypnutem_stavu_ve_w', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
    { label: 'Příkon v pohotovostním režimu ve W', key: 'hospodarnost_a_udrzitelnost', code: 'prikon_v_pohotovostnim_rezimu_ve_w', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'prikon_v_pohotovostnim_rezimu_ve_w', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
    { label: 'Počet jídelních souprav', key: 'hospodarnost_a_udrzitelnost', code: 'pocet_jidelnich_souprav', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'pocet_jidelnich_souprav', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
    { label: 'Třída akustických emisí', key: 'hospodarnost_a_udrzitelnost', code: 'trida_akustickych_emisi', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'trida_akustickych_emisi', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
    { label: 'Akustické emise v dB(A)', key: 'hospodarnost_a_udrzitelnost', code: 'akusticke_emise_v_db_a', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'akusticke_emise_v_db_a', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
    { label: 'Příkon v síťovém pohotovostním režimu (W)', key: 'hospodarnost_a_udrzitelnost', code: 'prikon_v_sitovem_pohotovostnim_rezimu_ve_w', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'prikon_v_sitovem_pohotovostnim_rezimu_ve_w', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },

    { label: 'Technologie EcoPower', key: 'hospodarnost_a_udrzitelnost', code: 'technologie_ecopower', tooltipGroup: 'hospodarnost_a_udrzitelnost' },
    { label: 'Testovaná hygiena', key: 'hospodarnost_a_udrzitelnost', code: 'testovana_hygiena', tooltipGroup: 'hospodarnost_a_udrzitelnost' },
    { label: 'Připojení na teplou vodu', key: 'hospodarnost_a_udrzitelnost', code: 'pripojeni_na_teplou_vodu', tooltipGroup: 'hospodarnost_a_udrzitelnost' },
    { label: 'Poloviční naplnění', key: 'hospodarnost_a_udrzitelnost', code: 'polovicni_naplneni', tooltipGroup: 'hospodarnost_a_udrzitelnost' },
    { label: 'Ekologická informace', key: 'hospodarnost_a_udrzitelnost', code: 'ekologicka_informace', tooltipGroup: 'hospodarnost_a_udrzitelnost' },
    { label: 'Časovač FlexiTimer s funkcí EcoStart', key: 'hospodarnost_a_udrzitelnost', code: 'casovac_flexitimer_s_funkci_ecostart', tooltipGroup: 'hospodarnost_a_udrzitelnost' }
  ]
},
  {
    title: 'TECHNICKÉ ÚDAJE',
    rows: [
      { label: 'Minimální šířka výklenku v mm', key: 'technicke_udaje', code: 'minimalni_sirka_vyklenku_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'minimalni_sirka_vyklenku_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Maximální šířka výklenku v mm', key: 'technicke_udaje', code: 'maximalni_sirka_vyklenku_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'maximalni_sirka_vyklenku_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Minimální výška výklenku v mm', key: 'technicke_udaje', code: 'minimalni_vyska_vyklenku_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'minimalni_vyska_vyklenku_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Maximální výška výklenku v mm', key: 'technicke_udaje', code: 'maximalni_vyska_vyklenku_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'maximalni_vyska_vyklenku_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Hloubka výklenku v mm', key: 'technicke_udaje', code: 'hloubka_vyklenku_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'hloubka_vyklenku_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Rozměry v mm (šířka)', key: 'technicke_udaje', code: 'rozmery_v_mm_sirka', valueKey: 'technicke_udaje_hodnota', valueCode: 'rozmery_v_mm_sirka', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Rozměry v mm (výška)', key: 'technicke_udaje', code: 'rozmery_v_mm_vyska', valueKey: 'technicke_udaje_hodnota', valueCode: 'rozmery_v_mm_vyska', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Rozměry v mm (hloubka)', key: 'technicke_udaje', code: 'rozmery_v_mm_hloubka', valueKey: 'technicke_udaje_hodnota', valueCode: 'rozmery_v_mm_hloubka', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Hloubka přístroje s otevřenými dvířky v cm', key: 'technicke_udaje', code: 'hloubka_pristroje_s_otevrenymi_dvirky_v_cm', valueKey: 'technicke_udaje_hodnota', valueCode: 'hloubka_pristroje_s_otevrenymi_dvirky_v_cm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Hmotnost v kg', key: 'technicke_udaje', code: 'hmotnost_v_kg', valueKey: 'technicke_udaje_hodnota', valueCode: 'hmotnost_v_kg', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Celkový příkon v kW', key: 'technicke_udaje', code: 'celkovy_prikon_v_kw', valueKey: 'technicke_udaje_hodnota', valueCode: 'celkovy_prikon_v_kw', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Napětí ve V', key: 'technicke_udaje', code: 'napeti_ve_v', valueKey: 'technicke_udaje_hodnota', valueCode: 'napeti_ve_v', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Jištění v A', key: 'technicke_udaje', code: 'jisteni_v_a', valueKey: 'technicke_udaje_hodnota', valueCode: 'jisteni_v_a', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Počet fází', key: 'technicke_udaje', code: 'pocet_fazi', valueKey: 'technicke_udaje_hodnota', valueCode: 'pocet_fazi', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Standardní elektrická frekvence', key: 'technicke_udaje', code: 'standardni_elektricka_frekvence', valueKey: 'technicke_udaje_hodnota', valueCode: 'standardni_elektricka_frekvence', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Délka přívodní hadice v m', key: 'technicke_udaje', code: 'delka_privodni_hadice_v_m', valueKey: 'technicke_udaje_hodnota', valueCode: 'delka_privodni_hadice_v_m', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Délka vypouštěcí hadice v m', key: 'technicke_udaje', code: 'delka_vypousteci_hadice_v_m', valueKey: 'technicke_udaje_hodnota', valueCode: 'delka_vypousteci_hadice_v_m', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Délka elektrického přívodního kabelu v m', key: 'technicke_udaje', code: 'delka_elektrickeho_privodniho_kabelu_v_m', valueKey: 'technicke_udaje_hodnota', valueCode: 'delka_elektrickeho_privodniho_kabelu_v_m', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Minimální hmotnost čelní desky v kg', key: 'technicke_udaje', code: 'minimalni_hmotnost_celni_desky_v_kg', valueKey: 'technicke_udaje_hodnota', valueCode: 'minimalni_hmotnost_celni_desky_v_kg', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Maximální hmotnost čelní desky v kg', key: 'technicke_udaje', code: 'maximalni_hmotnost_celni_desky_v_kg', valueKey: 'technicke_udaje_hodnota', valueCode: 'maximalni_hmotnost_celni_desky_v_kg', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Hmotnost čelní desky dostupná přes servis min. v kg', key: 'technicke_udaje', code: 'hmotnost_celni_desky_dostupna_pres_servis_min_v_kg', valueKey: 'technicke_udaje_hodnota', valueCode: 'hmotnost_celni_desky_dostupna_pres_servis_min_v_kg', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Hmotnost čelní desky dostupná přes servis max. v kg', key: 'technicke_udaje', code: 'hmotnost_celni_desky_dostupna_pres_servis_max_v_kg', valueKey: 'technicke_udaje_hodnota', valueCode: 'hmotnost_celni_desky_dostupna_pres_servis_max_v_kg', tooltipGroup: 'technicke_udaje', alwaysShow: true }
    ]
  },
  {
    title: 'DODÁVANÉ PŘÍSLUŠENSTVÍ',
    rows: [
      {
        label: 'Voucher na 1 balení UltraTabs (20 kusů) nebo 3 balení (po 60 kusech) za speciální cenu',
        key: 'dodavane_prislusenstvi',
        code: 'voucher_na_1_baleni_ultratabs_20_kusu_nebo_3_baleni_po_60_kusech_za_specialni_cenu',
        tooltipGroup: 'dodavane_prislusenstvi',
        alwaysShow: true
      },
      {
        label: '1 x PowerDisk',
        key: 'dodavane_prislusenstvi',
        code: '1x_powerdisk',
        tooltipGroup: 'dodavane_prislusenstvi',
        alwaysShow: true
      },
      {
        label: 'Voucher na 6 PowerDisků',
        key: 'dodavane_prislusenstvi',
        code: 'voucher_na_6_powerdisku',
        tooltipGroup: 'dodavane_prislusenstvi',
        alwaysShow: true
      }
    ]
  },
  {
    title: 'DOSTUPNÉ JAZYKY DISPLEJE',
    rows: [
      { label: 'Dostupné jazyky displeje díky MultiLingua', key: 'dostupne_jazyky_displeje_diky_multilingua' }
    ]
  }
];
function makeCompareMetaRows(key, valueKey, rows) {
  return rows.map(function(row) {
    const item = {
      label: row[0],
      key: key,
      code: row[1],
      tooltipGroup: key
    };

    if (valueKey) {
      item.valueKey = valueKey;
      item.valueCode = row[1];
      item.valueOnly = true;
    }

    return item;
  });
}
COMPARE_SCHEMAS.zehlici_pristroje = [
  {
    title: 'VŠEOBECNÉ ÚDAJE',
    rows: [
      { label: 'Číslo EAN', key: 'cislo_ean', alwaysShow: true }
    ]
  },
  {
    title: 'DESIGN',
    rows: [
      { label: 'Barva přístroje', key: 'design', code: 'barva_pristroje', valueKey: 'design_hodnoty', valueCode: 'barva_pristroje', valueOnly: true, tooltipGroup: 'design', alwaysShow: true },
      { label: 'Barva žehličky', key: 'design', code: 'barva_zehlicky', valueKey: 'design_hodnoty', valueCode: 'barva_zehlicky', valueOnly: true, tooltipGroup: 'design', alwaysShow: true },
      { label: 'Barva žehlicího potahu', key: 'design', code: 'barva_zehliciho_potahu', valueKey: 'design_hodnoty', valueCode: 'barva_zehliciho_potahu', valueOnly: true, tooltipGroup: 'design', alwaysShow: true },
      { label: 'Displej', key: 'design', code: 'displej', valueKey: 'design_hodnoty', valueCode: 'displej', valueOnly: true, tooltipGroup: 'design', alwaysShow: true }
    ]
  },
  {
    title: 'KOMFORT PŘI OBSLUZE',
    rows: [
      { label: 'Výběr teploty podle druhu textilie', key: 'komfort_pri_obsluze', code: 'vyber_teploty_podle_druhu_textilie', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: 'Vysoký přítlak v N/cm²', key: 'komfort_pri_obsluze', code: 'vysoky_pritlak_v_n_cm2', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'vysoky_pritlak_v_n_cm2', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Prostor pro snadné vkládání prádla', key: 'komfort_pri_obsluze', code: 'prostor_pro_snadne_vkladani_pradla', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: 'Žehlicí prkno na prádlo s velkým odkládacím prostorem', key: 'komfort_pri_obsluze', code: 'zehlici_prkno_na_pradlo_s_velkym_odkladacim_prostorem', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: 'Odkládací tyč k vychladnutí vymandlovaného prádla bez pomačkání', key: 'komfort_pri_obsluze', code: 'odkladaci_tyc_k_vychladnuti_vymandlovaneho_pradla_bez_pomackani', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: 'Funkce páry', key: 'komfort_pri_obsluze', code: 'funkce_pary', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: 'Objem vyvíječe páry v l', key: 'komfort_pri_obsluze', code: 'objem_vyvijece_pary_v_l', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'objem_vyvijece_pary_v_l', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Technika dvou zásobníků', key: 'komfort_pri_obsluze', code: 'technika_dvou_zasobniku', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: 'Provoz s vodou z vodovodu', key: 'komfort_pri_obsluze', code: 'provoz_s_vodou_z_vodovodu', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: 'Voštinová struktura', key: 'komfort_pri_obsluze', code: 'vostinova_struktura', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: 'Tlak páry v barech', key: 'komfort_pri_obsluze', code: 'tlak_pary_v_barech', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'tlak_pary_v_barech', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Množství páry v g/min', key: 'komfort_pri_obsluze', code: 'mnozstvi_pary_v_g_min', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'mnozstvi_pary_v_g_min', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Vertikální použití páry', key: 'komfort_pri_obsluze', code: 'vertikalni_pouziti_pary', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: 'Pára od teplotního stupně', key: 'komfort_pri_obsluze', code: 'para_od_teplotniho_stupne', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'para_od_teplotniho_stupne', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Dávka páry', key: 'komfort_pri_obsluze', code: 'davka_pary', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'davka_pary', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Konstantní přívod páry', key: 'komfort_pri_obsluze', code: 'konstantni_privod_pary', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: 'Aktivní žehlicí prkno (funkce nafouknutí a odsávání)', key: 'komfort_pri_obsluze', code: 'aktivni_zehlici_prkno_funkce_nafouknuti_a_odsavani', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: 'Funkce odsávání', key: 'komfort_pri_obsluze', code: 'funkce_odsavani', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: '2. výkonnostní stupeň ventilátoru', key: 'komfort_pri_obsluze', code: '2_vykonnostni_stupen_ventilatoru', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: 'Žehlicí násada s nepřilnavým efektem', key: 'komfort_pri_obsluze', code: 'zehlici_nasada_s_neprilnavym_efektem', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: 'Steamer', key: 'komfort_pri_obsluze', code: 'steamer', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: 'Testovaná protivirová hygiena', key: 'komfort_pri_obsluze', code: 'testovana_protivirova_hygiena', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: 'Vyjímatelný zásobník na vodu', key: 'komfort_pri_obsluze', code: 'vyjimatelny_zasobnik_na_vodu', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: 'Variabilní rychlost otáčení válce', key: 'komfort_pri_obsluze', code: 'variabilni_rychlost_otaceni_valce', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'variabilni_rychlost_otaceni_valce', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Savé ovinutí válce', key: 'komfort_pri_obsluze', code: 'save_ovinuti_valce', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: 'Zásobník na vodu s možností průběžného doplňování', key: 'komfort_pri_obsluze', code: 'zasobnik_na_vodu_s_moznosti_prubezneho_doplnovani', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: 'Vícevrstvé žehlení', key: 'komfort_pri_obsluze', code: 'vicevrstve_zehleni', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: 'Žehlení vsedě bez námahy', key: 'komfort_pri_obsluze', code: 'zehleni_vsede_bez_namahy', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: 'Konec válce volný po celém obvodu', key: 'komfort_pri_obsluze', code: 'konec_valce_volny_po_celem_obvodu', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: 'Přehledný ovládací panel', key: 'komfort_pri_obsluze', code: 'prehledny_ovladaci_panel', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: 'Komfortní sklápěcí mechanismus', key: 'komfort_pri_obsluze', code: 'komfortni_sklapeci_mechanismus', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: 'Snadné přemístění díky čtyřem kolečkům', key: 'komfort_pri_obsluze', code: 'snadne_premisteni_diky_ctyrem_koleckum', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: 'All-in-one', key: 'komfort_pri_obsluze', code: 'all_in_one', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: '1-2-Lift systém', key: 'komfort_pri_obsluze', code: '1_2_lift_system', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: 'Plynulé nastavení výšky pomocí pneumatických pístů v mm', key: 'komfort_pri_obsluze', code: 'plynule_nastaveni_vysky_pomoci_pneumatickych_pistu_v_mm', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'plynule_nastaveni_vysky_pomoci_pneumatickych_pistu_v_mm', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Šetrná kolečka', key: 'komfort_pri_obsluze', code: 'setrna_kolecka', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: 'Žehlicí prkno s Comfort zónou', key: 'komfort_pri_obsluze', code: 'zehlici_prkno_s_comfort_zonou', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: 'Automatické zapínání/vypínání ventilátoru', key: 'komfort_pri_obsluze', code: 'automaticke_zapinani_vypinani_ventilatoru', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: 'Ventilátor s funkcí Memory', key: 'komfort_pri_obsluze', code: 'ventilator_s_funkci_memory', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: 'Jazyková flexibilita', key: 'komfort_pri_obsluze', code: 'jazykova_flexibilita', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: 'Asistované uvedení do provozu', key: 'komfort_pri_obsluze', code: 'asistovane_uvedeni_do_provozu', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: 'Řízené odvápňování', key: 'komfort_pri_obsluze', code: 'rizene_odvapnovani', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: 'Automatické odvápňování', key: 'komfort_pri_obsluze', code: 'automaticke_odvapnovani', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: 'Automatické proplachování', key: 'komfort_pri_obsluze', code: 'automaticke_proplachovani', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: 'Úložný prostor pro žehličku', key: 'komfort_pri_obsluze', code: 'ulozny_prostor_pro_zehlicku', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true },
      { label: 'Úložný prostor pro připojovací kabel a příslušenství', key: 'komfort_pri_obsluze', code: 'ulozny_prostor_pro_pripojovaci_kabel_a_prislusenstvi', tooltipGroup: 'komfort_pri_obsluze', emptyAsNo: true, alwaysShow: true }
    ]
  },
  {
    title: 'BEZPEČNOST',
    rows: [
      { label: 'Automatický systém ochrany prstů', key: 'bezpecnost', code: 'automaticky_system_ochrany_prstu', tooltipGroup: 'bezpecnost', emptyAsNo: true, alwaysShow: true },
      { label: 'Nouzové odblokování', key: 'bezpecnost', code: 'nouzove_odblokovani', tooltipGroup: 'bezpecnost', emptyAsNo: true, alwaysShow: true },
      { label: 'Dobrá stabilita', key: 'bezpecnost', code: 'dobra_stabilita', tooltipGroup: 'bezpecnost', emptyAsNo: true, alwaysShow: true },
      { label: 'Funkce CoolDown', key: 'bezpecnost', code: 'funkce_cooldown', tooltipGroup: 'bezpecnost', emptyAsNo: true, alwaysShow: true },
      { label: 'Funkce AutoOff', key: 'bezpecnost', code: 'funkce_autooff', tooltipGroup: 'bezpecnost', emptyAsNo: true, alwaysShow: true }
    ]
  },
  {
    title: 'TECHNICKÉ ÚDAJE',
    rows: [
      { label: 'Šířka žehlicího válce v mm', key: 'technicke_udaje', code: 'sirka_zehliciho_valce_v_mm2', valueKey: 'technicke_udaje_hodnoty', valueCode: 'sirka_zehliciho_valce_v_mm2', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Objem zásobníku na vodu v l', key: 'technicke_udaje', code: 'objem_zasobniku_na_vodu_v_l2', valueKey: 'technicke_udaje_hodnoty', valueCode: 'objem_zasobniku_na_vodu_v_l2', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Rozměry v mm (šířka)', key: 'technicke_udaje', code: 'rozmery_v_mm_sirka', valueKey: 'technicke_udaje_hodnoty', valueCode: 'rozmery_v_mm_sirka', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Rozměry v mm (výška)', key: 'technicke_udaje', code: 'rozmery_v_mm_vyska', valueKey: 'technicke_udaje_hodnoty', valueCode: 'rozmery_v_mm_vyska', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Rozměry v mm (hloubka)', key: 'technicke_udaje', code: 'rozmery_v_mm_hloubka', valueKey: 'technicke_udaje_hodnoty', valueCode: 'rozmery_v_mm_hloubka', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Rozměry v mm (šířka), ve složeném stavu', key: 'technicke_udaje', code: 'rozmery_v_mm_sirka_ve_slozenem_stavu', valueKey: 'technicke_udaje_hodnoty', valueCode: 'rozmery_v_mm_sirka_ve_slozenem_stavu', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Rozměry v mm (výška), ve složeném stavu', key: 'technicke_udaje', code: 'rozmery_v_mm_vyska_ve_slozenem_stavu', valueKey: 'technicke_udaje_hodnoty', valueCode: 'rozmery_v_mm_vyska_ve_slozenem_stavu', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Rozměry v mm (hloubka), ve složeném stavu', key: 'technicke_udaje', code: 'rozmery_v_mm_hloubka_ve_slozenem_stavu', valueKey: 'technicke_udaje_hodnoty', valueCode: 'rozmery_v_mm_hloubka_ve_slozenem_stavu', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Celkový příkon v kW', key: 'technicke_udaje', code: 'celkovy_prikon_v_kw', valueKey: 'technicke_udaje_hodnoty', valueCode: 'celkovy_prikon_v_kw', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Frekvence v Hz', key: 'technicke_udaje', code: 'frekvence_v_hz', valueKey: 'technicke_udaje_hodnoty', valueCode: 'frekvence_v_hz', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true }
    ]
  },
  {
    title: 'DODÁVANÉ PŘÍSLUŠENSTVÍ',
    rows: [
      { label: 'Lepicí fólie pro volič teploty', key: 'dodavane_prislusenstvi', code: 'lepici_folie_pro_volic_teploty', tooltipGroup: 'dodavane_prislusenstvi', emptyAsNo: true, alwaysShow: true },
      { label: 'Nálevka pro doplnění zásobníku na vodu', key: 'dodavane_prislusenstvi', code: 'nalevka_pro_doplneni_zasobniku_na_vodu', tooltipGroup: 'dodavane_prislusenstvi', emptyAsNo: true, alwaysShow: true },
      { label: 'Žehlicí násada s nepřilnavým efektem – dodávané příslušenství', key: 'dodavane_prislusenstvi', code: 'zehlici_nasada_s_neprilnavym_efektem_dodavane_prislusenstvi', tooltipGroup: 'dodavane_prislusenstvi', emptyAsNo: true, alwaysShow: true },
      { label: 'Steamer – dodávané příslušenství', key: 'dodavane_prislusenstvi', code: 'steamer_dodavane_prislusenstvi', tooltipGroup: 'dodavane_prislusenstvi', emptyAsNo: true, alwaysShow: true },
      { label: 'Žehlicí potah Premium', key: 'dodavane_prislusenstvi', code: 'zehlici_potah_premium', tooltipGroup: 'dodavane_prislusenstvi', emptyAsNo: true, alwaysShow: true },
      { label: 'Držák hadice na přívod páry', key: 'dodavane_prislusenstvi', code: 'drzak_hadice_na_privod_pary', tooltipGroup: 'dodavane_prislusenstvi', emptyAsNo: true, alwaysShow: true },
      { label: 'Testovací proužek ke zjištění tvrdosti vody', key: 'dodavane_prislusenstvi', code: 'testovaci_prouzek_ke_zjisteni_tvrdosti_vody', tooltipGroup: 'dodavane_prislusenstvi', emptyAsNo: true, alwaysShow: true },
      { label: 'Odvápňovací tablety', key: 'dodavane_prislusenstvi', code: 'odvapnovaci_tablety', tooltipGroup: 'dodavane_prislusenstvi', emptyAsNo: true, alwaysShow: true }
    ]
  }
];
COMPARE_SCHEMAS.kavovary = [
  {
    title: 'VŠEOBECNÉ ÚDAJE',
    rows: [
      { label: 'Označení modelu', key: 'oznaceni_modelu' },
      { label: 'Číslo EAN', key: 'cislo_ean' },
      { label: 'Typ přístroje', key: 'typ_pristroje', alwaysShow: true },
      { label: 'Třída', key: 'trida' },
      { label: 'Typ produktu', key: 'typ_produktu' },
      { label: 'Popis', key: 'popis' },
      { label: 'Marketingové body', key: 'marketingove_body' }
    ]
  },
  {
    title: 'PROVEDENÍ A DESIGN',
    rows: [
      {
        label: 'Vestavný kávovar s mlýnkem na kávu',
        key: 'provedeni_a_design',
        code: 'vestavny_kavovar_s_mlynkem_na_kavu',
        tooltipGroup: 'provedeni_a_design'
      },
      {
        label: 'Barva přístroje',
        key: 'provedeni_a_design',
        code: 'barva_pristroje',
        valueKey: 'provedeni_a_design_hodnota',
        valueCode: 'barva_pristroje',
        valueOnly: true,
        alwaysShow: true,
        tooltipGroup: 'provedeni_a_design'
      },
      {
        label: 'PureLine',
        key: 'provedeni_a_design',
        code: 'pureline',
        tooltipGroup: 'provedeni_a_design'
      },
      {
        label: 'VitroLine',
        key: 'provedeni_a_design',
        code: 'vitroline',
        tooltipGroup: 'provedeni_a_design'
      },
      {
        label: 'ArtLine',
        key: 'provedeni_a_design',
        code: 'artline',
        tooltipGroup: 'provedeni_a_design'
      }
    ]
  },
  {
    title: 'UŽIVATELSKÉ VÝHODY',
    rows: [
      { label: 'AromaticSystemFresh', key: 'uzivatelske_vyhody', code: 'aromaticsystemfresh', tooltipGroup: 'uzivatelske_vyhody' },
      { label: 'CoffeeSelect', key: 'uzivatelske_vyhody', code: 'coffeeselect', tooltipGroup: 'uzivatelske_vyhody' },
      { label: 'Příprava OneTouch', key: 'uzivatelske_vyhody', code: 'priprava_onetouch', tooltipGroup: 'uzivatelske_vyhody' },
      { label: 'Příprava OneTouch for Two', key: 'uzivatelske_vyhody', code: 'priprava_onetouch_for_two', tooltipGroup: 'uzivatelske_vyhody' },
      { label: 'DoubleShot', key: 'uzivatelske_vyhody', code: 'doubleshot', tooltipGroup: 'uzivatelske_vyhody' },
      {
        label: 'Programovatelné uživatelské profily',
        key: 'uzivatelske_vyhody',
        code: 'programovatelne_uzivatelske_profily',
        valueKey: 'uzivatelske_vyhody_hodnota',
        valueCode: 'programovatelne_uzivatelske_profily',
        tooltipGroup: 'uzivatelske_vyhody',
        alwaysShow: true
      },
      { label: 'Kuželový mlýnek pro zavařování', key: 'uzivatelske_vyhody', code: 'kuzelovy_mlynek_pro_zavarovani', tooltipGroup: 'uzivatelske_vyhody' },
      { label: 'Nastavení stupně namletí', key: 'uzivatelske_vyhody', code: 'nastaveni_stupne_namleti', tooltipGroup: 'uzivatelske_vyhody' },
      { label: 'Nastavitelné množství namletí', key: 'uzivatelske_vyhody', code: 'nastavitelne_mnozstvi_namleti', tooltipGroup: 'uzivatelske_vyhody' },
      { label: 'Nastavitelné množství vody', key: 'uzivatelske_vyhody', code: 'nastavitelne_mnozstvi_vody', tooltipGroup: 'uzivatelske_vyhody' },
      { label: 'Nastavitelná teplota vody', key: 'uzivatelske_vyhody', code: 'nastavitelna_teplota_vody', tooltipGroup: 'uzivatelske_vyhody' },
      { label: 'Nastavitelné množství mléka', key: 'uzivatelske_vyhody', code: 'nastavitelne_mnozstvi_mleka', tooltipGroup: 'uzivatelske_vyhody' },
      { label: 'Nastavitelné množství mléčné pěny', key: 'uzivatelske_vyhody', code: 'nastavitelne_mnozstvi_mlecne_peny', tooltipGroup: 'uzivatelske_vyhody' },
      { label: 'Nastavitelné předspaření', key: 'uzivatelske_vyhody', code: 'nastavitelne_predspareni', tooltipGroup: 'uzivatelske_vyhody' },
      { label: 'TeaTimer', key: 'uzivatelske_vyhody', code: 'teatimer', tooltipGroup: 'uzivatelske_vyhody' }
    ]
  },
  {
    title: 'KOMFORT PŘI OBSLUZE',
    rows: makeCompareMetaRows('komfort_pri_obsluze', 'komfort_pri_obsluze_hodnoty', [
      ['Propojení s Miele@home', 'propojeni_s_miele_home'],
      ['Displej', 'displej'],
      ['MotionReact: osvětlení se rozsvítí při přiblížení', 'motionreact_osvetleni_se_rozsviti_pri_priblizeni'],
      ['MotionReact: displej se rozsvítí při přiblížení', 'motionreact_displej_se_rozsviti_pri_priblizeni'],
      ['CupSensor', 'cupsensor'],
      ['Režim Performance', 'rezim_performance'],
      ['Nádoba na mléko EasyClick', 'nadoba_na_mleko_easyclick'],
      ['DirectWater', 'directwater'],
      ['ComfortDoor', 'comfortdoor'],
      ['Skrytá rukojeť dvířek', 'skryta_rukojet_dvirek'],
      ['BrilliantLight', 'brilliantlight'],
      ['Osvětlení spařovací jednotky', 'osvetleni_sparovaci_jednotky'],
      ['Expert mód', 'expert_mod'],
      ['MultiLingua', 'multilingua'],
      ['MyMiele', 'mymiele'],
      ['Funkce nápovědy', 'funkce_napovedy'],
      ['Počet druhů zrnkové kávy', 'pocet_druhu_zrnkove_kavy'],
      ['Počet zásobníků na zrnkovou kávu', 'pocet_zasobniku_na_zrnkovou_kavu'],
      ['Objem zásobníku na zrnkovou kávu A v g', 'objem_zasobniku_na_zrnkovou_kavu_a_v_g'],
      ['Objem zásobníku na zrnkovou kávu B v g', 'objem_zasobniku_na_zrnkovou_kavu_b_v_g'],
      ['Objem zásobníku na zrnkovou kávu C v g', 'objem_zasobniku_na_zrnkovou_kavu_c_v_g'],
      ['Celkový objem zásobníku na zrnkovou kávu v g', 'celkovy_objem_zasobniku_na_zrnkovou_kavu_v_g'],
      ['Vyjímatelné zásobníky na zrnkovou kávu', 'vyjimatelne_zasobniky_na_zrnkovou_kavu'],
      ['Objem zásobníku na vodu v l', 'objem_zasobniku_na_vodu_v_l'],
      ['Objem nádoby na mléko v l', 'objem_nadoby_na_mleko_v_l'],
      ['Objem zásobníku na kávovou sedlinu v ks', 'objem_zasobniku_na_kavovou_sedlinu_v_ks'],
      ['Objem odkapávací misky v l', 'objem_odkapavaci_misky_v_l'],
      ['Snadno přístupné zásobníky', 'snadno_pristupne_zasobniky'],
      ['Zobrazení denního času', 'zobrazeni_denniho_casu'],
      ['Synchronizace času', 'synchronizace_casu'],
      ['Zobrazení data', 'zobrazeni_data'],
      ['Nastavitelný čas zapnutí', 'nastavitelny_cas_zapnuti'],
      ['Nastavitelný čas vypnutí', 'nastavitelny_cas_vypnuti'],
      ['Nastavitelné přepnutí do pohotovostního režimu', 'nastavitelne_prepnuti_do_pohotovostniho_rezimu'],
      ['Individuální nastavení', 'individualni_nastaveni']
    ])
  },
  {
    title: 'NÁPOJOVÉ SPECIALITY',
    rows: [
      ['Nastavitelné množství nápoje v ml', 'nastavitelne_mnozstvi_napoje_v_ml'],
      ['Ristretto klasické', 'ristretto_klasicke'],
      ['Ristretto dvojité', 'ristretto_dvojite'],
      ['Espresso klasické', 'espresso_klasicke'],
      ['Espresso dvojité', 'espresso_dvojite'],
      ['Káva klasická', 'kava_klasicka'],
      ['Káva dvojitá', 'kava_dvojita'],
      ['Caffè lungo klasické', 'caffe_lungo_klasicke'],
      ['Caffè lungo dvojité', 'caffe_lungo_dvojite'],
      ['Cappuccino klasické', 'cappuccino_klasicke'],
      ['Horké mléko klasické', 'horke_mleko_klasicke'],
      ['Horké mléko dvojité', 'horke_mleko_dvojite'],
      ['Mléčná pěna klasická', 'mlecna_pena_klasicka'],
      ['Mléčná pěna dvojitá', 'mlecna_pena_dvojita'],
      ['Espresso macchiato klasické', 'espresso_macchiato_klasicke'],
      ['Espresso macchiato dvojité', 'espresso_macchiato_dvojite'],
      ['Cappuccino italiano klasické', 'cappuccino_italiano_klasicke'],
      ['Cappuccino italiano dvojité', 'cappuccino_italiano_dvojite'],
      ['Flat white klasická', 'flat_white_klasicka'],
      ['Flat white dvojitá', 'flat_white_dvojita'],
      ['Café au lait klasické', 'cafe_au_lait_klasicke'],
      ['Café au lait dvojité', 'cafe_au_lait_dvojite'],
      ['Caffè latte klasické', 'caffe_latte_klasicke'],
      ['Caffè latte dvojité', 'caffe_latte_dvojite'],
      ['Caffè americano klasické', 'caffe_americano_klasicke'],
      ['Caffè americano dvojité', 'caffe_americano_dvojite'],
      ['Long black klasická', 'long_black_klasicka'],
      ['Long black dvojitá', 'long_black_dvojita'],
      ['Teplá voda klasická', 'tepla_voda_klasicka'],
      ['Teplá voda dvojitá', 'tepla_voda_dvojita'],
      ['Horká voda klasická', 'horka_voda_klasicka'],
      ['Horká voda dvojitá', 'horka_voda_dvojita'],
      ['Černý čaj klasický', 'cerny_caj_klasicky'],
      ['Černý čaj dvojitý', 'cerny_caj_dvojity'],
      ['Bylinkový čaj klasický', 'bylinkovy_caj_klasicky'],
      ['Bylinkový čaj dvojitý', 'bylinkovy_caj_dvojity'],
      ['Ovocný čaj klasický', 'ovocny_caj_klasicky'],
      ['Ovocný čaj dvojitý', 'ovocny_caj_dvojity'],
      ['Zelený čaj klasický', 'zeleny_caj_klasicky'],
      ['Zelený čaj dvojitý', 'zeleny_caj_dvojity'],
      ['Bílý čaj klasický', 'bily_caj_klasicky'],
      ['Bílý čaj dvojitý', 'bily_caj_dvojity'],
      ['Japonský čaj klasický', 'japonsky_caj_klasicky'],
      ['Japonský čaj dvojitý', 'japonsky_caj_dvojity'],
      ['Chai latte klasický', 'chai_latte_klasicky'],
      ['Chai latte dvojitý', 'chai_latte_dvojity'],
      ['Konvice kávy', 'konvice_kavy'],
      ['Konvice čaje', 'konvice_caje'],
      ['Cappuccino dvojité', 'cappuccino_dvojite'],
      ['Latte macchiato dvojité', 'latte_macchiato_dvojite'],
      ['Latte macchiato klasické', 'latte_macchiato_klasicke']
    ].map(function(row) {
      const item = {
        label: row[0],
        key: 'napojove_speciality',
        code: row[1],
        alwaysShow: true,
        tooltipGroup: 'napojove_speciality'
      };

      if (row[1] === 'nastavitelne_mnozstvi_napoje_v_ml') {
        item.valueKey = 'custom_napojove_speciality_hodnota';
        item.valueCode = row[1];
        item.emptyAsText = true;
      }

      return item;
    })
  },
  {
    title: 'HOSPODÁRNOST A UDRŽITELNOST',
    rows: makeCompareMetaRows('hospodarnost_a_udrzitelnost', 'hospodarnost_a_udrzitelnost_hodnoty', [
      ['Energeticky úsporný režim ECO', 'energeticky_usporny_rezim_eco'],
      ['Příkon v pohotovostním režimu ve W', 'prikon_v_pohotovostnim_rezimu_ve_w'],
      ['Příkon v síťovém pohotovostním režimu ve W', 'prikon_v_sitovem_pohotovostnim_rezimu_ve_w'],
      ['Čas do automatického zapnutí z vypnutého stavu v min', 'cas_do_automatickeho_zapnuti_z_vypnuteho_stavu_v_min'],
      ['Čas do automatického zapnutí z pohotovostního režimu v min', 'cas_do_automatickeho_zapnuti_z_pohotovostniho_rezimu_v_min'],
      ['Čas do automatického zapnutí ze síťového pohotovostního režimu v min', 'cas_do_automatickeho_zapnuti_ze_sitoveho_pohotovostniho_rezimu_v_min'],
      ['Příkon ve stavu pohotovosti ve W', 'prikon_ve_stavu_pohotovosti_ve_w'],
      ['Doba do automatického přepnutí do pohotovostního režimu v min', 'doba_do_automatickeho_prepnuti_do_pohotovostniho_rezimu_v_min'],
      ['Doba do automatického přepnutí do síťového pohotovostního režimu v min', 'doba_do_automatickeho_prepnuti_do_sitoveho_pohotovostniho_rezimu_v_min']
    ])
  },
  {
    title: 'KOMFORT PŘI ÚDRŽBĚ',
    rows: makeCompareMetaRows('komfort_pri_udrzbe', 'komfort_pri_udrzbe_hodnoty', [
      ['Nerezová čelní stěna s povrchem CleanSteel', 'nerezova_celni_stena_s_povrchem_cleansteel'],
      ['Automatické odvápňování', 'automaticke_odvapnovani'],
      ['Manuální odvápňování', 'manualni_odvapnovani'],
      ['AutoClean', 'autoclean'],
      ['Automatické proplachování rozvodů mléka ze zásobníku na vodu', 'automaticke_proplachovani_rozvodu_mleka_ze_zasobniku_na_vodu'],
      ['Komfortní čisticí programy', 'komfortni_cistici_programy'],
      ['Funkce automatického propláchnutí', 'funkce_automatickeho_proplachnuti'],
      ['ComfortClean', 'comfortclean'],
      ['Vyjímatelné rozvody mléka', 'vyjimatelne_rozvody_mleka'],
      ['Vyjímatelná spařovací jednotka', 'vyjimatelna_sparovaci_jednotka'],
      ['Nastavitelná tvrdost vody', 'nastavitelna_tvrdost_vody']
    ])
  },
  {
    title: 'BEZPEČNOST',
    rows: makeCompareMetaRows('bezpecnost', null, [
      ['Zablokování zprovoznění', 'zablokovani_zprovozneni']
    ])
  },
  {
    title: 'TECHNICKÉ ÚDAJE',
    rows: makeCompareMetaRows('technicke_udaje', 'technicke_udaje_hodnoty', [
      ['Minimální šířka výklenku v mm', 'minimalni_sirka_vyklenku_v_mm'],
      ['Maximální šířka výklenku v mm', 'maximalni_sirka_vyklenku_v_mm'],
      ['Minimální výška výklenku v mm', 'minimalni_vyska_vyklenku_v_mm'],
      ['Maximální výška výklenku v mm', 'maximalni_vyska_vyklenku_v_mm'],
      ['Hloubka výklenku v mm', 'hloubka_vyklenku_v_mm'],
      ['Výškově nastavitelné trysky – max. v cm', 'vyskove_nastavitelne_trysky_max_v_cm'],
      ['Výškově nastavitelné trysky – min. v cm', 'vyskove_nastavitelne_trysky_min_v_cm'],
      ['Šířka přístroje v mm', 'sirka_pristroje_v_mm'],
      ['Výška přístroje v mm', 'vyska_pristroje_v_mm'],
      ['Hloubka přístroje v mm', 'hloubka_pristroje_v_mm'],
      ['Hloubka s otevřenými dvířky v cm', 'hloubka_s_otevrenymi_dvirky_v_cm'],
      ['Celkový příkon v kW', 'celkovy_prikon_v_kw'],
      ['Napětí ve V', 'napeti_ve_v'],
      ['Jištění v A', 'jisteni_v_a'],
      ['Počet fází', 'pocet_fazi'],
      ['Délka přívodní hadice v m', 'delka_privodni_hadice_v_m'],
      ['Délka elektrického přívodního kabelu v m', 'delka_elektrickeho_privodniho_kabelu_v_m']
    ])
  },
  {
    title: 'DODÁVANÉ PŘÍSLUŠENSTVÍ',
    rows: [
      {
        label: 'Skleněná nádoba na mléko',
        key: 'dodavane_prislusenstvi',
        code: 'sklenena_nadoba_na_mleko',
        tooltipGroup: 'dodavane_prislusenstvi',
        alwaysShow: true
      },
      {
        label: 'Odvápňovací kartuše',
        key: 'dodavane_prislusenstvi',
        code: 'odvapnovaci_kartuse',
        tooltipGroup: 'dodavane_prislusenstvi',
        alwaysShow: true
      },
      {
        label: 'Odvápňovací tablety',
        key: 'dodavane_prislusenstvi',
        code: 'odvapnovaci_tablety',
        tooltipGroup: 'dodavane_prislusenstvi',
        alwaysShow: true
      },
      {
        label: 'Čisticí tablety',
        key: 'dodavane_prislusenstvi',
        code: 'cistici_tablety',
        tooltipGroup: 'dodavane_prislusenstvi',
        alwaysShow: true
      },
      {
        label: 'Čisticí prostředek na rozvody mléka',
        key: 'dodavane_prislusenstvi',
        code: 'cistici_prostredek_na_rozvody_mleka',
        tooltipGroup: 'dodavane_prislusenstvi',
        alwaysShow: true
      },
      {
        label: 'AutoCleaner',
        key: 'dodavane_prislusenstvi',
        code: 'autocleaner',
        tooltipGroup: 'dodavane_prislusenstvi',
        alwaysShow: true
      }
    ]
  },
  {
    title: 'INSTALAČNÍ VÝKRESY',
    rows: [
      {
        label: 'Boční pohled',
        key: 'instalacni_vykresy',
        code: 'bocni_pohled',
        tooltipGroup: 'instalacni_vykresy',
        alwaysShow: true
      },
      {
        label: 'Pohled shora',
        key: 'instalacni_vykresy',
        code: 'pohled_shora',
        tooltipGroup: 'instalacni_vykresy',
        alwaysShow: true
      },
      {
        label: 'Instalační výkres',
        key: 'instalacni_vykresy',
        code: 'instalacni_vykres',
        tooltipGroup: 'instalacni_vykresy',
        alwaysShow: true
      },
      {
        label: 'Vestavba do vysoké skříně s přípojkou čerstvé vody',
        key: 'instalacni_vykresy',
        code: 'vestavba_do_vysoke_skrine_s_pripojkou_cerstve_vody',
        tooltipGroup: 'instalacni_vykresy',
        alwaysShow: true
      }
    ]
  },
  {
    title: 'DOSTUPNÉ JAZYKY DISPLEJE',
    rows: [
      { label: 'Dostupné jazyky displeje díky funkci MultiLingua', key: 'dostupne_jazyky_displeje_diky_multilingua', alwaysShow: true }
    ]
  }
];
COMPARE_SCHEMAS.profesionalni_mycky = [
   {
    title: 'VŠEOBECNÉ INFORMACE',
    rows: [
      { label: 'Číslo EAN', key: 'cislo_ean', alwaysShow: true },
  { label: 'Typ přístroje', key: 'typ_pristroje', alwaysShow: true }
    ]
  },
  {
    title: 'PROVEDENÍ',
  rows: [
    {
      label: 'Provedení',
      key: 'provedeni',
      code: 'provedeni',
      valueKey: 'provedeni_hodnota',
      valueCode: 'provedeni',
      tooltipGroup: 'provedeni',
      alwaysShow: true
    },
    {
      label: 'Myčka nádobí XXL',
      key: 'provedeni',
      code: 'mycka_nadobi_xxl',
      tooltipGroup: 'provedeni',
      alwaysShow: true
    },
    {
      label: 'Řada',
      key: 'provedeni',
      code: 'rada',
      valueKey: 'provedeni_hodnota',
      valueCode: 'rada',
      tooltipGroup: 'provedeni',
      alwaysShow: true
    },
    {
      label: 'Mycí systém',
      key: 'provedeni',
      code: 'myci_system',
      valueKey: 'provedeni_hodnota',
      valueCode: 'myci_system',
      tooltipGroup: 'provedeni',
      alwaysShow: true
    },
    {
      label: 'Počet úrovní mytí',
      key: 'provedeni',
      code: 'pocet_urovni_myti',
      valueKey: 'provedeni_hodnota',
      valueCode: 'pocet_urovni_myti',
      tooltipGroup: 'provedeni',
      alwaysShow: true
    },
    {
      label: 'Čelní stěna',
      key: 'provedeni',
      code: 'celni_stena',
      valueKey: 'provedeni_hodnota',
      valueCode: 'celni_stena',
      tooltipGroup: 'provedeni',
      alwaysShow: true
    },
    {
      label: 'Víko',
      key: 'provedeni',
      code: 'viko',
      valueKey: 'provedeni_hodnota',
      valueCode: 'viko',
      tooltipGroup: 'provedeni',
      alwaysShow: true
    },
    {
      label: 'Boční stěny',
      key: 'provedeni',
      code: 'bocni_steny',
      valueKey: 'provedeni_hodnota',
      valueCode: 'bocni_steny',
      tooltipGroup: 'provedeni',
      alwaysShow: true
    },
    {
      label: 'Barva ovládacího panelu',
      key: 'provedeni',
      code: 'barva_ovladaciho_panelu',
      valueKey: 'provedeni_hodnota',
      valueCode: 'barva_ovladaciho_panelu',
      tooltipGroup: 'provedeni',
      alwaysShow: true
    },
    {
      label: 'Minimální hmotnost čelní desky v kg',
      key: 'provedeni',
      code: 'minimalni_hmotnost_celni_desky_v_kg',
      valueKey: 'provedeni_hodnota',
      valueCode: 'minimalni_hmotnost_celni_desky_v_kg',
      tooltipGroup: 'provedeni',
      alwaysShow: true
    },
    {
      label: 'Maximální hmotnost čelní desky v kg',
      key: 'provedeni',
      code: 'maximalni_hmotnost_celni_desky_v_kg',
      valueKey: 'provedeni_hodnota',
      valueCode: 'maximalni_hmotnost_celni_desky_v_kg',
      tooltipGroup: 'provedeni',
      alwaysShow: true
    }
  ]
},
{
  title: 'POUŽITÍ',
  rows: [
    {
      label: 'Vhodné pro penziony',
      key: 'pouziti',
      code: 'penziony',
      tooltipGroup: 'pouziti',
      alwaysShow: true
    },
    {
      label: 'Vhodné pro univerzity a školy',
      key: 'pouziti',
      code: 'univerzity_skoly',
      tooltipGroup: 'pouziti',
      alwaysShow: true
    },
    {
      label: 'Vhodné pro kanceláře a agentury',
      key: 'pouziti',
      code: 'kancelare_agentury',
      tooltipGroup: 'pouziti',
      alwaysShow: true
    },
    {
      label: 'Vhodné pro domácnosti',
      key: 'pouziti',
      code: 'domacnosti',
      tooltipGroup: 'pouziti',
      alwaysShow: true
    },
    {
      label: 'Vhodné pro řemeslnou výrobu',
      key: 'pouziti',
      code: 'remeslna_vyroba',
      tooltipGroup: 'pouziti',
      alwaysShow: true
    },
    {
      label: 'Vhodné pro sportovní kluby',
      key: 'pouziti',
      code: 'sportovni_kluby',
      tooltipGroup: 'pouziti',
      alwaysShow: true
    }
  ]
},
  {
    title: 'VÝKONOVÉ ÚDAJE',
    rows: [
      {
        label: 'Prověřená účinnost proti virům',
        key: 'vykonove_udaje',
        code: 'proverena_ucinnost_proti_virum',
        valueKey: 'vykonove_udaje_hodnota',
        valueCode: 'proverena_ucinnost_proti_virum',
        tooltipGroup: 'vykonove_udaje',
        alwaysShow: true
      },
      {
        label: 'Testovaná hygiena',
        key: 'vykonove_udaje',
        code: 'testovana_hygiena',
        valueKey: 'vykonove_udaje_hodnota',
        valueCode: 'testovana_hygiena',
        tooltipGroup: 'vykonove_udaje',
        alwaysShow: true
      },
      {
        label: 'Oběhové čerpadlo, Qmax v l/min',
        key: 'vykonove_udaje',
        code: 'obehove_cerpadlo_qmax_v_l_min',
        valueKey: 'vykonove_udaje_hodnota',
        valueCode: 'obehove_cerpadlo_qmax_v_l_min',
        tooltipGroup: 'vykonove_udaje',
        alwaysShow: true
      },
      {
        label: 'Nejkratší čas programu v min',
        key: 'vykonove_udaje',
        code: 'nejkratsi_cas_programu_v_min',
        valueKey: 'vykonove_udaje_hodnota',
        valueCode: 'nejkratsi_cas_programu_v_min',
        tooltipGroup: 'vykonove_udaje',
        alwaysShow: true
      },
      {
        label: 'Maximální teplota oplachování ve °C',
        key: 'vykonove_udaje',
        code: 'maximalni_teplota_oplachovani_ve_c',
        valueKey: 'vykonove_udaje_hodnota',
        valueCode: 'maximalni_teplota_oplachovani_ve_c',
        tooltipGroup: 'vykonove_udaje',
        alwaysShow: true
      },
      {
        label: 'Čisticí výkon počet jídelních souprav/šarže',
        key: 'vykonove_udaje',
        code: 'cistici_vykon_pocet_jidelnich_souprav_sarze',
        valueKey: 'vykonove_udaje_hodnota',
        valueCode: 'cistici_vykon_pocet_jidelnich_souprav_sarze',
        tooltipGroup: 'vykonove_udaje',
        alwaysShow: true
      },
      {
        label: 'Životnost v cyklech mytí',
        key: 'vykonove_udaje',
        code: 'zivotnost_v_cyklech_myti',
        valueKey: 'vykonove_udaje_hodnota',
        valueCode: 'zivotnost_v_cyklech_myti',
        tooltipGroup: 'vykonove_udaje',
        alwaysShow: true
      }
    ]
  },
  {
    title: 'ŘÍDICÍ JEDNOTKA',
    rows: [
      { label: 'Typ ovládání', key: 'ridici_jednotka', code: 'typ_ovladani', valueKey: 'ridici_jednotka_hodnota', valueCode: 'typ_ovladani', tooltipGroup: 'ridici_jednotka', alwaysShow: true },
      { label: 'Výběr programů', key: 'ridici_jednotka', code: 'vyber_programu', valueKey: 'ridici_jednotka_hodnota', valueCode: 'vyber_programu', tooltipGroup: 'ridici_jednotka', alwaysShow: true },
      { label: 'Maximální předvolba startu v hodinách', key: 'ridici_jednotka', code: 'maximalni_predvolba_startu_v_hodinach', valueKey: 'ridici_jednotka_hodnota', valueCode: 'maximalni_predvolba_startu_v_hodinach', tooltipGroup: 'ridici_jednotka', alwaysShow: true },
      { label: 'Indikace zbývajícího času', key: 'ridici_jednotka', code: 'indikace_zbyvajiciho_casu', valueKey: 'ridici_jednotka_hodnota', valueCode: 'indikace_zbyvajiciho_casu', tooltipGroup: 'ridici_jednotka', alwaysShow: true },
      { label: 'Mycí programy [počet]', key: 'ridici_jednotka', code: 'myci_programy_pocet', valueKey: 'ridici_jednotka_hodnota', valueCode: 'myci_programy_pocet', tooltipGroup: 'ridici_jednotka', alwaysShow: true },
      { label: 'Nastavitelná teplota oplachu', key: 'ridici_jednotka', code: 'nastavitelna_teplota_oplachu', valueKey: 'ridici_jednotka_hodnota', valueCode: 'nastavitelna_teplota_oplachu', tooltipGroup: 'ridici_jednotka', alwaysShow: true },
      { label: 'Indikace průběhu programu', key: 'ridici_jednotka', code: 'indikace_prubehu_programu', valueKey: 'ridici_jednotka_hodnota', valueCode: 'indikace_prubehu_programu', tooltipGroup: 'ridici_jednotka', alwaysShow: true },
      { label: 'Nastavitelné jazyky displeje', key: 'ridici_jednotka', code: 'nastavitelne_jazyky_displeje', valueKey: 'ridici_jednotka_hodnota', valueCode: 'nastavitelne_jazyky_displeje', tooltipGroup: 'ridici_jednotka', alwaysShow: true },
      { label: 'Kontrola sít', key: 'ridici_jednotka', code: 'kontrola_sit', valueKey: 'ridici_jednotka_hodnota', valueCode: 'kontrola_sit', tooltipGroup: 'ridici_jednotka', alwaysShow: true }
    ]
  },
  {
    title: 'STANDARDNÍ ELEKTRICKÉ PŘIPOJENÍ',
    rows: [
      { label: 'Elektrická přípojka', key: 'standardni_elektricke_pripojeni', code: 'elektricka_pripojka', valueKey: 'standardni_elektricke_pripojeni_hodnota', valueCode: 'elektricka_pripojka', tooltipGroup: 'standardni_elektricke_pripojeni', alwaysShow: true },
      { label: 'Topný výkon v kW', key: 'standardni_elektricke_pripojeni', code: 'topny_vykon_v_kw', valueKey: 'standardni_elektricke_pripojeni_hodnota', valueCode: 'topny_vykon_v_kw', tooltipGroup: 'standardni_elektricke_pripojeni', alwaysShow: true },
      { label: 'Celkový příkon v kW', key: 'standardni_elektricke_pripojeni', code: 'celkovy_prikon_v_kw', valueKey: 'standardni_elektricke_pripojeni_hodnota', valueCode: 'celkovy_prikon_v_kw', tooltipGroup: 'standardni_elektricke_pripojeni', alwaysShow: true },
      { label: 'Jištění v A', key: 'standardni_elektricke_pripojeni', code: 'jisteni_v_a', valueKey: 'standardni_elektricke_pripojeni_hodnota', valueCode: 'jisteni_v_a', tooltipGroup: 'standardni_elektricke_pripojeni', alwaysShow: true },
      { label: 'Délka přívodního síťového kabelu v m', key: 'standardni_elektricke_pripojeni', code: 'delka_privodniho_sitoveho_kabelu_v_m', valueKey: 'standardni_elektricke_pripojeni_hodnota', valueCode: 'delka_privodniho_sitoveho_kabelu_v_m', tooltipGroup: 'standardni_elektricke_pripojeni', alwaysShow: true }
    ]
  },
  {
    title: 'MOŽNÁ VARIANTA NAPĚTÍ 1',
    rows: [
      { label: 'Elektrická přípojka', key: 'mozna_varianta_napeti_1', code: 'elektricka_pripojka', valueKey: 'mozna_varianta_napeti_1_hodnota', valueCode: 'elektricka_pripojka', tooltipGroup: 'mozna_varianta_napeti_1', alwaysShow: true },
      { label: 'Topný výkon v kW', key: 'mozna_varianta_napeti_1', code: 'topny_vykon_v_kw', valueKey: 'mozna_varianta_napeti_1_hodnota', valueCode: 'topny_vykon_v_kw', tooltipGroup: 'mozna_varianta_napeti_1', alwaysShow: true },
      { label: 'Celkový příkon v kW', key: 'mozna_varianta_napeti_1', code: 'celkovy_prikon_v_kw', valueKey: 'mozna_varianta_napeti_1_hodnota', valueCode: 'celkovy_prikon_v_kw', tooltipGroup: 'mozna_varianta_napeti_1', alwaysShow: true },
      { label: 'Jištění v A', key: 'mozna_varianta_napeti_1', code: 'jisteni_v_a', valueKey: 'mozna_varianta_napeti_1_hodnota', valueCode: 'jisteni_v_a', tooltipGroup: 'mozna_varianta_napeti_1', alwaysShow: true }
    ]
  },
  {
    title: 'PŘÍPOJKA PŘÍVODU A ODVODU VODY',
    rows: [
      { label: 'Studená nebo teplá voda [počet]', key: 'pripojka_privodu_a_odvodu_vody', code: 'studena_nebo_tepla_voda_pocet', valueKey: 'pripojka_privodu_a_odvodu_vody_hodnota', valueCode: 'studena_nebo_tepla_voda_pocet', tooltipGroup: 'pripojka_privodu_a_odvodu_vody', alwaysShow: true },
      { label: 'Potřebný průtokový tlak v barech', key: 'pripojka_privodu_a_odvodu_vody', code: 'potrebny_prutokovy_tlak_v_barech', valueKey: 'pripojka_privodu_a_odvodu_vody_hodnota', valueCode: 'potrebny_prutokovy_tlak_v_barech', tooltipGroup: 'pripojka_privodu_a_odvodu_vody', alwaysShow: true },
      { label: 'Vypouštěcí čerpadlo [DN]', key: 'pripojka_privodu_a_odvodu_vody', code: 'vypousteci_cerpadlo_dn', valueKey: 'pripojka_privodu_a_odvodu_vody_hodnota', valueCode: 'vypousteci_cerpadlo_dn', tooltipGroup: 'pripojka_privodu_a_odvodu_vody', alwaysShow: true },
      { label: 'Maximální dopravní výška vypouštěcího čerpadla v cm', key: 'pripojka_privodu_a_odvodu_vody', code: 'maximalni_dopravni_vyska_vypousteciho_cerpadla_v_cm', valueKey: 'pripojka_privodu_a_odvodu_vody_hodnota', valueCode: 'maximalni_dopravni_vyska_vypousteciho_cerpadla_v_cm', tooltipGroup: 'pripojka_privodu_a_odvodu_vody', alwaysShow: true },
      { label: 'Integrovaný změkčovač vody', key: 'pripojka_privodu_a_odvodu_vody', code: 'integrovany_zmekcovac_vody', valueKey: 'pripojka_privodu_a_odvodu_vody_hodnota', valueCode: 'integrovany_zmekcovac_vody', tooltipGroup: 'pripojka_privodu_a_odvodu_vody', alwaysShow: true },
      { label: 'Maximální tvrdost vody v mmol/l', key: 'pripojka_privodu_a_odvodu_vody', code: 'maximalni_tvrdost_vody_v_mmol_l', valueKey: 'pripojka_privodu_a_odvodu_vody_hodnota', valueCode: 'maximalni_tvrdost_vody_v_mmol_l', tooltipGroup: 'pripojka_privodu_a_odvodu_vody', alwaysShow: true },
      { label: 'Systém ochrany proti poškození vodou', key: 'pripojka_privodu_a_odvodu_vody', code: 'system_ochrany_proti_poskozeni_vodou', valueKey: 'pripojka_privodu_a_odvodu_vody_hodnota', valueCode: 'system_ochrany_proti_poskozeni_vodou', tooltipGroup: 'pripojka_privodu_a_odvodu_vody', alwaysShow: true },
      { label: 'Délka přívodní hadice vody v cm', key: 'pripojka_privodu_a_odvodu_vody', code: 'delka_privodni_hadice_vody_v_cm', valueKey: 'pripojka_privodu_a_odvodu_vody_hodnota', valueCode: 'delka_privodni_hadice_vody_v_cm', tooltipGroup: 'pripojka_privodu_a_odvodu_vody', alwaysShow: true },
      { label: 'Délka vypouštěcí hadice vody v cm', key: 'pripojka_privodu_a_odvodu_vody', code: 'delka_vypousteci_hadice_vody_v_cm', valueKey: 'pripojka_privodu_a_odvodu_vody_hodnota', valueCode: 'delka_vypousteci_hadice_vody_v_cm', tooltipGroup: 'pripojka_privodu_a_odvodu_vody', alwaysShow: true }
    ]
  },
  {
    title: 'ROZMĚRY A HMOTNOST',
    rows: [
      { label: 'Vnější rozměr, výška v mm', key: 'rozmery_a_hmotnost', code: 'vnejsi_rozmer_vyska_v_mm', valueKey: 'rozmery_a_hmotnost_hodnota', valueCode: 'vnejsi_rozmer_vyska_v_mm', tooltipGroup: 'rozmery_a_hmotnost', alwaysShow: true },
      { label: 'Vnější rozměr s víkem, výška v mm', key: 'rozmery_a_hmotnost', code: 'vnejsi_rozmer_s_vikem_vyska_v_mm', valueKey: 'rozmery_a_hmotnost_hodnota', valueCode: 'vnejsi_rozmer_s_vikem_vyska_v_mm', tooltipGroup: 'rozmery_a_hmotnost', alwaysShow: true, emptyAsText: true },
      { label: 'Vnější rozměr, šířka v mm', key: 'rozmery_a_hmotnost', code: 'vnejsi_rozmer_sirka_v_mm', valueKey: 'rozmery_a_hmotnost_hodnota', valueCode: 'vnejsi_rozmer_sirka_v_mm', tooltipGroup: 'rozmery_a_hmotnost', alwaysShow: true },
      { label: 'Vnější rozměr, hloubka v mm', key: 'rozmery_a_hmotnost', code: 'vnejsi_rozmer_hloubka_v_mm', valueKey: 'rozmery_a_hmotnost_hodnota', valueCode: 'vnejsi_rozmer_hloubka_v_mm', tooltipGroup: 'rozmery_a_hmotnost', alwaysShow: true },
      { label: 'Vnější rozměr, výška brutto v mm', key: 'rozmery_a_hmotnost', code: 'vnejsi_rozmer_vyska_brutto_v_mm', valueKey: 'rozmery_a_hmotnost_hodnota', valueCode: 'vnejsi_rozmer_vyska_brutto_v_mm', tooltipGroup: 'rozmery_a_hmotnost', alwaysShow: true },
      { label: 'Vnější rozměr, šířka brutto v mm', key: 'rozmery_a_hmotnost', code: 'vnejsi_rozmer_sirka_brutto_v_mm', valueKey: 'rozmery_a_hmotnost_hodnota', valueCode: 'vnejsi_rozmer_sirka_brutto_v_mm', tooltipGroup: 'rozmery_a_hmotnost', alwaysShow: true },
      { label: 'Vnější rozměr, hloubka brutto v mm', key: 'rozmery_a_hmotnost', code: 'vnejsi_rozmer_hloubka_brutto_v_mm', valueKey: 'rozmery_a_hmotnost_hodnota', valueCode: 'vnejsi_rozmer_hloubka_brutto_v_mm', tooltipGroup: 'rozmery_a_hmotnost', alwaysShow: true },
      { label: 'Užitný mycí prostor, výška v mm', key: 'rozmery_a_hmotnost', code: 'uzitny_myci_prostor_vyska_v_mm', valueKey: 'rozmery_a_hmotnost_hodnota', valueCode: 'uzitny_myci_prostor_vyska_v_mm', tooltipGroup: 'rozmery_a_hmotnost', alwaysShow: true },
      { label: 'Užitný mycí prostor, šířka v mm', key: 'rozmery_a_hmotnost', code: 'uzitny_myci_prostor_sirka_v_mm', valueKey: 'rozmery_a_hmotnost_hodnota', valueCode: 'uzitny_myci_prostor_sirka_v_mm', tooltipGroup: 'rozmery_a_hmotnost', alwaysShow: true },
      { label: 'Užitný mycí prostor, hloubka horního koše v mm', key: 'rozmery_a_hmotnost', code: 'uzitny_myci_prostor_hloubka_horniho_kose_v_mm', valueKey: 'rozmery_a_hmotnost_hodnota', valueCode: 'uzitny_myci_prostor_hloubka_horniho_kose_v_mm', tooltipGroup: 'rozmery_a_hmotnost', alwaysShow: true },
      { label: 'Užitný mycí prostor, hloubka spodního koše v mm', key: 'rozmery_a_hmotnost', code: 'uzitny_myci_prostor_hloubka_spodniho_kose_v_mm', valueKey: 'rozmery_a_hmotnost_hodnota', valueCode: 'uzitny_myci_prostor_hloubka_spodniho_kose_v_mm', tooltipGroup: 'rozmery_a_hmotnost', alwaysShow: true },
      { label: 'Výška zásuvky nad podlahou v mm', key: 'rozmery_a_hmotnost', code: 'vyska_zasuvky_nad_podlahou_v_mm', valueKey: 'rozmery_a_hmotnost_hodnota', valueCode: 'vyska_zasuvky_nad_podlahou_v_mm', tooltipGroup: 'rozmery_a_hmotnost', alwaysShow: true },
      { label: 'Nezbytná šířka výklenku v mm', key: 'rozmery_a_hmotnost', code: 'nezbytna_sirka_vyklenku_v_mm', valueKey: 'rozmery_a_hmotnost_hodnota', valueCode: 'nezbytna_sirka_vyklenku_v_mm', tooltipGroup: 'rozmery_a_hmotnost', alwaysShow: true },
      { label: 'Hmotnost netto v [kg]', key: 'rozmery_a_hmotnost', code: 'hmotnost_netto_v_kg', valueKey: 'rozmery_a_hmotnost_hodnota', valueCode: 'hmotnost_netto_v_kg', tooltipGroup: 'rozmery_a_hmotnost', alwaysShow: true },
      { label: 'Hmotnost brutto v kg', key: 'rozmery_a_hmotnost', code: 'hmotnost_brutto_v_kg', valueKey: 'rozmery_a_hmotnost_hodnota', valueCode: 'hmotnost_brutto_v_kg', tooltipGroup: 'rozmery_a_hmotnost', alwaysShow: true },
      { label: 'Maximální zatížení podlahy v N/m²', key: 'rozmery_a_hmotnost', code: 'maximalni_zatizeni_podlahy_v_n_m2', valueKey: 'rozmery_a_hmotnost_hodnota', valueCode: 'maximalni_zatizeni_podlahy_v_n_m2', tooltipGroup: 'rozmery_a_hmotnost', alwaysShow: true }
    ]
  },
  {
    title: 'EMISNÍ HODNOTY',
    rows: [
      { label: 'Emisní hladina akustického tlaku na pracovišti (LpA)', key: 'emisni_hodnoty', code: 'emisni_hladina_akustickeho_tlaku_na_pracovisti_lpa', valueKey: 'emisni_hodnoty_hodnota', valueCode: 'emisni_hladina_akustickeho_tlaku_na_pracovisti_lpa', tooltipGroup: 'emisni_hodnoty', alwaysShow: true },
      { label: 'Hladina akustického výkonu (LwA)', key: 'emisni_hodnoty', code: 'hladina_akustickeho_vykonu_lwa', valueKey: 'emisni_hodnoty_hodnota', valueCode: 'hladina_akustickeho_vykonu_lwa', tooltipGroup: 'emisni_hodnoty', alwaysShow: true }
    ]
  },
  {
    title: 'PROGRAMY MYTÍ',
    rows: [
      { label: 'Univerzální', key: 'programy_myti', code: 'univerzalni', tooltipGroup: 'programy_myti' },
      { label: 'Krátký', key: 'programy_myti', code: 'kratky', tooltipGroup: 'programy_myti' },
      { label: 'Hygiena', key: 'programy_myti', code: 'hygiena', tooltipGroup: 'programy_myti' },
      { label: 'Studená/předmytí', key: 'programy_myti', code: 'studena_predmyti', tooltipGroup: 'programy_myti' },
      { label: 'Sklenice', key: 'programy_myti', code: 'sklenice', tooltipGroup: 'programy_myti' },
      { label: 'Plasty', key: 'programy_myti', code: 'plasty', tooltipGroup: 'programy_myti' },
      { label: 'Energeticky úsporný/ECO', key: 'programy_myti', code: 'energeticky_usporny_eco', tooltipGroup: 'programy_myti' },
      { label: 'Intenzivní', key: 'programy_myti', code: 'intenzivni', tooltipGroup: 'programy_myti' }
    ]
  },
  {
    title: 'KOŠOVÉ USPOŘÁDÁNÍ',
    rows: [
      { label: 'Košové vybavení', key: 'kosove_usporadani', code: 'kosove_vybaveni', valueKey: 'kosove_usporadani_hodnota', valueCode: 'kosove_vybaveni', tooltipGroup: 'kosove_usporadani', alwaysShow: true },
      { label: 'Flexibilní košové vybavení', key: 'kosove_usporadani', code: 'flexibilni_kosove_vybaveni', valueKey: 'kosove_usporadani_hodnota', valueCode: 'flexibilni_kosove_vybaveni', tooltipGroup: 'kosove_usporadani', alwaysShow: true },
      { label: 'Držák na sklenice FlexCare [počet]', key: 'kosove_usporadani', code: 'drzak_na_sklenice_flexcare_pocet', valueKey: 'kosove_usporadani_hodnota', valueCode: 'drzak_na_sklenice_flexcare_pocet', tooltipGroup: 'kosove_usporadani', alwaysShow: true },
      { label: 'Odkládací plocha na šálky FlexCare [počet]', key: 'kosove_usporadani', code: 'odkladaci_plocha_na_salky_flexcare_pocet', valueKey: 'kosove_usporadani_hodnota', valueCode: 'odkladaci_plocha_na_salky_flexcare_pocet', tooltipGroup: 'kosove_usporadani', alwaysShow: true },
      { label: 'Koš na příbory', key: 'kosove_usporadani', code: 'kos_na_pribory', tooltipGroup: 'kosove_usporadani' },
      { label: 'Patentovaná 3D zásuvka MultiFlex', key: 'kosove_usporadani', code: 'patentovana_3d_zasuvka_multiflex', tooltipGroup: 'kosove_usporadani' },
      { label: 'Výškově nastavitelný horní koš', key: 'kosove_usporadani', code: 'vyskove_nastavitelny_horni_kos', tooltipGroup: 'kosove_usporadani' },
      { label: 'Lze kombinovat s košem na lahve APFD 210', key: 'kosove_usporadani', code: 'lze_kombinovat_s_kosem_na_lahve_apfd_210', tooltipGroup: 'kosove_usporadani' }
    ]
  },
  {
    title: 'BEZPEČNOST',
    rows: [
      { label: 'Dětská pojistka', key: 'bezpecnost', code: 'detska_pojistka', tooltipGroup: 'bezpecnost', alwaysShow: true },
      { label: 'Optické rozhraní', key: 'bezpecnost', code: 'opticke_rozhrani', tooltipGroup: 'bezpecnost', alwaysShow: true }
    ]
  },
  {
    title: 'KOMFORT PŘI OBSLUZE',
    rows: [
      { label: 'Profesionální elektrická přípojka', key: 'komfort_pri_obsluze', code: 'profesionalni_elektricka_pripojka', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Sušení', key: 'komfort_pri_obsluze', code: 'suseni', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'suseni', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'AutoClose', key: 'komfort_pri_obsluze', code: 'autoclose', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: '1 kombinovaný dávkovač na prášek a leštidlo/dvířka', key: 'komfort_pri_obsluze', code: '1_kombinovany_davkovac_na_prasek_a_lestidlo_dvirka', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Eko informace', key: 'komfort_pri_obsluze', code: 'eko_informace', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Brilliant GlassCare', key: 'komfort_pri_obsluze', code: 'brilliant_glasscare', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Mycí prostor z kvalitní nerezové oceli', key: 'komfort_pri_obsluze', code: 'myci_prostor_z_kvalitni_nerezove_oceli', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'SmartStart', key: 'komfort_pri_obsluze', code: 'smartstart', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Časovač FlexiTimer s funkcí EcoStart', key: 'komfort_pri_obsluze', code: 'casovac_flexitimer_s_funkci_ecostart', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'BrilliantLight', key: 'komfort_pri_obsluze', code: 'brilliantlight', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Knock2open', key: 'komfort_pri_obsluze', code: 'knock2open', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true }
    ]
  },
  {
    title: 'HOSPODÁRNOST A UDRŽITELNOST',
    rows: [
      { label: 'Kapacita náplně pro program ECO v jídelních sadách', key: 'hospodarnost_a_udrzitelnost', code: 'kapacita_naplne_pro_program_eco_v_jidelnich_sadach', valueKey: 'hospodarnost_a_udrzitelnost_hodnota', valueCode: 'kapacita_naplne_pro_program_eco_v_jidelnich_sadach', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Třída energetické účinnosti (A–G)', key: 'hospodarnost_a_udrzitelnost', code: 'trida_energeticke_ucinnosti_a_g', valueKey: 'hospodarnost_a_udrzitelnost_hodnota', valueCode: 'trida_energeticke_ucinnosti_a_g', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Spotřeba elektrické energie v programu ECO na 100 mycích cyklů v kWh', key: 'hospodarnost_a_udrzitelnost', code: 'spotreba_elektricke_energie_v_programu_eco_na_100_mycich_cyklu_v_kwh', valueKey: 'hospodarnost_a_udrzitelnost_hodnota', valueCode: 'spotreba_elektricke_energie_v_programu_eco_na_100_mycich_cyklu_v_kwh', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Spotřeba vody v programu ECO na jeden mycí cyklus v l', key: 'hospodarnost_a_udrzitelnost', code: 'spotreba_vody_v_programu_eco_na_jeden_myci_cyklus_v_l', valueKey: 'hospodarnost_a_udrzitelnost_hodnota', valueCode: 'spotreba_vody_v_programu_eco_na_jeden_myci_cyklus_v_l', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Třída úrovně emisí hluku (A–D)', key: 'hospodarnost_a_udrzitelnost', code: 'trida_urovne_emisi_hluku_a_d', valueKey: 'hospodarnost_a_udrzitelnost_hodnota', valueCode: 'trida_urovne_emisi_hluku_a_d', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Úroveň emisí hluku v dB(A) re 1 pW', key: 'hospodarnost_a_udrzitelnost', code: 'uroven_emisi_hluku_v_db_a_re_1_pw', valueKey: 'hospodarnost_a_udrzitelnost_hodnota', valueCode: 'uroven_emisi_hluku_v_db_a_re_1_pw', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Délka programu ECO v min', key: 'hospodarnost_a_udrzitelnost', code: 'delka_programu_eco_v_min', valueKey: 'hospodarnost_a_udrzitelnost_hodnota', valueCode: 'delka_programu_eco_v_min', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true }
    ]
  },
  {
    title: 'MOŽNOSTI PŘIPOJENÍ',
    rows: [
      { label: 'Externí dávkovací modul pro tekutý čisticí prostředek', key: 'moznosti_pripojeni', code: 'externi_davkovaci_modul_pro_tekuty_cistici_prostredek', tooltipGroup: 'moznosti_pripojeni', alwaysShow: true },
      { label: 'WiFi', key: 'moznosti_pripojeni', code: 'wifi', tooltipGroup: 'moznosti_pripojeni', alwaysShow: true }
    ]
  },
  {
    title: 'NORMY, ZKUŠEBNÍ A IDENTIFIKAČNÍ OZNAČENÍ',
    rows: [
      { label: 'CE', key: 'normy_zkusebni_a_identifikacni_oznaceni', code: 'ce', tooltipGroup: 'normy_zkusebni_a_identifikacni_oznaceni', alwaysShow: true },
      { label: 'Shoda se směrnicí o strojních zařízeních podle 2006/42/ ES', key: 'normy_zkusebni_a_identifikacni_oznaceni', code: 'shoda_se_smernici_o_strojnich_zarizenich_podle_2006_42_es', tooltipGroup: 'normy_zkusebni_a_identifikacni_oznaceni', alwaysShow: true },
      { label: 'VDE', key: 'normy_zkusebni_a_identifikacni_oznaceni', code: 'vde', tooltipGroup: 'normy_zkusebni_a_identifikacni_oznaceni', alwaysShow: true },
      { label: 'Elektromagnetická kompatibilita rádiových zařízení', key: 'normy_zkusebni_a_identifikacni_oznaceni', code: 'elektromagneticka_kompatibilita_radiovych_zarizeni', tooltipGroup: 'normy_zkusebni_a_identifikacni_oznaceni', alwaysShow: true },
      { label: 'DIN EN 17735', key: 'normy_zkusebni_a_identifikacni_oznaceni', code: 'din_en_17735', tooltipGroup: 'normy_zkusebni_a_identifikacni_oznaceni', alwaysShow: true },
      { label: 'EN 1717', key: 'normy_zkusebni_a_identifikacni_oznaceni', code: 'en_1717', tooltipGroup: 'normy_zkusebni_a_identifikacni_oznaceni', alwaysShow: true }
    ]
  }
];
COMPARE_SCHEMAS.mikrovlnne_trouby = [
  {
    title: 'VŠEOBECNÉ ÚDAJE',
    rows: [
      { label: 'Marketingová třída', key: 'vseobecne_udaje', code: 'marketingova_trida', valueKey: 'vseobecne_udaje_hodnoty', valueCode: 'marketingova_trida', valueOnly: true, tooltipGroup: 'vseobecne_udaje', alwaysShow: true }
    ]
  },
  {
    title: 'PROVEDENÍ A DESIGN',
    rows: [
      { label: 'SideControl', key: 'provedeni', code: 'sidecontrol', tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'PureLine', key: 'provedeni', code: 'pureline', tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'VitroLine', key: 'provedeni', code: 'vitroline', tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'TopControl', key: 'provedeni', code: 'topcontrol', tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'Vestavná mikrovlnná trouba', key: 'provedeni', code: 'vestavna_mikrovlnna_trouba', tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'Volně stojící mikrovlnná trouba', key: 'provedeni', code: 'volne_stojici_mikrovlnna_trouba', tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'Barva přístroje', key: 'provedeni', code: 'barva_pristroje', valueKey: 'provedeni_hodnota', valueCode: 'barva_pristroje', valueOnly: true, tooltipGroup: 'provedeni', alwaysShow: true }
    ]
  },
  {
    title: 'UŽIVATELSKÉ VÝHODY',
    rows: [
      { label: 'Udržování teploty', key: 'uzivatelske_vyhody', code: 'udrzovani_teploty', tooltipGroup: 'uzivatelske_vyhody' },
      { label: 'Křemenný gril', key: 'uzivatelske_vyhody', code: 'kremenny_gril', tooltipGroup: 'uzivatelske_vyhody' }
    ]
  },
  {
    title: 'PROVOZNÍ ZPŮSOBY',
    rows: [
      { label: 'Mikrovlna', key: 'provozni_zpusoby', code: 'mikrovlna', tooltipGroup: 'provozni_zpusoby' },
      { label: 'Gril', key: 'provozni_zpusoby', code: 'gril', tooltipGroup: 'provozni_zpusoby' },
      { label: 'Kombinovaný provoz mikrovlna/gril', key: 'provozni_zpusoby', code: 'kombinovany_provoz_mikrovlna_gril', tooltipGroup: 'provozni_zpusoby' },
      { label: 'Automatické programy', key: 'provozni_zpusoby', code: 'automaticke_programy', tooltipGroup: 'provozni_zpusoby' }
    ]
  },
  {
    title: 'KOMFORT PŘI OBSLUZE',
    rows: [
      { label: 'Displej', key: 'komfort_pri_obsluze', code: 'displej', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'displej', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'SoftOpen', key: 'komfort_pri_obsluze', code: 'softopen', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'SoftClose', key: 'komfort_pri_obsluze', code: 'softclose', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'MultiLingua', key: 'komfort_pri_obsluze', code: 'multilingua', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Funkce Popcorn', key: 'komfort_pri_obsluze', code: 'funkce_popcorn', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Zobrazení denního času', key: 'komfort_pri_obsluze', code: 'zobrazeni_denniho_casu', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Kuchyňský budík', key: 'komfort_pri_obsluze', code: 'kuchynsky_budik', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Programování konce přípravy', key: 'komfort_pri_obsluze', code: 'programovani_konce_pripravy', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Nastavení délky přípravy', key: 'komfort_pri_obsluze', code: 'nastaveni_delky_pripravy', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Quick mikrovlna', key: 'komfort_pri_obsluze', code: 'quick_mikrovlna', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Funkce Memory', key: 'komfort_pri_obsluze', code: 'funkce_memory', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Individuální nastavení', key: 'komfort_pri_obsluze', code: 'individualni_nastaveni', tooltipGroup: 'komfort_pri_obsluze' }
    ]
  },
  {
    title: 'HOSPODÁRNOST A UDRŽITELNOST',
    rows: [
      { label: 'Noční vypnutí', key: 'hospodarnost_a_udrzitelnost', code: 'nocni_vypnuti', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'nocni_vypnuti', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Příkon ve vypnutém stavu ve W', key: 'hospodarnost_a_udrzitelnost', code: 'prikon_ve_vypnutem_stavu_ve_w', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'prikon_ve_vypnutem_stavu_ve_w', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Příkon v pohotovostním režimu ve W', key: 'hospodarnost_a_udrzitelnost', code: 'prikon_v_pohotovostnim_rezimu_ve_w', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'prikon_v_pohotovostnim_rezimu_ve_w', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Čas do automatického zapnutí z vypnutého stavu v min', key: 'hospodarnost_a_udrzitelnost', code: 'cas_do_automatickeho_zapnuti_z_vypnuteho_stavu_v_min', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'cas_do_automatickeho_zapnuti_z_vypnuteho_stavu_v_min', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Čas do automatického zapnutí z pohotovostního režimu v min', key: 'hospodarnost_a_udrzitelnost', code: 'cas_do_automatickeho_zapnuti_z_pohotovostniho_rezimu_v_min', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'cas_do_automatickeho_zapnuti_z_pohotovostniho_rezimu_v_min', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true }
    ]
  },
{
  title: 'KOMFORT PŘI ÚDRŽBĚ',
  rows: [
    { label: 'Nerezový povrch/CleanSteel', key: 'komfort_pri_udrzbe', code: 'nerezovy_povrch_cleansteel', tooltipGroup: 'komfort_pri_udrzbe' },
    { label: 'Nerezový ohřevný prostor', key: 'komfort_pri_udrzbe', code: 'nerezovy_ohrevny_prostor', tooltipGroup: 'komfort_pri_udrzbe' },
    { label: 'Dvířka CleanGlass', key: 'komfort_pri_udrzbe', code: 'dvirka_cleanglass', tooltipGroup: 'komfort_pri_udrzbe' }
  ]
},
  {
    title: 'BEZPEČNOST',
    rows: [
      { label: 'Systém chlazení přístroje s vlažnou čelní stěnou', key: 'system_chlazeni_pristroje_s_vlaznou_celni_stenou', tooltipGroup: 'bezpecnost' },
      { label: 'Zablokování zprovoznění', key: 'zablokovani_zprovozneni', tooltipGroup: 'bezpecnost' },
      { label: 'Bezpečnostní vypínač', key: 'bezpecnostni_vypinac', tooltipGroup: 'bezpecnost' },
      { label: 'Bezpečnostní upozornění při nedovřených dvířkách', key: 'bezpecnostni_upozorneni_pri_nedovrenych_dvirkach', tooltipGroup: 'bezpecnost' }
    ]
  },
  {
    title: 'TECHNICKÉ ÚDAJE',
    rows: [
      { label: 'Objem ohřevného prostoru v l', key: 'technicke_udaje', code: 'objem_ohrevneho_prostoru_v_l', valueKey: 'technicke_udaje_hodnota', valueCode: 'objem_ohrevneho_prostoru_v_l', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Závěs dvířek', key: 'technicke_udaje', code: 'zaves_dvirek', valueKey: 'technicke_udaje_hodnota', valueCode: 'zaves_dvirek', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Osvětlení ohřevného prostoru', key: 'technicke_udaje', code: 'osvetleni_ohrevneho_prostoru', valueKey: 'technicke_udaje_hodnota', valueCode: 'osvetleni_ohrevneho_prostoru', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Průměr otočného talíře v cm', key: 'technicke_udaje', code: 'prumer_otocneho_talire_v_cm', valueKey: 'technicke_udaje_hodnota', valueCode: 'prumer_otocneho_talire_v_cm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Výška ohřevného prostoru v cm', key: 'technicke_udaje', code: 'vyska_ohrevneho_prostoru_v_cm', valueKey: 'technicke_udaje_hodnota', valueCode: 'vyska_ohrevneho_prostoru_v_cm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Typ zásuvky', key: 'technicke_udaje', code: 'typ_zasuvky', valueKey: 'technicke_udaje_hodnota', valueCode: 'typ_zasuvky', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Elektronicky řízený výkon mikrovlny', key: 'technicke_udaje', code: 'elektronicky_rizeny_vykon_mikrovlny', valueKey: 'technicke_udaje_hodnota', valueCode: 'elektronicky_rizeny_vykon_mikrovlny', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Stupně výkonu mikrovlny ve W', key: 'technicke_udaje', code: 'stupne_vykonu_mikrovlny_ve_w', valueKey: 'technicke_udaje_hodnota', valueCode: 'stupne_vykonu_mikrovlny_ve_w', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Maximální výkon mikrovlny ve W', key: 'technicke_udaje', code: 'maximalni_vykon_mikrovlny_ve_w', valueKey: 'technicke_udaje_hodnota', valueCode: 'maximalni_vykon_mikrovlny_ve_w', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Výkon grilu ve W', key: 'technicke_udaje', code: 'vykon_grilu_ve_w', valueKey: 'technicke_udaje_hodnota', valueCode: 'vykon_grilu_ve_w', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Minimální šířka výklenku v mm', key: 'technicke_udaje', code: 'minimalni_sirka_vyklenku_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'minimalni_sirka_vyklenku_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Maximální šířka výklenku v mm', key: 'technicke_udaje', code: 'maximalni_sirka_vyklenku_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'maximalni_sirka_vyklenku_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Ventilace nezávisle na výklenku', key: 'technicke_udaje', code: 'ventilace_nezavisle_na_vyklenku', valueKey: 'technicke_udaje_hodnota', valueCode: 'ventilace_nezavisle_na_vyklenku', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Minimální výška výklenku v mm', key: 'technicke_udaje', code: 'minimalni_vyska_vyklenku_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'minimalni_vyska_vyklenku_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Maximální výška výklenku v mm', key: 'technicke_udaje', code: 'maximalni_vyska_vyklenku_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'maximalni_vyska_vyklenku_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Hloubka výklenku v mm', key: 'technicke_udaje', code: 'hloubka_vyklenku_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'hloubka_vyklenku_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Rozměry přístroje (š × v × h) v mm', key: 'technicke_udaje', code: 'rozmery_pristroje_s_x_v_x_h_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'rozmery_pristroje_s_x_v_x_h_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Hmotnost v kg', key: 'technicke_udaje', code: 'hmotnost_v_kg', valueKey: 'technicke_udaje_hodnota', valueCode: 'hmotnost_v_kg', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Celkový příkon v kW', key: 'technicke_udaje', code: 'celkovy_prikon_v_kw', valueKey: 'technicke_udaje_hodnota', valueCode: 'celkovy_prikon_v_kw', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Délka elektrického přívodního kabelu v m', key: 'technicke_udaje', code: 'delka_elektrickeho_privodniho_kabelu_v_m', valueKey: 'technicke_udaje_hodnota', valueCode: 'delka_elektrickeho_privodniho_kabelu_v_m', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Napětí ve V', key: 'technicke_udaje', code: 'napeti_ve_v', valueKey: 'technicke_udaje_hodnota', valueCode: 'napeti_ve_v', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Frekvence v Hz', key: 'technicke_udaje', code: 'frekvence_v_hz', valueKey: 'technicke_udaje_hodnota', valueCode: 'frekvence_v_hz', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Jištění v A', key: 'technicke_udaje', code: 'jisteni_v_a', valueKey: 'technicke_udaje_hodnota', valueCode: 'jisteni_v_a', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Počet fází', key: 'technicke_udaje', code: 'pocet_fazi', valueKey: 'technicke_udaje_hodnota', valueCode: 'pocet_fazi', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Připojovací kabel se zástrčkou', key: 'technicke_udaje', code: 'pripojovaci_kabel_se_zastrckou', valueKey: 'technicke_udaje_hodnota', valueCode: 'pripojovaci_kabel_se_zastrckou', tooltipGroup: 'technicke_udaje', alwaysShow: true }
    ]
  },
  {
    title: 'DODÁVANÉ PŘÍSLUŠENSTVÍ',
    rows: [
      { label: 'Grilovací rošt', key: 'grilovaci_rost' },
      { label: 'Tác na grilování Gourmet', key: 'tac_na_grilovani_gourmet' },
      { label: 'Poklop na pokrm', key: 'poklop_na_pokrm' },
      { label: 'Otočný talíř', key: 'otocny_talir' }
    ]
  },
{
  title: 'DOSTUPNÉ JAZYKY DISPLEJE',
  rows: [
    { label: 'Dostupné jazyky displeje díky funkci MultiLingua', key: 'dostupne_jazyky_displeje_diky_multilingua', alwaysShow: true }
  ]
}
];
COMPARE_SCHEMAS.konvektomaty = [
  {
    title: 'VŠEOBECNÉ ÚDAJE',
    rows: [
      { label: 'Číslo materiálu výrobce', key: 'cislo_materialu_vyrobce' },
      { label: 'Číslo EAN', key: 'cislo_ean' },
      { label: 'Marketingová třída', key: 'vseobecne_udaje', code: 'marketingova_trida', valueKey: 'vseobecne_udaje_hodnoty', valueCode: 'marketingova_trida', valueOnly: true, tooltipGroup: 'vseobecne_udaje', alwaysShow: true }
    ]
  },
  {
    title: 'PROVEDENÍ A DESIGN',
    rows: [
      { label: 'Barva přístroje', key: 'provedeni', code: 'barva_pristroje', valueKey: 'provedeni_hodnota', valueCode: 'barva_pristroje', valueOnly: true, tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'PureLine', key: 'provedeni', code: 'pureline', tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'Vestavná parní trouba', key: 'provedeni', code: 'vestavna_parni_trouba', tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'ContourLine', key: 'provedeni', code: 'contourline', tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'VitroLine', key: 'provedeni', code: 'vitroline', tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'BlackLine', key: 'provedeni', code: 'blackline', tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'Konvektomat', key: 'provedeni', code: 'konvektomat', tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'ArtLine', key: 'provedeni', code: 'artline', tooltipGroup: 'provedeni', alwaysShow: true },
     { label: 'Bez rukojeti', key: 'provedeni', code: 'bez_rukojeti', tooltipGroup: 'provedeni', alwaysShow: true }
    ]
  },
  {
    title: 'UŽIVATELSKÉ VÝHODY',
    rows: [
      { label: 'Externí vyvíjení páry', key: 'uzivatelske_vyhody', code: 'externi_vyvijeni_pary', tooltipGroup: 'uzivatelske_vyhody' },
      { label: 'Příprava menu bez přenosu chutí', key: 'uzivatelske_vyhody', code: 'priprava_menu_bez_prenosu_chuti', tooltipGroup: 'uzivatelske_vyhody' },
      { label: 'Automatické programy s individuálním přizpůsobením', key: 'uzivatelske_vyhody', code: 'automaticke_programy_s_individualnim_prizpusobenim', tooltipGroup: 'uzivatelske_vyhody' },
      { label: 'Udržování teploty', key: 'uzivatelske_vyhody', code: 'udrzovani_teploty', tooltipGroup: 'uzivatelske_vyhody' },
      { label: 'TasteControl', key: 'uzivatelske_vyhody', code: 'taste_control', tooltipGroup: 'uzivatelske_vyhody' },
      { label: 'Rychloohřev', key: 'uzivatelske_vyhody', code: 'rychloohrev', tooltipGroup: 'uzivatelske_vyhody' },
      { label: 'Předehřátí', key: 'uzivatelske_vyhody', code: 'predehrati', tooltipGroup: 'uzivatelske_vyhody' },
      { label: 'Funkce Crisp', key: 'uzivatelske_vyhody', code: 'funkce_crisp', tooltipGroup: 'uzivatelske_vyhody' },
      { label: 'Klimatický senzor', key: 'uzivatelske_vyhody', code: 'klimaticky_senzor', tooltipGroup: 'uzivatelske_vyhody' },
      { label: 'Individuální možnosti nastavení vlhkosti při kombinovaném pečení', key: 'uzivatelske_vyhody', code: 'individualni_nastaveni_vlhkosti_kombinovane_peceni', tooltipGroup: 'uzivatelske_vyhody' },
      { label: 'Mix & Match', key: 'uzivatelske_vyhody', code: 'mix_and_match', tooltipGroup: 'uzivatelske_vyhody' },
      { label: 'Quick & Gentle', key: 'uzivatelske_vyhody', code: 'quick_gentle', tooltipGroup: 'uzivatelske_vyhody' }
    ]
  },
  PARNI_TECHNOLOGIE_PRIVOD_VODY_SECTION,
  {
    title: 'PROVOZNÍ ZPŮSOBY',
    rows: [
      { label: 'Příprava v páře', key: 'provozni_zpusoby', code: 'priprava_v_pare', tooltipGroup: 'provozni_zpusoby' },
      { label: 'Příprava v páře Eco', key: 'provozni_zpusoby', code: 'priprava_v_pare_eco', tooltipGroup: 'provozni_zpusoby' },
      { label: 'Rozmrazování', key: 'provozni_zpusoby', code: 'rozmrazovani', tooltipGroup: 'provozni_zpusoby' },
      { label: 'Ohřev', key: 'provozni_zpusoby', code: 'ohrev', tooltipGroup: 'provozni_zpusoby' },
      { label: 'Automatické programy', key: 'provozni_zpusoby', code: 'automaticke_programy', tooltipGroup: 'provozni_zpusoby' },
      { label: 'Speciální použití', key: 'provozni_zpusoby', code: 'specialni_pouziti', tooltipGroup: 'provozni_zpusoby' },
      { label: 'Sous-vide', key: 'provozni_zpusoby', code: 'sous_vide', tooltipGroup: 'provozni_zpusoby' },
      { label: 'Specifické národní automatické programy', key: 'provozni_zpusoby', code: 'specificke_narodni_automaticke_programy', tooltipGroup: 'provozni_zpusoby' },
      { label: 'Horký vzduch plus', key: 'provozni_zpusoby', code: 'horky_vzduch_plus', tooltipGroup: 'provozni_zpusoby' },
      { label: 'Horní/spodní pečení', key: 'provozni_zpusoby', code: 'horni_spodni_peceni', tooltipGroup: 'provozni_zpusoby' },
      { label: 'Klimatické pečení', key: 'provozni_zpusoby', code: 'klimaticke_peceni', tooltipGroup: 'provozni_zpusoby' },
      { label: 'Intenzivní pečení', key: 'provozni_zpusoby', code: 'intenzivni_peceni', tooltipGroup: 'provozni_zpusoby' },
      { label: 'Pečicí automatika', key: 'provozni_zpusoby', code: 'pecici_automatika', tooltipGroup: 'provozni_zpusoby' },
      { label: 'Grilování s cirkulací vzduchu', key: 'provozni_zpusoby', code: 'grilovani_s_cirkulaci_vzduchu', tooltipGroup: 'provozni_zpusoby' },
      { label: 'Gril', key: 'provozni_zpusoby', code: 'gril', tooltipGroup: 'provozni_zpusoby' },
      { label: 'Provozní způsoby grilu', key: 'provozni_zpusoby', code: 'provozni_zpusoby_grilu', tooltipGroup: 'provozni_zpusoby' },
      { label: 'Spodní pečení', key: 'provozni_zpusoby', code: 'spodni_peceni', tooltipGroup: 'provozni_zpusoby' },
      { label: 'Horký vzduch Eco', key: 'provozni_zpusoby', code: 'horky_vzduch_eco', tooltipGroup: 'provozni_zpusoby' },
      { label: 'Klimatické pečení s pečicí automatikou', key: 'provozni_zpusoby', code: 'klimaticke_peceni_s_pecici_automatikou', tooltipGroup: 'provozni_zpusoby' },
      { label: 'Klimatické pečení s horkým vzduchem plus', key: 'provozni_zpusoby', code: 'klimaticke_peceni_s_horkym_vzduchem_plus', tooltipGroup: 'provozni_zpusoby' },
      { label: 'Klimatické pečení s intenzivním pečením', key: 'provozni_zpusoby', code: 'klimaticke_peceni_s_intenzivnim_pecenim', tooltipGroup: 'provozni_zpusoby' },
      { label: 'Klimatické pečení s horním/spodním pečením', key: 'provozni_zpusoby', code: 'klimaticke_peceni_s_hornim_spodnim_pecenim', tooltipGroup: 'provozni_zpusoby' },
      { label: 'Kombinovaná příprava', key: 'provozni_zpusoby', code: 'kombinovana_priprava', tooltipGroup: 'provozni_zpusoby' },
      { label: 'Kombinovaná příprava s horkým vzduchem plus', key: 'provozni_zpusoby', code: 'kombinovana_priprava_s_horkym_vzduchem_plus', tooltipGroup: 'provozni_zpusoby' },
      { label: 'Kombinovaná příprava s horním/spodním pečením', key: 'provozni_zpusoby', code: 'kombinovana_priprava_s_hornim_spodnim_pecenim', tooltipGroup: 'provozni_zpusoby' },
      { label: 'Kombinovaná příprava s velkým grilem', key: 'provozni_zpusoby', code: 'kombinovana_priprava_s_velkym_grilem', tooltipGroup: 'provozni_zpusoby' },
      { label: 'Malý gril', key: 'provozni_zpusoby', code: 'maly_gril', tooltipGroup: 'provozni_zpusoby' },
      { label: 'Horní pečení', key: 'provozni_zpusoby', code: 'horni_peceni', tooltipGroup: 'provozni_zpusoby' },
      { label: 'Speciální moučník', key: 'provozni_zpusoby', code: 'specialni_moucnik', tooltipGroup: 'provozni_zpusoby' },
      { label: 'Pečení Gourmet', key: 'provozni_zpusoby', code: 'peceni_gourmet', tooltipGroup: 'provozni_zpusoby' },
      { label: 'Nahřívání talířů', key: 'provozni_zpusoby', code: 'nahrivani_taliru', tooltipGroup: 'provozni_zpusoby' },
      { label: 'Grilování s cirkulací', key: 'provozni_zpusoby', code: 'grilovani_s_cirkulaci', tooltipGroup: 'provozni_zpusoby' },
      { label: 'Mikrovlna', key: 'provozni_zpusoby', code: 'mikrovlna', tooltipGroup: 'provozni_zpusoby' },
      { label: 'Rychlá příprava pokrmů', key: 'provozni_zpusoby', code: 'rychla_priprava_pokrmu', tooltipGroup: 'provozni_zpusoby' }
    ]
  },
  {
    title: 'KOMFORT PŘI OBSLUZE',
    rows: [
      { label: 'Displej', key: 'komfort_pri_obsluze', code: 'displej', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'displej', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'SoftOpen', key: 'komfort_pri_obsluze', code: 'softopen', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'SoftClose', key: 'komfort_pri_obsluze', code: 'softclose', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Příprava nezávislá na množství', key: 'komfort_pri_obsluze', code: 'priprava_nezavisla_na_mnozstvi', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Příprava v páře až na 3 úrovních současně', key: 'komfort_pri_obsluze', code: 'priprava_v_pare_az_na_3_urovnich_soucasne', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Příprava menu', key: 'komfort_pri_obsluze', code: 'priprava_menu', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Redukce páry před ukončením programu', key: 'komfort_pri_obsluze', code: 'redukce_pary_pred_ukoncenim_programu', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Nastavení délky přípravy', key: 'komfort_pri_obsluze', code: 'nastaveni_delky_pripravy', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Ukazatel aktuální teploty', key: 'komfort_pri_obsluze', code: 'ukazatel_aktualni_teploty', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Individuální nastavení', key: 'komfort_pri_obsluze', code: 'individualni_nastaveni', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Propojení s Miele@home', key: 'komfort_pri_obsluze', code: 'propojeni_s_miele_home', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'MultiLingua', key: 'komfort_pri_obsluze', code: 'multilingua', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Zobrazení denního času', key: 'komfort_pri_obsluze', code: 'zobrazeni_denniho_casu', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Kuchyňský budík', key: 'komfort_pri_obsluze', code: 'kuchynsky_budik', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Programování začátku přípravy', key: 'komfort_pri_obsluze', code: 'programovani_zacatku_pripravy', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Programování konce přípravy', key: 'komfort_pri_obsluze', code: 'programovani_konce_pripravy', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Navrhovaná teplota', key: 'komfort_pri_obsluze', code: 'navrhovana_teplota', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Automatická příprava menu', key: 'komfort_pri_obsluze', code: 'automaticka_priprava_menu', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Zobrazení data', key: 'komfort_pri_obsluze', code: 'zobrazeni_data', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Ukazatel požadované teploty', key: 'komfort_pri_obsluze', code: 'ukazatel_pozadovane_teploty', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Signální tón při dosažení požadované teploty', key: 'komfort_pri_obsluze', code: 'signalni_ton_pri_dosazeni_pozadovane_teploty', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Vlastní programy', key: 'komfort_pri_obsluze', code: 'vlastni_programy', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Časové funkce', key: 'komfort_pri_obsluze', code: 'casove_funkce', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Časově programovatelné dávky páry', key: 'komfort_pri_obsluze', code: 'casove_programovatelne_davky_pary', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Motoricky výsuvný panel', key: 'komfort_pri_obsluze', code: 'motoricky_vysuvny_panel', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Program Sabat', key: 'komfort_pri_obsluze', code: 'program_sabat', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Touch2Open', key: 'komfort_pri_obsluze', code: 'touch2open', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Příprava v páře až na 4 úrovních současně', key: 'komfort_pri_obsluze', code: 'priprava_v_pare_az_na_4_urovnich_soucasne', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Senzor přiblížení MotionReact', key: 'komfort_pri_obsluze', code: 'senzor_priblizeni_motionreact', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'MyMiele', key: 'komfort_pri_obsluze', code: 'mymiele', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Funkce nápovědy', key: 'komfort_pri_obsluze', code: 'funkce_napovedy', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Polyfonní signální tóny', key: 'komfort_pri_obsluze', code: 'polyfonni_signalni_tony', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Funkce Popcorn', key: 'komfort_pri_obsluze', code: 'funkce_popcorn', tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Quick mikrovlna', key: 'komfort_pri_obsluze', code: 'quick_mikrovlna', tooltipGroup: 'komfort_pri_obsluze' }
    ]
  },
    {
    title: 'KOMFORT PŘI ÚDRŽBĚ',
    rows: [
      { label: 'Nerezový povrch/CleanSteel', key: 'komfort_pri_udrzbe', code: 'nerezovy_povrch_cleansteel', tooltipGroup: 'komfort_pri_udrzbe' },
      { label: 'Nerezový ohřevný prostor se lněnou strukturou', key: 'komfort_pri_udrzbe', code: 'nerezovy_ohrevny_prostor_se_lnenou_strukturou', tooltipGroup: 'komfort_pri_udrzbe' },
      { label: 'Externí vyvíječ páry', key: 'komfort_pri_udrzbe', code: 'externi_vyvijec_pary', tooltipGroup: 'komfort_pri_udrzbe' },
      { label: 'Topné těleso ve dně k redukci kondenzátu', key: 'komfort_pri_udrzbe', code: 'topne_teleso_ve_dne_k_redukci_kondenzatu', tooltipGroup: 'komfort_pri_udrzbe' },
      { label: 'Rychloupínáky pro postranní mřížky', key: 'komfort_pri_udrzbe', code: 'rychloupinaky_pro_postranni_mrizky', tooltipGroup: 'komfort_pri_udrzbe' },
      { label: 'Vyjímatelné postranní mřížky', key: 'komfort_pri_udrzbe', code: 'vyjimatelne_postranni_mrizky', tooltipGroup: 'komfort_pri_udrzbe' },
      { label: 'odvápnění', key: 'komfort_pri_udrzbe', code: 'odvapneni', tooltipGroup: 'komfort_pri_udrzbe' },
      { label: 'Dvířka CleanGlass', key: 'komfort_pri_udrzbe', code: 'dvirka_cleanglass', tooltipGroup: 'komfort_pri_udrzbe' },
      { label: 'Emailovaný ohřevný prostor s úpravou PerfectClean a katalytickou zadní stěnou', key: 'komfort_pri_udrzbe', code: 'emailovany_ohrevny_prostor_perfectclean_katalyticka_zadni_stena', tooltipGroup: 'komfort_pri_udrzbe' },
      { label: 'Programy pro údržbu', key: 'komfort_pri_udrzbe', code: 'programy_pro_udrzbu', tooltipGroup: 'komfort_pri_udrzbe' },
      { label: 'Ošetřující program Odmočení', key: 'komfort_pri_udrzbe', code: 'osetrujici_program_odmoceni', tooltipGroup: 'komfort_pri_udrzbe' },
      { label: 'Ohřevný prostor - program Sušení', key: 'komfort_pri_udrzbe', code: 'ohrevny_prostor_program_suseni', tooltipGroup: 'komfort_pri_udrzbe' },
      { label: 'Odvápňování', key: 'komfort_pri_udrzbe', code: 'odvapnovani', tooltipGroup: 'komfort_pri_udrzbe' },
      { label: 'Sklopné grilovací těleso', key: 'komfort_pri_udrzbe', code: 'sklopne_grilovaci_teleso', tooltipGroup: 'komfort_pri_udrzbe' },
      { label: 'HydroClean', key: 'komfort_pri_udrzbe', code: 'hydroclean', tooltipGroup: 'komfort_pri_udrzbe' },
      { label: 'Ošetřující program Proplachování', key: 'komfort_pri_udrzbe', code: 'osetrujici_program_proplachovani', tooltipGroup: 'komfort_pri_udrzbe' },
      { label: 'Nerezový ohřevný prostor se lněnou strukturou a úpravou PerfectClean', key: 'komfort_pri_udrzbe', code: 'nerezovy_ohrevny_prostor_se_lnenou_strukturou_a_upravou_perfectclean', tooltipGroup: 'komfort_pri_udrzbe' }
    ]
  },
    {
    title: 'BEZPEČNOST',
    rows: [
      { label: 'Systém chlazení přístroje s vlažnou čelní stěnou', key: 'bezpecnost', code: 'system_chlazeni_pristroje_s_vlaznou_celni_stenou', tooltipGroup: 'bezpecnost' },
      { label: 'Bezpečnostní vypínání', key: 'bezpecnost', code: 'bezpecnostni_vypinani', tooltipGroup: 'bezpecnost' },
      { label: 'Systém chlazení výparů', key: 'bezpecnost', code: 'system_chlazeni_vyparu', tooltipGroup: 'bezpecnost' },
      { label: 'Zablokování zprovoznění', key: 'bezpecnost', code: 'zablokovani_zprovozneni', tooltipGroup: 'bezpecnost' },
      { label: 'Zablokování tlačítek', key: 'bezpecnost', code: 'zablokovani_tlacitek', tooltipGroup: 'bezpecnost' }
    ]
  },
  {
    title: 'HOSPODÁRNOST A UDRŽITELNOST',
    rows: [
      { label: 'Příkon ve vypnutém stavu ve W', key: 'hospodarnost_a_udrzitelnost', code: 'prikon_ve_vypnutem_stavu_ve_w', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'prikon_ve_vypnutem_stavu_ve_w', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Příkon v pohotovostním režimu ve W', key: 'hospodarnost_a_udrzitelnost', code: 'prikon_v_pohotovostnim_rezimu_ve_w', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'prikon_v_pohotovostnim_rezimu_ve_w', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Příkon v síťovém pohotovostním režimu ve W', key: 'hospodarnost_a_udrzitelnost', code: 'prikon_v_sitovem_pohotovostnim_rezimu_ve_w', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'prikon_v_sitovem_pohotovostnim_rezimu_ve_w', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Čas do automatického zapnutí z vypnutého stavu v min', key: 'hospodarnost_a_udrzitelnost', code: 'cas_do_automatickeho_zapnuti_z_vypnuteho_stavu_v_min', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'cas_do_automatickeho_zapnuti_z_vypnuteho_stavu_v_min', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Čas do automatického zapnutí z pohotovostního režimu v min', key: 'hospodarnost_a_udrzitelnost', code: 'cas_do_automatickeho_zapnuti_z_pohotovostniho_rezimu_v_min', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'cas_do_automatickeho_zapnuti_z_pohotovostniho_rezimu_v_min', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Čas do automatického zapnutí ze síťového pohotovostního režimu v min', key: 'hospodarnost_a_udrzitelnost', code: 'cas_do_automatickeho_zapnuti_ze_sitoveho_pohotovostniho_rezimu_v_min', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'cas_do_automatickeho_zapnuti_ze_sitoveho_pohotovostniho_rezimu_v_min', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Třída energetické účinnosti (A+++ – D)', key: 'hospodarnost_a_udrzitelnost', code: 'trida_energeticke_ucinnosti_a_d', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'trida_energeticke_ucinnosti_a_d', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Automatické využití zbytkového tepla', key: 'hospodarnost_a_udrzitelnost', code: 'automaticke_vyuziti_zbytkoveho_tepla', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'automaticke_vyuziti_zbytkoveho_tepla', emptyAsNo: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true }
    ]
  },
  {
    title: 'TECHNICKÉ ÚDAJE',
    rows: [
      { label: 'Ohřevný prostor L', key: 'technicke_udaje', code: 'ohrevny_prostor_l', valueKey: 'technicke_udaje_hodnota', valueCode: 'ohrevny_prostor_l', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Objem ohřevného prostoru v l', key: 'technicke_udaje', code: 'objem_ohrevneho_prostoru_v_l', valueKey: 'technicke_udaje_hodnota', valueCode: 'objem_ohrevneho_prostoru_v_l', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Počet úrovní zasunutí', key: 'technicke_udaje', code: 'pocet_urovni_zasunuti', valueKey: 'technicke_udaje_hodnota', valueCode: 'pocet_urovni_zasunuti', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Závěs dvířek', key: 'technicke_udaje', code: 'zaves_dvirek', valueKey: 'technicke_udaje_hodnota', valueCode: 'zaves_dvirek', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Minimální teploty při provozu parní trouby ve °C', key: 'technicke_udaje', code: 'minimalni_teploty_pri_provozu_parni_trouby_ve_c', valueKey: 'technicke_udaje_hodnota', valueCode: 'minimalni_teploty_pri_provozu_parni_trouby_ve_c', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Maximální teploty při provozu parní trouby ve °C', key: 'technicke_udaje', code: 'maximalni_teploty_pri_provozu_parni_trouby_ve_c', valueKey: 'technicke_udaje_hodnota', valueCode: 'maximalni_teploty_pri_provozu_parni_trouby_ve_c', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Minimální šířka výklenku v mm', key: 'technicke_udaje', code: 'minimalni_sirka_vyklenku_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'minimalni_sirka_vyklenku_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Maximální šířka výklenku v mm', key: 'technicke_udaje', code: 'maximalni_sirka_vyklenku_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'maximalni_sirka_vyklenku_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Minimální výška výklenku v mm', key: 'technicke_udaje', code: 'minimalni_vyska_vyklenku_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'minimalni_vyska_vyklenku_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Maximální výška výklenku v mm', key: 'technicke_udaje', code: 'maximalni_vyska_vyklenku_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'maximalni_vyska_vyklenku_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Hloubka výklenku v mm', key: 'technicke_udaje', code: 'hloubka_vyklenku_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'hloubka_vyklenku_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Šířka přístroje v mm', key: 'technicke_udaje', code: 'sirka_pristroje_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'sirka_pristroje_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Výška přístroje v mm', key: 'technicke_udaje', code: 'vyska_pristroje_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'vyska_pristroje_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Hloubka přístroje v mm', key: 'technicke_udaje', code: 'hloubka_pristroje_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'hloubka_pristroje_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Hmotnost v kg', key: 'technicke_udaje', code: 'hmotnost_v_kg', valueKey: 'technicke_udaje_hodnota', valueCode: 'hmotnost_v_kg', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Celkový příkon v kW', key: 'technicke_udaje', code: 'celkovy_prikon_v_kw', valueKey: 'technicke_udaje_hodnota', valueCode: 'celkovy_prikon_v_kw', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Napětí ve V', key: 'technicke_udaje', code: 'napeti_ve_v', valueKey: 'technicke_udaje_hodnota', valueCode: 'napeti_ve_v', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Frekvence v Hz', key: 'technicke_udaje', code: 'frekvence_v_hz', valueKey: 'technicke_udaje_hodnota', valueCode: 'frekvence_v_hz', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Jištění v A', key: 'technicke_udaje', code: 'jisteni_v_a', valueKey: 'technicke_udaje_hodnota', valueCode: 'jisteni_v_a', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Počet fází', key: 'technicke_udaje', code: 'pocet_fazi', valueKey: 'technicke_udaje_hodnota', valueCode: 'pocet_fazi', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Nulový vodič', key: 'technicke_udaje', code: 'nulovy_vodic', valueKey: 'technicke_udaje_hodnota', valueCode: 'nulovy_vodic', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Připojovací kabel se zástrčkou', key: 'technicke_udaje', code: 'pripojovaci_kabel_se_zastrckou', valueKey: 'technicke_udaje_hodnota', valueCode: 'pripojovaci_kabel_se_zastrckou', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Délka elektrického přívodního kabelu v m', key: 'technicke_udaje', code: 'delka_elektrickeho_privodniho_kabelu_v_m', valueKey: 'technicke_udaje_hodnota', valueCode: 'delka_elektrickeho_privodniho_kabelu_v_m', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Osvětlení ohřevného prostoru', key: 'technicke_udaje', code: 'osvetleni_ohrevneho_prostoru', valueKey: 'technicke_udaje_hodnota', valueCode: 'osvetleni_ohrevneho_prostoru', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Výměna svítidel', key: 'technicke_udaje', code: 'vymena_svitidel', valueKey: 'technicke_udaje_hodnota', valueCode: 'vymena_svitidel', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Označení úrovní zasunutí', key: 'technicke_udaje', code: 'oznaceni_urovni_zasunuti', valueKey: 'technicke_udaje_hodnota', valueCode: 'oznaceni_urovni_zasunuti', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Minimální teploty při provozu pečicí trouby ve °C', key: 'technicke_udaje', code: 'minimalni_teploty_pri_provozu_pecici_trouby_ve_c', valueKey: 'technicke_udaje_hodnota', valueCode: 'minimalni_teploty_pri_provozu_pecici_trouby_ve_c', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Maximální teploty při provozu pečicí trouby ve °C', key: 'technicke_udaje', code: 'maximalni_teploty_pri_provozu_pecici_trouby_ve_c', valueKey: 'technicke_udaje_hodnota', valueCode: 'maximalni_teploty_pri_provozu_pecici_trouby_ve_c', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Teploty při provozu pečicí trouby ve °C', key: 'technicke_udaje', code: 'teploty_pri_provozu_pecici_trouby_ve_c', valueKey: 'technicke_udaje_hodnota', valueCode: 'teploty_pri_provozu_pecici_trouby_ve_c', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Teploty při provozu parní trouby ve °C', key: 'technicke_udaje', code: 'teploty_pri_provozu_parni_trouby_ve_c', valueKey: 'technicke_udaje_hodnota', valueCode: 'teploty_pri_provozu_parni_trouby_ve_c', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Rozměry výklenku (š x v x h) v mm', key: 'technicke_udaje', code: 'rozmery_vyklenku_s_x_v_x_h_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'rozmery_vyklenku_s_x_v_x_h_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Rozměry přístroje (š x v x h) v mm', key: 'technicke_udaje', code: 'rozmery_pristroje_s_x_v_x_h_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'rozmery_pristroje_s_x_v_x_h_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Délka přívodní hadice v m', key: 'technicke_udaje', code: 'delka_privodni_hadice_v_m', valueKey: 'technicke_udaje_hodnota', valueCode: 'delka_privodni_hadice_v_m', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Délka odtokové hadice v m', key: 'technicke_udaje', code: 'delka_odtokove_hadice_v_m', valueKey: 'technicke_udaje_hodnota', valueCode: 'delka_odtokove_hadice_v_m', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Elektronicky řízený výkon mikrovlny', key: 'technicke_udaje', code: 'elektronicky_rizeny_vykon_mikrovlny', valueKey: 'technicke_udaje_hodnota', valueCode: 'elektronicky_rizeny_vykon_mikrovlny', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Stupně výkonu mikrovlny ve W', key: 'technicke_udaje', code: 'stupne_vykonu_mikrovlny_ve_w', valueKey: 'technicke_udaje_hodnota', valueCode: 'stupne_vykonu_mikrovlny_ve_w', tooltipGroup: 'technicke_udaje', alwaysShow: true }
    ]
  },
  {
    title: 'DODÁVANÉ PŘÍSLUŠENSTVÍ',
    rows: [
      { label: 'Vyjímatelné postranní mřížky (pár)', key: 'dodavane_prislusenstvi', code: 'vyjimatelne_postranni_mrizky_par', tooltipGroup: 'dodavane_prislusenstvi' },
      { label: 'Perforované nerezové varné nádoby', key: 'dodavane_prislusenstvi', code: 'perforovane_nerezove_varne_nadoby', tooltipGroup: 'dodavane_prislusenstvi' },
      { label: 'Neperforované nerezové varné nádoby DGG 50 40', key: 'dodavane_prislusenstvi', code: 'neperforovane_nerezove_varne_nadoby_dgg_50_40', tooltipGroup: 'dodavane_prislusenstvi' },
      { label: 'Odkládací rošt', key: 'dodavane_prislusenstvi', code: 'odkladaci_rost', tooltipGroup: 'dodavane_prislusenstvi' },
      { label: 'Záchytná miska DGG 100 40', key: 'dodavane_prislusenstvi', code: 'zachytna_miska_dgg_100_40', tooltipGroup: 'dodavane_prislusenstvi' },
      { label: 'Odvápňovací tablety', key: 'dodavane_prislusenstvi', code: 'odvapnovaci_tablety', tooltipGroup: 'dodavane_prislusenstvi' },
      { label: 'Pečicí plech s úpravou PerfectClean HBB 71', key: 'dodavane_prislusenstvi', code: 'pecici_plech_s_upravou_perfectclean_hbb_71', tooltipGroup: 'dodavane_prislusenstvi' },
      { label: 'Univerzální plech s úpravou PerfectClean HUBB 71', key: 'dodavane_prislusenstvi', code: 'univerzalni_plech_s_upravou_perfectclean_hubb_71', tooltipGroup: 'dodavane_prislusenstvi' },
      { label: 'Pečicí rošt s úpravou PerfectClean HBBR 71', key: 'dodavane_prislusenstvi', code: 'pecici_rost_s_upravou_perfectclean_hbbr_71', tooltipGroup: 'dodavane_prislusenstvi' },
      { label: 'Výsuvné pojezdy FlexiClip s úpravou PerfectClean HFC 71 (pár)', key: 'dodavane_prislusenstvi', code: 'vysuvne_pojezdy_flexiclip_s_upravou_perfectclean_hfc_71_par', tooltipGroup: 'dodavane_prislusenstvi' },
      { label: 'Neperforované nerezové varné nádoby', key: 'dodavane_prislusenstvi', code: 'neperforovane_nerezove_varne_nadoby', tooltipGroup: 'dodavane_prislusenstvi' },
      { label: 'Poukaz na pekáč Gourmet vhodný na indukci HUB 5001-M', key: 'dodavane_prislusenstvi', code: 'poukaz_na_pekac_gourmet_vhodny_na_indukci_hub_5001_m', tooltipGroup: 'dodavane_prislusenstvi' },
      { label: 'Čisticí prostředek HydroClean', key: 'dodavane_prislusenstvi', code: 'cistici_prostredek_hydroclean', tooltipGroup: 'dodavane_prislusenstvi' },
      { label: 'Kabelový pokrmový teploměr', key: 'dodavane_prislusenstvi', code: 'kabelovy_pokrmovy_teplomer', tooltipGroup: 'dodavane_prislusenstvi' },
      { label: 'Bezdrátový pokrmový teploměr', key: 'dodavane_prislusenstvi', code: 'bezdratovy_pokrmovy_teplomer', tooltipGroup: 'dodavane_prislusenstvi' },
      { label: 'Čisticí prostředek DGClean', key: 'dodavane_prislusenstvi', code: 'cistici_prostredek_dgclean', tooltipGroup: 'dodavane_prislusenstvi' },
      { label: 'Skleněná miska DMGS 100 30', key: 'dodavane_prislusenstvi', code: 'sklenena_miska_dmgs_100_30', tooltipGroup: 'dodavane_prislusenstvi' },
      { label: 'Neperforované nerezové varné nádoby DGG 50 80', key: 'dodavane_prislusenstvi', code: 'neperforovane_nerezove_varne_nadoby_dgg_50_80', tooltipGroup: 'dodavane_prislusenstvi' }
    ]
  },
  {
    title: 'DOSTUPNÉ JAZYKY DISPLEJE',
    rows: [
      { label: 'Dostupné jazyky displeje díky funkci MultiLingua', key: 'dostupne_jazyky_displeje_diky_multilingua', alwaysShow: true }
    ]
  }
];
COMPARE_SCHEMAS.susicky = [
  {
    title: 'VŠEOBECNÉ ÚDAJE',
    rows: [
      { label: 'Číslo EAN', key: 'vseobecne_udaje', code: 'cislo_ean', valueKey: 'vseobecne_udaje_hodnoty', valueCode: 'cislo_ean', valueOnly: true, tooltipGroup: 'vseobecne_udaje', alwaysShow: true },
      { label: 'Marketingová třída', key: 'vseobecne_udaje', code: 'marketingova_trida', valueKey: 'vseobecne_udaje_hodnoty', valueCode: 'marketingova_trida', valueOnly: true, tooltipGroup: 'vseobecne_udaje', alwaysShow: true }
    ]
  },
  {
    title: 'PROVEDENÍ',
    rows: [
      { label: 'Možnost věžového uspořádání', key: 'provedeni', code: 'moznost_vezoveho_usporadani', valueKey: 'provedeni_hodnota', valueCode: 'moznost_vezoveho_usporadani', tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'Závěs dvířek vlevo', key: 'provedeni', code: 'zaves_dvirek_vlevo', valueKey: 'provedeni_hodnota', valueCode: 'zaves_dvirek_vlevo', tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'Závěs dvířek vlevo, vyměnitelný', key: 'provedeni', code: 'zaves_dvirek_vlevo_vymenitelny', valueKey: 'provedeni_hodnota', valueCode: 'zaves_dvirek_vlevo_vymenitelny', tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'Závěs dvířek měnitelný', key: 'provedeni', code: 'zaves_dvirek_menitelny', valueKey: 'provedeni_hodnota', valueCode: 'zaves_dvirek_menitelny', tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'Side-by-side', key: 'provedeni', code: 'side_by_side', valueKey: 'provedeni_hodnota', valueCode: 'side_by_side', tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'Možnost podsunutí', key: 'provedeni', code: 'moznost_podsunuti', valueKey: 'provedeni_hodnota', valueCode: 'moznost_podsunuti', tooltipGroup: 'provedeni', alwaysShow: true }
    ]
  },
  {
    title: 'KONSTRUKCE',
    rows: [
      { label: 'Označení přístroje', key: 'oznaceni_pristroje' },
      { label: 'Sušička s tepelným čerpadlem', key: 'konstrukce', code: 'susicka_s_tepelnym_cerpadlem' }
    ]
  },
  {
    title: 'DESIGN',
    rows: [
      { label: 'Barva přístroje', key: 'design', code: 'barva_pristroje', valueKey: 'design_hodnoty', valueCode: 'barva_pristroje', valueOnly: true, tooltipGroup: 'design', alwaysShow: true },
      { label: 'Barva ovládacího panelu', key: 'design', code: 'barva_ovladaciho_panelu', valueKey: 'design_hodnoty', valueCode: 'barva_ovladaciho_panelu', valueOnly: true, tooltipGroup: 'design', alwaysShow: true },
      { label: 'Design dvířek', key: 'design', code: 'design_dvirek', valueKey: 'design_hodnoty', valueCode: 'design_dvirek', valueOnly: true, tooltipGroup: 'design', alwaysShow: true },
      { label: 'Barva otočného voliče', key: 'design', code: 'barva_otocneho_volice', valueKey: 'design_hodnoty', valueCode: 'barva_otocneho_volice', valueOnly: true, tooltipGroup: 'design', alwaysShow: true },
      { label: 'Provedení ovládacího panelu', key: 'design', code: 'provedeni_ovladaciho_panelu', valueKey: 'design_hodnoty', valueCode: 'provedeni_ovladaciho_panelu', valueOnly: true, tooltipGroup: 'design', alwaysShow: true },
      { label: 'Způsob ovládání', key: 'design', code: 'zpusob_ovladani', valueKey: 'design_hodnoty', valueCode: 'zpusob_ovladani', valueOnly: true, tooltipGroup: 'design', alwaysShow: true },
      { label: 'Displej', key: 'design', code: 'displej', valueKey: 'design_hodnoty', valueCode: 'displej', valueOnly: true, tooltipGroup: 'design', alwaysShow: true },
      { label: 'AmbientLight', key: 'design', code: 'ambientlight', valueKey: 'design_hodnoty', valueCode: 'ambientlight', emptyAsNo: true, tooltipGroup: 'design', alwaysShow: true },
      { label: 'MotionReact', key: 'design', code: 'motionreact', valueKey: 'design_hodnoty', valueCode: 'motionreact', emptyAsNo: true, tooltipGroup: 'design', alwaysShow: true }
    ]
  },

{
  title: 'EXTRA FUNKCE',
  rows: [
    { label: 'Ochrana proti pomačkání', key: 'extra_funkce', code: 'ochrana_proti_pomackani' },
    { label: 'Šetrný plus', key: 'extra_funkce', code: 'setrny_plus' },
    { label: 'Bzučák', key: 'extra_funkce', code: 'bzucak' },
    { label: 'Quick', key: 'extra_funkce', code: 'quick' },
    { label: 'SingleDry', key: 'extra_funkce', code: 'singledry' },
    { label: 'DryCare 40', key: 'extra_funkce', code: 'drycare_40' },
    { label: 'Oblíbené', key: 'extra_funkce', code: 'oblibene' },
    { label: 'Úspora energie', key: 'extra_funkce', code: 'uspora_energie' }
  ]
},
  {
    title: 'ŠETRNÁ PÉČE O PRÁDLO',
    rows: [
      { label: 'Voštinový buben', key: 'setrna_pece_o_pradlo', code: 'vostinovy_buben' },
      { label: 'SilenceDrum', key: 'setrna_pece_o_pradlo', code: 'silencedrum' },
      { label: 'Hmotnost náplně v kg', key: 'setrna_pece_o_pradlo', code: 'hmotnost_naplne_v_kg', valueKey: 'setrna_pece_o_pradlo_hodnota', valueCode: 'hmotnost_naplne_v_kg', valueOnly: true, tooltipGroup: 'setrna_pece_o_pradlo', alwaysShow: true }
    ]
  },
   {
    title: 'VÝSLEDEK SUŠENÍ',
    rows: [
      { label: 'Na stupeň přesné sušení PerfectDry', key: 'vysledek_suseni', code: 'na_stupen_presne_suseni_perfectdry' },
      { label: 'Systém vůně FragranceDos', key: 'vysledek_suseni', code: 'system_vune_fragrancedos' },
      { label: 'Systém vůně FragranceDos²', key: 'vysledek_suseni', code: 'system_vune_fragrancedos_2' },
      { label: 'PowerDry', key: 'vysledek_suseni', code: 'powerdry' },
      { label: 'Inteligentní reverzace bubnu', key: 'vysledek_suseni', code: 'inteligentni_reverzace_bubnu' },
      { label: 'HygieneDry', key: 'vysledek_suseni', code: 'hygienedry' }
    ]
  },
  {
    title: 'PROGRAMY SUŠENÍ',
    rows: [
      { label: 'Automatika plus', key: 'programy_suseni', code: 'automatika_plus' },
      { label: 'Automatika', key: 'programy_suseni', code: 'automatika' },
      { label: 'Bavlna', key: 'programy_suseni', code: 'bavlna' },
      { label: 'ECO', key: 'programy_suseni', code: 'eco' },
      { label: 'Snadno ošetřovatelné', key: 'programy_suseni', code: 'snadno_osetrovatelne' },
      { label: 'Jemné prádlo', key: 'programy_suseni', code: 'jemne_pradlo' },
      { label: 'Košile', key: 'programy_suseni', code: 'kosile' },
      { label: 'Košile/halenky', key: 'programy_suseni', code: 'kosile_halenky' },
      { label: 'Konečná úprava hedvábí', key: 'programy_suseni', code: 'konecna_uprava_hedvabi' },
      { label: 'Konečná úprava vlny', key: 'programy_suseni', code: 'konecna_uprava_vlny' },
      { label: 'Vlna', key: 'programy_suseni', code: 'vlna' },
      { label: 'Expres', key: 'programy_suseni', code: 'expres' },
      { label: 'Jeans', key: 'programy_suseni', code: 'jeans' },
      { label: 'Outdoor', key: 'programy_suseni', code: 'outdoor' },
      { label: 'Impregnace', key: 'programy_suseni', code: 'impregnace' },
      { label: 'Sportovní prádlo', key: 'programy_suseni', code: 'sportovni_prado' },
      { label: 'Studený vzduch', key: 'programy_suseni', code: 'studeny_vzduch' },
      { label: 'Teplý vzduch', key: 'programy_suseni', code: 'teply_vzduch' },
      { label: 'Teplý vzduch/DryFresh', key: 'programy_suseni', code: 'teply_vzduch_dryfresh' },
      { label: 'Program „Koš“', key: 'programy_suseni', code: 'program_kos' },
      { label: 'Vyhlazování', key: 'programy_suseni', code: 'vyhlazovani' },
      { label: 'Předžehlení', key: 'programy_suseni', code: 'predzehleni' },
      { label: 'Ložní prádlo', key: 'programy_suseni', code: 'lozni_pradlo' },
      { label: 'Konečná úprava párou', key: 'programy_suseni', code: 'konecna_uprava_parou' },
      { label: 'QuickPowerDry', key: 'programy_suseni', code: 'quickpowerdry' },
      { label: 'QuickHygiene', key: 'programy_suseni', code: 'quickhygiene' },
      { label: 'PowerFresh', key: 'programy_suseni', code: 'powerfresh' },
      { label: 'Peří/přikrývky', key: 'programy_suseni', code: 'peri_prikryvky' },
      { label: 'DryFresh', key: 'programy_suseni', code: 'dryfresh' }
    ]
  },
 {
  title: 'KOMFORT PŘI OBSLUZE',
  rows: [
    { label: 'Propojení s Miele@home', key: 'komfort_pri_obsluze', code: 'propojeni_s_miele_home', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'propojeni_s_miele_home', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
    { label: 'Wash2Dry', key: 'komfort_pri_obsluze', code: 'wash2dry', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'wash2dry', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
    { label: 'Předvolba startu až 24 hodin', key: 'komfort_pri_obsluze', code: 'predvolba_startu_az_24_hodin', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'predvolba_startu_az_24_hodin', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
    { label: 'Indikace zbývajícího času', key: 'komfort_pri_obsluze', code: 'indikace_zbyvajiciho_casu', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'indikace_zbyvajiciho_casu', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
    { label: 'Indikace průběhu programu', key: 'komfort_pri_obsluze', code: 'indikace_prubehu_programu', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'indikace_prubehu_programu', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
    { label: 'Zobrazení denního času', key: 'komfort_pri_obsluze', code: 'zobrazeni_denniho_casu', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'zobrazeni_denniho_casu', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
    { label: 'Informační texty', key: 'komfort_pri_obsluze', code: 'informacni_texty', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'informacni_texty', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
    { label: 'Oblíbené programy', key: 'komfort_pri_obsluze', code: 'oblibene_programy', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'oblibene_programy', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
    { label: 'Osvětlení bubnu', key: 'komfort_pri_obsluze', code: 'osvetleni_bubnu', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'osvetleni_bubnu', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
    { label: 'MultiLingua', key: 'komfort_pri_obsluze', code: 'multilingua', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'multilingua', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
    { label: 'Akustický balíček pro minimální hlučnost', key: 'komfort_pri_obsluze', code: 'akusticky_balicek_pro_minimalni_hlucnost', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'akusticky_balicek_pro_minimalni_hlucnost', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
    { label: 'Zásobník na kondenzát', key: 'komfort_pri_obsluze', code: 'zasobnik_na_kondenzat', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'zasobnik_na_kondenzat', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
    { label: 'Integrovaný odvod kondenzátu', key: 'komfort_pri_obsluze', code: 'integrovany_odvod_kondenzatu', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'integrovany_odvod_kondenzatu', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
    { label: 'AddLoad', key: 'komfort_pri_obsluze', code: 'addload', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'addload', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
    { label: 'ComfortOpen', key: 'komfort_pri_obsluze', code: 'comfortopen', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'comfortopen', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true }
  ]
},
{
  title: 'HOSPODÁRNOST A UDRŽITELNOST',
  rows: [
    { label: 'Třída energetické účinnosti (A–G)', key: 'energeticka_trida', alwaysShow: true },

    { label: 'EcoFeedback', key: 'hospodarnost', code: 'ecofeedback', tooltipGroup: 'hospodarnost' },
    { label: 'Technologie EcoDry', key: 'hospodarnost', code: 'technologie_ecodry', tooltipGroup: 'hospodarnost' },
    { label: 'Bezúdržbový výměník tepla', key: 'hospodarnost', code: 'bezudrzbovy_vymenik_tepla', tooltipGroup: 'hospodarnost' },
    { label: 'Motor ProfiEco', key: 'hospodarnost', code: 'motor_profieco', tooltipGroup: 'hospodarnost' },
    { label: 'EcoSpeed', key: 'hospodarnost', code: 'ecospeed', tooltipGroup: 'hospodarnost' },

    { label: 'Třída účinnosti kondenzace (A–D)', key: 'hospodarnost_a_udrzitelnost', code: 'trida_ucinnosti_kondenzace_a_d', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'trida_ucinnosti_kondenzace_a_d', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
    { label: 'Účinnost kondenzace v %', key: 'hospodarnost_a_udrzitelnost', code: 'ucinnost_kondenzace_v', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'ucinnost_kondenzace_v', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
    { label: 'Vážená spotřeba el. energie na 100 cyklů programu ECO Normal v kWh', key: 'hospodarnost_a_udrzitelnost', code: 'vazena_spotreba_el_energie_na_100_mycich_sarzi_v_programu_eco_no', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'vazena_spotreba_el_energie_na_100_mycich_sarzi_v_programu_eco_no', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
    { label: 'Emise hluku přenášeného vzduchem v dB(A)', key: 'hospodarnost_a_udrzitelnost', code: 'emise_hluku_prenaseneho_vzduchem_ve_standardnim_programu_eco_nor', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'emise_hluku_prenaseneho_vzduchem_ve_standardnim_programu_eco_nor', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
    { label: 'Třída emisí hluku přenášeného vzduchem (A–D)', key: 'hospodarnost_a_udrzitelnost', code: 'trida_emisi_hluku_prenaseneho_vzduchem_a_d', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'trida_emisi_hluku_prenaseneho_vzduchem_a_d', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
    { label: 'Doba trvání programu ECO Normal v min', key: 'hospodarnost_a_udrzitelnost', code: 'doba_trvani_programu_eco_normal_v_min', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'doba_trvani_programu_eco_normal_v_min', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true }
  ]
},
{
  title: 'TECHNICKÉ ÚDAJE',
  rows: [
    { label: 'Rozměry (v × š × h) v mm', key: 'technicke_udaje', code: 'rozmery_v_x_s_x_h_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'rozmery_v_x_s_x_h_v_mm', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Rozměry v mm (šířka)', key: 'technicke_udaje', code: 'rozmery_v_mm_sirka', valueKey: 'technicke_udaje_hodnota', valueCode: 'rozmery_v_mm_sirka', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Rozměry v mm (výška)', key: 'technicke_udaje', code: 'rozmery_v_mm_vyska', valueKey: 'technicke_udaje_hodnota', valueCode: 'rozmery_v_mm_vyska', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Rozměry v mm (hloubka)', key: 'technicke_udaje', code: 'rozmery_v_mm_hloubka', valueKey: 'technicke_udaje_hodnota', valueCode: 'rozmery_v_mm_hloubka', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Hmotnost v kg', key: 'technicke_udaje', code: 'hmotnost_v_kg', valueKey: 'technicke_udaje_hodnota', valueCode: 'hmotnost_v_kg', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },

    { label: 'Napětí ve V', key: 'technicke_udaje', code: 'napeti_ve_v', valueKey: 'technicke_udaje_hodnota', valueCode: 'napeti_ve_v', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Jištění v A', key: 'technicke_udaje', code: 'jisteni_v_a', valueKey: 'technicke_udaje_hodnota', valueCode: 'jisteni_v_a', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Frekvence v Hz', key: 'technicke_udaje', code: 'frekvence_v_hz', valueKey: 'technicke_udaje_hodnota', valueCode: 'frekvence_v_hz', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Celkový příkon v kW', key: 'technicke_udaje', code: 'celkovy_prikon_v_kw', valueKey: 'technicke_udaje_hodnota', valueCode: 'celkovy_prikon_v_kw', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Délka elektrického přívodního kabelu v m', key: 'technicke_udaje', code: 'delka_elektrickeho_privodniho_kabelu_v_m', valueKey: 'technicke_udaje_hodnota', valueCode: 'delka_elektrickeho_privodniho_kabelu_v_m', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },

    { label: 'Hermeticky uzavřeno', key: 'technicke_udaje', code: 'hermeticky_uzavreno', tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Typ chladiva', key: 'technicke_udaje', code: 'typ_chladiva', valueKey: 'technicke_udaje_hodnota', valueCode: 'typ_chladiva', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Množství chladiva v kg', key: 'technicke_udaje', code: 'mnozstvi_chladiva_v_kg', valueKey: 'technicke_udaje_hodnota', valueCode: 'mnozstvi_chladiva_v_kg', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Potenciál globálního oteplování chladiva v CO₂e', key: 'technicke_udaje', code: 'potencial_globalniho_oteplovani_chladiva_v_co_e', valueKey: 'technicke_udaje_hodnota', valueCode: 'potencial_globalniho_oteplovani_chladiva_v_co_e', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Potenciál globálního oteplování přístroje v CO₂e', key: 'technicke_udaje', code: 'potencial_globalniho_oteplovani_pristroje_v_co_e', valueKey: 'technicke_udaje_hodnota', valueCode: 'potencial_globalniho_oteplovani_pristroje_v_co_e', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
    { label: 'Výměna svítidel', key: 'technicke_udaje', code: 'vymena_svitidel', valueKey: 'technicke_udaje_hodnota', valueCode: 'vymena_svitidel', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true }
  ]
},
{
  title: 'BEZPEČNOST',
  rows: [
    { label: 'Dětská pojistka', key: 'bezpecnost', code: 'detska_pojistka' },
    { label: 'PIN kód', key: 'bezpecnost', code: 'pin_kod' },
    { label: 'Indikace „Vyprázdnit zásobník“', key: 'bezpecnost', code: 'indikace_vyprazdnit_zasobnik' },
    { label: 'Indikace „Vyčistit filtr“', key: 'bezpecnost', code: 'indikace_vycistit_filtr' },
    { label: 'Optické rozhraní', key: 'bezpecnost', code: 'opticke_rozhrani' }
  ]
},
{
  title: 'DODÁVANÉ PŘÍSLUŠENSTVÍ',
  rows: [
    { label: 'Voucher na druhý flakón s vůní', key: 'voucher_na_druhy_flakon_s_vuni' },
    { label: 'Flakón s vůní', key: 'flakon_s_vuni' }
  ]
},
{
  title: 'DOSTUPNÉ JAZYKY DISPLEJE',
  rows: [
    { label: 'Dostupné jazyky displeje díky MultiLingua', key: 'dostupne_jazyky_displeje_diky_multilingua' }
  ]
}
];
COMPARE_SCHEMAS.bezsackove_vysavace = [
  {
    title: 'VŠEOBECNÉ ÚDAJE',
    rows: [
      { label: 'Číslo EAN', key: 'cislo_ean', alwaysShow: true },
      { label: 'Označení produktu', key: 'provedeni', code: 'oznaceni_produktu', valueKey: 'provedeni_hodnota', valueCode: 'oznaceni_produktu', valueOnly: true, tooltipGroup: 'provedeni', alwaysShow: true }
    ]
  },
  {
    title: 'PROVEDENÍ',
    rows: [
      { label: 'Varianta motoru', key: 'provedeni', code: 'varianta_motoru', valueKey: 'provedeni_hodnota', valueCode: 'varianta_motoru', valueOnly: true, tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'Typ přístroje', key: 'provedeni', code: 'typ_pristroje', valueKey: 'provedeni_hodnota', valueCode: 'typ_pristroje', valueOnly: true, tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'Barva přístroje', key: 'provedeni', code: 'barva_pristroje', valueKey: 'provedeni_hodnota', valueCode: 'barva_pristroje', valueOnly: true, tooltipGroup: 'provedeni', alwaysShow: true }
    ]
  },
  {
    title: 'ČIŠTĚNÍ',
    rows: [
      { label: 'Technologie Vortex', key: 'cisteni', code: 'technologie_vortex', tooltipGroup: 'cisteni', alwaysShow: true }
    ]
  },
  {
    title: 'KOMFORT PŘI OBSLUZE',
    rows: [
      { label: 'Elektronická regulace výkonu', key: 'komfort_pri_obsluze', code: 'elektronicka_regulace_vykonu', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'elektronicka_regulace_vykonu', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Ergonomické držadlo', key: 'komfort_pri_obsluze', code: 'ergonomicke_drzadlo', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'ergonomicke_drzadlo', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Ergonomická rukojeť', key: 'komfort_pri_obsluze', code: 'ergonomicka_rukojet', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'ergonomicka_rukojet', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Sací trubice', key: 'komfort_pri_obsluze', code: 'saci_trubice', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'saci_trubice', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Parkovací systém pro přestávky ve vysávání', key: 'komfort_pri_obsluze', code: 'parkovaci_system_pro_prestavky_ve_vysavani', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'parkovaci_system_pro_prestavky_ve_vysavani', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Parkovací systém pro uskladnění', key: 'komfort_pri_obsluze', code: 'parkovaci_system_pro_uskladneni', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'parkovaci_system_pro_uskladneni', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Komfortní navíjení kabelu', key: 'komfort_pri_obsluze', code: 'komfortni_navijeni_kabelu', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'komfortni_navijeni_kabelu', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Systém Silence', key: 'komfort_pri_obsluze', code: 'system_silence', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'system_silence', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true }
    ]
  },
  {
    title: 'MOBILITA',
    rows: [
      { label: 'TrackDrive', key: 'mobilita', code: 'trackdrive', tooltipGroup: 'mobilita', alwaysShow: true },
      { label: 'Dynamic Drive', key: 'mobilita', code: 'dynamic_drive', tooltipGroup: 'mobilita', alwaysShow: true },
      { label: '4bodové řízení', key: 'mobilita', code: '4bodove_rizeni', tooltipGroup: 'mobilita', alwaysShow: true },
      { label: 'Šetrná kolečka na ocelových osách', key: 'mobilita', code: 'setrna_kolecka_na_ocelovych_osach', tooltipGroup: 'mobilita', alwaysShow: true },
      { label: 'Akční rádius v m', key: 'akcni_radius_v_m', tooltipGroup: 'mobilita' },
      { label: 'Délka kabelu v m', key: 'delka_kabelu_v_m', tooltipGroup: 'mobilita' }
    ]
  },
  {
    title: 'FILTRAČNÍ SYSTÉM',
    rows: [
      { label: 'ComfortClean', key: 'filtracni_system', code: 'comfort_clean', valueKey: 'filtracni_system_hodnota', valueCode: 'comfort_clean', emptyAsNo: true, tooltipGroup: 'filtracni_system', alwaysShow: true },
      { label: 'Vzduchový filtr', key: 'filtracni_system', code: 'vzduchovy_filtr', valueKey: 'filtracni_system_hodnota', valueCode: 'vzduchovy_filtr', valueOnly: true, tooltipGroup: 'filtracni_system', alwaysShow: true },
      { label: 'Objem prachové nádoby v l', key: 'filtracni_system', code: 'objem_prachove_nadoby_v_l', valueKey: 'filtracni_system_hodnota', valueCode: 'objem_prachove_nadoby_v_l', valueOnly: true, tooltipGroup: 'filtracni_system', alwaysShow: true }
    ]
  },
  {
    title: 'TECHNICKÉ ÚDAJE',
    rows: [
      { label: 'Výkon ve wattech', key: 'technicke_udaje', code: 'vykon_ve_wattech', valueKey: 'technicke_udaje_hodnota', valueCode: 'vykon_ve_wattech', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Hlasitost v dB', key: 'technicke_udaje', code: 'hlasitost_v_db', valueKey: 'technicke_udaje_hodnota', valueCode: 'hlasitost_v_db', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Šířka v mm', key: 'technicke_udaje', code: 'rozmery_v_mm_sirka', valueKey: 'technicke_udaje_hodnota', valueCode: 'rozmery_v_mm_sirka', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Výška v mm', key: 'technicke_udaje', code: 'rozmery_v_mm_vyska', valueKey: 'technicke_udaje_hodnota', valueCode: 'rozmery_v_mm_vyska', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Hloubka v mm', key: 'technicke_udaje', code: 'rozmery_v_mm_hloubka', valueKey: 'technicke_udaje_hodnota', valueCode: 'rozmery_v_mm_hloubka', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Hmotnost v kg', key: 'technicke_udaje', code: 'hmotnost_v_kg', valueKey: 'technicke_udaje_hodnota', valueCode: 'hmotnost_v_kg', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true }
    ]
  },
  {
    title: 'DODÁVANÉ PŘÍSLUŠENSTVÍ',
    rows: [
      { label: 'Hubice na čalounění', key: 'dodavane_prislusenstvi', code: 'hubice_na_calouneni', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Hubice pro vysávání spár', key: 'dodavane_prislusenstvi', code: 'hubice_pro_vysavani_spar', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Sací štětec', key: 'dodavane_prislusenstvi', code: 'saci_stetec', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Podlahová hubice SBD 365-3', key: 'dodavane_prislusenstvi', code: 'podlahova_hubice_sbd_365_3', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Podlahová hubice SBD 355-3', key: 'dodavane_prislusenstvi', code: 'podlahova_hubice_sbd_355_3', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Podlahová hubice SBD 660-3', key: 'dodavane_prislusenstvi', code: 'podlahova_hubice_sbd_660_3', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Kartáč Parquet Twister SBB 300-3', key: 'dodavane_prislusenstvi', code: 'kartac_parquet_twister_sbb_300_3', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Turbokartáč STB 305-3', key: 'dodavane_prislusenstvi', code: 'turbokartac_stb_305_3_dvojity_zamceny', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Čistící kartáč', key: 'dodavane_prislusenstvi', code: 'cistici_kartac', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true }
    ]
  }
];
COMPARE_SCHEMAS.sackove_vysavace = [
  {
    title: 'VŠEOBECNÉ ÚDAJE',
    rows: [
      { label: 'Číslo EAN', key: 'cislo_ean', alwaysShow: true },
      { label: 'Označení produktu', key: 'provedeni', code: 'oznaceni_produktu', valueKey: 'provedeni_hodnota', valueCode: 'oznaceni_produktu', valueOnly: true, tooltipGroup: 'provedeni', alwaysShow: true }
    ]
  },
  {
    title: 'PROVEDENÍ',
    rows: [
      { label: 'Varianta motoru', key: 'provedeni', code: 'varianta_motoru', valueKey: 'provedeni_hodnota', valueCode: 'varianta_motoru', valueOnly: true, tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'Typ přístroje', key: 'provedeni', code: 'typ_pristroje', valueKey: 'provedeni_hodnota', valueCode: 'typ_pristroje', valueOnly: true, tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'Barva přístroje', key: 'provedeni', code: 'barva_pristroje', valueKey: 'provedeni_hodnota', valueCode: 'barva_pristroje', valueOnly: true, tooltipGroup: 'provedeni', alwaysShow: true }
    ]
  },
  {
    title: 'KOMFORT PŘI OBSLUZE',
    rows: [
      { label: 'Elektronická regulace výkonu', key: 'komfort_pri_obsluze', code: 'elektronicka_regulace_vykonu', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'elektronicka_regulace_vykonu', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Světelný displej pro indikaci stupně výkonu', key: 'komfort_pri_obsluze', code: 'svetelny_displej_pro_indikaci_stupne_vykonu', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'svetelny_displej_pro_indikaci_stupne_vykonu', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Ergonomické držadlo', key: 'komfort_pri_obsluze', code: 'ergonomicke_drzadlo', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'ergonomicke_drzadlo', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Ergonomická rukojeť', key: 'komfort_pri_obsluze', code: 'ergonomicka_rukojet', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'ergonomicka_rukojeti', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Sací trubice', key: 'komfort_pri_obsluze', code: 'saci_trubice', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'saci_trubice', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Parkovací systém pro přestávky ve vysávání', key: 'komfort_pri_obsluze', code: 'parkovaci_system_pro_prestavky_ve_vysavani', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'parkovaci_system_pro_prestavky_ve_vysavani', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Stupeň Automatika', key: 'komfort_pri_obsluze', code: 'stupen_automatika', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'stupen_automatika', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Parkovací systém pro uskladnění', key: 'komfort_pri_obsluze', code: 'parkovaci_system_pro_uskladneni', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'parkovaci_system_pro_uskladneni', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Komfortní navíjení kabelu', key: 'komfort_pri_obsluze', code: 'komfortni_navijeni_kabelu', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'komfortni_navijeni_kabelu', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Rukojeť Comfort 2.0', key: 'komfort_pri_obsluze', code: 'rukojeti_comfort_2_0', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'rukojeti_comfort_2_0', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Bezdrátová rukojeť Comfort 2.0', key: 'komfort_pri_obsluze', code: 'bezdratova_rukojeti_comfort_2_0', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'bezdratova_rukojeti_comfort_2_0', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Miele@home', key: 'komfort_pri_obsluze', code: 'propojeni_s_miele_home', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'propojeni_s_miele_home', emptyAsNo: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true }
    ]
  },
  {
    title: 'MOBILITA',
    rows: [
      { label: 'Šetrná kolečka na ocelových osách', key: 'mobilita', code: 'setrna_kolecka_na_ocelovych_osach', tooltipGroup: 'mobilita', alwaysShow: true },
      { label: 'Dynamic Drive', key: 'mobilita', code: 'dynamic_drive', tooltipGroup: 'mobilita', alwaysShow: true },
      { label: '3bodové řízení', key: 'mobilita', code: '3bodove_rizeni', tooltipGroup: 'mobilita', alwaysShow: true },
      { label: '4bodové řízení', key: 'mobilita', code: '4bodove_rizeni', tooltipGroup: 'mobilita', alwaysShow: true }
    ]
  },
  {
    title: 'FILTRAČNÍ SYSTÉM',
    rows: [
      { label: 'Indikace výměny sáčku', key: 'filtracni_system', code: 'indikace_vymeny_sacku', valueKey: 'filtracni_system_hodnota', valueCode: 'indikace_vymeny_sacku', emptyAsNo: true, tooltipGroup: 'filtracni_system', alwaysShow: true },
      { label: 'Vzduchový filtr', key: 'filtracni_system', code: 'vzduchovy_filtr', valueKey: 'filtracni_system_hodnota', valueCode: 'vzduchovy_filtr', valueOnly: true, tooltipGroup: 'filtracni_system', alwaysShow: true },
      { label: 'Motorový filtr', key: 'filtracni_system', code: 'motorovy_filtr', valueKey: 'filtracni_system_hodnota', valueCode: 'motorovy_filtr', emptyAsNo: true, tooltipGroup: 'filtracni_system', alwaysShow: true }
    ]
  },
  {
    title: 'BEZPEČNOST',
    rows: [
      { label: 'Spojovací pojistka pro podlahovou hubici a rukojeť', key: 'bezpecnost', code: 'spojovaci_pojistka_pro_podlahovou_hubici_a_rukojet', tooltipGroup: 'bezpecnost', alwaysShow: true },
      { label: 'Automatické polohování sáčku', key: 'bezpecnost', code: 'automaticke_polohovani_sacku', tooltipGroup: 'bezpecnost', alwaysShow: true },
      { label: 'Ochrana nábytku', key: 'bezpecnost', code: 'ochrana_nabytku', tooltipGroup: 'bezpecnost', alwaysShow: true }
    ]
  },
  {
    title: 'TECHNICKÉ ÚDAJE',
    rows: [
      { label: 'Akční rádius v m', key: 'technicke_udaje', code: 'akcni_radius_v_m', valueKey: 'technicke_udaje_hodnota', valueCode: 'akcni_radius_v_m', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Délka elektrického přívodního kabelu v m', key: 'technicke_udaje', code: 'delka_elektrickeho_privodniho_kabelu_v_m', valueKey: 'technicke_udaje_hodnota', valueCode: 'delka_elektrickeho_privodniho_kabelu_v_m', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Typ sáčku do vysavače', key: 'technicke_udaje', code: 'typ_sacku_do_vysavace', valueKey: 'technicke_udaje_hodnota', valueCode: 'typ_sacku_do_vysavace', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Objem sáčku v l', key: 'technicke_udaje', code: 'objem_sacku_v_l', valueKey: 'technicke_udaje_hodnota', valueCode: 'objem_sacku_v_l', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Výkon ve wattech', key: 'technicke_udaje', code: 'vykon_ve_wattech', valueKey: 'technicke_udaje_hodnota', valueCode: 'vykon_ve_wattech', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Hlasitost v dB', key: 'technicke_udaje', code: 'hlasitost_v_db', valueKey: 'technicke_udaje_hodnota', valueCode: 'hlasitost_v_db', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Šířka v mm', key: 'technicke_udaje', code: 'sirka_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'sirka_v_mm', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Výška v mm', key: 'technicke_udaje', code: 'vyska_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'vyska_v_mm', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Hloubka v mm', key: 'technicke_udaje', code: 'hloubka_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'hloubka_v_mm', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Hmotnost v kg', key: 'technicke_udaje', code: 'hmotnost_v_kg', valueKey: 'technicke_udaje_hodnota', valueCode: 'hmotnost_v_kg', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Uložení příslušenství', key: 'technicke_udaje', code: 'ulozeni_prislusenstvi', valueKey: 'technicke_udaje_hodnota', valueCode: 'ulozeni_prislusenstvi', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true }
    ]
  },
  {
    title: 'DODÁVANÉ PŘÍSLUŠENSTVÍ',
    rows: [
      { label: 'Hubice na čalounění', key: 'dodavane_prislusenstvi', code: 'hubice_na_calouneni', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Hubice pro vysávání spár', key: 'dodavane_prislusenstvi', code: 'hubice_pro_vysavani_spar', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Extra dlouhá, flexibilní spárová hubice SFD 20', key: 'dodavane_prislusenstvi', code: 'extra_dlouha_flexibilni_sparova_hubice_sfd_20', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Sací štětec', key: 'dodavane_prislusenstvi', code: 'saci_stetec', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Podlahová hubice SBD 355-3', key: 'dodavane_prislusenstvi', code: 'podlahova_hubice_sbd_355_3', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Podlahová hubice SBD 365-3', key: 'dodavane_prislusenstvi', code: 'podlahova_hubice_sbd_365_3', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'SBB AllFloor', key: 'dodavane_prislusenstvi', code: 'sbb_allfloor', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Kartáč Parquet Twister SBB 300-3', key: 'dodavane_prislusenstvi', code: 'kartac_parquet_twister_sbb_300_3', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Turbokartáč STB 305-3', key: 'dodavane_prislusenstvi', code: 'turbokartac_stb_305_3', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Prachový sáček HyClean Pure TU', key: 'dodavane_prislusenstvi', code: 'prachovy_sacek_hyclean_pure_tu', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Prachový sáček HyClean Pure CO', key: 'dodavane_prislusenstvi', code: 'prachovy_sacek_hyclean_pure_co', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Poukaz na prachové sáčky HyClean Pure TU', key: 'dodavane_prislusenstvi', code: 'poukaz_na_prachove_sacky_hyclean_pure_tu', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Poukaz na prachové sáčky HyClean Pure CO', key: 'dodavane_prislusenstvi', code: 'poukaz_na_prachove_sacky_hyclean_pure_co', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Voucher: doplňkové HEPA filtry', key: 'dodavane_prislusenstvi', code: 'voucher_doplnkove_hepa_filtry', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Voucher na podlahovou hubici FiberTeQ AllFloor SBD 380-3', key: 'dodavane_prislusenstvi', code: 'voucher_na_podlahovou_hubici_fiberteq_allfloor_sbd_380_3', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true }
    ]
  }
];



COMPARE_SCHEMAS.tycove_akumulatorove_vysavace = [
  {
    title: 'VŠEOBECNÉ ÚDAJE',
    rows: [
      { label: 'Číslo EAN', key: 'cislo_ean', alwaysShow: true },
      { label: 'Označení produktu', key: 'provedeni', code: 'oznaceni_produktu', valueKey: 'provedeni_hodnota', valueCode: 'oznaceni_produktu', valueOnly: true, tooltipGroup: 'provedeni', alwaysShow: true }
    ]
  },
  {
    title: 'PROVEDENÍ',
    rows: [
      { label: 'Varianta motoru', key: 'provedeni', code: 'varianta_motoru', valueKey: 'provedeni_hodnota', valueCode: 'varianta_motoru', valueOnly: true, tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'Typ přístroje', key: 'provedeni', code: 'typ_pristroje', valueKey: 'provedeni_hodnota', valueCode: 'typ_pristroje', valueOnly: true, tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'Barva přístroje', key: 'provedeni', code: 'barva_pristroje', valueKey: 'provedeni_hodnota', valueCode: 'barva_pristroje', valueOnly: true, tooltipGroup: 'provedeni', alwaysShow: true }
    ]
  },
  {
    title: 'ČIŠTĚNÍ',
    rows: [
      { label: 'Technologie Vortex', key: 'cisteni', code: 'technologie_vortex', tooltipGroup: 'cisteni', alwaysShow: true },
      { label: 'Elektrokartáč Multi Floor XXL SEB 435 s osvětlením BrilliantLight', key: 'cisteni', code: 'elektrokartac_multi_floor_xxl_seb_435_s_osvetlenim_brilliantlight', tooltipGroup: 'cisteni', alwaysShow: true }
    ]
  },
  {
    title: 'KOMFORT PŘI OBSLUZE',
    rows: [
      { label: 'Elektronická regulace výkonu', key: 'komfort_pri_obsluze', code: 'elektronicka_regulace_vykonu', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'elektronicka_regulace_vykonu', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Výměnný akumulátor Li-Ion', key: 'komfort_pri_obsluze', code: 'vymenny_akumulator_li_ion', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'vymenny_akumulator_li_ion', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Funkce 3 v 1', key: 'komfort_pri_obsluze', code: 'funkce_3_v_1', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'funkce_3_v_1', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Nástěnný držák', key: 'komfort_pri_obsluze', code: 'nastenny_drzak', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'nastenny_drzak', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Systém SpeedLock', key: 'komfort_pri_obsluze', code: 'system_speedlock', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'system_speedlock', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Ukládání příslušenství', key: 'komfort_pri_obsluze', code: 'ukladani_prislusenstvi', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'ukladani_prislusenstvi', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true }
    ]
  },
  {
    title: 'FILTRAČNÍ SYSTÉM',
    rows: [
      { label: 'ComfortClean', key: 'filtracni_system', code: 'comfort_clean', valueKey: 'filtracni_system_hodnota', valueCode: 'comfort_clean', valueOnly: true, tooltipGroup: 'filtracni_system', alwaysShow: true },
      { label: 'Vzduchový filtr', key: 'filtracni_system', code: 'vzduchovy_filtr', valueKey: 'filtracni_system_hodnota', valueCode: 'vzduchovy_filtr', valueOnly: true, tooltipGroup: 'filtracni_system', alwaysShow: true }
    ]
  },
  {
    title: 'TECHNICKÉ ÚDAJE',
    rows: [
      { label: 'Objem prachové nádoby v l', key: 'technicke_udaje', code: 'objem_prachove_nadoby_v_l', valueKey: 'technicke_udaje_hodnota', valueCode: 'objem_prachove_nadoby_v_l', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Typ akumulátoru', key: 'technicke_udaje', code: 'typ_akumulatoru', valueKey: 'technicke_udaje_hodnota', valueCode: 'typ_akumulatoru', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Jmenovitá kapacita akumulátoru v mAh', key: 'technicke_udaje', code: 'jmenovita_kapacita_akumulatoru_v_mah', valueKey: 'technicke_udaje_hodnota', valueCode: 'jmenovita_kapacita_akumulatoru_v_mah', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Hlasitost v dB', key: 'technicke_udaje', code: 'hlasitost_v_db', valueKey: 'technicke_udaje_hodnota', valueCode: 'hlasitost_v_db', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Šířka v mm', key: 'technicke_udaje', code: 'sirka_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'sirka_v_mm', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Výška v mm', key: 'technicke_udaje', code: 'vyska_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'vyska_v_mm', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Hloubka v mm', key: 'technicke_udaje', code: 'hloubka_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'hloubka_v_mm', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Hmotnost v kg', key: 'technicke_udaje', code: 'hmotnost_v_kg', valueKey: 'technicke_udaje_hodnota', valueCode: 'hmotnost_v_kg', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Napětí ve V', key: 'technicke_udaje', code: 'napeti_ve_v', valueKey: 'technicke_udaje_hodnota', valueCode: 'napeti_ve_v', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Doba provozu na stupeň MIN – PowerUnit samostatně', key: 'technicke_udaje', code: 'doba_provozu_na_stupen_min_powerunit_samostatne', valueKey: 'technicke_udaje_hodnota', valueCode: 'doba_provozu_na_stupen_min_powerunit_samostatne', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Doba provozu na stupeň MIN s elektropříslušenstvím', key: 'technicke_udaje', code: 'doba_provozu_na_stupen_min_s_elektroprislusenstvim', valueKey: 'technicke_udaje_hodnota', valueCode: 'doba_provozu_na_stupen_min_s_elektroprislusenstvim', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Doba provozu na stupeň MAX s elektropříslušenstvím', key: 'technicke_udaje', code: 'doba_provozu_na_stupen_max_s_elektroprislusenstvim', valueKey: 'technicke_udaje_hodnota', valueCode: 'doba_provozu_na_stupen_max_s_elektroprislusenstvim', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Plošný výkon v m²', key: 'technicke_udaje', code: 'plosny_vykon_v_m', valueKey: 'technicke_udaje_hodnota', valueCode: 'plosny_vykon_v_m', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Doba nabíjení v min', key: 'technicke_udaje', code: 'doba_nabijeni_v_min', valueKey: 'technicke_udaje_hodnota', valueCode: 'doba_nabijeni_v_min', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Uložení příslušenství', key: 'technicke_udaje', code: 'ulozeni_prislusenstvi', valueKey: 'technicke_udaje_hodnota', valueCode: 'ulozeni_prislusenstvi', valueOnly: true, tooltipGroup: 'technicke_udaje', alwaysShow: true }
    ]
  },
  {
    title: 'DODÁVANÉ PŘÍSLUŠENSTVÍ',
    rows: [
      { label: 'Hubice pro vysávání spár', key: 'dodavane_prislusenstvi', code: 'hubice-pro-vysavani-spar', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Sací štětec', key: 'dodavane_prislusenstvi', code: 'saci-stetec', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Hubice na čalounění XXL SPD 20', key: 'dodavane_prislusenstvi', code: 'hubice_na_calouneni_xxl_spd_20', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Elektrokartáč Multi Floor XXL s BrilliantLight', key: 'dodavane_prislusenstvi', code: 'elektrokartac_multi_floor_xxl_brilliantlight', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Čistící kartáč', key: 'dodavane_prislusenstvi', code: 'cistici_kartac', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Nástěnný držák', key: 'dodavane_prislusenstvi', code: 'nastenny_drzak', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Síťový adaptér', key: 'dodavane_prislusenstvi', code: 'sitovy_adapter', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Kartáč Electro Compact HX-EC 20', key: 'dodavane_prislusenstvi', code: 'kartac_electro_compact_hx_ec_20', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Nabíjecí stanice', key: 'dodavane_prislusenstvi', code: 'nabijeci_stanice', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Dodatečný akumulátor', key: 'dodavane_prislusenstvi', code: 'dodatecny_akumulator', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Kartáčový válec Hardfloor Care', key: 'dodavane_prislusenstvi', code: 'kartacovy_valec_hardfloor_care', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Elektrický kartáč', key: 'dodavane_prislusenstvi', code: 'elektricky_kartac', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Elektrokartáč MultiFloor', key: 'dodavane_prislusenstvi', code: 'elektrokartac_multifloor', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Hubice na čalounění', key: 'dodavane_prislusenstvi', code: 'hubice-na-calouneni', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
      { label: 'Spárová hubice', key: 'dodavane_prislusenstvi', code: 'sparova_hubice', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true }
    ]
  }
];
COMPARE_SCHEMAS.varne_desky = [
  {
    title: 'VŠEOBECNÉ ÚDAJE',
    rows: [
      { label: 'Číslo EAN', key: 'cislo_ean', alwaysShow: true },
      { label: 'Marketingová třída', key: 'marketingova_trida', alwaysShow: true },
      { label: 'Druh ohřevu', key: 'druh_ohrevu', alwaysShow: true }
    ]
  },
  {
    title: 'PROVEDENÍ',
    rows: [
      { label: 'Nezávisle na sporáku', key: 'provedeni', code: 'nezavisle_na_sporaku', tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'Indukční varná deska s integrovaným odsavačem par', key: 'provedeni', code: 'indukcni_varna_deska_s_integrovanym_odsavacem_par', tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'SmartLine', key: 'provedeni', code: 'smartline', tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'Odsavač par do pracovní desky', key: 'provedeni', code: 'odsavac_par_do_pracovni_desky', tooltipGroup: 'provedeni', alwaysShow: true },
      { label: 'ProLine', key: 'provedeni', code: 'proline', tooltipGroup: 'provedeni', alwaysShow: true }
    ]
  },
  {
    title: 'PROVOZNÍ ZPŮSOBY',
    rows: [
      { label: 'Cirkulace vedená pomocí dokoupitelného příslušenství', key: 'provozni_zpusoby', code: 'cirkulace_vedena_pomoci_dokoupitelneho_prislusenstvi', valueKey: 'provozni_zpusoby_hodnoty', valueCode: 'cirkulace_vedena_pomoci_dokoupitelneho_prislusenstvi', tooltipGroup: 'provozni_zpusoby', alwaysShow: true },
      { label: 'Cirkulace nevedená (Plug&Play instalace)', key: 'provozni_zpusoby', code: 'cirkulace_nevedena_plug_and_play', valueKey: 'provozni_zpusoby_hodnoty', valueCode: 'cirkulace_nevedena_plug_and_play_instalace', emptyAsNo: true, tooltipGroup: 'provozni_zpusoby', alwaysShow: true },
      { label: 'Odtah vedený pomocí volitelného příslušenství', key: 'provozni_zpusoby', code: 'odtah_vedeny_pomoci_volitelneho_prislusenstvi', valueKey: 'provozni_zpusoby_hodnoty', valueCode: 'odtah_vedeny_pomoci_volitelneho_prislusenstvi', tooltipGroup: 'provozni_zpusoby', alwaysShow: true },
      { label: 'Způsob vedení vzduchu', key: 'provozni_zpusoby', code: 'zpusob_vedeni_vzduchu', valueKey: 'provozni_zpusoby_hodnoty', valueCode: 'zpusob_vedeni_vzduchu', valueOnly: true, tooltipGroup: 'provozni_zpusoby', alwaysShow: true },
      { label: 'Potřebné díly pro ploché odtahové potrubí k dokoupení', key: 'provozni_zpusoby', code: 'potrebne_dily_pro_ploche_odtahove_potrubi_k_dokoupeni', valueKey: 'provozni_zpusoby_hodnoty', valueCode: 'potrebne_dily_pro_ploche_odtahove_potrubi_k_dokoupeni', valueOnly: true, tooltipGroup: 'provozni_zpusoby', alwaysShow: true },
      { label: 'Potřebná sada pro přestavbu na cirkulaci k dokoupení', key: 'provozni_zpusoby', code: 'potrebna_sada_pro_prestavbu_na_cirkulaci_k_dokoupeni', valueKey: 'provozni_zpusoby_hodnoty', valueCode: 'potrebna_sada_pro_prestavbu_na_cirkulaci_k_dokoupeni', valueOnly: true, tooltipGroup: 'provozni_zpusoby', alwaysShow: true }
    ]
  },
  {
    title: 'DESIGN',
    rows: [
      { label: 'Elegantní sklokeramický povrch', key: 'design', code: 'elegantni_sklokeramicky_povrch', tooltipGroup: 'design', alwaysShow: true },
      { label: 'Barva sklokeramiky', key: 'design', code: 'barva_sklokeramiky', valueKey: 'design_hodnoty', valueCode: 'barva_sklokeramiky', valueOnly: true, tooltipGroup: 'design', alwaysShow: true },
      { label: 'Povrch odolný proti poškrábání', key: 'design', code: 'povrch_odolny_proti_poskrabani', valueKey: 'design_hodnoty', valueCode: 'povrch_odolny_proti_poskrabani', valueOnly: true, tooltipGroup: 'design', alwaysShow: true },
      { label: 'Efekt proti otiskům prstů', key: 'design', code: 'efekt_proti_otiskum_prstu', tooltipGroup: 'design', alwaysShow: true },
      { label: 'Instalace se zapuštěním do pracovní desky', key: 'design', code: 'instalace_se_zapustenim_do_pracovni_desky', tooltipGroup: 'design', alwaysShow: true },
      { label: 'Instalace bez rámu na pracovní desku', key: 'design', code: 'instalace_bez_ramu_na_pracovni_desku', tooltipGroup: 'design', alwaysShow: true },
      { label: 'DiamondFinish', key: 'design', code: 'diamondfinish', tooltipGroup: 'design', alwaysShow: true },
      { label: 'Zapuštěný odsavač par', key: 'design', code: 'zapusteny_odsavac_par', tooltipGroup: 'design', alwaysShow: true },
      { label: 'Barva krycí mřížky', key: 'design', code: 'barva_kryci_mrizky', valueKey: 'design_hodnoty', valueCode: 'barva_kryci_mrizky', valueOnly: true, tooltipGroup: 'design', alwaysShow: true },
      { label: 'Barva tukového filtru', key: 'design', code: 'barva_tukoveho_filtru', valueKey: 'design_hodnoty', valueCode: 'barva_tukoveho_filtru', valueOnly: true, tooltipGroup: 'design', alwaysShow: true },
      { label: 'Nerezový rám', key: 'design', code: 'nerezovy_ram', tooltipGroup: 'design', alwaysShow: true },
      { label: 'Vyražené logo Miele', key: 'design', code: 'vyrazene_logo_miele', tooltipGroup: 'design', alwaysShow: true },
      { label: 'Litinové nosiče nádobí (matně černé, emailované)', key: 'design', code: 'litinove_nosice_nadodi_matne_cerne_emailovane', tooltipGroup: 'design', alwaysShow: true },
      { label: 'Nerezový tepan', key: 'design', code: 'nerezovy_tepan', tooltipGroup: 'design', alwaysShow: true },
      { label: 'Povrchová montáž/ bez rámu pro zapuštění', key: 'design', code: 'povrchova_montaz_bez_ramu_pro_zapusteni', valueKey: 'design_hodnoty', valueCode: 'povrchova_montaz_bez_ramu_pro_zapusteni', valueOnly: true, tooltipGroup: 'design', alwaysShow: true },
      { label: 'Design s potiskem', key: 'design', code: 'design_s_potiskem', valueKey: 'design_hodnoty', valueCode: 'design_s_potiskem', valueOnly: true, tooltipGroup: 'design', alwaysShow: true },
      { label: 'Lze kombinovat s přístroji SmartLine', key: 'design', code: 'lze_kombinovat_s_pristroji_smartline', tooltipGroup: 'design', alwaysShow: true },
      { label: 'Lze kombinovat s odsavačem par do pracovní desky - SmartLine', key: 'design', code: 'lze_kombinovat_s_odsavacem_par_do_pracovni_desky_smartline', tooltipGroup: 'design', alwaysShow: true },
      { label: 'Nerezová varná deska', key: 'design', code: 'nerezova_varna_deska', tooltipGroup: 'design', alwaysShow: true }
    ]
  },
  {
    title: 'VYBAVENÍ VARNÝCH ZÓN',
    rows: [
      { label: 'Počet varných zón', key: 'vybaveni_varnych_zon', code: 'pocet_varnych_zon', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: 'pocet_varnych_zon', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon', alwaysShow: true },
      { label: 'Počet varných ploch', key: 'vybaveni_varnych_zon', code: 'pocet_varnych_ploch', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: 'pocet_varnych_ploch', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon', alwaysShow: true },
      { label: 'Maximální počet kusů varného nádobí', key: 'vybaveni_varnych_zon', code: 'maximalni_pocet_kusu_varneho_nadobi', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: 'maximalni_pocet_kusu_varneho_nadobi', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon', alwaysShow: true },
      { label: 'Varné zóny PowerFlex - Počet', key: 'vybaveni_varnych_zon', code: 'varne_zony_powerflex_pocet', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: 'varne_zony_powerflex_pocet', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon', alwaysShow: true },
      { label: 'Varné zóny PowerFlex - Druh', key: 'vybaveni_varnych_zon', code: 'varne_zony_powerflex_druh', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: 'varne_zony_powerflex_druh', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon', alwaysShow: true },
      { label: 'Varné zóny PowerFlex - Velikost v mm', key: 'vybaveni_varnych_zon', code: 'varne_zony_powerflex_velikost_v_mm', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: 'varne_zony_powerflex_velikost_v_mm', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon', alwaysShow: true },
      { label: 'Varné zóny PowerFlex - Maximální výkon ve W', key: 'vybaveni_varnych_zon', code: 'varne_zony_powerflex_maximalni_vykon_ve_w', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: 'varne_zony_powerflex_maximalni_vykon_ve_w', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon', alwaysShow: true },
      { label: 'Varné zóny PowerFlex - Maximální výkon boosteru ve W', key: 'vybaveni_varnych_zon', code: 'varne_zony_powerflex_maximalni_vykon_boosteru_ve_w', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: 'varne_zony_powerflex_maximalni_vykon_boosteru_ve_w', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon', alwaysShow: true },
      { label: 'Varné zóny PowerFlex - Maximální výkon TwinBoosteru ve W', key: 'vybaveni_varnych_zon', code: 'varne_zony_powerflex_maximalni_vykon_twinboosteru_ve_w', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: 'varne_zony_powerflex_maximalni_vykon_twinboosteru_ve_w', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon', alwaysShow: true },
      { label: '1. varná zóna/varná oblast - Umístění', key: 'vybaveni_varnych_zon', code: '1_varna_zona_varna_oblast_umisteni', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: '1_varna_zona_varna_oblast_umisteni', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon', alwaysShow: true },
      { label: '1. varná zóna/varná oblast - Druh', key: 'vybaveni_varnych_zon', code: '1_varna_zona_varna_oblast_druh', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: '1_varna_zona_varna_oblast_druh', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon', alwaysShow: true },
      { label: '1. varná zóna/varná oblast - Velikost v mm', key: 'vybaveni_varnych_zon', code: '1_varna_zona_varna_oblast_velikost_v_mm', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: '1_varna_zona_varna_oblast_velikost_v_mm', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon', alwaysShow: true },
      { label: '1. varná zóna/varná oblast - Maximální výkon ve W', key: 'vybaveni_varnych_zon', code: '1_varna_zona_varna_oblast_maximalni_vykon_ve_w', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: '1_varna_zona_varna_oblast_maximalni_vykon_ve_w', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon', alwaysShow: true },
      { label: '1. varná zóna/varná oblast - Maximální výkon boosteru ve W', key: 'vybaveni_varnych_zon', code: '1_varna_zona_varna_oblast_maximalni_vykon_boosteru_ve_w', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: '1_varna_zona_varna_oblast_maximalni_vykon_boosteru_ve_w', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon', alwaysShow: true },
      { label: '1. varná zóna/varná oblast - Maximální výkon TwinBoosteru ve W', key: 'vybaveni_varnych_zon', code: '1_varna_zona_varna_oblast_maximalni_vykon_twinboosteru_ve_w', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: '1_varna_zona_varna_oblast_maximalni_vykon_twinboosteru_ve_w', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon', alwaysShow: true },
      { label: '2. varná zóna/varná oblast - Umístění', key: 'vybaveni_varnych_zon', code: '2_varna_zona_varna_oblast_umisteni', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: '2_varna_zona_varna_oblast_umisteni', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon', alwaysShow: true },
      { label: '2. varná zóna/varná oblast - Druh', key: 'vybaveni_varnych_zon', code: '2_varna_zona_varna_oblast_druh', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: '2_varna_zona_varna_oblast_druh', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon', alwaysShow: true },
      { label: '2. varná zóna/varná oblast - Velikost v mm', key: 'vybaveni_varnych_zon', code: '2_varna_zona_varna_oblast_velikost_v_mm', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: '2_varna_zona_varna_oblast_velikost_v_mm', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon', alwaysShow: true },
      { label: '2. varná zóna/varná oblast - Maximální výkon ve W', key: 'vybaveni_varnych_zon', code: '2_varna_zona_varna_oblast_maximalni_vykon_ve_w', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: '2_varna_zona_varna_oblast_maximalni_vykon_ve_w', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon', alwaysShow: true },
      { label: '2. varná zóna/varná oblast - Maximální výkon boosteru ve W', key: 'vybaveni_varnych_zon', code: '2_varna_zona_varna_oblast_maximalni_vykon_boosteru_ve_w', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: '2_varna_zona_varna_oblast_maximalni_vykon_boosteru_ve_w', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon', alwaysShow: true },
      { label: '2. varná zóna/varná oblast - Maximální výkon TwinBoosteru ve W', key: 'vybaveni_varnych_zon', code: '2_varna_zona_varna_oblast_maximalni_vykon_twinboosteru_ve_w', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: '2_varna_zona_varna_oblast_maximalni_vykon_twinboosteru_ve_w', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon', alwaysShow: true },
      { label: '3. varná zóna/varná oblast - Umístění', key: 'vybaveni_varnych_zon', code: '3_varna_zona_varna_oblast_umisteni', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: '3_varna_zona_varna_oblast_umisteni', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon' },
      { label: '3. varná zóna/varná oblast - Druh', key: 'vybaveni_varnych_zon', code: '3_varna_zona_varna_oblast_druh', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: '3_varna_zona_varna_oblast_druh', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon' },
      { label: '3. varná zóna/varná oblast - Velikost v mm', key: 'vybaveni_varnych_zon', code: '3_varna_zona_varna_oblast_velikost_v_mm', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: '3_varna_zona_varna_oblast_velikost_v_mm', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon' },
      { label: '3. varná zóna/varná oblast - Maximální výkon ve W', key: 'vybaveni_varnych_zon', code: '3_varna_zona_varna_oblast_maximalni_vykon_ve_w', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: '3_varna_zona_varna_oblast_maximalni_vykon_ve_w', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon' },
      { label: '3. varná zóna/varná oblast - Maximální výkon boosteru ve W', key: 'vybaveni_varnych_zon', code: '3_varna_zona_varna_oblast_maximalni_vykon_boosteru_ve_w', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: '3_varna_zona_varna_oblast_maximalni_vykon_boosteru_ve_w', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon' },
      { label: '3. varná zóna/varná oblast - Maximální výkon TwinBoosteru ve W', key: 'vybaveni_varnych_zon', code: '3_varna_zona_varna_oblast_maximalni_vykon_twinboosteru_ve_w', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: '3_varna_zona_varna_oblast_maximalni_vykon_twinboosteru_ve_w', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon' },
      { label: '4. varná zóna/varná oblast - Umístění', key: 'vybaveni_varnych_zon', code: '4_varna_zona_varna_oblast_umisteni', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: '4_varna_zona_varna_oblast_umisteni', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon' },
      { label: '4. varná zóna/varná oblast - Druh', key: 'vybaveni_varnych_zon', code: '4_varna_zona_varna_oblast_druh', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: '4_varna_zona_varna_oblast_druh', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon' },
      { label: '4. varná zóna/varná oblast - Velikost v mm', key: 'vybaveni_varnych_zon', code: '4_varna_zona_varna_oblast_velikost_v_mm', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: '4_varna_zona_varna_oblast_velikost_v_mm', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon' },
      { label: '4. varná zóna/varná oblast - Maximální výkon ve W', key: 'vybaveni_varnych_zon', code: '4_varna_zona_varna_oblast_maximalni_vykon_ve_w', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: '4_varna_zona_varna_oblast_maximalni_vykon_ve_w', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon' },
      { label: '4. varná zóna/varná oblast - Maximální výkon boosteru ve W', key: 'vybaveni_varnych_zon', code: '4_varna_zona_varna_oblast_maximalni_vykon_boosteru_ve_w', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: '4_varna_zona_varna_oblast_maximalni_vykon_boosteru_ve_w', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon' },
      { label: 'Počet varných zón/ varných oblastí', key: 'vybaveni_varnych_zon', code: 'pocet_varnych_zon_varnych_oblasti', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: 'pocet_varnych_zon_varnych_oblasti', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon' },
      { label: 'Výkon plynového hořáku - Úsporný hořák v kW', key: 'vybaveni_varnych_zon', code: 'vykon_plynoveho_horaku_usporny_horak_v_kw', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: 'vykon_plynoveho_horaku_usporny_horak_v_kw', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon' },
      { label: 'Výkon plynového hořáku - Normální hořák v kW', key: 'vybaveni_varnych_zon', code: 'vykon_plynoveho_horaku_normalni_horak_v_kw', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: 'vykon_plynoveho_horaku_normalni_horak_v_kw', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon' },
      { label: 'Výkon plynového hořáku - Silný hořák v kW', key: 'vybaveni_varnych_zon', code: 'vykon_plynoveho_horaku_silny_horak_v_kw', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: 'vykon_plynoveho_horaku_silny_horak_v_kw', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon' },
      { label: 'Výkon plynového hořáku - Dvojitý hořák wok v kW', key: 'vybaveni_varnych_zon', code: 'vykon_plynoveho_horaku_dvojity_horak_wok_v_kw', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: 'vykon_plynoveho_horaku_dvojity_horak_wok_v_kw', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon' },
      { label: '5. varná zóna/varná oblast - Umístění', key: 'vybaveni_varnych_zon', code: '5_varna_zona_varna_oblast_umisteni', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: '5_varna_zona_varna_oblast_umisteni', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon' },
      { label: '5. varná zóna/varná oblast - Druh', key: 'vybaveni_varnych_zon', code: '5_varna_zona_varna_oblast_druh', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: '5_varna_zona_varna_oblast_druh', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon' },
      { label: '5. varná zóna/varná oblast - Maximální výkon ve W', key: 'vybaveni_varnych_zon', code: '5_varna_zona_varna_oblast_maximalni_vykon_ve_w', valueKey: 'vybaveni_varnych_zon_hodnoty', valueCode: '5_varna_zona_varna_oblast_maximalni_vykon_ve_w', valueOnly: true, tooltipGroup: 'vybaveni_varnych_zon' }
    ]
  },
  {
    title: 'KOMFORT PŘI OBSLUZE',
    rows: [
      { label: 'Propojení s Miele@home', key: 'komfort_pri_obsluze', code: 'propojeni_s_miele_home', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'propojeni_s_miele_home', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Con@ctivity', key: 'komfort_pri_obsluze', code: 'con_ctivity', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'con_ctivity', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Rozpoznání přítomnosti a velikosti hrnce', key: 'komfort_pri_obsluze', code: 'rozpoznani_pritomnosti_a_velikosti_hrnce', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'rozpoznani_pritomnosti_a_velikosti_hrnce', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Ovládání senzorovými tlačítky', key: 'komfort_pri_obsluze', code: 'ovladani_senzorovymi_tlacitky', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'ovladani_senzorovymi_tlacitky', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Barva zobrazení', key: 'komfort_pri_obsluze', code: 'barva_zobrazeni', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'barva_zobrazeni', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Permanentní rozpoznání hrnce', key: 'komfort_pri_obsluze', code: 'permanentni_rozpoznani_hrnce', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'permanentni_rozpoznani_hrnce', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Funkce Stop&Go', key: 'komfort_pri_obsluze', code: 'funkce_stop_go', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'funkce_stop_go', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Ochrana při utírání', key: 'komfort_pri_obsluze', code: 'ochrana_pri_utirani', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'ochrana_pri_utirani', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Funkce Recall', key: 'komfort_pri_obsluze', code: 'funkce_recall', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'funkce_recall', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Kuchyňský budík', key: 'komfort_pri_obsluze', code: 'kuchynsky_budik', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'kuchynsky_budik', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Automatické vypínání', key: 'komfort_pri_obsluze', code: 'automaticke_vypinani', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'automaticke_vypinani', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Automatika předvaření', key: 'komfort_pri_obsluze', code: 'automatika_predvareni', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'automatika_predvareni', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Udržování teploty', key: 'komfort_pri_obsluze', code: 'udrzovani_teploty', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'udrzovani_teploty', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Individuální možnosti nastavení (např. signální tóny)', key: 'komfort_pri_obsluze', code: 'individualni_moznosti_nastaveni_napr_signalni_tony', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'individualni_moznosti_nastaveni_napr_signalni_tony', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Inteligentní rozpoznání hrnce', key: 'komfort_pri_obsluze', code: 'inteligentni_rozpoznani_hrnce', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'inteligentni_rozpoznani_hrnce', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Indikátor změny pozice', key: 'komfort_pri_obsluze', code: 'indikator_zmeny_pozice', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'indikator_zmeny_pozice', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Digitální indikace stupňů výkonu', key: 'komfort_pri_obsluze', code: 'digitalni_indikace_stupnu_vykonu', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'digitalni_indikace_stupnu_vykonu', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Doběh 5/15 min', key: 'komfort_pri_obsluze', code: 'dobeh_5_15_min', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'dobeh_5_15_min', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Indikace nasycení aktivních uhlíkových filtrů', key: 'komfort_pri_obsluze', code: 'indikace_nasyceni_aktivnich_uhlikovych_filtru', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'indikace_nasyceni_aktivnich_uhlikovych_filtru', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Indikace nasycení tukových filtrů', key: 'komfort_pri_obsluze', code: 'indikace_nasyceni_tukovych_filtru', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'indikace_nasyceni_tukovych_filtru', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Snadné čištění vnitřního prostoru odsavače CleanCover', key: 'komfort_pri_obsluze', code: 'snadne_cisteni_vnitrniho_prostoru_odsavace_cleancover', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'snadne_cisteni_vnitrniho_prostoru_odsavace_cleancover', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Ovládání otočnými voliči', key: 'komfort_pri_obsluze', code: 'ovladani_otocnymi_volici', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'ovladani_otocnymi_volici', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'QuickStart', key: 'komfort_pri_obsluze', code: 'quickstart', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'quickstart', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Elektrické zapalování a ovládání jednou rukou', key: 'komfort_pri_obsluze', code: 'elektricke_zapalovani_a_ovladani_jednou_rukou', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'elektricke_zapalovani_a_ovladani_jednou_rukou', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Rozšíření varných zón', key: 'komfort_pri_obsluze', code: 'rozsireni_varnych_zon', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'rozsireni_varnych_zon', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Doběh 5 min', key: 'komfort_pri_obsluze', code: 'dobeh_5_min', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'dobeh_5_min', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Ovládání pomocí dotykového displeje', key: 'komfort_pri_obsluze', code: 'ovladani_pomoci_dotykoveho_displeje', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'ovladani_pomoci_dotykoveho_displeje', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'TempControl', key: 'komfort_pri_obsluze', code: 'tempcontrol', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'tempcontrol', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'PowerFlex Plus', key: 'komfort_pri_obsluze', code: 'powerflex_plus', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'powerflex_plus', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Asistenční programy', key: 'komfort_pri_obsluze', code: 'asistencni_programy', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'asistencni_programy', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true }
    ]
  },
{
  title: 'HOSPODÁRNOST A UDRŽITELNOST',
  rows: [
    { label: 'Příkon ve vypnutém stavu ve W', key: 'hospodarnost_a_udrzitelnost', code: 'prikon_ve_vypnutem_stavu_ve_w', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'prikon_ve_vypnutem_stavu_ve_w', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
    { label: 'Příkon v pohotovostním režimu ve W', key: 'hospodarnost_a_udrzitelnost', code: 'prikon_v_pohotovostnim_rezimu_ve_w', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'prikon_v_pohotovostnim_rezimu_ve_w', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
    { label: 'Příkon v síťovém pohotovostním režimu ve W', key: 'hospodarnost_a_udrzitelnost', code: 'prikon_v_sitovem_pohotovostnim_rezimu_ve_w', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'prikon_v_sitovem_pohotovostnim_rezimu_ve_w', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
    { label: 'Čas do automatického zapnutí z vypnutého stavu v min', key: 'hospodarnost_a_udrzitelnost', code: 'cas_do_automatickeho_zapnuti_z_vypnuteho_stavu_v_min', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'cas_do_automatickeho_zapnuti_z_vypnuteho_stavu_v_min', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
    { label: 'Čas do automatického zapnutí z pohotovostního režimu v min', key: 'hospodarnost_a_udrzitelnost', code: 'cas_do_automatickeho_zapnuti_z_pohotovostniho_rezimu_v_min', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'cas_do_automatickeho_zapnuti_z_pohotovostniho_rezimu_v_min', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
    { label: 'Čas do automatického zapnutí ze síťového pohotovostního režimu v min', key: 'hospodarnost_a_udrzitelnost', code: 'cas_do_automatickeho_zapnuti_ze_sitoveho_pohotovostniho_rezimu_v_min', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'cas_do_automatickeho_zapnuti_ze_sitoveho_pohotovostniho_rezimu_v_min', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },

    { label: 'ECO motor', key: 'hospodarnost_a_udrzitelnost', code: 'eco_motor', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'eco_motor', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
    { label: 'Motor Silence', key: 'hospodarnost_a_udrzitelnost', code: 'motor_silence', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'motor_silence', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },

    { label: 'Třída energetické účinnosti (A+++ – D)', key: 'hospodarnost_a_udrzitelnost', code: 'trida_energeticke_ucinnosti_a_d', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'trida_energeticke_ucinnosti_a_d', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
    { label: 'Roční spotřeba energie v kWh/rok', key: 'hospodarnost_a_udrzitelnost', code: 'rocni_spotreba_energie_v_kwh_rok', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'rocni_spotreba_energie_v_kwh_rok', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
    { label: 'Třída účinnosti proudění kapalin', key: 'hospodarnost_a_udrzitelnost', code: 'trida_ucinnosti_proudeni_kapalin', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'trida_ucinnosti_proudeni_kapalin', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
    { label: 'Třída účinnosti osvětlení', key: 'hospodarnost_a_udrzitelnost', code: 'trida_ucinnosti_osvetleni', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'trida_ucinnosti_osvetleni', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
    { label: 'Třída účinnosti filtrace tuků', key: 'hospodarnost_a_udrzitelnost', code: 'trida_ucinnosti_filtrace_tuku', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'trida_ucinnosti_filtrace_tuku', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },

    { label: 'Využití zbytkového tepla', key: 'hospodarnost_a_udrzitelnost', code: 'vyuziti_zbytkoveho_tepla', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'vyuziti_zbytkoveho_tepla', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },

    { label: 'Roční spotřeba elektrické energie v kWh/rok', key: 'hospodarnost_a_udrzitelnost', code: 'rocni_spotreba_elektricke_energie_v_kwh_rok', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'rocni_spotreba_elektricke_energie_v_kwh_rok', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
    { label: 'Stupeň odloučení tuků', key: 'hospodarnost_a_udrzitelnost', code: 'stupen_odlouceni_tuku', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'stupen_odlouceni_tuku', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true }
  ]
}
  ,
  {
    title: 'KOMFORT PŘI ÚDRŽBĚ',
    rows: [
      ['Snadná údržba sklokeramiky', 'snadna_udrzba_sklokeramiky', 0],
      ['Filtrační systém - Počet tukových filtrů z nerezové oceli vhodných k mytí v myčce (10vrstvých)', 'filtracni_system_pocet_tukovych_filtru_z_nerezove_oceli_vhodnych_k_myti_v_mycce_10vrstvych', 1],
      ['Cirkulace - Výkon stupně min. (m³/h) podle EN 61591', 'cirkulace_vykon_stupne_min_m3_h_podle_en_61591', 1],
      ['Cirkulace - Výkon stupně max. (m³/h) podle EN 61591', 'cirkulace_vykon_stupne_max_m3_h_podle_en_61591', 1],
      ['Cirkulace - Výkon odtahu vzduchu intenzivního stupně 1 (m³/h) podle EN 61591', 'cirkulace_vykon_odtahu_vzduchu_intenzivniho_stupne_1_m3_h_podle_en_61591', 1],
      ['Cirkulace - Hlučnost – min. stupeň (dB(A) re 1 pW) podle EN 60704-3', 'cirkulace_hlucnost_min_stupen_db_a_re_1_pw_podle_en_60704_3', 1],
      ['Cirkulace - Hlučnost – max. stupeň (dB(A) re 1 pW) podle EN 60704-3', 'cirkulace_hlucnost_max_stupen_db_a_re_1_pw_podle_en_60704_3', 1],
      ['Cirkulace - Hlučnost intenzivního stupně 1 (dB(A) re 1 pW) podle EN 60704-3', 'cirkulace_hlucnost_intenzivniho_stupne_1_db_a_re_1_pw_podle_en_60704_3', 1],
      ['Cirkulace - Akustický tlak – min. stupeň (dB(A) re 20 µPa) podle EN 60704-2-13', 'cirkulace_akusticky_tlak_min_stupen_db_a_re_20_pa_podle_en_60704_2_13', 1],
      ['Cirkulace - Akustický tlak – max. stupeň (dB(A) re 20 µPa) podle EN 60704-2-13', 'cirkulace_akusticky_tlak_max_stupen_db_a_re_20_pa_podle_en_60704_2_13', 1],
      ['Cirkulace - Akustický tlak intenzivního stupně 1 (dB(A) re 20 µPa) podle EN 60704-2-13', 'cirkulace_akusticky_tlak_intenzivniho_stupne_1_db_a_re_20_pa_podle_en_60704_2_13', 1],
      ['Odtah - Výkon stupně min. (m³/h) podle EN 61591', 'odtah_vykon_stupne_min_m3_h_podle_en_61591', 1],
      ['Odtah - Výkon stupně max. (m³/h) podle EN 61591', 'odtah_vykon_stupne_max_m3_h_podle_en_61591', 1],
      ['Odtah - Výkon intenzivního stupně (m³/h) dle EN 61591', 'odtah_vykon_intenzivniho_stupne_m3_h_dle_en_61591', 1],
      ['Odtah - Hlučnost – min. stupeň (dB(A) re 1 pW) podle EN 60704-3', 'odtah_hlucnost_min_stupen_db_a_re_1_pw_podle_en_60704_3', 1],
      ['Odtah - Hlučnost – max. stupeň (dB(A) re 1 pW) podle EN 60704-3', 'odtah_hlucnost_max_stupen_db_a_re_1_pw_podle_en_60704_3', 1],
      ['Odtah - Hlučnost intenzivního stupně (dB(A) re 1 pW) podle EN 60704-3', 'odtah_hlucnost_intenzivniho_stupne_db_a_re_1_pw_podle_en_60704_3', 1],
      ['Odtah - Akustický tlak stupně min. (dB(A) re 20 µPa) podle EN 60704-2-13', 'odtah_akusticky_tlak_stupne_min_db_a_re_20_pa_podle_en_60704_2_13', 1],
      ['Odtah - Akustický tlak – max. stupeň (dB(A) re 20 µPa) podle EN 60704-2-13', 'odtah_akusticky_tlak_max_stupen_db_a_re_20_pa_podle_en_60704_2_13', 1],
      ['Odtah - Akustický tlak intenzivního stupně (dB(A) re 20 µPa) podle EN 60704-2-13', 'odtah_akusticky_tlak_intenzivniho_stupne_db_a_re_20_pa_podle_en_60704_2_13', 1],
      ['Nosiče nádobí vhodné k mytí v myčce nádobí', 'nosice_nadodi_vhodne_k_myti_v_mycce_nadodi', 0],
      ['Odtah - Výkon stupně 1 (m³/h) dle EN 61591', 'odtah_vykon_stupne_1_m3_h_dle_en_61591', 1],
      ['Odtah - Výkon stupně 2 (m³/h) dle EN 61591', 'odtah_vykon_stupne_2_m3_h_dle_en_61591', 1],
      ['Odtah - Výkon odtahu vzduchu stupně 3 (m³/h) podle EN 61591', 'odtah_vykon_odtahu_vzduchu_stupne_3_m3_h_podle_en_61591', 1],
      ['Odtah - Výkon vzduchu intenzivního stupně 1 (m³/h) podle EN 61591', 'odtah_vykon_vzduchu_intenzivniho_stupne_1_m3_h_podle_en_61591', 1],
      ['Odtah - Hlučnost stupně 2 (dB(A) re 1 pW) podle EN 60704-3', 'odtah_hlucnost_stupne_2_db_a_re_1_pw_podle_en_60704_3', 1],
      ['Odtah - Hlučnost intenzivního stupně 1 (dB(A) re 1 pW) podle EN 60704-3', 'odtah_hlucnost_intenzivniho_stupne_1_db_a_re_1_pw_podle_en_60704_3', 1],
      ['Odtah - Akustický tlak stupně 1 (dB(A) re 20 µPa) podle EN 60704-2-13', 'odtah_akusticky_tlak_stupne_1_db_a_re_20_pa_podle_en_60704_2_13', 1],
      ['Odtah - Akustický tlak stupně 2 (dB(A) re 20 µPa) podle EN 60704-2-13', 'odtah_akusticky_tlak_stupne_2_db_a_re_20_pa_podle_en_60704_2_13', 1],
      ['Odtah - Akustický tlak stupně 3 (dB(A) re 20 µPa) podle EN 60704-2-13', 'odtah_akusticky_tlak_stupne_3_db_a_re_20_pa_podle_en_60704_2_13', 1],
      ['Odtah - Akustický tlak intenzivního stupně 1 (dB(A) re 20 µPa) podle EN 60704-2-13', 'odtah_akusticky_tlak_intenzivniho_stupne_1_db_a_re_20_pa_podle_en_60704_2_13', 1],
      ['Cirkulace - Výkon odtahu vzduchu stupně 1 (m³/h) podle EN 61591', 'cirkulace_vykon_odtahu_vzduchu_stupne_1_m3_h_podle_en_61591', 1],
      ['Cirkulace - Výkon odtahu vzduchu stupně 2 (m³/h) podle EN 61591', 'cirkulace_vykon_odtahu_vzduchu_stupne_2_m3_h_podle_en_61591', 1],
      ['Cirkulace - Výkon odtahu vzduchu stupně 3 (m³/h) podle EN 61591', 'cirkulace_vykon_odtahu_vzduchu_stupne_3_m3_h_podle_en_61591', 1],
      ['Cirkulace - Hlučnost stupně 1 (dB(A) re 1 pW) podle EN 60704-3', 'cirkulace_hlucnost_stupne_1_db_a_re_1_pw_podle_en_60704_3', 1],
      ['Cirkulace - Hlučnost stupně 2 (dB(A) re 1 pW) podle EN 60704-3', 'cirkulace_hlucnost_stupne_2_db_a_re_1_pw_podle_en_60704_3', 1],
      ['Cirkulace - Hlučnost stupně 3 (dB(A) re 1 pW) podle EN 60704-3', 'cirkulace_hlucnost_stupne_3_db_a_re_1_pw_podle_en_60704_3', 1],
      ['Cirkulace - Akustický tlak stupně 1 (dB(A) re 20 µPa) podle EN 60704-2-13', 'cirkulace_akusticky_tlak_stupne_1_db_a_re_20_pa_podle_en_60704_2_13', 1],
      ['Cirkulace - Akustický tlak stupně 2 (dB(A) re 20 µPa) podle EN 60704-2-13', 'cirkulace_akusticky_tlak_stupne_2_db_a_re_20_pa_podle_en_60704_2_13', 1],
      ['Cirkulace - Akustický tlak stupně 3 (dB(A) re 20 µPa) podle EN 60704-2-13', 'cirkulace_akusticky_tlak_stupne_3_db_a_re_20_pa_podle_en_60704_2_13', 1],
      ['Hořák s úpravou PerfectClean', 'horak_s_upravou_perfectclean', 0]
    ].map(function(row) {
      const item = { label: row[0], key: 'komfort_pri_udrzbe', code: row[1], tooltipGroup: 'komfort_pri_udrzbe', alwaysShow: true };
      if (row[2] === 1 || row[2] === 2) {
        item.valueKey = 'komfort_pri_udrzbe_hodnoty';
        item.valueCode = row[1];
      }
      if (row[2] === 1) item.valueOnly = true;
      if (row[2] === 2) item.emptyAsNo = true;
      return item;
    })
  },
  {
    title: 'BEZPEČNOST',
    rows: [
      ['Bezpečnostní vypínání', 'bezpecnostni_vypinani'],
      ['Blokovací funkce', 'blokovaci_funkce'],
      ['Zablokování zprovoznění', 'zablokovani_zprovozneni'],
      ['Integrovaný ochlazovací ventilátor', 'integrovany_ochlazovaci_ventilator'],
      ['Ochrana proti přehřátí', 'ochrana_proti_prehrati'],
      ['Ukazatel zbytkového tepla', 'ukazatel_zbytkoveho_tepla'],
      ['Přípojka pro spínač okenního kontaktu', 'pripojka_pro_spinac_okenniho_kontaktu'],
      ['GasStop a ReStart', 'gasstop_a_restart'],
      ['Indikace tepla', 'indikace_tepla'],
      ['Indikace provozu', 'indikace_provozu'],
      ['GasStop', 'gasstop'],
      ['FlameGuard (ochrana před plamenem)', 'flameguard']
    ].map(function(row) {
      return {
        label: row[0],
        key: 'bezpecnost',
        code: row[1],
        tooltipGroup: 'bezpecnost',
        alwaysShow: true
      };
    })
  },
  {
    title: 'TECHNICKÉ ÚDAJE',
    rows: [
      ['Rozměry v mm (šířka)', 'rozmery_v_mm_sirka', 1],
      ['Rozměry v mm (výška)', 'rozmery_v_mm_vyska', 1],
      ['Rozměry v mm (hloubka)', 'rozmery_v_mm_hloubka', 1],
      ['Vestavná výška se svorkovnicí v mm', 'vestavna_vyska_se_svorkovnici_v_mm', 1],
      ['Rozměry výřezu v mm (šířka) při instalaci bez rámu na pracovní desku', 'rozmery_vyrezu_v_mm_sirka_pri_instalaci_bez_ramu_na_pracovni_desku', 1],
      ['Rozměry výřezu v mm (hloubka) při instalaci bez rámu na pracovní desku', 'rozmery_vyrezu_v_mm_hloubka_pri_instalaci_bez_ramu_na_pracovni_desku', 1],
      ['Vnitřní rozměr výřezu v mm (šířka) při instalaci se zapuštěním do pracovní desky', 'vnitrni_rozmer_vyrezu_v_mm_sirka_pri_instalaci_se_zapustenim_do_pracovni_desky', 1],
      ['Vnitřní rozměr výřezu v mm (hloubka) při instalaci se zapuštěním do pracovní desky', 'vnitrni_rozmer_vyrezu_v_mm_hloubka_pri_instalaci_se_zapustenim_do_pracovni_desky', 1],
      ['Hmotnost v kg', 'hmotnost_v_kg', 1],
      ['Vnější rozměr výřezu v mm (šířka) při instalaci se zapuštěním do pracovní desky', 'vnejsi_rozmer_vyrezu_v_mm_sirka_pri_instalaci_se_zapustenim_do_pracovni_desky', 1],
      ['Vnější rozměr výřezu v mm (hloubka) při instalaci se zapuštěním do pracovní desky', 'vnejsi_rozmer_vyrezu_v_mm_hloubka_pri_instalaci_se_zapustenim_do_pracovni_desky', 1],
      ['Celkový příkon v kW', 'celkovy_prikon_v_kw', 1],
      ['Délka elektrického přívodního kabelu v m', 'delka_elektrickeho_privodniho_kabelu_v_m', 1],
      ['Napětí ve V', 'napeti_ve_v', 1],
      ['Frekvence v Hz', 'frekvence_v_hz', 1],
      ['Rozměry přístroje (š × v × h) v mm', 'rozmery_pristroje_s_x_v_x_h_v_mm', 1],
      ['Počet fází', 'pocet_fazi', 1],
      ['Umístění plynové přípojky', 'umisteni_plynove_pripojky', 1],
      ['Nulový vodič', 'nulovy_vodic', 2],
      ['Rozměry výřezu (š x h) při instalaci se zapuštěním do pracovní desky v mm', 'rozmery_vyrezu_s_x_h_pri_instalaci_se_zapustenim_do_pracovni_desky_v_mm', 1],
      ['Rozměry výřezu vnitřní v mm (šířka) při instalaci se zapuštěním do pracovní desky', 'rozmery_vyrezu_vnitrni_v_mm_sirka_pri_instalaci_se_zapustenim_do_pracovni_desky', 1],
      ['Rozměry výřezu vnitřní v mm (hloubka) při instalaci se zapuštěním do pracovní desky', 'rozmery_vyrezu_vnitrni_v_mm_hloubka_pri_instalaci_se_zapustenim_do_pracovni_desky', 1],
      ['Rozměry výřezu vnější v mm (šířka) při instalaci se zapuštěním do pracovní desky', 'rozmery_vyrezu_vnejsi_v_mm_sirka_pri_instalaci_se_zapustenim_do_pracovni_desky', 1],
      ['Rozměry výřezu vnější v mm (hloubka) při instalaci se zapuštěním do pracovní desky', 'rozmery_vyrezu_vnejsi_v_mm_hloubka_pri_instalaci_se_zapustenim_do_pracovni_desky', 1],
      ['Jištění v A', 'jisteni_v_a', 1],
      ['Rozměry výřezu (š x h) při instalaci bez rámečku na pracovní desku v mm', 'rozmery_vyrezu_s_x_h_pri_instalaci_bez_ramecku_na_pracovni_desku_v_mm', 1]
    ].map(function(row) {
      const item = { label: row[0], key: 'technicke_udaje', code: row[1], tooltipGroup: 'technicke_udaje', alwaysShow: true };
      if (row[2] === 1 || row[2] === 2) {
        item.valueKey = 'technicke_udaje_hodnota';
        item.valueCode = row[1];
      }
      if (row[2] === 1) item.valueOnly = true;
      if (row[2] === 2) item.emptyAsNo = true;
      return item;
    })
  },
  {
    title: 'MONTÁŽNÍ POKYNY',
    rows: [
      ['Soklový ventilátor s přípojkou na odtah', 'soklovy_ventilator_s_pripojkou_na_odtah', 2],
      ['Připojení odtahu dozadu a bočně', 'pripojeni_odtahu_dozadu_a_bocne', 2],
      ['Rozměry odtahového hrdla v mm (šířka)', 'rozmery_odtahoveho_hrdla_v_mm_sirka', 1],
      ['Rozměry odtahového hrdla v mm (hloubka)', 'rozmery_odtahoveho_hrdla_v_mm_hloubka', 1]
    ].map(function(row) {
      const item = { label: row[0], key: 'montazni_pokyny', code: row[1], tooltipGroup: 'montazni_pokyny', alwaysShow: true };
      if (row[2] === 1 || row[2] === 2) {
        item.valueKey = 'montazni_pokyny_hodnoty';
        item.valueCode = row[1];
      }
      if (row[2] === 1) item.valueOnly = true;
      if (row[2] === 2) item.emptyAsNo = true;
      return item;
    })
  },
  {
    title: 'DODÁVANÉ PŘÍSLUŠENSTVÍ',
    rows: [
      ['Připojovací kabel', 'pripojovaci_kabel', 0],
      ['Filtr s aktivním uhlím DKF 35-P', 'filtr_s_aktivnim_uhlim_dkf_35_p', 0],
      ['Adaptér Plug&Play', 'adapter_plug_and_play', 0],
      ['Držák na wok', 'drzak_na_wok', 0],
      ['Držák na malé nádobí', 'drzak_na_male_nadobi', 0],
      ['CSFG7000 FlameGuard', 'csfg7000_flameguard', 0],
      ['Sada trysek na zemní plyn', 'sada_trysek_na_zemni_plyn', 0],
      ['Sada trysek na propan-butan', 'sada_trysek_na_propan_butan', 0],
      ['Škrabka na sklokeramiku', 'skrabka_na_sklokeramiku', 0],
      ['Systém odtahového potrubí až k soklovému ventilátoru', 'system_odtahoveho_potrubi_az_k_soklovemu_ventilator', 0],
      ['Voucher na grilovací desku GGRP Gourmet', 'voucher_na_grilovaci_desku_ggrp_gourmet', 0],
      ['WiFi adaptér XKS 3170 W', 'wifi_adapter_xks_3170_w', 0]
    ].map(function(row) {
      const item = { label: row[0], key: 'dodavane_prislusenstvi', code: row[1], tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true };
      return item;
    })
  }
];
COMPARE_SCHEMAS.odsavace = [
  {
    title: 'VŠEOBECNÉ ÚDAJE',
    rows: [
      { label: 'Číslo EAN', key: 'cislo_ean', alwaysShow: true },
      { label: 'Marketingová třída', key: 'vseobecne_udaje', code: 'marketingova_trida', valueKey: 'vseobecne_udaje_hodnoty', valueCode: 'marketingova_trida', valueOnly: true, tooltipGroup: 'vseobecne_udaje', alwaysShow: true }
    ]
  },
  {
    title: 'PROVEDENÍ',
    rows: [
      { label: 'Provedení', key: 'provedeni', tooltipGroup: 'provedeni' }
    ]
  },
  {
    title: 'DESIGN',
    rows: [
      { label: 'Barva přístroje', key: 'design', code: 'barva_pristroje', valueKey: 'design_hodnoty', valueCode: 'barva_pristroje', valueOnly: true, tooltipGroup: 'design', alwaysShow: true },
      { label: 'Okrajové odsávání', key: 'design', code: 'okrajove_odsavani', valueKey: 'design_hodnoty', valueCode: 'okrajove_odsavani', emptyAsNo: true, tooltipGroup: 'design', alwaysShow: true },
      { label: 'Možné v barvě RAL (při objednávce uveďte kód barvy)', key: 'design', code: 'mozne_v_barve_ral', valueKey: 'design_hodnoty', valueCode: 'mozne_v_barve_ral', emptyAsNo: true, tooltipGroup: 'design', alwaysShow: true }
    ]
  },
  {
    title: 'PROVOZNÍ ZPŮSOBY',
    rows: [
      { label: 'Způsob vedení vzduchu', key: 'provozni_zpusoby', code: 'zpusob_vedeni_vzduchu', valueKey: 'provozni_zpusoby_hodnoty', valueCode: 'zpusob_vedeni_vzduchu', valueOnly: true, tooltipGroup: 'provozni_zpusoby', alwaysShow: true },
      { label: 'Potřebná sada pro přestavbu na cirkulaci k dokoupení', key: 'provozni_zpusoby', code: 'potrebna_sada_pro_prestavbu_na_cirkulaci_k_dokoupeni', valueKey: 'provozni_zpusoby_hodnoty', valueCode: 'potrebna_sada_pro_prestavbu_na_cirkulaci_k_dokoupeni', valueOnly: true, tooltipGroup: 'provozni_zpusoby', alwaysShow: true },
      { label: 'Potřebný uhlíkový filtr k dokoupení', key: 'provozni_zpusoby', code: 'potrebny_uhlikovy_filtr_k_dokoupeni', valueKey: 'provozni_zpusoby_hodnoty', valueCode: 'potrebny_uhlikovy_filtr_k_dokoupeni', valueOnly: true, tooltipGroup: 'provozni_zpusoby', alwaysShow: true }
    ]
  },
  {
  title: 'ODTAH',
  rows: [
    { label: 'Výkon stupně 1 (m³/h) dle EN 61591', key: 'odtah_hodnoty', code: 'vykon_stupen_1_m3_h_dle_en_61591', tooltipGroup: 'odtah', alwaysShow: true },
    { label: 'Výkon stupně 2 (m³/h) dle EN 61591', key: 'odtah_hodnoty', code: 'vykon_stupne_2_m3_h_dle_en_61591', tooltipGroup: 'odtah', alwaysShow: true },
    { label: 'Výkon odtahu vzduchu stupně 3 (m³/h) podle EN 61591', key: 'odtah_hodnoty', code: 'vykon_odtahu_vzduchu_stupne_3_m3_h_podle_en_61591', tooltipGroup: 'odtah', alwaysShow: true },
    { label: 'Výkon vzduchu intenzivního stupně 1 (m³/h) podle EN 61591', key: 'odtah_hodnoty', code: 'vykon_vzduchu_intenzivniho_stupne_1_m3_h_podle_en_61591', tooltipGroup: 'odtah', alwaysShow: true },
    { label: 'Výkon vzduchu intenzivního stupně 2 (m³/h) podle EN 61591', key: 'odtah_hodnoty', code: 'vykon_vzduchu_intenzivniho_stupne_2_m3_h_podle_en_61591', tooltipGroup: 'odtah', alwaysShow: true },
    { label: 'Hlučnost stupně 1 (dB(A) re 1 pW) podle EN 60704-3', key: 'odtah_hodnoty', code: 'hlucnost_stupne_1_dba_re_1_pw_podle_en_60704_3', tooltipGroup: 'odtah', alwaysShow: true },
    { label: 'Hlučnost stupně 2 (dB(A) re 1 pW) podle EN 60704-3', key: 'odtah_hodnoty', code: 'hlucnost_stupne_2_dba_re_1_pw_podle_en_60704_3', tooltipGroup: 'odtah', alwaysShow: true },
    { label: 'Hlučnost stupně 3 (dB(A) re 1 pW) podle EN 60704-3', key: 'odtah_hodnoty', code: 'hlucnost_stupne_3_dba_re_1_pw_podle_en_60704_3', tooltipGroup: 'odtah', alwaysShow: true },
    { label: 'Hlučnost intenzivního stupně 1 (dB(A) re 1 pW) podle EN 60704-3', key: 'odtah_hodnoty', code: 'hlucnost_intenzivniho_stupne_1_dba_re_1_pw_podle_en_60704_3', tooltipGroup: 'odtah', alwaysShow: true },
    { label: 'Hlučnost intenzivního stupně 2 (dB(A) re 1 pW) podle EN 60704-3', key: 'odtah_hodnoty', code: 'hlucnost_intenzivniho_stupne_2_dba_re_1_pw_podle_en_60704_3', tooltipGroup: 'odtah', alwaysShow: true },
    { label: 'Akustický tlak stupně 1 (dB(A) re 20 µPa) podle EN 60704-2-13', key: 'odtah_hodnoty', code: 'akusticky_tlak_stupne_1_dba_re_20_upa_podle_en_60704_2_13', tooltipGroup: 'odtah', alwaysShow: true },
    { label: 'Akustický tlak stupně 2 (dB(A) re 20 µPa) podle EN 60704-2-13', key: 'odtah_hodnoty', code: 'akusticky_tlak_stupne_2_dba_re_20_upa_podle_en_60704_2_13', tooltipGroup: 'odtah', alwaysShow: true },
    { label: 'Akustický tlak stupně 3 (dB(A) re 20 µPa) podle EN 60704-2-13', key: 'odtah_hodnoty', code: 'akusticky_tlak_stupne_3_dba_re_20_upa_podle_en_60704_2_13', tooltipGroup: 'odtah', alwaysShow: true },
    { label: 'Akustický tlak intenzivního stupně 1 (dB(A) re 20 µPa) podle EN 60704-2-13', key: 'odtah_hodnoty', code: 'akusticky_tlak_intenzivniho_stupne_1_dba_re_20_upa_podle_en_60704_2_13', tooltipGroup: 'odtah', alwaysShow: true },
    { label: 'Akustický tlak intenzivního stupně 2 (dB(A) re 20 µPa) podle EN 60704-2-13', key: 'odtah_hodnoty', code: 'akusticky_tlak_intenzivniho_stupne_2_dba_re_20_upa_podle_en_60704_2_13', tooltipGroup: 'odtah', alwaysShow: true }
  ]
},
  {
    title: 'CIRKULACE',
    rows: [
      { label: 'Výkon odtahu vzduchu stupně 1 (m³/h) podle EN 61591', key: 'cirkulace_hodnoty', code: 'vykon_odtahu_vzduchu_stupne_1_m3_h_podle_en_61591', tooltipGroup: 'cirkulace', alwaysShow: true },
      { label: 'Výkon odtahu vzduchu stupně 2 (m³/h) podle EN 61591', key: 'cirkulace_hodnoty', code: 'vykon_odtahu_vzduchu_stupne_2_m3_h_podle_en_61591', tooltipGroup: 'cirkulace', alwaysShow: true },
      { label: 'Výkon odtahu vzduchu stupně 3 (m³/h) podle EN 61591', key: 'cirkulace_hodnoty', code: 'vykon_odtahu_vzduchu_stupne_3_m3_h_podle_en_61591', tooltipGroup: 'cirkulace', alwaysShow: true },
      { label: 'Výkon odtahu vzduchu intenzivního stupně 1 (m³/h) podle EN 61591', key: 'cirkulace_hodnoty', code: 'vykon_odtahu_vzduchu_intenzivniho_stupne_1_m3_h_podle_en_61591', tooltipGroup: 'cirkulace', alwaysShow: true },
      { label: 'Výkon odtahu vzduchu intenzivního stupně 2 (m³/h) podle EN 61591', key: 'cirkulace_hodnoty', code: 'vykon_odtahu_vzduchu_intenzivniho_stupne_2_m3_h_podle_en_61591', tooltipGroup: 'cirkulace', alwaysShow: true },
      { label: 'Hlučnost stupně 1 (dB(A) re 1 pW) podle EN 60704-3', key: 'cirkulace_hodnoty', code: 'hlucnost_stupne_1_dba_re_1_pw_podle_en_60704_3', tooltipGroup: 'cirkulace', alwaysShow: true },
      { label: 'Hlučnost stupně 2 (dB(A) re 1 pW) podle EN 60704-3', key: 'cirkulace_hodnoty', code: 'hlucnost_stupne_2_dba_re_1_pw_podle_en_60704_3', tooltipGroup: 'cirkulace', alwaysShow: true },
      { label: 'Hlučnost stupně 3 (dB(A) re 1 pW) podle EN 60704-3', key: 'cirkulace_hodnoty', code: 'hlucnost_stupne_3_dba_re_1_pw_podle_en_60704_3', tooltipGroup: 'cirkulace', alwaysShow: true },
      { label: 'Hlučnost intenzivního stupně 1 (dB(A) re 1 pW) podle EN 60704-3', key: 'cirkulace_hodnoty', code: 'hlucnost_intenzivniho_stupne_1_dba_re_1_pw_podle_en_60704_3', tooltipGroup: 'cirkulace', alwaysShow: true },
      { label: 'Hlučnost intenzivního stupně 2 (dB(A) re 1 pW) podle EN 60704-3', key: 'cirkulace_hodnoty', code: 'hlucnost_intenzivniho_stupne_2_dba_re_1_pw_podle_en_60704_3', tooltipGroup: 'cirkulace', alwaysShow: true },
      { label: 'Akustický tlak stupně 1 (dB(A) re 20 µPa) podle EN 60704-2-13', key: 'cirkulace_hodnoty', code: 'akusticky_tlak_stupne_1_dba_re_20_upa_podle_en_60704_2_13', tooltipGroup: 'cirkulace', alwaysShow: true },
      { label: 'Akustický tlak stupně 2 (dB(A) re 20 µPa) podle EN 60704-2-13', key: 'cirkulace_hodnoty', code: 'akusticky_tlak_stupne_2_dba_re_20_upa_podle_en_60704_2_13', tooltipGroup: 'cirkulace', alwaysShow: true },
      { label: 'Akustický tlak stupně 3 (dB(A) re 20 µPa) podle EN 60704-2-13', key: 'cirkulace_hodnoty', code: 'akusticky_tlak_stupne_3_dba_re_20_upa_podle_en_60704_2_13', tooltipGroup: 'cirkulace', alwaysShow: true },
      { label: 'Akustický tlak intenzivního stupně 1 (dB(A) re 20 µPa) podle EN 60704-2-13', key: 'cirkulace_hodnoty', code: 'akusticky_tlak_intenzivniho_stupne_1_dba_re_20_upa_podle_en_60704_2_13', tooltipGroup: 'cirkulace', alwaysShow: true },
      { label: 'Akustický tlak intenzivního stupně 2 (dB(A) re 20 µPa) podle EN 60704-2-13', key: 'cirkulace_hodnoty', code: 'akusticky_tlak_intenzivniho_stupne_2_dba_re_20_upa_podle_en_60704_2_13', tooltipGroup: 'cirkulace', alwaysShow: true }
    ]
  },
  {
    title: 'KOMFORT PŘI OBSLUZE',
    rows: [
      { label: 'Propojení s Miele@home', key: 'komfort_pri_obsluze', code: 'propojeni_s_miele_home', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'propojeni_s_miele_home', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Elektronické ovládání', key: 'komfort_pri_obsluze', code: 'elektronicke_ovladani', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'elektronicke_ovladani', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Con@ctivity', key: 'komfort_pri_obsluze', code: 'con_at_ctivity', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'con_at_ctivity', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'SmartControl', key: 'komfort_pri_obsluze', code: 'smartcontrol', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'smartcontrol', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Stupně výkonu', key: 'komfort_pri_obsluze', code: 'stupne_vykonu', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'stupne_vykonu', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Doběh 5/15 min', key: 'komfort_pri_obsluze', code: 'dobeh_5_15_min', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'dobeh_5_15_min', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Intenzivní stupně', key: 'komfort_pri_obsluze', code: 'intenzivni_stupne', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'intenzivni_stupne', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Indikace nasycení tukového filtru', key: 'komfort_pri_obsluze', code: 'indikace_nasyceni_tukoveho_filtru', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'indikace_nasyceni_tukoveho_filtru', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Indikace nasycení aktivního uhlíkového filtru', key: 'komfort_pri_obsluze', code: 'indikace_nasyceni_aktivniho_uhlikoveho_filtru', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'indikace_nasyceni_aktivniho_uhlikoveho_filtru', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Snadné čištění vnitřního prostoru odsavače CleanCover', key: 'komfort_pri_obsluze', code: 'snadne_cisteni_vnitrniho_prostoru_odsavace_cleancover', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'snadne_cisteni_vnitrniho_prostoru_odsavace_cleancover', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'EasySwitch', key: 'komfort_pri_obsluze', code: 'easyswitch', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'easyswitch', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Obsluha', key: 'komfort_pri_obsluze', code: 'obsluha', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'obsluha', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Hood in motion', key: 'komfort_pri_obsluze', code: 'hood_in_motion', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'hood_in_motion', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Aplikace Miele@mobile', key: 'komfort_pri_obsluze', code: 'aplikace_miele_mobile', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'aplikace_miele_mobile', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Spínač pro zapnutí/vypnutí', key: 'komfort_pri_obsluze', code: 'spinac_pro_zapnuti_vypnuti', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'spinac_pro_zapnuti_vypnuti', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'ComfortControl', key: 'komfort_pri_obsluze', code: 'comfortcontrol', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'comfortcontrol', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Automatická funkce', key: 'komfort_pri_obsluze', code: 'automaticka_funkce', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'automaticka_funkce', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Akustický balíček Silence', key: 'komfort_pri_obsluze', code: 'akusticky_balicek_silence', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'akusticky_balicek_silence', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'SmartControl White', key: 'komfort_pri_obsluze', code: 'smartcontrol_white', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'smartcontrol_white', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Dotyková tlačítka', key: 'komfort_pri_obsluze', code: 'dotykova_tlacitka', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'dotykova_tlacitka', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze' },
      { label: 'Mechanické ovládání', key: 'komfort_pri_obsluze', code: 'mechanicke_ovladani', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'mechanicke_ovladani', valueOnly: true, tooltipGroup: 'komfort_pri_obsluze' }
    ]
  },
{
  title: 'HOSPODÁRNOST A UDRŽITELNOST',
  rows: [
    { label: 'Třída energetické účinnosti (A+++ – D)', key: 'hospodarnost_a_udrzitelnost', code: 'trida_energeticke_ucinnosti_a_d', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'trida_energeticke_ucinnosti_a_d', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
    { label: 'ECO motor (stejnosměrný motor)', key: 'hospodarnost_a_udrzitelnost', code: 'eco_motor_stejnosmerny_motor', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'eco_motor_stejnosmerny_motor', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost' },
    { label: 'Systém řízení výkonu', key: 'hospodarnost_a_udrzitelnost', code: 'system_rizeni_vykonu', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'system_rizeni_vykonu', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost' },
    { label: 'Roční spotřeba energie v kWh/rok', key: 'hospodarnost_a_udrzitelnost', code: 'rocni_spotreba_energie_v_kwh_rok', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'rocni_spotreba_energie_v_kwh_rok', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
    { label: 'Třída účinnosti proudění kapalin', key: 'hospodarnost_a_udrzitelnost', code: 'trida_ucinnosti_proudeni_kapalin', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'trida_ucinnosti_proudeni_kapalin', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
    { label: 'Třída účinnosti osvětlení', key: 'hospodarnost_a_udrzitelnost', code: 'trida_ucinnosti_osvetleni', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'trida_ucinnosti_osvetleni', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
    { label: 'Třída účinnosti filtrace tuků', key: 'hospodarnost_a_udrzitelnost', code: 'trida_ucinnosti_filtrace_tuku', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'trida_ucinnosti_filtrace_tuku', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
    { label: 'Stupeň odloučení tuků', key: 'hospodarnost_a_udrzitelnost', code: 'stupen_odlouceni_tuku', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'stupen_odlouceni_tuku', valueOnly: true, tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true }
  ]
},
  {
    title: 'FILTRAČNÍ SYSTÉM',
    rows: [
      { label: 'Počet tukových filtrů z nerezové oceli vhodných k mytí v myčce', key: 'filtracni_system', code: 'pocet_tukovych_filtru_z_nerezove_oceli_vhodnych_k_myti_v_mycce', valueKey: 'filtracni_system_hodnota', valueCode: 'pocet_tukovych_filtru_z_nerezove_oceli_vhodnych_k_myti_v_mycce', valueOnly: true, tooltipGroup: 'filtracni_system', alwaysShow: true }
    ]
  },
  {
    title: 'OSVĚTLENÍ',
    rows: [
      { label: 'Počet x W', key: 'osvetleni', code: 'pocet_x_w', valueKey: 'osvetleni_hodnota', valueCode: 'pocet_x_w', valueOnly: true, tooltipGroup: 'osvetleni', alwaysShow: true },
      { label: 'Intenzita osvětlení v lx', key: 'osvetleni', code: 'intenzita_osvetleni_v_lx', valueKey: 'osvetleni_hodnota', valueCode: 'intenzita_osvetleni_v_lx', valueOnly: true, tooltipGroup: 'osvetleni', alwaysShow: true },
      { label: 'Barevná teplota světla v K', key: 'osvetleni', code: 'barevna_teplota_svetla_v_k', valueKey: 'osvetleni_hodnota', valueCode: 'barevna_teplota_svetla_v_k', valueOnly: true, tooltipGroup: 'osvetleni', alwaysShow: true },
      { label: 'Ambientní osvětlení', key: 'osvetleni', code: 'ambientni_osvetleni', valueKey: 'osvetleni_hodnota', valueCode: 'ambientni_osvetleni', emptyAsNo: true, tooltipGroup: 'osvetleni' }
    ]
  },
  {
    title: 'VENTILÁTOR',
    rows: [
      { label: 'Oboustranně odsávací ventilátor', key: 'ventilator', code: 'oboustranne_odsavaci_ventilator', valueKey: 'ventilator_hodnota', valueCode: 'oboustranne_odsavaci_ventilator', valueOnly: true, tooltipGroup: 'ventilator', alwaysShow: true },
      { label: 'Počet ventilátorů', key: 'ventilator', code: 'pocet_ventilatoru', valueKey: 'ventilator_hodnota', valueCode: 'pocet_ventilatoru', valueOnly: true, tooltipGroup: 'ventilator', alwaysShow: true },
      { label: 'Jednostranně odsávací ventilátor', key: 'ventilator', code: 'jednostranne_odsavaci_ventilator', valueKey: 'ventilator_hodnota', valueCode: 'jednostranne_odsavaci_ventilator', valueOnly: true, tooltipGroup: 'ventilator', alwaysShow: true }
    ]
  },
  {
    title: 'BEZPEČNOST',
    rows: [
      { label: 'Bezpečnostní vypínání', key: 'bezpecnost', code: 'bezpecnostni_vypinani', tooltipGroup: 'bezpecnost' },
      { label: 'Jednovrstvé bezpečnostní sklo (ESG)', key: 'bezpecnost', code: 'jednovrstve_bezpecnostni_sklo_esg', tooltipGroup: 'bezpecnost' }
    ]
  },
  {
    title: 'TECHNICKÉ ÚDAJE',
    rows: [
      { label: 'Šířka těla odsavače v mm', key: 'technicke_udaje', code: 'sirka_tela_odsavace_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'sirka_tela_odsavace_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Výška těla odsavače v mm', key: 'technicke_udaje', code: 'vyska_tela_odsavace_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'vyska_tela_odsavace_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Hloubka těla odsavače v mm', key: 'technicke_udaje', code: 'hloubka_tela_odsavace_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'hloubka_tela_odsavace_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Hmotnost netto v kg', key: 'technicke_udaje', code: 'hmotnost_netto_v_kg', valueKey: 'technicke_udaje_hodnota', valueCode: 'hmotnost_netto_v_kg', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Délka elektrického přívodního kabelu v m', key: 'technicke_udaje', code: 'delka_elektrickeho_privodniho_kabelu_v_m', valueKey: 'technicke_udaje_hodnota', valueCode: 'delka_elektrickeho_privodniho_kabelu_v_m', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Ochranná zástrčka', key: 'technicke_udaje', code: 'ochranna_zastrcka', valueKey: 'technicke_udaje_hodnota', valueCode: 'ochranna_zastrcka', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Pevné připojení', key: 'technicke_udaje', code: 'pevne_pripojeni', valueKey: 'technicke_udaje_hodnota', valueCode: 'pevne_pripojeni', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Min. výška nad elektrickou varnou deskou v mm', key: 'technicke_udaje', code: 'min_vyska_nad_elektrickou_varnou_deskou_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'min_vyska_nad_elektrickou_varnou_deskou_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Min. bezpečná vzdálenost nad plynovými varnými deskami (celkový výkon max. 12,6 kW, hořák ≤ 4,5 kW) v mm', key: 'technicke_udaje', code: 'min_bezpecna_vzdalenost_nad_plynovymi_varnymi_deskami_celkovy_vykon_max_12_6_kw_horak_4_5_kw_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'min_bezpecna_vzdalenost_nad_plynovymi_varnymi_deskami_celkovy_vykon_max_12_6_kw_horak_4_5_kw_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Počet fází', key: 'technicke_udaje', code: 'pocet_fazi', valueKey: 'technicke_udaje_hodnota', valueCode: 'pocet_fazi', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Celkový příkon v kW', key: 'technicke_udaje', code: 'celkovy_prikon_v_kw', valueKey: 'technicke_udaje_hodnota', valueCode: 'celkovy_prikon_v_kw', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Napětí ve V', key: 'technicke_udaje', code: 'napeti_ve_v', valueKey: 'technicke_udaje_hodnota', valueCode: 'napeti_ve_v', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Jištění v A', key: 'technicke_udaje', code: 'jisteni_v_a', valueKey: 'technicke_udaje_hodnota', valueCode: 'jisteni_v_a', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Frekvence v Hz', key: 'technicke_udaje', code: 'frekvence_v_hz', valueKey: 'technicke_udaje_hodnota', valueCode: 'frekvence_v_hz', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Celková výška odsavače při odtahu a externím provedení v mm, minimum', key: 'technicke_udaje', code: 'celkova_vyska_odsavace_pri_odtahu_a_externim_provedeni_v_mm_minimum', valueKey: 'technicke_udaje_hodnota', valueCode: 'celkova_vyska_odsavace_pri_odtahu_a_externim_provedeni_v_mm_minimum', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Celková výška odsavače při odtahu a externím provedení v mm, maximum', key: 'technicke_udaje', code: 'celkova_vyska_odsavace_pri_odtahu_a_externim_provedeni_v_mm_maximum', valueKey: 'technicke_udaje_hodnota', valueCode: 'celkova_vyska_odsavace_pri_odtahu_a_externim_provedeni_v_mm_maximum', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Celková výška odsavače při cirkulaci v mm, minimum', key: 'technicke_udaje', code: 'celkova_vyska_odsavace_pri_cirkulaci_v_mm_minimum', valueKey: 'technicke_udaje_hodnota', valueCode: 'celkova_vyska_odsavace_pri_cirkulaci_v_mm_minimum', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Celková výška odsavače při cirkulaci v mm, maximum', key: 'technicke_udaje', code: 'celkova_vyska_odsavace_pri_cirkulaci_v_mm_maximum', valueKey: 'technicke_udaje_hodnota', valueCode: 'celkova_vyska_odsavace_pri_cirkulaci_v_mm_maximum', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Celková výška odsavače v odtahu a v externím provedení v mm', key: 'technicke_udaje', code: 'celkova_vyska_odsavace_v_odtahu_a_v_externim_provedeni_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'celkova_vyska_odsavace_v_odtahu_a_v_externim_provedeni_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Celková výška odsavače par v cirkulačním provozu v mm', key: 'technicke_udaje', code: 'celkova_vyska_odsavace_par_v_cirkulacnim_provozu_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'celkova_vyska_odsavace_par_v_cirkulacnim_provozu_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true }
    ]
  },
 {
  title: 'MONTÁŽNÍ POKYNY',
  rows: [
    { label: 'Připojení odtahu nahoru', key: 'montazni_pokyny', code: 'pripojeni_odtahu_nahoru', valueKey: 'montazni_pokyny_hodnota', valueCode: 'pripojeni_odtahu_nahoru', emptyAsNo: true, tooltipGroup: 'montazni_pokyny', alwaysShow: true },
    { label: 'Připojení odtahu nahoru a dozadu', key: 'montazni_pokyny', code: 'pripojeni_odtahu_nahoru_a_dozadu', valueKey: 'montazni_pokyny_hodnota', valueCode: 'pripojeni_odtahu_nahoru_a_dozadu', emptyAsNo: true, tooltipGroup: 'montazni_pokyny', alwaysShow: true },
    { label: 'Průměr odtahového hrdla v mm', key: 'montazni_pokyny', code: 'prumer_odtahoveho_hrdla_v_mm', valueKey: 'montazni_pokyny_hodnota', valueCode: 'prumer_odtahoveho_hrdla_v_mm', valueOnly: true, tooltipGroup: 'montazni_pokyny', alwaysShow: true },
    { label: 'Montážní šablona', key: 'montazni_pokyny', code: 'montazni_sablona', valueKey: 'montazni_pokyny_hodnota', valueCode: 'montazni_sablona', emptyAsNo: true, tooltipGroup: 'montazni_pokyny', alwaysShow: true },
    { label: 'Přípojka odtahu dole', key: 'montazni_pokyny', code: 'pripojka_odtahu_dole', valueKey: 'montazni_pokyny_hodnota', valueCode: 'pripojka_odtahu_dole', emptyAsNo: true, tooltipGroup: 'montazni_pokyny', alwaysShow: true },
    { label: 'Připojení odtahu bočně', key: 'montazni_pokyny', code: 'pripojeni_odtahu_bocne', valueKey: 'montazni_pokyny_hodnota', valueCode: 'pripojeni_odtahu_bocne', emptyAsNo: true, tooltipGroup: 'montazni_pokyny', alwaysShow: true },
    { label: 'Teleskopický komín', key: 'montazni_pokyny', code: 'teleskopicky_komin', valueKey: 'montazni_pokyny_hodnota', valueCode: 'teleskopicky_komin', emptyAsNo: true, tooltipGroup: 'montazni_pokyny', alwaysShow: true }
  ]
},
{
  title: 'DODÁVANÉ PŘÍSLUŠENSTVÍ',
  rows: [
    { label: 'Zpětná klapka', key: 'dodavane_prislusenstvi', code: 'zpetna_klapka', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
    { label: 'Redukční hrdlo z Ø 150 na 125 mm', key: 'dodavane_prislusenstvi', code: 'redukcni_hrdlo_z_150_na_125_mm', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
    { label: 'Dálkový ovladač', key: 'dodavane_prislusenstvi', code: 'dalkovy_ovladac', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true },
    { label: 'Rozdělovač vzduchu pro cirkulaci', key: 'dodavane_prislusenstvi', code: 'rozdelovac_vzduchu_pro_cirkulaci', tooltipGroup: 'dodavane_prislusenstvi', alwaysShow: true }
  ]
}
];
COMPARE_SCHEMAS.pracky_se_susickou = [
  COMPARE_SCHEMAS.pracky[0],
  {
    title: 'KONSTRUKCE',
    rows: [
      { label: 'Označení přístroje', key: 'oznaceni_pristroje' },
      { label: 'Pračka s předním plněním', key: 'konstrukce', code: 'pracka_s_prednim_plnenim' },
      { label: 'Pračka s funkcí sušičky', key: 'konstrukce', code: 'pracka_s_funkci_susicky' },
      { label: 'Praní a následné sušení', key: 'konstrukce', code: 'prani_a_nasledne_suseni' },
      { label: 'Elektronické měření zbytkové vlhkosti při sušení', key: 'konstrukce', code: 'elektronicke_mereni_zbytkove_vlhkosti_pri_suseni' },
      { label: 'Kondenzační sušička s ochlazováním vodou', key: 'konstrukce', code: 'kondenzacni_susicka_s_ochlazovanim_vodou' },
      { label: 'Termo-odstřeďování', key: 'konstrukce', code: 'termo_odstredovani' }
    ]
  },
  {
    title: 'KAPACITA',
    rows: [
      { label: 'Hmotnost náplně v kg', key: 'setrna_pece_o_pradlo', code: 'hmotnost_naplne_v_kg', valueKey: 'setrna_pece_o_pradlo_hodnota', valueCode: 'hmotnost_naplne_v_kg', valueOnly: true, tooltipGroup: 'setrna_pece_o_pradlo', alwaysShow: true },
      { label: 'Hmotnost náplně při praní v kg', key: 'hmotnost_naplne_pri_prani_v_kg' },
      { label: 'Hmotnost náplně při sušení v kg', key: 'hmotnost_naplne_pri_suseni_v_kg' }
    ]
  },
  {
    title: 'ODSTŘEĎOVÁNÍ',
    rows: [
      { label: 'Maximální počet otáček', key: 'maximalni_pocet_otacek' },
      { label: 'Konec máchání', key: 'odstredovani', code: 'konec_machani' },
      { label: 'Funkce bez odstřeďování', key: 'odstredovani', code: 'funkce_bez_odstredovani' }
    ]
  },
  COMPARE_SCHEMAS.pracky[3],
  COMPARE_SCHEMAS.pracky[4],
  {
    title: 'ŠETRNÁ PÉČE O PRÁDLO',
    rows: [
      { label: 'Voštinový buben', key: 'setrna_pece_o_pradlo', code: 'vostinovy_buben' },
      { label: 'Hmotnost náplně při praní v kg', key: 'hmotnost_naplne_pri_prani_v_kg' },
      { label: 'Hmotnost náplně při sušení v kg', key: 'hmotnost_naplne_pri_suseni_v_kg' }
    ]
  },
    {
    title: 'KOMFORT PŘI OBSLUZE',
    rows: [
      { label: 'Technologie PerfectCare', key: 'komfort_pri_obsluze', code: 'technologie_perfectcare', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'technologie_perfectcare', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Propojení s Miele@home', key: 'komfort_pri_obsluze', code: 'propojeni_s_miele_home', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'propojeni_s_miele_home', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Předvolba startu až 24 hodin', key: 'komfort_pri_obsluze', code: 'predvolba_startu_az_24_hodin', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'predvolba_startu_az_24_hodin', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Indikace zbývajícího času', key: 'komfort_pri_obsluze', code: 'indikace_zbyvajiciho_casu', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'indikace_zbyvajiciho_casu', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Indikace průběhu programu', key: 'komfort_pri_obsluze', code: 'indikace_prubehu_programu', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'indikace_prubehu_programu', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Zobrazení denního času', key: 'komfort_pri_obsluze', code: 'zobrazeni_denniho_casu', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'zobrazeni_denniho_casu', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Informační texty', key: 'komfort_pri_obsluze', code: 'informacni_texty', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'informacni_texty', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Oblíbené programy', key: 'komfort_pri_obsluze', code: 'oblibene_programy', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'oblibene_programy', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Automatické vyplachování filtru na zachycení vláken', key: 'komfort_pri_obsluze', code: 'automaticke_vyplachovani_filtru_na_zachyceni_vlaken', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'automaticke_vyplachovani_filtru_na_zachyceni_vlaken', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'MultiLingua', key: 'komfort_pri_obsluze', code: 'multilingua', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'multilingua', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Zásobník na prací prostředky AutoClean', key: 'komfort_pri_obsluze', code: 'zasobnik_na_praci_prostredky_autoclean', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'zasobnik_na_praci_prostredky_autoclean', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Indikace stupně naplnění a doporučení dávkování', key: 'komfort_pri_obsluze', code: 'indikace_stupne_naplneni_a_doporuceni_davkovani', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'indikace_stupne_naplneni_a_doporuceni_davkovani', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'AddLoad', key: 'komfort_pri_obsluze', code: 'addload', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'addload', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true },
      { label: 'Osvětlení bubnu LED', key: 'komfort_pri_obsluze', code: 'osvetleni_bubnu_led', valueKey: 'komfort_pri_obsluze_hodnoty', valueCode: 'osvetleni_bubnu_led', tooltipGroup: 'komfort_pri_obsluze', alwaysShow: true }
    ]
  },
  {
    title: 'HOSPODÁRNOST A UDRŽITELNOST',
    rows: [
      { label: 'Třída energetické účinnosti (A–G)', key: 'hospodarnost_a_udrzitelnost', code: 'trida_energeticke_ucinnosti_a_g', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'trida_energeticke_ucinnosti_a_g', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Třída energetické účinnosti praní a sušení (A–G)', key: 'hospodarnost_a_udrzitelnost', code: 'trida_energeticke_ucinnosti_prani_a_suseni_a_g', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'trida_energeticke_ucinnosti_prani_a_suseni_a_g', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Vážená spotřeba elektrické energie na 100 provozních cyklů pro kompletní provozní cyklus v kWh', key: 'hospodarnost_a_udrzitelnost', code: 'vazena_spotreba_elektricke_energie_na_100_provoznich_cyklu_pro_kompletni_provozni_cyklus_v_kwh', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'vazena_spotreba_elektricke_energie_na_100_provoznich_cyklu_pro_kompletni_provozni_cyklus_v_kwh', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Vážená spotřeba elektrické energie na 100 provozních cyklů pro cyklus praní v kWh', key: 'hospodarnost_a_udrzitelnost', code: 'vazena_spotreba_elektricke_energie_na_100_provoznich_cyklu_pro_cyklus_prani_v_kwh', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'vazena_spotreba_elektricke_energie_na_100_provoznich_cyklu_pro_cyklus_prani_v_kwh', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Vážená spotřeba vody na provozní cyklus pro cyklus praní v l', key: 'hospodarnost_a_udrzitelnost', code: 'vazena_spotreba_vody_na_provozni_cyklus_pro_cyklus_prani_v_l', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'vazena_spotreba_vody_na_provozni_cyklus_pro_cyklus_prani_v_l', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Vážená spotřeba vody na provozní cyklus pro kompletní provozní cyklus v l', key: 'hospodarnost_a_udrzitelnost', code: 'vazena_spotreba_vody_na_provozni_cyklus_pro_kompletni_provozni_cyklus_v_l', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'vazena_spotreba_vody_na_provozni_cyklus_pro_kompletni_provozni_cyklus_v_l', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Třída energetické účinnosti odstřeďování (A–G)', key: 'hospodarnost_a_udrzitelnost', code: 'trida_energeticke_ucinnosti_odstredovani_a_g', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'trida_energeticke_ucinnosti_odstredovani_a_g', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Třída úrovně emisí hluku (při odstřeďování; A–D)', key: 'hospodarnost_a_udrzitelnost', code: 'trida_urovne_emisi_hluku_pri_odstredovani_a_d', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'trida_urovne_emisi_hluku_pri_odstredovani_a_d', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Úroveň emisí hluku při odstřeďování v dB(A) re 1 pW', key: 'hospodarnost_a_udrzitelnost', code: 'uroven_emisi_hluku_pri_odstredovani_db_a', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'uroven_emisi_hluku_pri_odstredovani_db_a', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Délka programu při jmenovité kapacitě pro cyklus praní', key: 'hospodarnost_a_udrzitelnost', code: 'delka_programu_pri_jmenovite_kapacite_pro_cyklus_prani', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'delka_programu_pri_jmenovite_kapacite_pro_cyklus_prani', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Délka programu při jmenovité kapacitě pro kompletní provozní cyklus', key: 'hospodarnost_a_udrzitelnost', code: 'delka_programu_pri_jmenovite_kapacite_pro_kompletni_provozni_cyklus', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'delka_programu_pri_jmenovite_kapacite_pro_kompletni_provozni_cyklus', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Příkon ve vypnutém stavu ve W', key: 'hospodarnost_a_udrzitelnost', code: 'prikon_ve_vypnutem_stavu_ve_w', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'prikon_ve_vypnutem_stavu_ve_w', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Příkon v síťovém pohotovostním režimu ve W', key: 'hospodarnost_a_udrzitelnost', code: 'prikon_v_sitovem_pohotovostnim_rezimu_ve_w', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'prikon_v_sitovem_pohotovostnim_rezimu_ve_w', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Praní při nízkých teplotách – "studená" a "20 °C"', key: 'hospodarnost_a_udrzitelnost', code: 'prani_pri_nizkych_teplotach_studena_20_c', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'prani_pri_nizkych_teplotach_studena_20_c', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Množstevní automatika', key: 'hospodarnost_a_udrzitelnost', code: 'mnozstevni_automatika', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'mnozstevni_automatika', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Průtokový měřič', key: 'hospodarnost_a_udrzitelnost', code: 'prutokovy_meric', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'prutokovy_meric', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Regulace pěnivosti', key: 'hospodarnost_a_udrzitelnost', code: 'regulace_penivosti', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'regulace_penivosti', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true },
      { label: 'Motor ProfiEco', key: 'hospodarnost_a_udrzitelnost', code: 'motor_profieco', valueKey: 'hospodarnost_a_udrzitelnost_hodnoty', valueCode: 'motor_profieco', tooltipGroup: 'hospodarnost_a_udrzitelnost', alwaysShow: true }
    ]
  },
    {
    title: 'PROGRAMY PRANÍ',
    rows: [
      { label: 'Bavlna', key: 'programy_prani', code: 'bavlna' },
      { label: 'Snadno ošetřovatelné', key: 'programy_prani', code: 'snadno_osetrovatelne' },
      { label: 'Košile', key: 'programy_prani', code: 'kosile' },
      { label: 'Vlna (ruční praní)', key: 'programy_prani', code: 'vlna_rucni_prani' },
      { label: 'Expres', key: 'programy_prani', code: 'expres' },
      { label: 'Tmavé/jeans', key: 'programy_prani', code: 'tmave_jeans' },
      { label: 'Tmavé prádlo', key: 'programy_prani', code: 'tmave_pradlo' },
      { label: 'Jeans', key: 'programy_prani', code: 'jeans' },
      { label: 'Bavlna se šipkou', key: 'programy_prani', code: 'bavlna_se_sipkou' },
      { label: 'ECO 40–60', key: 'programy_prani', code: 'eco_40_60' },
      { label: 'QuickPower', key: 'programy_prani', code: 'quickpowerwash' },
      { label: 'Automatika', key: 'programy_prani', code: 'automatika' },
      { label: 'Hedvábí (ruční praní)', key: 'programy_prani', code: 'hedvabi_rucni_prani' },
      { label: 'Outdoor', key: 'programy_prani', code: 'outdoor' },
      { label: 'Impregnace', key: 'programy_prani', code: 'impregnace' },
      { label: 'Sportovní prádlo', key: 'programy_prani', code: 'sportovni_pradlo' },
      { label: 'Sportovní obuv', key: 'programy_prani', code: 'sportovni_obuv' },
      { label: 'Polštáře', key: 'programy_prani', code: 'polstare' },
      { label: 'Peří', key: 'programy_prani', code: 'peri' },
      { label: 'Záclony', key: 'programy_prani', code: 'zaclony' },
      { label: 'Bavlna hygiena', key: 'programy_prani', code: 'bavlna_hygiena' },
      { label: 'Čištění přístroje', key: 'programy_prani', code: 'cisteni_pristroje' },
      { label: 'Nové textilie', key: 'programy_prani', code: 'nove_textilie' },
      { label: 'Škrobení', key: 'programy_prani', code: 'skrobeni' }
    ]
  },
    {
    title: 'PROGRAMY SUŠENÍ',
    rows: [
      { label: 'Bavlna', key: 'programy_suseni', code: 'bavlna' },
      { label: 'Bavlna se šipkou', key: 'programy_suseni', code: 'bavlna_se_sipkou' },
      { label: 'Snadno ošetřovatelné', key: 'programy_suseni', code: 'snadno_osetrovatelne' },
      { label: 'Jemné prádlo', key: 'programy_suseni', code: 'jemne_pradlo' },
      { label: 'Košile', key: 'programy_suseni', code: 'kosile' },
      { label: 'Vlna', key: 'programy_suseni', code: 'vlna' },
      { label: 'Expres', key: 'programy_suseni', code: 'expres' },
      { label: 'Tmavé/jeans', key: 'programy_suseni', code: 'tmave_jeans' },
      { label: 'Teplý vzduch', key: 'programy_suseni', code: 'teply_vzduch' },
      { label: 'QuickPower', key: 'programy_suseni', code: 'quickpower' },
      { label: 'Automatika', key: 'programy_suseni', code: 'automatika' },
      { label: 'Hedvábí', key: 'programy_suseni', code: 'hedvabi' },
      { label: 'Tmavé prádlo', key: 'programy_suseni', code: 'tmave_pradlo' },
      { label: 'Jeans', key: 'programy_suseni', code: 'jeans' },
      { label: 'Outdoor', key: 'programy_suseni', code: 'outdoor' },
      { label: 'Impregnace', key: 'programy_suseni', code: 'impregnace' },
      { label: 'Sportovní prádlo', key: 'programy_suseni', code: 'sportovni_pradlo', alwaysShow: true },
      { label: 'Sportovní obuv', key: 'programy_suseni', code: 'sportovni_obuv' },
      { label: 'Polštáře', key: 'programy_suseni', code: 'polstare' },
      { label: 'Bavlna hygiena', key: 'programy_suseni', code: 'bavlna_hygiena' },
      { label: 'Nové textilie', key: 'programy_suseni', code: 'nove_textilie' },
      { label: 'Studený vzduch', key: 'programy_suseni', code: 'studeny_vzduch' },
      { label: 'Osvěžení', key: 'programy_suseni', code: 'osvezeni' },
      { label: 'Konečná úprava párou', key: 'programy_suseni', code: 'konecna_uprava_parou' }
    ]
  },
  {
    title: 'EXTRA FUNKCE',
    rows: [
      { label: 'Krátký', key: 'extra_funkce', code: 'kratky' },
      { label: 'Odmočení', key: 'extra_funkce', code: 'odmoceni' },
      { label: 'Předeprání', key: 'extra_funkce', code: 'predeprani' },
      { label: 'Více vody', key: 'extra_funkce', code: 'vice_vody' },
      { label: 'Extra máchání', key: 'extra_funkce', code: 'extra_machani' },
      { label: 'Předžehlení párou', key: 'extra_funkce', code: 'predzehleni_parou' },
      { label: 'Bzučák', key: 'extra_funkce', code: 'bzucak' },
      { label: 'AllergoWash', key: 'extra_funkce', code: 'allergowash' },
      { label: 'Single', key: 'extra_funkce', code: 'singlewash' },
      { label: 'Ochrana proti pomačkání', key: 'extra_funkce', code: 'ochrana_proti_pomackani' },
      { label: 'Šetrný', key: 'extra_funkce', code: 'setrny' }
    ]
  },
  {
    title: 'BEZPEČNOST',
    rows: [
      { label: 'Systém ochrany proti poškození vodou', key: 'bezpecnost', code: 'system_ochrany_proti_poskozeni_vodou', valueKey: 'bezpecnost_hodnota', valueCode: 'system_ochrany_proti_poskozeni_vodou', tooltipGroup: 'bezpecnost', alwaysShow: true, valueOnly: true },
      { label: 'Dětská pojistka', key: 'bezpecnost', code: 'detska_pojistka', valueKey: 'bezpecnost_hodnota', valueCode: 'detska_pojistka', tooltipGroup: 'bezpecnost', alwaysShow: true },
      { label: 'PIN kód', key: 'bezpecnost', code: 'pin_kod', valueKey: 'bezpecnost_hodnota', valueCode: 'pin_kod', tooltipGroup: 'bezpecnost', alwaysShow: true },
      { label: 'Optické rozhraní', key: 'bezpecnost', code: 'opticke_rozhrani', valueKey: 'bezpecnost_hodnota', valueCode: 'opticke_rozhrani', tooltipGroup: 'bezpecnost', alwaysShow: true }
    ]
  },
  {
    title: 'TECHNICKÉ ÚDAJE',
    rows: [
      { label: 'Rozměry v mm (šířka)', key: 'technicke_udaje', code: 'rozmery_v_mm_sirka', valueKey: 'technicke_udaje_hodnota', valueCode: 'rozmery_v_mm_sirka', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Hmotnost náplně při praní v kg', key: 'technicke_udaje', code: 'hmotnost_naplne_pri_prani_v_kg', valueKey: 'technicke_udaje_hodnota', valueCode: 'hmotnost_naplne_pri_prani_v_kg', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Hmotnost náplně při sušení v kg', key: 'technicke_udaje', code: 'hmotnost_naplne_pri_suseni_v_kg', valueKey: 'technicke_udaje_hodnota', valueCode: 'hmotnost_naplne_pri_suseni_v_kg', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Rozměry v mm (výška)', key: 'technicke_udaje', code: 'rozmery_v_mm_vyska', valueKey: 'technicke_udaje_hodnota', valueCode: 'rozmery_v_mm_vyska', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Rozměry v mm (hloubka)', key: 'technicke_udaje', code: 'rozmery_v_mm_hloubka', valueKey: 'technicke_udaje_hodnota', valueCode: 'rozmery_v_mm_hloubka', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Hloubka přístroje s otevřenými dvířky v mm', key: 'technicke_udaje', code: 'hloubka_pristroje_s_otevrenymi_dvirky_v_mm', valueKey: 'technicke_udaje_hodnota', valueCode: 'hloubka_pristroje_s_otevrenymi_dvirky_v_mm', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Hmotnost v kg', key: 'technicke_udaje', code: 'hmotnost_v_kg', valueKey: 'technicke_udaje_hodnota', valueCode: 'hmotnost_v_kg', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Napětí ve V', key: 'technicke_udaje', code: 'napeti_ve_v', valueKey: 'technicke_udaje_hodnota', valueCode: 'napeti_ve_v', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Jištění v A', key: 'technicke_udaje', code: 'jisteni_v_a', valueKey: 'technicke_udaje_hodnota', valueCode: 'jisteni_v_a', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Frekvence v Hz', key: 'technicke_udaje', code: 'frekvence_v_hz', valueKey: 'technicke_udaje_hodnota', valueCode: 'frekvence_v_hz', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Celkový příkon v kW', key: 'technicke_udaje', code: 'celkovy_prikon_v_kw', valueKey: 'technicke_udaje_hodnota', valueCode: 'celkovy_prikon_v_kw', tooltipGroup: 'technicke_udaje', alwaysShow: true },
      { label: 'Délka elektrického přívodního kabelu v m', key: 'technicke_udaje', code: 'delka_elektrickeho_privodniho_kabelu_v_m', valueKey: 'technicke_udaje_hodnota', valueCode: 'delka_elektrickeho_privodniho_kabelu_v_m', tooltipGroup: 'technicke_udaje', alwaysShow: true }
    ]
  },
  {
    title: 'DODÁVANÉ PŘÍSLUŠENSTVÍ',
    rows: [
      { label: '3 kapsle', key: 'dodavane_prislusenstvi', code: 'tri_kapsle', tooltipGroup: 'dodavane_prislusenstvi' },
      { label: 'UltraPhase 1 + 2', key: 'dodavane_prislusenstvi', code: 'ultraphase_1_2', tooltipGroup: 'dodavane_prislusenstvi' },
      { label: 'Voucher na 5 kartuší pracího prostředku UltraPhase od Miele', key: 'dodavane_prislusenstvi', code: 'voucher_na_5_kartusi_praciho_prostredku_ultraphase_od_miele', tooltipGroup: 'dodavane_prislusenstvi' }
    ]
  },
  {
    title: 'DOSTUPNÉ JAZYKY DISPLEJE',
    rows: [
      { label: 'Dostupné jazyky displeje díky funkci MultiLingua', key: 'dostupne_jazyky_displeje_diky_multilingua', alwaysShow: true, displayAsText: true }
    ]
  }
];
function prependCompareSectionIfMissing(schema, title, section) {
  if (!Array.isArray(schema)) return;

  const hasSection = schema.some(function(existingSection) {
    return normalizeCompareCode(existingSection && existingSection.title) === normalizeCompareCode(title);
  });

  if (!hasSection) {
    schema.unshift(section);
  }
}

const PRACKY_VSEOBECNE_UDAJE_SECTION = {
  title: 'VŠEOBECNÉ ÚDAJE',
  rows: [
    { label: 'Číslo EAN', key: 'vseobecne_udaje', code: 'cislo_ean', valueKey: 'vseobecne_udaje_hodnoty', valueCode: 'cislo_ean', valueOnly: true, tooltipGroup: 'vseobecne_udaje', alwaysShow: true },
    { label: 'Marketingová třída', key: 'vseobecne_udaje', code: 'marketingova_trida', valueKey: 'vseobecne_udaje_hodnoty', valueCode: 'marketingova_trida', valueOnly: true, tooltipGroup: 'vseobecne_udaje', alwaysShow: true }
  ]
};

prependCompareSectionIfMissing(COMPARE_SCHEMAS.pracky, 'VŠEOBECNÉ ÚDAJE', PRACKY_VSEOBECNE_UDAJE_SECTION);
prependCompareSectionIfMissing(COMPARE_SCHEMAS.pracky_se_susickou, 'VŠEOBECNÉ ÚDAJE', PRACKY_VSEOBECNE_UDAJE_SECTION);

  function getCompareItemValue(item, key) {
    if (!item) return '—';

    if (item[key] !== undefined && item[key] !== null && String(item[key]).trim() !== '') {
      return item[key];
    }

   const fallbackMap = {
    oznaceni_modelu: [
  'oznaceni_modelu',
  'custom.oznaceni_modelu',
  'custom_oznaceni_modelu',
  'product_title',
  'title'
],

cislo_materialu_vyrobce: [
  'cislo_materialu_vyrobce',
  'custom.cislo_materialu_vyrobce',
  'custom_cislo_materialu_vyrobce',
  'cislo_materialu',
  'custom.cislo_materialu',
  'custom_cislo_materialu'
],

cislo_ean: [
  'cislo_ean',
  'custom.cislo_ean',
  'custom_cislo_ean',
  'ean',
  'custom.ean',
  'custom_ean'
],

marketingova_trida: [
  'marketingova_trida',
  'custom.marketingova_trida',
  'custom_marketingova_trida'
],

cislo_stareho_materialu: [
  'cislo_stareho_materialu',
  'custom.cislo_stareho_materialu',
  'custom_cislo_stareho_materialu'
],
typ_produktu: [
  'typ_produktu',
  'custom.typ_produktu',
  'custom_typ_produktu'
],

provedeni_a_design: [
  'provedeni_a_design',
  'custom.provedeni_a_design',
  'custom_provedeni_a_design'
],

provedeni_a_design_hodnota: [
  'provedeni_a_design_hodnota',
  'custom.provedeni_a_design_hodnota',
  'custom_provedeni_a_design_hodnota'
],
provedeni: [
  'provedeni',
  'custom.provedeni',
  'custom_provedeni'
],

provedeni_hodnota: [
  'provedeni_hodnota',
  'custom.provedeni_hodnota',
  'custom_provedeni_hodnota'
],
cisteni: [
  'cisteni',
  'custom.cisteni',
  'custom_cisteni'
],

filtracni_system: [
  'filtracni_system',
  'custom.filtracni_system',
  'custom_filtracni_system'
],

filtracni_system_hodnota: [
  'filtracni_system_hodnota',
  'filtracni_system_hodnoty',
  'custom.filtracni_system_hodnota',
  'custom.filtracni_system_hodnoty',
  'custom_filtracni_system_hodnota',
  'custom_filtracni_system_hodnoty'
],

provozni_zpusoby_hodnoty: [
  'provozni_zpusoby_hodnoty',
  'provozni_zpusoby_hodnota',
  'custom.provozni_zpusoby_hodnoty',
  'custom.provozni_zpusoby_hodnota',
  'custom_provozni_zpusoby_hodnoty',
  'custom_provozni_zpusoby_hodnota'
],
vybaveni_varnych_zon: [
  'vybaveni_varnych_zon',
  'custom.vybaveni_varnych_zon',
  'custom_vybaveni_varnych_zon'
],

vybaveni_varnych_zon_hodnoty: [
  'vybaveni_varnych_zon_hodnoty',
  'vybaveni_varnych_zon_hodnota',
  'custom.vybaveni_varnych_zon_hodnoty',
  'custom.vybaveni_varnych_zon_hodnota',
  'custom_vybaveni_varnych_zon_hodnoty',
  'custom_vybaveni_varnych_zon_hodnota'
],
design: [
  'design',
  'custom.design',
  'custom_design'
],

design_hodnoty: [
  'design_hodnoty',
  'custom.design_hodnoty',
  'custom_design_hodnoty'
],
vseobecne_udaje: [
  'vseobecne_udaje',
  'custom.vseobecne_udaje',
  'custom_vseobecne_udaje'
],

vseobecne_udaje_hodnoty: [
  'vseobecne_udaje_hodnoty',
  'custom.vseobecne_udaje_hodnoty',
  'custom_vseobecne_udaje_hodnoty'
],
uzivatelske_vyhody: [
  'uzivatelske_vyhody',
  'custom.uzivatelske_vyhody',
  'custom_uzivatelske_vyhody'
],
setrna_pece_o_pradlo: [
  'setrna_pece_o_pradlo',
  'custom.setrna_pece_o_pradlo',
  'custom_setrna_pece_o_pradlo'
],

setrna_pece_o_pradlo_hodnota: [
  'setrna_pece_o_pradlo_hodnota',
  'setrna_pece_o_pradlo_hodnoty',
  'custom.setrna_pece_o_pradlo_hodnota',
  'custom.setrna_pece_o_pradlo_hodnoty',
  'custom_setrna_pece_o_pradlo_hodnota',
  'custom_setrna_pece_o_pradlo_hodnoty'
],

komfort_pri_obsluze: [
  'komfort_pri_obsluze',
  'custom.komfort_pri_obsluze',
  'custom_komfort_pri_obsluze'
],

napojove_speciality: [
  'napojove_speciality',
  'custom.napojove_speciality',
  'custom_napojove_speciality'
],

custom_napojove_speciality_hodnota: [
  'custom_napojove_speciality_hodnota',
  'napojove_speciality_hodnota',
  'custom.napojove_speciality_hodnota',
  'custom_napojove_speciality_hodnota'
],

hospodarnost_a_udrzitelnost: [
  'hospodarnost_a_udrzitelnost',
  'custom.hospodarnost_a_udrzitelnost',
  'custom_hospodarnost_a_udrzitelnost'
],

hospodarnost_a_udrzitelnost_hodnoty: [
  'hospodarnost_a_udrzitelnost_hodnoty',
  'custom.hospodarnost_a_udrzitelnost_hodnoty',
  'custom_hospodarnost_a_udrzitelnost_hodnoty'
],

komfort_pri_udrzbe: [
  'komfort_pri_udrzbe',
  'custom.komfort_pri_udrzbe',
  'custom_komfort_pri_udrzbe'
],

komfort_pri_udrzbe_hodnoty: [
  'komfort_pri_udrzbe_hodnoty',
  'custom.komfort_pri_udrzbe_hodnoty',
  'custom_komfort_pri_udrzbe_hodnoty'
],

technicke_udaje_hodnoty: [
  'technicke_udaje_hodnoty',
  'custom.technicke_udaje_hodnoty',
  'custom_technicke_udaje_hodnoty'
],

dodavane_prislusenstvi: [
  'dodavane_prislusenstvi',
  'custom.dodavane_prislusenstvi',
  'custom_dodavane_prislusenstvi'
],

dodavane_prislusenstvi_hodnota: [
  'dodavane_prislusenstvi_hodnota',
  'dodavane_prislusenstvi_hodnoty',
  'custom.dodavane_prislusenstvi_hodnota',
  'custom.dodavane_prislusenstvi_hodnoty',
  'custom_dodavane_prislusenstvi_hodnota',
  'custom_dodavane_prislusenstvi_hodnoty'
],

dodavane_prislusenstvi_hodnoty: [
  'dodavane_prislusenstvi_hodnoty',
  'dodavane_prislusenstvi_hodnota',
  'custom.dodavane_prislusenstvi_hodnoty',
  'custom.dodavane_prislusenstvi_hodnota',
  'custom_dodavane_prislusenstvi_hodnoty',
  'custom_dodavane_prislusenstvi_hodnota'
],

instalacni_vykresy: [
  'instalacni_vykresy',
  'custom.instalacni_vykresy',
  'custom_instalacni_vykresy'
],
pouziti: [
  'pouziti',
  'custom.pouziti',
  'custom_pouziti'
],

vykonove_udaje: [
  'vykonove_udaje',
  'custom.vykonove_udaje',
  'custom_vykonove_udaje'
],

vykonove_udaje_hodnota: [
  'vykonove_udaje_hodnota',
  'custom.vykonove_udaje_hodnota',
  'custom_vykonove_udaje_hodnota'
],
snadne_zavirani_dvirek: [
  'snadne_zavirani_dvirek',
  'custom.snadne_zavirani_dvirek',
  'custom_snadne_zavirani_dvirek'
],

indikator_provozu_kontrolni_funkce: [
  'indikator_provozu_kontrolni_funkce',
  'custom.indikator_provozu_kontrolni_funkce',
  'custom_indikator_provozu_kontrolni_funkce'
],
barva_ovladaciho_panelu: [
  'barva_ovladaciho_panelu',
  'custom.barva_ovladaciho_panelu',
  'custom_barva_ovladaciho_panelu'
],

provedeni_ovladaciho_panelu: [
  'provedeni_ovladaciho_panelu',
  'custom.provedeni_ovladaciho_panelu',
  'custom_provedeni_ovladaciho_panelu'
],

barva_displeje: [
  'barva_displeje',
  'custom.barva_displeje',
  'custom_barva_displeje'
],
zpusob_vedeni_vzduchu: [
  'zpusob_vedeni_vzduchu',
  'custom.zpusob_vedeni_vzduchu',
  'custom_zpusob_vedeni_vzduchu'
],

potrebna_sada_pro_prestavbu_na_cirkulaci_k_dokoupeni: [
  'potrebna_sada_pro_prestavbu_na_cirkulaci_k_dokoupeni',
  'custom.potrebna_sada_pro_prestavbu_na_cirkulaci_k_dokoupeni',
  'custom_potrebna_sada_pro_prestavbu_na_cirkulaci_k_dokoupeni'
],

potrebny_uhlikovy_filtr_k_dokoupeni: [
  'potrebny_uhlikovy_filtr_k_dokoupeni',
  'custom.potrebny_uhlikovy_filtr_k_dokoupeni',
  'custom_potrebny_uhlikovy_filtr_k_dokoupeni'
],
odtah_hodnoty: [
  'odtah_hodnoty',
  'custom.odtah_hodnoty',
  'custom_odtah_hodnoty'
],

cirkulace_hodnoty: [
  'cirkulace_hodnoty',
  'custom.cirkulace_hodnoty',
  'custom_cirkulace_hodnoty'
],

displej: [
  'displej',
  'custom.displej',
  'custom_displej'
],
nocni_vypnuti: [
  'nocni_vypnuti',
  'custom.nocni_vypnuti',
  'custom_nocni_vypnuti'
],

nerezovy_povrch_cleansteel: [
  'nerezovy_povrch_cleansteel',
  'custom.nerezovy_povrch_cleansteel',
  'custom_nerezovy_povrch_cleansteel'
],

nerezovy_ohrevny_prostor: [
  'nerezovy_ohrevny_prostor',
  'custom.nerezovy_ohrevny_prostor',
  'custom_nerezovy_ohrevny_prostor'
],

dvirka_cleanglass: [
  'dvirka_cleanglass',
  'custom.dvirka_cleanglass',
  'custom_dvirka_cleanglass'
],

system_chlazeni_pristroje_s_vlaznou_celni_stenou: [
  'system_chlazeni_pristroje_s_vlaznou_celni_stenou',
  'custom.system_chlazeni_pristroje_s_vlaznou_celni_stenou',
  'custom_system_chlazeni_pristroje_s_vlaznou_celni_stenou'
],

zablokovani_zprovozneni: [
  'zablokovani_zprovozneni',
  'custom.zablokovani_zprovozneni',
  'custom_zablokovani_zprovozneni'
],

bezpecnostni_vypinac: [
  'bezpecnostni_vypinac',
  'custom.bezpecnostni_vypinac',
  'custom_bezpecnostni_vypinac'
],

bezpecnostni_upozorneni_pri_nedovrenych_dvirkach: [
  'bezpecnostni_upozorneni_pri_nedovrenych_dvirkach',
  'custom.bezpecnostni_upozorneni_pri_nedovrenych_dvirkach',
  'custom_bezpecnostni_upozorneni_pri_nedovrenych_dvirkach'
],
    barva_pristroje: [
  'barva_pristroje',
  'custom.barva_pristroje',
  'custom_barva_pristroje'
],

varianta_motoru: [
  'varianta_motoru',
  'custom.varianta_motoru',
  'custom_varianta_motoru'
],

typ_pristroje: [
  'typ_pristroje',
  'custom.typ_pristroje',
  'custom_typ_pristroje'
],

elektronicka_regulace_vykonu: [
  'elektronicka_regulace_vykonu',
  'custom.elektronicka_regulace_vykonu',
  'custom_elektronicka_regulace_vykonu'
],

saci_trubice: [
  'saci_trubice',
  'custom.saci_trubice',
  'custom_saci_trubice'
],

parkovaci_system_pro_uskladneni: [
  'parkovaci_system_pro_uskladneni',
  'custom.parkovaci_system_pro_uskladneni',
  'custom_parkovaci_system_pro_uskladneni'
],

akcni_radius_v_m: [
  'akcni_radius_v_m',
  'custom.akcni_radius_v_m',
  'custom_akcni_radius_v_m'
],

delka_kabelu_v_m: [
  'delka_kabelu_v_m',
  'custom.delka_kabelu_v_m',
  'custom_delka_kabelu_v_m'
],

vzduchovy_filtr: [
  'vzduchovy_filtr',
  'custom.vzduchovy_filtr',
  'custom_vzduchovy_filtr'
],

objem_prachove_nadoby_v_l: [
  'objem_prachove_nadoby_v_l',
  'custom.objem_prachove_nadoby_v_l',
  'custom_objem_prachove_nadoby_v_l'
],

ulozeni_prislusenstvi: [
  'ulozeni_prislusenstvi',
  'custom.ulozeni_prislusenstvi',
  'custom_ulozeni_prislusenstvi'
],

typ_akumulatoru: [
  'typ_akumulatoru',
  'custom.typ_akumulatoru',
  'custom_typ_akumulatoru'
],

jmenovita_kapacita_akumulatoru_v_mah: [
  'jmenovita_kapacita_akumulatoru_v_mah',
  'custom.jmenovita_kapacita_akumulatoru_v_mah',
  'custom_jmenovita_kapacita_akumulatoru_v_mah'
],

doba_provozu_na_stupen_min_powerunit_samostatne: [
  'doba_provozu_na_stupen_min_powerunit_samostatne',
  'custom.doba_provozu_na_stupen_min_powerunit_samostatne',
  'custom_doba_provozu_na_stupen_min_powerunit_samostatne'
],

doba_provozu_na_stupen_min_s_elektroprislusenstvim: [
  'doba_provozu_na_stupen_min_s_elektroprislusenstvim',
  'custom.doba_provozu_na_stupen_min_s_elektroprislusenstvim',
  'custom_doba_provozu_na_stupen_min_s_elektroprislusenstvim'
],

doba_provozu_na_stupen_max_s_elektroprislusenstvim: [
  'doba_provozu_na_stupen_max_s_elektroprislusenstvim',
  'custom.doba_provozu_na_stupen_max_s_elektroprislusenstvim',
  'custom_doba_provozu_na_stupen_max_s_elektroprislusenstvim'
],

plosny_vykon_v_m: [
  'plosny_vykon_v_m',
  'custom.plosny_vykon_v_m',
  'custom_plosny_vykon_v_m'
],

doba_nabijeni_v_min: [
  'doba_nabijeni_v_min',
  'custom.doba_nabijeni_v_min',
  'custom_doba_nabijeni_v_min'
],

vykon_ve_wattech: [
  'vykon_ve_wattech',
  'custom.vykon_ve_wattech',
  'custom_vykon_ve_wattech'
],

hlasitost_v_db: [
  'hlasitost_v_db',
  'custom.hlasitost_v_db',
  'custom_hlasitost_v_db'
],

rozmery_v_mm_sirka: [
  'rozmery_v_mm_sirka',
  'custom.rozmery_v_mm_sirka',
  'custom_rozmery_v_mm_sirka'
],

rozmery_v_mm_vyska: [
  'rozmery_v_mm_vyska',
  'custom.rozmery_v_mm_vyska',
  'custom_rozmery_v_mm_vyska'
],

rozmery_v_mm_hloubka: [
  'rozmery_v_mm_hloubka',
  'custom.rozmery_v_mm_hloubka',
  'custom_rozmery_v_mm_hloubka'
],

hmotnost_v_kg: [
  'hmotnost_v_kg',
  'custom.hmotnost_v_kg',
  'custom_hmotnost_v_kg'
],
stupne_vykonu_pocet_bez_intenzivniho_stupne: [
  'stupne_vykonu_pocet_bez_intenzivniho_stupne',
  'custom.stupne_vykonu_pocet_bez_intenzivniho_stupne',
  'custom_stupne_vykonu_pocet_bez_intenzivniho_stupne'
],

intenzivni_stupne: [
  'intenzivni_stupne',
  'custom.intenzivni_stupne',
  'custom_intenzivni_stupne'
],

zpusob_ovladani: [
  'zpusob_ovladani',
  'custom.zpusob_ovladani',
  'custom_zpusob_ovladani'
],

automaticka_funkce: [
  'automaticka_funkce',
  'custom.automaticka_funkce',
  'custom_automaticka_funkce'
],

pocet_ventilatoru: [
  'pocet_ventilatoru',
  'custom.pocet_ventilatoru',
  'custom_pocet_ventilatoru'
],

prumer_odtahoveho_hrdla_v_mm: [
  'prumer_odtahoveho_hrdla_v_mm',
  'custom.prumer_odtahoveho_hrdla_v_mm',
  'custom_prumer_odtahoveho_hrdla_v_mm'
],

optimalni_kombinace_s_varnou_deskou_podle_dostupnosti: [
  'optimalni_kombinace_s_varnou_deskou_podle_dostupnosti',
  'custom.optimalni_kombinace_s_varnou_deskou_podle_dostupnosti',
  'custom_optimalni_kombinace_s_varnou_deskou_podle_dostupnosti'
],

kombinace_s_varnou_deskou_miele_podporujici_wifi: [
  'kombinace_s_varnou_deskou_miele_podporujici_wifi',
  'custom.kombinace_s_varnou_deskou_miele_podporujici_wifi',
  'custom_kombinace_s_varnou_deskou_miele_podporujici_wifi'
],
    objem_ohrevneho_prostoru_l: [
  'objem_ohrevneho_prostoru_l',
  'custom.objem_ohrevneho_prostoru_l',
  'custom_objem_ohrevneho_prostoru_l'
],
objem_ohrevneho_prostoru_v_l: [
  'objem_ohrevneho_prostoru_v_l',
  'custom.objem_ohrevneho_prostoru_v_l',
  'custom_objem_ohrevneho_prostoru_v_l',
  'objem_ohrevneho_prostoru_l',
  'custom.objem_ohrevneho_prostoru_l',
  'custom_objem_ohrevneho_prostoru_l'
],

prumer_otocneho_talire_v_cm: [
  'prumer_otocneho_talire_v_cm',
  'custom.prumer_otocneho_talire_v_cm',
  'custom_prumer_otocneho_talire_v_cm'
],

vyska_ohrevneho_prostoru_v_cm: [
  'vyska_ohrevneho_prostoru_v_cm',
  'custom.vyska_ohrevneho_prostoru_v_cm',
  'custom_vyska_ohrevneho_prostoru_v_cm'
],

elektronicky_rizeny_vykon_mikrovlny: [
  'elektronicky_rizeny_vykon_mikrovlny',
  'custom.elektronicky_rizeny_vykon_mikrovlny',
  'custom_elektronicky_rizeny_vykon_mikrovlny'
],

stupne_vykonu_mikrovlny_ve_w: [
  'stupne_vykonu_mikrovlny_ve_w',
  'custom.stupne_vykonu_mikrovlny_ve_w',
  'custom_stupne_vykonu_mikrovlny_ve_w',
  'stupne_vykonu_mikrovlny_w',
  'custom.stupne_vykonu_mikrovlny_w',
  'custom_stupne_vykonu_mikrovlny_w'
],

maximalni_vykon_mikrovlny_ve_w: [
  'maximalni_vykon_mikrovlny_ve_w',
  'custom.maximalni_vykon_mikrovlny_ve_w',
  'custom_maximalni_vykon_mikrovlny_ve_w'
],

vykon_grilu_ve_w: [
  'vykon_grilu_ve_w',
  'custom.vykon_grilu_ve_w',
  'custom_vykon_grilu_ve_w'
],

zaves_dvirek: [
  'zaves_dvirek',
  'custom.zaves_dvirek',
  'custom_zaves_dvirek'
],

pocet_urovni_zasunuti: [
  'pocet_urovni_zasunuti',
  'custom.pocet_urovni_zasunuti',
  'custom_pocet_urovni_zasunuti'
],

osvetleni_ohrevneho_prostoru: [
  'osvetleni_ohrevneho_prostoru',
  'custom.osvetleni_ohrevneho_prostoru',
  'custom_osvetleni_ohrevneho_prostoru'
],

typ_zasuvky: [
  'typ_zasuvky',
  'custom.typ_zasuvky',
  'custom_typ_zasuvky'
],

minimalni_sirka_vyklenku_v_mm: [
  'minimalni_sirka_vyklenku_v_mm',
  'custom.minimalni_sirka_vyklenku_v_mm',
  'custom_minimalni_sirka_vyklenku_v_mm'
],

maximalni_sirka_vyklenku_v_mm: [
  'maximalni_sirka_vyklenku_v_mm',
  'custom.maximalni_sirka_vyklenku_v_mm',
  'custom_maximalni_sirka_vyklenku_v_mm'
],

minimalni_vyska_vyklenku_v_mm: [
  'minimalni_vyska_vyklenku_v_mm',
  'custom.minimalni_vyska_vyklenku_v_mm',
  'custom_minimalni_vyska_vyklenku_v_mm'
],

maximalni_vyska_vyklenku_v_mm: [
  'maximalni_vyska_vyklenku_v_mm',
  'custom.maximalni_vyska_vyklenku_v_mm',
  'custom_maximalni_vyska_vyklenku_v_mm'
],

hloubka_vyklenku_v_mm: [
  'hloubka_vyklenku_v_mm',
  'custom.hloubka_vyklenku_v_mm',
  'custom_hloubka_vyklenku_v_mm'
],
ventilace_nezavisle_na_vyklenku: [
  'ventilace_nezavisle_na_vyklenku',
  'custom.ventilace_nezavisle_na_vyklenku',
  'custom_ventilace_nezavisle_na_vyklenku'
],

rozmery_pristroje_s_x_v_x_h_v_mm: [
  'rozmery_pristroje_s_x_v_x_h_v_mm',
  'custom.rozmery_pristroje_s_x_v_x_h_v_mm',
  'custom_rozmery_pristroje_s_x_v_x_h_v_mm',
  'rozmery_v_x_s_x_h_v_mm',
  'custom.rozmery_v_x_s_x_h_v_mm',
  'custom_rozmery_v_x_s_x_h_v_mm'
],

rozmery_v_x_s_x_h_v_mm: [
  'rozmery_v_x_s_x_h_v_mm',
  'custom.rozmery_v_x_s_x_h_v_mm',
  'custom_rozmery_v_x_s_x_h_v_mm',
  'rozmery_pristroje_s_x_v_x_h_v_mm',
  'custom.rozmery_pristroje_s_x_v_x_h_v_mm',
  'custom_rozmery_pristroje_s_x_v_x_h_v_mm'
],

pripojovaci_kabel_se_zastrckou: [
  'pripojovaci_kabel_se_zastrckou',
  'custom.pripojovaci_kabel_se_zastrckou',
  'custom_pripojovaci_kabel_se_zastrckou'
], 
pocet_fazi: [
  'pocet_fazi',
  'custom.pocet_fazi',
  'custom_pocet_fazi'
],

vymena_svitidel: [
  'vymena_svitidel',
  'custom.vymena_svitidel',
  'custom_vymena_svitidel'
],
grilovaci_rost: [
  'grilovaci_rost',
  'custom.grilovaci_rost',
  'custom_grilovaci_rost'
],

tac_na_grilovani_gourmet: [
  'tac_na_grilovani_gourmet',
  'custom.tac_na_grilovani_gourmet',
  'custom_tac_na_grilovani_gourmet'
],

poklop_na_pokrm: [
  'poklop_na_pokrm',
  'custom.poklop_na_pokrm',
  'custom_poklop_na_pokrm'
],

otocny_talir: [
  'otocny_talir',
  'custom.otocny_talir',
  'custom_otocny_talir'
],
pocet_urovni_zasunuti_ohrevny_prostor_1: [
  'pocet_urovni_zasunuti_ohrevny_prostor_1',
  'custom.pocet_urovni_zasunuti_ohrevny_prostor_1',
  'custom_pocet_urovni_zasunuti_ohrevny_prostor_1'
],

pocet_urovni_zasunuti_ohrevny_prostor_2: [
  'pocet_urovni_zasunuti_ohrevny_prostor_2',
  'custom.pocet_urovni_zasunuti_ohrevny_prostor_2',
  'custom_pocet_urovni_zasunuti_ohrevny_prostor_2'
],

teploty_ve_c: [
  'teploty_ve_c',
  'custom.teploty_ve_c',
  'custom_teploty_ve_c'
],
minimalni_teploty_pri_provozu_parni_trouby_ve_c: [
  'minimalni_teploty_pri_provozu_parni_trouby_ve_c',
  'custom.minimalni_teploty_pri_provozu_parni_trouby_ve_c',
  'custom_minimalni_teploty_pri_provozu_parni_trouby_ve_c',
  'minimalni_teploty_ve_c',
  'custom.minimalni_teploty_ve_c',
  'custom_minimalni_teploty_ve_c'
],

maximalni_teploty_pri_provozu_parni_trouby_ve_c: [
  'maximalni_teploty_pri_provozu_parni_trouby_ve_c',
  'custom.maximalni_teploty_pri_provozu_parni_trouby_ve_c',
  'custom_maximalni_teploty_pri_provozu_parni_trouby_ve_c',
  'maximalni_teploty_ve_c',
  'custom.maximalni_teploty_ve_c',
  'custom_maximalni_teploty_ve_c'
],

minimalni_teploty_pri_provozu_pecici_trouby_ve_c: [
  'minimalni_teploty_pri_provozu_pecici_trouby_ve_c',
  'custom.minimalni_teploty_pri_provozu_pecici_trouby_ve_c',
  'custom_minimalni_teploty_pri_provozu_pecici_trouby_ve_c'
],

maximalni_teploty_pri_provozu_pecici_trouby_ve_c: [
  'maximalni_teploty_pri_provozu_pecici_trouby_ve_c',
  'custom.maximalni_teploty_pri_provozu_pecici_trouby_ve_c',
  'custom_maximalni_teploty_pri_provozu_pecici_trouby_ve_c'
],

teploty_pri_provozu_pecici_trouby_ve_c: [
  'teploty_pri_provozu_pecici_trouby_ve_c',
  'custom.teploty_pri_provozu_pecici_trouby_ve_c',
  'custom_teploty_pri_provozu_pecici_trouby_ve_c',
  'teploty_ve_c',
  'custom.teploty_ve_c',
  'custom_teploty_ve_c'
],

teploty_pri_provozu_parni_trouby_ve_c: [
  'teploty_pri_provozu_parni_trouby_ve_c',
  'custom.teploty_pri_provozu_parni_trouby_ve_c',
  'custom_teploty_pri_provozu_parni_trouby_ve_c'
],

rozmery_vyklenku_s_x_v_x_h_v_mm: [
  'rozmery_vyklenku_s_x_v_x_h_v_mm',
  'custom.rozmery_vyklenku_s_x_v_x_h_v_mm',
  'custom_rozmery_vyklenku_s_x_v_x_h_v_mm',
  'rozmery_vyklenku_v_x_s_x_h_v_mm',
  'custom.rozmery_vyklenku_v_x_s_x_h_v_mm',
  'custom_rozmery_vyklenku_v_x_s_x_h_v_mm'
],

delka_privodni_hadice_v_m: [
  'delka_privodni_hadice_v_m',
  'custom.delka_privodni_hadice_v_m',
  'custom_delka_privodni_hadice_v_m'
],

delka_odtokove_hadice_v_m: [
  'delka_odtokove_hadice_v_m',
  'custom.delka_odtokove_hadice_v_m',
  'custom_delka_odtokove_hadice_v_m',
  'delka_vypousteci_hadice_v_m',
  'custom.delka_vypousteci_hadice_v_m',
  'custom_delka_vypousteci_hadice_v_m'
],

minimalni_teploty_ve_c: [
  'minimalni_teploty_ve_c',
  'custom.minimalni_teploty_ve_c',
  'custom_minimalni_teploty_ve_c'
],

maximalni_teploty_ve_c: [
  'maximalni_teploty_ve_c',
  'custom.maximalni_teploty_ve_c',
  'custom_maximalni_teploty_ve_c'
],

stupne_vykonu_mikrovlny_w: [
  'stupne_vykonu_mikrovlny_w',
  'custom.stupne_vykonu_mikrovlny_w',
  'custom_stupne_vykonu_mikrovlny_w'
],
  oznaceni_pristroje: [
  'oznaceni_pristroje',
  'custom.oznaceni_pristroje',
  'custom_oznaceni_pristroje'
],

oznaceni_produktu: [
  'oznaceni_produktu',
  'custom.oznaceni_produktu',
  'custom_oznaceni_produktu',
  'oznaceni_pristroje',
  'custom.oznaceni_pristroje',
  'custom_oznaceni_pristroje'
],

  trida_energeticke_ucinnosti: [
  'trida_energeticke_ucinnosti',
  'energeticka_trida'
],

energeticka_trida: [
  'energeticka_trida',
  'trida_energeticke_ucinnosti'
],

trida_ucinnosti_kondenzace_a_d: [
  'trida_ucinnosti_kondenzace_a_d'
],

ucinnost_kondenzace_v: [
  'ucinnost_kondenzace_v'
],

vazena_spotreba_el_energie_na_100_mycich_sarzi_v_programu_eco_no: [
  'vazena_spotreba_el_energie_na_100_mycich_sarzi_v_programu_eco_no'
],

emise_hluku_prenaseneho_vzduchem_ve_standardnim_programu_eco_nor: [
  'emise_hluku_prenaseneho_vzduchem_ve_standardnim_programu_eco_nor'
],

trida_emisi_hluku_prenaseneho_vzduchem_a_d: [
  'trida_emisi_hluku_prenaseneho_vzduchem_a_d'
],

doba_trvani_programu_eco_normal_v_min: [
  'doba_trvani_programu_eco_normal_v_min'
],

kvalita_vysledku: [
  'kvalita_vysledku',
  'custom.kvalita_vysledku',
  'custom_kvalita_vysledku'
],

programy_myti: [
  'programy_myti',
  'custom.programy_myti',
  'custom_programy_myti'
],

programy_myti_hodnoty: [
  'programy_myti_hodnoty',
  'custom.programy_myti_hodnoty',
  'custom_programy_myti_hodnoty'
],

komfort_pri_obsluze_hodnoty: [
  'komfort_pri_obsluze_hodnoty',
  'custom.komfort_pri_obsluze_hodnoty',
  'custom_komfort_pri_obsluze_hodnoty'
],
mobilita: [
  'mobilita',
  'custom.mobilita',
  'custom_mobilita'
],

filtracni_system: [
  'filtracni_system',
  'custom.filtracni_system',
  'custom_filtracni_system'
],

filtracni_system_hodnota: [
  'filtracni_system_hodnota',
  'filtracni_system_hodnoty',
  'custom.filtracni_system_hodnota',
  'custom.filtracni_system_hodnoty',
  'custom_filtracni_system_hodnota',
  'custom_filtracni_system_hodnoty'
],

moznosti_myti: [
  'moznosti_myti',
  'custom.moznosti_myti',
  'custom_moznosti_myti'
],

kosove_usporadani: [
  'kosove_usporadani',
  'custom.kosove_usporadani',
  'custom_kosove_usporadani'
],

kosove_usporadani_hodnota: [
  'kosove_usporadani_hodnota',
  'custom.kosove_usporadani_hodnota',
  'custom_kosove_usporadani_hodnota'
],

bezpecnost: [
  'bezpecnost',
  'custom.bezpecnost',
  'custom_bezpecnost'
],

bezpecnost_hodnoty: [
  'bezpecnost_hodnoty',
  'bezpecnost_hodnota',
  'custom.bezpecnost_hodnoty',
  'custom.bezpecnost_hodnota',
  'custom_bezpecnost_hodnoty',
  'custom_bezpecnost_hodnota'
],

technicke_udaje: [
  'technicke_udaje',
  'custom.technicke_udaje',
  'custom_technicke_udaje'
],

technicke_udaje_hodnota: [
  'technicke_udaje_hodnota',
  'custom.technicke_udaje_hodnota',
  'custom_technicke_udaje_hodnota'
],

extra_tichy_hodnota: [
  'extra_tichy_hodnota',
  'custom.extra_tichy_hodnota',
  'custom_extra_tichy_hodnota'
],

voucher_na_druhy_flakon_s_vuni: [
  'voucher_na_druhy_flakon_s_vuni'
],

flakon_s_vuni: [
  'flakon_s_vuni'
],

hermeticky_uzavreno: [
  'hermeticky_uzavreno'
],
dostupne_jazyky_displeje_diky_multilingua: [
  'dostupne_jazyky_displeje_diky_multilingua',
  'custom.dostupne_jazyky_displeje_diky_multilingua',
  'custom_dostupne_jazyky_displeje_diky_multilingua',
  'dostupne_jazyky_displeje_diky_funkci_multilingua',
  'custom.dostupne_jazyky_displeje_diky_funkci_multilingua',
  'custom_dostupne_jazyky_displeje_diky_funkci_multilingua'
],
typ_chladiva: [
  'typ_chladiva'
],

mnozstvi_chladiva_v_kg: [
  'mnozstvi_chladiva_v_kg'
],

potencial_globalniho_oteplovani_chladiva_v_co_e: [
  'potencial_globalniho_oteplovani_chladiva_v_co_e'
],

potencial_globalniho_oteplovani_pristroje_v_co_e: [
  'potencial_globalniho_oteplovani_pristroje_v_co_e'
],

  trida_energeticke_ucinnosti_prani_a_suseni_a_g: [
    'trida_energeticke_ucinnosti_prani_a_suseni_a_g',
    'trida_energeticke_ucinnosti_prani_a_suseni'
  ],

 vazena_spotreba_elektricke_energie_na_100_provoznich_cyklu_pro_kompletni_provozni_cyklus_v_kwh: [
  'vazena_spotreba_elektricke_energie_na_100_provoznich_cyklu_pro_kompletni_provozni_cyklus_v_kwh',
  'vazena_spotreba_elektricke_energie_na_100_provoznich_cyklu_pro_kompletni_provozni_cyklus_kwh',
  'vazena_spotreba_elektricke_energie_na_100_provoznich_cyklu_pro_k'
],

  vazena_spotreba_elektricke_energie_na_100_provoznich_cyklu_pro_cyklus_prani_v_kwh: [
  'vazena_spotreba_elektricke_energie_na_100_provoznich_cyklu_pro_cyklus_prani_v_kwh',
  'vazena_spotreba_elektricke_energie_na_100_provoznich_cyklu_pro_cyklus_prani_kwh',
  'vazena_spotreba_elektricke_energie_na_100_provoznich_cyklu_pro_c',
  'vazena_spotreba_elektricke_energie_na_100_cyklu_kwh'
],

  vazena_spotreba_vody_na_provozni_cyklus_pro_cyklus_prani_v_l: [
    'vazena_spotreba_vody_na_provozni_cyklus_pro_cyklus_prani_v_l',
    'vazena_spotreba_vody_na_provozni_cyklus_pro_cyklus_prani_l',
    'vazena_spotreba_vody_na_provozni_cyklus_v_l'
  ],

  vazena_spotreba_vody_na_provozni_cyklus_pro_kompletni_provozni_cyklus_v_l: [
  'vazena_spotreba_vody_na_provozni_cyklus_pro_kompletni_provozni_cyklus_v_l',
  'vazena_spotreba_vody_na_provozni_cyklus_pro_kompletni_provozni_cyklus_l',
  'vazena_spotreba_vody_na_provozni_cyklus_pro_kompletni_provozni_c'
],

  trida_energeticke_ucinnosti_odstredovani_a_g: [
    'trida_energeticke_ucinnosti_odstredovani_a_g',
    'trida_energeticke_ucinnosti_odstredovani'
  ],

  trida_urovne_emisi_hluku_pri_odstredovani_a_d: [
    'trida_urovne_emisi_hluku_pri_odstredovani_a_d',
    'trida_urovne_emisi_hluku_pri_odstredovani'
  ],

  uroven_emisi_hluku_pri_odstredovani_v_db_a_re_1_pw: [
    'uroven_emisi_hluku_pri_odstredovani_v_db_a_re_1_pw',
    'uroven_emisi_hluku_pri_odstredovani_db_a'
  ],

  delka_programu_pri_jmenovite_kapacite_pro_cyklus_prani: [
    'delka_programu_pri_jmenovite_kapacite_pro_cyklus_prani'
  ],

  delka_programu_pri_jmenovite_kapacite_pro_kompletni_provozni_cyklus: [
  'delka_programu_pri_jmenovite_kapacite_pro_kompletni_provozni_cyklus',
  'delka_programu_pri_jmenovite_kapacite_pro_kompletni_cyklus',
  'delka_programu_pri_jmenovite_kapacite_pro_kompletni_provozni_cyk'
],

  prikon_ve_vypnutem_stavu_ve_w: [
  'prikon_ve_vypnutem_stavu_ve_w',
  'prikon_ve_vypnutem_stavu_v_w',
  'prikon_ve_vypnutem_stavu_w',
  'prikon_ve_vypnutem_stavu'
],
trida_energeticke_ucinnosti_a_d: [
  'trida_energeticke_ucinnosti_a_d',
  'custom.trida_energeticke_ucinnosti_a_d',
  'custom_trida_energeticke_ucinnosti_a_d'
],
rocni_spotreba_energie_v_kwh_rok: [
  'rocni_spotreba_energie_v_kwh_rok',
  'custom.rocni_spotreba_energie_v_kwh_rok',
  'custom_rocni_spotreba_energie_v_kwh_rok'
],

trida_ucinnosti_proudeni_kapalin: [
  'trida_ucinnosti_proudeni_kapalin',
  'custom.trida_ucinnosti_proudeni_kapalin',
  'custom_trida_ucinnosti_proudeni_kapalin'
],

trida_ucinnosti_osvetleni: [
  'trida_ucinnosti_osvetleni',
  'custom.trida_ucinnosti_osvetleni',
  'custom_trida_ucinnosti_osvetleni'
],

trida_ucinnosti_filtrace_tuku: [
  'trida_ucinnosti_filtrace_tuku',
  'custom.trida_ucinnosti_filtrace_tuku',
  'custom_trida_ucinnosti_filtrace_tuku'
],

stupen_odlouceni_tuku: [
  'stupen_odlouceni_tuku',
  'custom.stupen_odlouceni_tuku',
  'custom_stupen_odlouceni_tuku'
],

prikon_ve_vypnutem_stavu_ve_w: [
  'prikon_ve_vypnutem_stavu_ve_w',
  'custom.prikon_ve_vypnutem_stavu_ve_w',
  'custom_prikon_ve_vypnutem_stavu_ve_w',
  'prikon_ve_vypnutem_stavu_v_w',
  'prikon_ve_vypnutem_stavu_w',
  'prikon_ve_vypnutem_stavu'
],

prikon_v_pohotovostnim_rezimu_ve_w: [
  'prikon_v_pohotovostnim_rezimu_ve_w',
  'custom.prikon_v_pohotovostnim_rezimu_ve_w',
  'custom_prikon_v_pohotovostnim_rezimu_ve_w',
  'prikon_v_pohotovostnim_rezimu_v_w',
  'prikon_v_pohotovostnim_rezimu_w',
  'prikon_v_pohotovostnim_rezimu'
],

prikon_v_sitovem_pohotovostnim_rezimu_ve_w: [
  'prikon_v_sitovem_pohotovostnim_rezimu_ve_w',
  'custom.prikon_v_sitovem_pohotovostnim_rezimu_ve_w',
  'custom_prikon_v_sitovem_pohotovostnim_rezimu_ve_w',
  'prikon_v_sitovem_pohotovostnim_rezimu_v_w',
  'prikon_v_sitovem_pohotovostnim_rezimu_w',
  'prikon_v_sitovem_pohotovostnim_rezimu'
],

cas_do_automatickeho_zapnuti_z_pohotovostniho_rezimu_v_min: [
  'cas_do_automatickeho_zapnuti_z_pohotovostniho_rezimu_v_min',
  'custom.cas_do_automatickeho_zapnuti_z_pohotovostniho_rezimu_v_min',
  'custom_cas_do_automatickeho_zapnuti_z_pohotovostniho_rezimu_v_min'
],

cas_do_automatickeho_zapnuti_ze_sitoveho_pohotovostniho_rezimu_m: [
  'cas_do_automatickeho_zapnuti_ze_sitoveho_pohotovostniho_rezimu_m',
  'custom.cas_do_automatickeho_zapnuti_ze_sitoveho_pohotovostniho_rezimu_m',
  'custom_cas_do_automatickeho_zapnuti_ze_sitoveho_pohotovostniho_rezimu_m',
  'cas_do_automatickeho_zapnuti_ze_sitoveho_pohotovostniho_rezimu_v_min'
],

cas_do_automatickeho_zapnuti_z_vypnuteho_stavu_v_min: [
  'cas_do_automatickeho_zapnuti_z_vypnuteho_stavu_v_min',
  'custom.cas_do_automatickeho_zapnuti_z_vypnuteho_stavu_v_min',
  'custom_cas_do_automatickeho_zapnuti_z_vypnuteho_stavu_v_min'
],

prikon_v_pohotovostnim_rezimu_ve_w: [
  'prikon_v_pohotovostnim_rezimu_ve_w',
  'prikon_v_pohotovostnim_rezimu_v_w',
  'prikon_v_pohotovostnim_rezimu_w',
  'prikon_v_pohotovostnim_rezimu'
],

prikon_v_sitovem_pohotovostnim_rezimu_ve_w: [
  'prikon_v_sitovem_pohotovostnim_rezimu_ve_w',
  'prikon_v_sitovem_pohotovostnim_rezimu_v_w',
  'prikon_v_sitovem_pohotovostnim_rezimu_w',
  'prikon_v_sitovem_pohotovostnim_rezimu'
]
};

    const fallbacks = (fallbackMap[key] || [])
      .concat([key, 'custom.' + key, 'custom_' + key])
      .filter(function(fallbackKey, index, array) {
        return fallbackKey && array.indexOf(fallbackKey) === index;
      });

    for (let i = 0; i < fallbacks.length; i++) {
      const fallbackKey = fallbacks[i];
      if (
        item[fallbackKey] !== undefined &&
        item[fallbackKey] !== null &&
        String(item[fallbackKey]).trim() !== ''
      ) {
        return item[fallbackKey];
      }
    }

    return '—';
  }

 function buildCompareTable(products, items) {
  const showDifferencesOnly = getShowDifferencesOnly();
  const compareCategory = getCompareCategory(items, products);
  const baseSchema = COMPARE_SCHEMAS[compareCategory] || COMPARE_SCHEMAS.pracky_se_susickou || COMPARE_SCHEMAS.pracky || [];
  let schema = getCompareSchemaWithDynamicAccessoryRows(baseSchema, compareCategory);

  // HLAVNÍ PARAMETRY PRO VŠECHNY KATEGORIE
const MAIN_COMPARE_PARAMETERS = {
  pracky: [
    'Hmotnost náplně v kg',
    'Třída energetické účinnosti (A–G)',
    'Maximální počet otáček',
    'PowerWash',
    'TwinDos'
  ],

  pracky_se_susickou: [
    'Hmotnost náplně při praní v kg',
    'Hmotnost náplně při sušení v kg',
    'Třída energetické účinnosti praní a sušení (A–G)',
    'Maximální počet otáček',
    'Technologie PerfectCare'
  ],

  susicky: [
    'Hmotnost náplně v kg',
    'Třída energetické účinnosti (A–G)',
    'Sušička s tepelným čerpadlem',
    'Na stupeň přesné sušení PerfectDry',
    'Technologie EcoDry'
  ],

  mycky: [
    'Počet jídelních souprav',
    'Třída energetické účinnosti (A–G)',
    'Automatické dávkování s PowerDiskem',
    'Sušení AutoOpen',
    'Spotřeba vody v programu ECO na jeden programový cyklus v l'
  ],

  profesionalni_mycky: [
    'Mycí systém',
    'Nejkratší čas programu v min',
    'Čisticí výkon počet jídelních souprav/šarže',
    'Maximální teplota oplachování ve °C',
    'Testovaná hygiena'
  ],

  chladnicky: [
    'Třída energetické účinnosti (A–G)',
    'Celkový užitný objem v l',
    'Systém uchování čerstvosti',
    'NoFrost',
    'SoftClose'
  ],

  mraznicky: [
    'Třída energetické účinnosti (A–G)',
    '4hvězdičková mrazicí zóna v l',
    'NoFrost',
    'VarioRoom',
    'Kapacita mražení v kg/24 h'
  ],

  vinoteky: [
    'Počet lahví na víno o objemu 0,75 l',
    'Počet teplotních zón pro víno',
    'Třída energetické účinnosti (A–G)',
    'UV ochrana vína',
    'DynaCool'
  ],

  varne_desky: [
    'Druh ohřevu',
    'Počet varných zón',
    'Indukční varná deska s integrovaným odsavačem par',
    'PowerFlex Plus',
    'TempControl'
  ],

  odsavace: [
    'Provedení',
    'Šířka těla odsavače v mm',
    'Výkon odtahu vzduchu stupně 3 (m³/h) podle EN 61591',
    'Hlučnost stupně 3 (dB(A) re 1 pW) podle EN 60704-3',
    'Třída energetické účinnosti (A+++ – D)'
  ],

  pecici_trouby: [
    'Objem ohřevného prostoru v l',
    'Třída energetické účinnosti (A+++ – D)',
    'Pokrmový teploměr',
    'TasteControl',
    'Pyrolytické samočištění'
  ],

  mikrovlnne_trouby: [
    'Objem ohřevného prostoru v l',
    'Maximální výkon mikrovlny ve W',
    'Křemenný gril',
    'Automatické programy',
    'Quick mikrovlna'
  ],

  konvektomaty: [
    'Objem ohřevného prostoru v l',
    'Klimatický senzor',
    'TasteControl',
    'Propojení s Miele@home',
    'Displej'
  ],

  kavovary: [
    'AromaticSystemFresh',
    'CoffeeSelect',
    'Příprava OneTouch',
    'Příprava OneTouch for Two',
    'Programovatelné uživatelské profily'
  ],

  zehlici_pristroje: [
    'Funkce páry',
    'Tlak páry v barech',
    'Množství páry v g/min',
    'Šířka žehlicího válce v mm',
    'Objem zásobníku na vodu v l'
  ],

  sackove_vysavace: [
    'Akční rádius v m',
    'Hlasitost v dB',
    'Objem sáčku v l',
    'Vzduchový filtr',
    'Výkon ve wattech'
  ],

bezsackove_vysavace: [
  'Varianta motoru',
  'Elektronická regulace výkonu',
  'Sací trubice',
  'Hlasitost v dB',
  'Technologie Vortex'
],

  tycove_akumulatorove_vysavace: [
    'Doba provozu na stupeň MIN s elektropříslušenstvím',
    'Doba provozu na stupeň MAX s elektropříslušenstvím',
    'Doba nabíjení v min',
    'Plošný výkon v m²',
    'Hmotnost v kg'
  ]
};

const mainParameterLabels = MAIN_COMPARE_PARAMETERS[compareCategory] || [];

if (mainParameterLabels.length) {
  const normalizedMainLabels = mainParameterLabels.map(function(label) {
    return normalizeCompareCode(label);
  });

  const allRows = [];

  schema.forEach(function(section) {
    (section.rows || []).forEach(function(row) {
      allRows.push(row);
    });
  });

const mainRows = mainParameterLabels
  .map(function(label) {
    const normalizedLabel = normalizeCompareCode(label);

    const matchingRows = allRows.filter(function(row) {
      return normalizeCompareCode(row.label) === normalizedLabel;
    });

    if (!matchingRows.length) return null;

    return (
      matchingRows.find(function(row) {
        return row.valueKey && row.valueCode;
      }) ||
      matchingRows.find(function(row) {
        return row.valueKey;
      }) ||
      matchingRows[0]
    );
  })
  .filter(Boolean)
  .map(function(row) {
    return Object.assign({}, row, {
      alwaysShow: false
    });
  });

  function isMainParameter(row) {
    return normalizedMainLabels.includes(
      normalizeCompareCode(row.label)
    );
  }

  if (mainRows.length) {
    const remainingSchema = schema
      .map(function(section) {
        return {
          title: section.title,
          rows: (section.rows || []).filter(function(row) {
            return !isMainParameter(row);
          })
        };
      })
      .filter(function(section) {
        return section.rows.length > 0;
      });

    schema = [
      {
        title: 'HLAVNÍ PARAMETRY',
        rows: mainRows
      }
    ].concat(remainingSchema);
  }
}

  const sections = schema.map(function(section) {
   return {
  title: section.title,
  rows: section.rows.map(function(row) {
return {
      label: row.label,
      tooltipGroup: row.tooltipGroup || section.title,
      tooltipCode: row.code || '',
      valueKey: row.valueKey || '',
      valueCode: row.valueCode || '',
displayAsText: row.displayAsText === true,
alwaysShow: row.alwaysShow === true,
values: items.map(function(item) {

  // KÁVOVARY – počet programovatelných uživatelských profilů
  if (
    compareCategory === 'kavovary' &&
    normalizeCompareCode(row.label) === 'programovatelne_uzivatelske_profily'
  ) {
    const profileValue = getCompareJsonValue(
      item,
      'uzivatelske_vyhody_hodnota',
      'programovatelne_uzivatelske_profily'
    );

    if (normalizeCompareRawValue(profileValue) === 'ne') {
      return '0';
    }

    return profileValue;
  }

  // PRAČKY SE SUŠIČKOU – kapacita praní / sušení
  if (
    compareCategory === 'pracky_se_susickou' &&
    (
      normalizeCompareCode(row.label) === 'hmotnost_naplne_pri_prani_v_kg' ||
      normalizeCompareCode(row.label) === 'hmotnost_naplne_pri_suseni_v_kg'
    )
  ) {
    const capacityCode = normalizeCompareCode(row.label);

    // 1. zkusit technické údaje
    let capacityValue = getCompareJsonValue(
      item,
      'technicke_udaje_hodnota',
      capacityCode
    );

    // 2. u praní zkusit i běžnou hmotnost náplně
    if (
      !isFilledCompareValue(capacityValue) &&
      capacityCode === 'hmotnost_naplne_pri_prani_v_kg'
    ) {
      capacityValue = getCompareJsonValue(
        item,
        'setrna_pece_o_pradlo_hodnota',
        'hmotnost_naplne_v_kg'
      );
    }

    if (isFilledCompareValue(capacityValue)) {
      return capacityValue;
    }

    // 3. poslední fallback z názvu produktu např. 9/6kg nebo 8/5 kg
    const productTitle = String(
      item.title ||
      item.product_title ||
      item.name ||
      ''
    );

    const capacityMatch = productTitle.match(
      /(\d+(?:[.,]\d+)?)\s*\/\s*(\d+(?:[.,]\d+)?)\s*kg/i
    );

    if (capacityMatch) {
      return capacityCode === 'hmotnost_naplne_pri_prani_v_kg'
        ? capacityMatch[1]
        : capacityMatch[2];
    }
  }
          if (
            (
row.key === 'odtah_hodnoty' ||
row.key === 'cirkulace_hodnoty' ||
row.key === 'komfort_pri_obsluze_hodnoty' ||
row.key === 'komfort_pri_udrzbe_hodnoty' ||
row.key === 'kosove_usporadani_hodnota' ||
row.key === 'technicke_udaje_hodnota' ||
row.key === 'technicke_udaje_hodnoty' ||
row.key === 'vykonove_udaje_hodnota' ||
row.key === 'hospodarnost_a_udrzitelnost_hodnota' ||
row.key === 'hospodarnost_a_udrzitelnost_hodnoty' ||
row.key === 'custom_napojove_speciality_hodnota' ||
row.key === 'uzivatelske_vyhody_hodnota'
            ) &&
            row.code
          ) {
            return getCompareJsonValue(item, row.key, row.code);
          }

if (
  (
    row.key === 'kategorie_pristroju' ||
    row.key === 'provedeni' ||
    row.key === 'provedeni_a_design' ||
    row.key === 'vseobecne_udaje' ||
    row.key === 'uzivatelske_vyhody' ||
    row.key === 'napojove_speciality' ||
    row.key === 'parni_technologie_privod_vody' ||
    row.key === 'provozni_zpusoby' ||
    row.key === 'vybaveni_varnych_zon' ||
    row.key === 'konstrukce' ||
    row.key === 'odstredovani' ||
    row.key === 'design' ||
    row.key === 'cistici_vykon' ||
    row.key === 'cisteni' ||
    row.key === 'setrna_pece_o_pradlo' ||
    row.key === 'komfort_pri_obsluze' ||
    row.key === 'mobilita' ||
    row.key === 'filtracni_system' ||
    row.key === 'hospodarnost' ||
    row.key === 'hospodarnost_a_udrzitelnost' ||
    row.key === 'komfort_pri_udrzbe' ||
    row.key === 'kvalita_vysledku' ||
    row.key === 'programy_myti' ||
    row.key === 'moznosti_myti' ||
    row.key === 'pouziti' ||
    row.key === 'vykonove_udaje' ||
    row.key === 'ridici_jednotka' ||
    row.key === 'chladici_zona' ||
    row.key === 'mrazici_zona' ||
    row.key === 'standardni_elektricke_pripojeni' ||
    row.key === 'mozna_varianta_napeti_1' ||
    row.key === 'pripojka_privodu_a_odvodu_vody' ||
    row.key === 'rozmery_a_hmotnost' ||
    row.key === 'emisni_hodnoty' ||
    row.key === 'kosove_usporadani' ||
    row.key === 'programy_prani' ||
    row.key === 'programy_suseni' ||
    row.key === 'vysledek_suseni' ||
    row.key === 'extra_funkce' ||
    row.key === 'bezpecnost' ||
    row.key === 'technicke_udaje' ||
    row.key === 'instalacni_vykresy' ||
    row.key === 'osvetleni' ||
    row.key === 'ventilator' ||
    row.key === 'montazni_pokyny' ||
    row.key === 'moznosti_pripojeni' ||
    row.key === 'normy_zkusebni_a_identifikacni_oznaceni'
  ) &&
  row.code
) {
const raw = getCompareItemValue(item, row.key);
if (row.valueKey) {
  let linkedValue = row.valueCode
    ? getCompareJsonValue(item, row.valueKey, row.valueCode)
    : getCompareItemValue(item, row.valueKey);

  if (
    !isFilledCompareValue(linkedValue) &&
    row.valueKey === 'hospodarnost_a_udrzitelnost_hodnoty'
  ) {
    linkedValue = getCompareJsonValue(item, 'hospodarnost_a_udrzitelnost_hodnota', row.valueCode || row.code);
  }

  if (
    !isFilledCompareValue(linkedValue) &&
    normalizeCompareCode(row.valueCode || row.code) === 'trida_urovne_emisi_hluku_a_d'
  ) {
    linkedValue =
      getCompareJsonValue(item, 'technicke_udaje_hodnota', row.valueCode || row.code) ||
      getCompareJsonValue(item, 'technicke_udaje_hodnoty', row.valueCode || row.code);
  }

  if (isFilledCompareValue(linkedValue)) {
    return linkedValue;
  }

    if (
    !isFilledCompareValue(linkedValue) &&
    row.valueKey === 'technicke_udaje_hodnota'
  ) {
    linkedValue = getCompareJsonValue(item, 'technicke_udaje_hodnoty', row.valueCode || row.code);
  }

  if (
    !isFilledCompareValue(linkedValue) &&
    normalizeCompareCode(row.valueCode || row.code) === 'rozmery_pristroje_s_x_v_x_h_v_mm'
  ) {
    const directDimensions =
      getCompareItemValue(item, 'rozmery_pristroje_s_x_v_x_h_v_mm') ||
      getCompareItemValue(item, 'rozmery_v_x_s_x_h_v_mm');

    if (isFilledCompareValue(directDimensions)) {
      linkedValue = directDimensions;
    }

    if (!isFilledCompareValue(linkedValue)) {
      const widthFromJson =
        getCompareJsonValue(item, 'technicke_udaje_hodnota', 'rozmery_v_mm_sirka');
      const heightFromJson =
        getCompareJsonValue(item, 'technicke_udaje_hodnota', 'rozmery_v_mm_vyska');
      const depthFromJson =
        getCompareJsonValue(item, 'technicke_udaje_hodnota', 'rozmery_v_mm_hloubka');

      const width =
        isFilledCompareValue(widthFromJson)
          ? widthFromJson
          : getCompareItemValue(item, 'rozmery_v_mm_sirka');

      const height =
        isFilledCompareValue(heightFromJson)
          ? heightFromJson
          : getCompareItemValue(item, 'rozmery_v_mm_vyska');

      const depth =
        isFilledCompareValue(depthFromJson)
          ? depthFromJson
          : getCompareItemValue(item, 'rozmery_v_mm_hloubka');

      if (
        isFilledCompareValue(width) &&
        isFilledCompareValue(height) &&
        isFilledCompareValue(depth)
      ) {
        linkedValue = width + ' × ' + height + ' × ' + depth;
      }
    }
  }

  if (isFilledCompareValue(linkedValue)) {
    return linkedValue;
  }
  const prefixedLinkedValue = getCompareItemValue(item, row.key + '_' + (row.valueCode || row.code));

  if (isFilledCompareValue(prefixedLinkedValue)) {
    return prefixedLinkedValue;
  }

  const directLinkedValue = getCompareItemValue(item, row.valueCode || row.code);

  if (isFilledCompareValue(directLinkedValue)) {
    return directLinkedValue;
  }

  if (normalizeCompareCode(row.valueCode || row.code) === 'trida_energeticke_ucinnosti_a_g') {
    const directEnergyClass =
      getCompareItemValue(item, 'trida_energeticke_ucinnosti') ||
      getCompareItemValue(item, 'energeticka_trida') ||
      getCompareItemValue(item, 'trida_energeticke_ucinnosti_a_d') ||
      getCompareItemValue(item, 'trida_energeticke_ucinnosti_a_g_hodnota');

    if (isFilledCompareValue(directEnergyClass)) {
      return directEnergyClass;
    }
  }

  if (normalizeCompareCode(row.valueCode || row.code) === 'trida_urovne_emisi_hluku_a_d') {
    const directNoiseClass =
      getCompareItemValue(item, 'trida_urovne_emisi_hluku_a_d') ||
      getCompareItemValue(item, 'trida_urovne_emisi_hluku') ||
      getCompareItemValue(item, 'trida_emisi_hluku_prenaseneho_vzduchem_a_d') ||
      getCompareItemValue(item, 'trida_akustickych_emisi');

    if (isFilledCompareValue(directNoiseClass)) {
      return directNoiseClass;
    }
  }
  if (row.valueOnly === true || row.valueKey === 'technicke_udaje_hodnota') {
    return '—';
  }

  if (row.code && compareCodeListIncludes(raw, row.code)) {
    return 'ano';
  }

  if (row.emptyAsNo === true) {
    return 'ne';
  }

  if (row.emptyAsText === true) {
    return '—';
  }
}
const prefixedDirectValue = getCompareItemValue(item, row.key + '_' + row.code);
const directValue = getCompareItemValue(item, row.code);

if (isFilledCompareValue(raw) && compareCodeListIncludes(raw, row.code)) {
  return 'ano';
}

if (isFilledCompareValue(prefixedDirectValue)) {
  return prefixedDirectValue;
}

if (isFilledCompareValue(directValue)) {
  return directValue;
}

if (row.emptyAsNo === true) {
  return 'ne';
}

return row.valueKey ? '—' : 'ne';
            }

            const value = getCompareItemValue(item, row.key);
            if (
  section.title === 'DODÁVANÉ PŘÍSLUŠENSTVÍ' &&
  row.displayAsText &&
  row.key === 'dodavane_prislusenstvi'
) {
  return formatCompareCodeListLabels(value, 'dodavane_prislusenstvi');
}
if (section.title === 'DODÁVANÉ PŘÍSLUŠENSTVÍ' && !row.displayAsText) {
  if (row.valueKey) {
    let linkedValue = row.valueCode
      ? getCompareJsonValue(item, row.valueKey, row.valueCode)
      : getCompareItemValue(item, row.valueKey);

    if (
      !isFilledCompareValue(linkedValue) &&
      row.valueKey === 'dodavane_prislusenstvi_hodnota'
    ) {
      linkedValue = getCompareJsonValue(item, 'dodavane_prislusenstvi_hodnoty', row.valueCode || row.code);
    }

    if (isFilledCompareValue(linkedValue)) {
      return linkedValue;
    }
  }

  const accessoryCode = row.code || row.key;
  const grouped = String(getCompareItemValue(item, 'dodavane_prislusenstvi') || '');

  const aliasesByCode = {
    tri_kapsle: [
      'tri_kapsle',
      '3_kapsle',
      '3-kapsle'
    ],
    ultraphase_1_2: [
      'ultraphase_1_2',
      'ultra_phase_1_2',
      'ultra-phase-1-2',
      'UltraPhase 1 + 2'
    ],
    voucher_na_5_kartusi_praciho_prostredku_ultraphase_od_miele: [
      'voucher_na_5_kartusi_praciho_prostredku_ultraphase_od_miele',
      'voucher-na-5-kartusi-praciho-prostredku-ultraphase-od-miele',
      'Voucher na 5 kartuší pracího prostředku UltraPhase od Miele'
    ],
    voucher_na_praci_prostredky_miele: [
      'voucher_na_praci_prostredky_miele',
      'voucher-na-praci-prostredky-miele',
      'Voucher na prací prostředky Miele'
    ],
    '1x_powerdisk': [
      '1x_powerdisk',
      '1_x_powerdisk',
      '1-x-powerdisk',
      '1 x PowerDisk',
      '1× PowerDisk'
    ]
  };

  const aliases = aliasesByCode[accessoryCode] || [accessoryCode];

  const hasDirectYes = aliases.some(function(alias) {
    return (
      normalizeCompareRawValue(getCompareItemValue(item, alias)) === 'ano' ||
      normalizeCompareRawValue(getCompareItemValue(item, 'dodavane_prislusenstvi_' + alias)) === 'ano'
    );
  });

  if (
    normalizeCompareRawValue(value) === 'ano' ||
    hasDirectYes
  ) {
    return 'ano';
  }

  const hasGroupedMatch = aliases.some(function(alias) {
    return compareCodeListIncludes(grouped, alias);
  });

  if (grouped && hasGroupedMatch) {
    return 'ano';
  }

  return 'ne';
}

            return value;
          })
        };
      })
    };
  });

    return sections.map(function(section) {
const rowsHtml = section.rows.map(function(row) {
      const hasAnyFilledValue = row.values.some(isFilledCompareValue);
      const hasDifferences = rowHasDifferences(row.values);
      const hasAnyYesValue = row.values.some(function(value) {
        return normalizeCompareRawValue(value) === 'ano';
      });

      const forceShowMraznickySection =
        compareCategory === 'mraznicky' &&
        (
          section.title === 'TECHNICKÉ ÚDAJE' ||
          section.title === 'DODÁVANÉ PŘÍSLUŠENSTVÍ'
        );

if (!forceShowMraznickySection && !row.alwaysShow && !hasAnyFilledValue && section.title !== 'DODÁVANÉ PŘÍSLUŠENSTVÍ') {
  return '';
}
if (
  !forceShowMraznickySection &&
  section.title === 'DODÁVANÉ PŘÍSLUŠENSTVÍ' &&
  !row.displayAsText &&
  !row.alwaysShow &&
  !hasAnyYesValue
) {
  return '';
}

                   if (
        compareCategory === 'susicky' &&
        section.title === 'PROVEDENÍ' &&
        row.tooltipCode &&
        !row.valueKey &&
        !hasAnyYesValue
      ) {
        return '';
      }

      if (
        compareCategory === 'pracky_se_susickou' &&
        row.tooltipCode &&
        !hasAnyYesValue &&
        !row.alwaysShow &&
        !row.valueKey &&
        row.key !== 'bezpecnost'
      ) {
        return '';
      }
            if (
        compareCategory === 'profesionalni_mycky' &&
        section.title === 'PROGRAMY MYTÍ' &&
        row.tooltipCode &&
        !hasAnyYesValue
      ) {
        return '';
      }

if (showDifferencesOnly && !forceShowMraznickySection && !hasDifferences) {
  return '';
}

      const valuesHtml = row.values.map(function(value) {
                return `<div class="compare-page__value">${renderCompareValue(value, {
          booleanFilled: section.title === 'DODÁVANÉ PŘÍSLUŠENSTVÍ' && !row.displayAsText
        })}</div>`;
      }).join('');

      return `
        <div class="compare-page__row">
          <div class="compare-page__label">${renderCompareLabel(row.label, row.tooltipGroup, row.tooltipCode)}</div>
          ${valuesHtml}
        </div>
      `;
    }).join('');

    if (!rowsHtml.trim()) {
      return '';
    }

    return `
      <div class="compare-page__section">
        <div class="compare-page__section-header">
          <h2 class="compare-page__section-title">${escapeHtml(section.title)}</h2>
        </div>
        <div class="compare-page__section-table">
          ${rowsHtml}
        </div>
      </div>
    `;
  }).join('');
}

  async function renderComparePage() {
    const top = document.querySelector('[data-compare-top]');
    const controls = document.querySelector('[data-compare-controls]');
    const table = document.querySelector('[data-compare-table]');
    const empty = document.querySelector('[data-compare-empty]');
    const content = document.querySelector('[data-compare-content]');

    if (!top || !controls || !table || !empty || !content) return;

    function getStoredCompareHandle(item) {
      const directHandle = String((item && item.handle) || '').trim();

      if (directHandle) {
        return directHandle;
      }

      const url = String((item && item.url) || '').trim();
      const match = url.match(/\/products\/([^/?#]+)/);

      if (match && match[1]) {
        return match[1];
      }

      return '';
    }

    const storedItems = getCompareItems();

    const items = storedItems
      .map(function(item) {
        const handle = getStoredCompareHandle(item);

        if (!handle) {
          return null;
        }

        return Object.assign({}, item, {
          handle: handle
        });
      })
      .filter(Boolean);

    if (!items.length) {
      localStorage.removeItem('product_compare_items_v2');
      top.innerHTML = '';
      controls.innerHTML = '';
      table.innerHTML = '';
      content.style.removeProperty('--compare-columns');
      empty.hidden = false;
      content.hidden = true;
      updateCompareButtons();
      updateCompareCount();
      return;
    }

    try {
      const results = await Promise.all(
        items.map(function(item) {
          return fetchProductData(item.handle)
            .then(function(product) {
              return {
                item: item,
                product: product
              };
            })
            .catch(function(error) {
              console.warn('Produkt v porovnávači se nepodařilo načíst, bude odebrán:', item.handle, error);
              return null;
            });
        })
      );

      const validPairs = results.filter(Boolean);
      const validItems = validPairs.map(function(pair) {
        return pair.item;
      });
      const products = validPairs.map(function(pair) {
        return pair.product;
      });

      if (!validItems.length) {
        localStorage.removeItem('product_compare_items_v2');
        top.innerHTML = '';
        controls.innerHTML = '';
        table.innerHTML = '';
        content.style.removeProperty('--compare-columns');
        empty.hidden = false;
        content.hidden = true;
        updateCompareButtons();
        updateCompareCount();
        return;
      }

      if (JSON.stringify(validItems) !== JSON.stringify(storedItems)) {
        localStorage.setItem('product_compare_items_v2', JSON.stringify(validItems));
        updateCompareButtons();
        updateCompareCount();
      }

      empty.hidden = true;
      content.hidden = false;
      content.style.setProperty('--compare-columns', String(products.length));
      top.innerHTML = buildCompareTop(products, validItems);
      controls.innerHTML = buildCompareControls();
      table.innerHTML = buildCompareTable(products, validItems);
    } catch (error) {
      console.error(error);
      top.innerHTML = '';
      controls.innerHTML = '';
      table.innerHTML = '';
      empty.hidden = false;
      content.hidden = true;
    }
  }

  document.addEventListener('click', function(event) {
    const clearButton = event.target.closest('[data-compare-clear]');
    if (clearButton) {
      localStorage.removeItem('product_compare_items_v2');
      renderComparePage();
      updateCompareButtons();
      updateCompareCount();
      return;
    }

    const removeButton = event.target.closest('[data-compare-remove]');
    if (!removeButton) return;

    const productId = String(removeButton.dataset.productId);
    let items = getCompareItems();

    items = items.filter(function(item) {
      return String(item.id) !== productId;
    });

    localStorage.setItem('product_compare_items_v2', JSON.stringify(items));

    renderComparePage();
    updateCompareButtons();
    updateCompareCount();
  });

  document.addEventListener('change', function(event) {
    const toggle = event.target.closest('[data-compare-differences-toggle]');
    if (!toggle) return;

    setShowDifferencesOnly(toggle.checked);
    renderComparePage();
  });

function initComparePage() {
  renderComparePage();
  updateCompareButtons();
  updateCompareCount();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initComparePage);
} else {
  initComparePage();
}

window.addEventListener('compare:updated', function() {
  renderComparePage();
  updateCompareButtons();
  updateCompareCount();
});
